var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _g, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _g2, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _g3, _path99, _path100, _path101, _path102, _path103, _path104, _g4, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _g5, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _g6, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _g7, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _g8, _path158, _path159, _path160, _path161, _path162, _path163, _g9, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _g0, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _g1, _path291, _path292, _g10, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 832,
    height: 650,
    viewBox: "0 0 832 650",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M425.924 511.132L230.922 623.808L231.782 625.296L426.784 512.621L425.924 511.132Z",
    fill: "#EDF0F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M266.998 255.459L71.9961 368.134L72.856 369.622L267.858 256.947L266.998 255.459Z",
    fill: "#EDF0F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M238.768 180.881L43.7656 293.557L44.6255 295.045L239.628 182.369L238.768 180.881Z",
    fill: "#EDF0F8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M378.733 209.509L183.73 322.184L184.59 323.672L379.592 210.997L378.733 209.509Z",
    fill: "#EDF0F8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M775.26 212.99L580.258 325.666L581.118 327.154L776.12 214.479L775.26 212.99Z",
    fill: "#EDF0F8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M329.272 535.836L134.27 648.512L135.129 650L330.132 537.325L329.272 535.836Z",
    fill: "#EDF0F8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M213.948 415.615L68.5781 499.612L69.438 501.1L214.808 417.103L213.948 415.615Z",
    fill: "#EDF0F8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M136.802 480.749L47.4785 531.947L48.3332 533.438L137.657 482.241L136.802 480.749Z",
    fill: "#EDF0F8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M786.426 408.758L697.146 460.034L698.003 461.524L787.282 410.249L786.426 408.758Z",
    fill: "#EDF0F8"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M509.779 532.021L420.5 583.297L421.356 584.787L510.635 533.512L509.779 532.021Z",
    fill: "#EDF0F8"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M584.872 183.568L534.285 212.621L535.141 214.112L585.728 185.059L584.872 183.568Z",
    fill: "#EDF0F8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M758.813 492.463L563.811 605.138L564.67 606.627L759.673 493.951L758.813 492.463Z",
    fill: "#EDF0F8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M809.299 311.088L614.297 423.763L615.157 425.251L810.159 312.576L809.299 311.088Z",
    fill: "#EDF0F8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M578.659 575.401L475.822 634.821L476.682 636.31L579.519 576.889L578.659 575.401Z",
    fill: "#EDF0F8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter0_f_1606_3980)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M366.092 485.011C365.505 484.715 364.858 484.561 364.201 484.561C363.544 484.561 362.896 484.715 362.31 485.011L317.501 510.793C317.273 510.87 317.074 511.017 316.933 511.213C316.792 511.408 316.717 511.643 316.717 511.885C316.717 512.126 316.792 512.361 316.933 512.557C317.074 512.752 317.273 512.899 317.501 512.976L362.31 538.93C362.896 539.226 363.544 539.38 364.201 539.38C364.858 539.38 365.505 539.226 366.092 538.93L410.78 513.148C411.009 513.071 411.207 512.924 411.348 512.728C411.489 512.533 411.565 512.298 411.565 512.056C411.565 511.815 411.489 511.58 411.348 511.384C411.207 511.189 411.009 511.042 410.78 510.965L366.092 485.011Z",
    fill: "url(#paint0_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.075 485.2C365.495 484.903 364.853 484.748 364.202 484.748C363.55 484.748 362.908 484.903 362.328 485.2L317.846 510.862C317.623 510.943 317.431 511.09 317.295 511.283C317.159 511.477 317.086 511.708 317.086 511.945C317.086 512.181 317.159 512.412 317.295 512.606C317.431 512.8 317.623 512.947 317.846 513.028L362.328 538.707C362.908 539.004 363.55 539.159 364.202 539.159C364.853 539.159 365.495 539.004 366.075 538.707L410.54 513.045C410.763 512.964 410.955 512.817 411.091 512.623C411.227 512.43 411.3 512.199 411.3 511.962C411.3 511.725 411.227 511.494 411.091 511.301C410.955 511.107 410.763 510.96 410.54 510.879L366.075 485.2Z",
    fill: "url(#paint1_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.057 485.389C365.478 485.102 364.839 484.952 364.192 484.952C363.545 484.952 362.907 485.102 362.327 485.389L318.171 510.862C317.947 510.938 317.752 511.083 317.614 511.275C317.476 511.468 317.401 511.699 317.401 511.936C317.401 512.173 317.476 512.404 317.614 512.597C317.752 512.79 317.947 512.934 318.171 513.01L362.327 538.517C362.907 538.805 363.545 538.955 364.192 538.955C364.839 538.955 365.478 538.805 366.057 538.517L410.196 513.028C410.42 512.951 410.615 512.807 410.754 512.614C410.892 512.422 410.966 512.19 410.966 511.953C410.966 511.716 410.892 511.485 410.754 511.293C410.615 511.1 410.42 510.955 410.196 510.879L366.057 485.389Z",
    fill: "url(#paint2_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.058 485.647C365.484 485.35 364.847 485.195 364.201 485.195C363.555 485.195 362.919 485.35 362.345 485.647L318.516 510.931C318.289 511.002 318.091 511.144 317.95 511.335C317.81 511.527 317.734 511.759 317.734 511.996C317.734 512.234 317.81 512.465 317.95 512.657C318.091 512.849 318.289 512.991 318.516 513.062L362.345 538.38C362.921 538.669 363.557 538.819 364.201 538.819C364.846 538.819 365.481 538.669 366.058 538.38L409.87 513.079C410.094 513.003 410.289 512.858 410.427 512.666C410.565 512.473 410.64 512.242 410.64 512.005C410.64 511.768 410.565 511.537 410.427 511.344C410.289 511.151 410.094 511.007 409.87 510.931L366.058 485.647Z",
    fill: "url(#paint3_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.04 485.785C365.47 485.496 364.84 485.346 364.201 485.346C363.562 485.346 362.932 485.496 362.362 485.785L318.842 510.879C318.623 510.959 318.435 511.104 318.301 511.295C318.168 511.485 318.096 511.712 318.096 511.945C318.096 512.177 318.168 512.404 318.301 512.595C318.435 512.786 318.623 512.931 318.842 513.011L362.362 538.122C362.932 538.411 363.562 538.561 364.201 538.561C364.84 538.561 365.47 538.411 366.04 538.122L409.543 513.011C409.763 512.935 409.955 512.793 410.09 512.603C410.226 512.414 410.299 512.186 410.299 511.953C410.299 511.72 410.226 511.493 410.09 511.304C409.955 511.114 409.763 510.972 409.543 510.896L366.04 485.785Z",
    fill: "url(#paint4_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.021 485.974C365.457 485.685 364.833 485.535 364.199 485.535C363.566 485.535 362.942 485.685 362.377 485.974L319.167 510.896C318.952 510.975 318.767 511.118 318.636 511.305C318.506 511.493 318.435 511.716 318.435 511.945C318.435 512.173 318.506 512.396 318.636 512.584C318.767 512.771 318.952 512.914 319.167 512.993L362.377 537.933C362.942 538.221 363.566 538.371 364.199 538.371C364.833 538.371 365.457 538.221 366.021 537.933L409.198 513.01C409.418 512.935 409.609 512.792 409.745 512.603C409.88 512.413 409.953 512.186 409.953 511.953C409.953 511.72 409.88 511.493 409.745 511.304C409.609 511.114 409.418 510.972 409.198 510.896L366.021 485.974Z",
    fill: "url(#paint5_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.006 486.163C365.446 485.883 364.828 485.737 364.201 485.737C363.575 485.737 362.957 485.883 362.397 486.163L319.513 510.896C319.298 510.975 319.113 511.118 318.982 511.305C318.851 511.493 318.781 511.716 318.781 511.945C318.781 512.173 318.851 512.396 318.982 512.584C319.113 512.771 319.298 512.914 319.513 512.993L362.397 537.744C362.957 538.024 363.575 538.169 364.201 538.169C364.828 538.169 365.446 538.024 366.006 537.744L408.873 512.993C409.089 512.918 409.277 512.778 409.41 512.592C409.543 512.405 409.614 512.182 409.614 511.953C409.614 511.724 409.543 511.501 409.41 511.315C409.277 511.128 409.089 510.988 408.873 510.913L366.006 486.163Z",
    fill: "url(#paint6_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.989 486.352C365.432 486.072 364.817 485.926 364.193 485.926C363.569 485.926 362.954 486.072 362.397 486.352L319.839 510.914C319.621 510.983 319.43 511.121 319.295 511.306C319.16 511.492 319.087 511.715 319.087 511.945C319.087 512.174 319.16 512.398 319.295 512.583C319.43 512.769 319.621 512.906 319.839 512.976L362.397 537.555C362.954 537.835 363.569 537.98 364.193 537.98C364.817 537.98 365.432 537.835 365.989 537.555L408.529 512.993C408.746 512.919 408.934 512.778 409.066 512.592C409.199 512.405 409.271 512.182 409.271 511.953C409.271 511.724 409.199 511.501 409.066 511.315C408.934 511.128 408.746 510.988 408.529 510.914L365.989 486.352Z",
    fill: "url(#paint7_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.988 486.558C365.433 486.279 364.821 486.133 364.2 486.133C363.579 486.133 362.967 486.279 362.413 486.558L320.182 510.913C319.963 510.983 319.773 511.121 319.637 511.306C319.502 511.492 319.429 511.715 319.429 511.945C319.429 512.174 319.502 512.398 319.637 512.583C319.773 512.768 319.963 512.906 320.182 512.976L362.413 537.366C362.967 537.645 363.579 537.791 364.2 537.791C364.821 537.791 365.433 537.645 365.988 537.366L408.202 512.993C408.42 512.923 408.611 512.786 408.746 512.6C408.881 512.415 408.954 512.191 408.954 511.962C408.954 511.732 408.881 511.509 408.746 511.324C408.611 511.138 408.42 511.001 408.202 510.931L365.988 486.558Z",
    fill: "url(#paint8_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.971 486.747C365.422 486.468 364.816 486.322 364.2 486.322C363.585 486.322 362.978 486.468 362.43 486.747L320.509 510.913C320.296 510.987 320.112 511.126 319.982 511.309C319.852 511.492 319.782 511.711 319.782 511.936C319.782 512.161 319.852 512.38 319.982 512.564C320.112 512.747 320.296 512.885 320.509 512.959L362.43 537.211C362.978 537.49 363.585 537.636 364.2 537.636C364.816 537.636 365.422 537.49 365.971 537.211L407.875 513.028C408.088 512.954 408.272 512.816 408.402 512.632C408.532 512.449 408.602 512.23 408.602 512.005C408.602 511.78 408.532 511.561 408.402 511.378C408.272 511.194 408.088 511.056 407.875 510.982L365.971 486.747Z",
    fill: "url(#paint9_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.952 486.936C365.417 486.676 364.829 486.541 364.233 486.541C363.638 486.541 363.05 486.676 362.515 486.936L320.902 510.999C320.688 511.069 320.501 511.204 320.368 511.386C320.236 511.569 320.164 511.788 320.164 512.013C320.164 512.239 320.236 512.458 320.368 512.641C320.501 512.823 320.688 512.958 320.902 513.028L362.515 537.091C363.048 537.358 363.637 537.498 364.233 537.498C364.83 537.498 365.419 537.358 365.952 537.091L407.53 513.028C407.745 512.958 407.932 512.823 408.064 512.641C408.197 512.458 408.268 512.239 408.268 512.013C408.268 511.788 408.197 511.569 408.064 511.386C407.932 511.204 407.745 511.069 407.53 510.999L365.952 486.936Z",
    fill: "url(#paint10_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.938 487.125C365.403 486.863 364.815 486.726 364.219 486.726C363.623 486.726 363.035 486.863 362.5 487.125L321.249 510.931C320.286 511.498 320.286 512.392 321.249 512.942L362.5 536.781C363.035 537.044 363.623 537.18 364.219 537.18C364.815 537.18 365.403 537.044 365.938 536.781L407.189 512.959C407.397 512.886 407.578 512.75 407.705 512.57C407.833 512.389 407.901 512.174 407.901 511.953C407.901 511.733 407.833 511.517 407.705 511.337C407.578 511.157 407.397 511.021 407.189 510.948L365.938 487.125Z",
    fill: "url(#paint11_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.936 487.366C365.402 487.101 364.813 486.963 364.217 486.963C363.621 486.963 363.033 487.101 362.498 487.366L321.539 510.999C321.329 511.068 321.146 511.201 321.016 511.38C320.886 511.559 320.816 511.775 320.816 511.996C320.816 512.218 320.886 512.433 321.016 512.612C321.146 512.791 321.329 512.925 321.539 512.993L362.498 536.644C363.033 536.909 363.621 537.047 364.217 537.047C364.813 537.047 365.402 536.909 365.936 536.644L406.861 513.01C407.071 512.942 407.254 512.809 407.384 512.629C407.514 512.45 407.584 512.235 407.584 512.013C407.584 511.792 407.514 511.577 407.384 511.398C407.254 511.218 407.071 511.085 406.861 511.017L365.936 487.366Z",
    fill: "url(#paint12_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.918 487.521C365.386 487.249 364.797 487.107 364.199 487.107C363.602 487.107 363.013 487.249 362.481 487.521L321.848 510.948C321.638 511.016 321.454 511.15 321.324 511.329C321.194 511.508 321.124 511.723 321.124 511.945C321.124 512.166 321.194 512.382 321.324 512.561C321.454 512.74 321.638 512.873 321.848 512.942L362.481 536.403C363.016 536.666 363.604 536.802 364.199 536.802C364.795 536.802 365.383 536.666 365.918 536.403L406.533 512.942C406.738 512.869 406.915 512.735 407.04 512.558C407.165 512.381 407.232 512.17 407.232 511.953C407.232 511.737 407.165 511.525 407.04 511.348C406.915 511.171 406.738 511.037 406.533 510.965L365.918 487.521Z",
    fill: "url(#paint13_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.903 487.71C365.373 487.433 364.783 487.288 364.184 487.288C363.586 487.288 362.996 487.433 362.466 487.71L322.143 510.965C321.936 511.033 321.757 511.164 321.629 511.34C321.502 511.516 321.433 511.728 321.433 511.945C321.433 512.162 321.502 512.374 321.629 512.55C321.757 512.726 321.936 512.857 322.143 512.925L362.466 536.197C362.996 536.474 363.586 536.619 364.184 536.619C364.783 536.619 365.373 536.474 365.903 536.197L406.192 512.942C406.396 512.869 406.573 512.736 406.698 512.559C406.823 512.382 406.89 512.17 406.89 511.953C406.89 511.737 406.823 511.525 406.698 511.348C406.573 511.171 406.396 511.037 406.192 510.965L365.903 487.71Z",
    fill: "url(#paint14_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.886 487.899C365.354 487.624 364.765 487.481 364.167 487.481C363.569 487.481 362.98 487.624 362.448 487.899L322.435 510.965C322.228 511.033 322.049 511.164 321.921 511.34C321.794 511.516 321.725 511.727 321.725 511.945C321.725 512.162 321.794 512.374 321.921 512.549C322.049 512.725 322.228 512.857 322.435 512.924L362.448 536.008C362.98 536.282 363.569 536.425 364.167 536.425C364.765 536.425 365.354 536.282 365.886 536.008L405.865 512.924C406.065 512.853 406.239 512.721 406.361 512.547C406.484 512.373 406.549 512.166 406.549 511.953C406.549 511.741 406.484 511.533 406.361 511.359C406.239 511.185 406.065 511.054 405.865 510.982L365.886 487.899Z",
    fill: "url(#paint15_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.867 488.088C365.336 487.811 364.747 487.666 364.148 487.666C363.549 487.666 362.96 487.811 362.429 488.088L322.759 510.982C322.557 511.049 322.381 511.178 322.256 511.351C322.132 511.524 322.064 511.732 322.064 511.945C322.064 512.158 322.132 512.366 322.256 512.538C322.381 512.711 322.557 512.84 322.759 512.907L362.429 535.819C362.96 536.096 363.549 536.241 364.148 536.241C364.747 536.241 365.336 536.096 365.867 535.819L405.537 512.925C405.737 512.853 405.91 512.721 406.033 512.547C406.155 512.374 406.221 512.166 406.221 511.953C406.221 511.741 406.155 511.533 406.033 511.359C405.91 511.186 405.737 511.054 405.537 510.982L365.867 488.088Z",
    fill: "url(#paint16_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.867 488.277C365.348 488.022 364.778 487.889 364.2 487.889C363.622 487.889 363.052 488.022 362.533 488.277L323.172 510.982C322.97 511.049 322.794 511.178 322.669 511.351C322.544 511.524 322.477 511.732 322.477 511.945C322.477 512.158 322.544 512.365 322.669 512.538C322.794 512.711 322.97 512.84 323.172 512.907L362.533 535.63C363.049 535.892 363.62 536.029 364.2 536.029C364.779 536.029 365.351 535.892 365.867 535.63L405.193 512.907C405.39 512.836 405.559 512.707 405.679 512.536C405.799 512.365 405.863 512.162 405.863 511.953C405.863 511.745 405.799 511.541 405.679 511.37C405.559 511.2 405.39 511.07 405.193 510.999L365.867 488.277Z",
    fill: "url(#paint17_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.851 488.483C365.341 488.221 364.775 488.084 364.201 488.084C363.627 488.084 363.061 488.221 362.551 488.483L323.517 511C323.319 511.066 323.146 511.193 323.024 511.362C322.902 511.532 322.837 511.736 322.837 511.945C322.837 512.154 322.902 512.358 323.024 512.527C323.146 512.697 323.319 512.824 323.517 512.89L362.551 535.492C363.064 535.747 363.628 535.879 364.201 535.879C364.773 535.879 365.338 535.747 365.851 535.492L404.937 512.907C405.133 512.837 405.302 512.707 405.422 512.536C405.542 512.366 405.607 512.162 405.607 511.953C405.607 511.745 405.542 511.541 405.422 511.371C405.302 511.2 405.133 511.07 404.937 511L365.851 488.483Z",
    fill: "url(#paint18_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.833 488.672C365.326 488.418 364.767 488.286 364.2 488.286C363.633 488.286 363.074 488.418 362.567 488.672L323.843 511.017C323.644 511.083 323.472 511.21 323.35 511.38C323.228 511.549 323.162 511.753 323.162 511.962C323.162 512.171 323.228 512.375 323.35 512.544C323.472 512.714 323.644 512.841 323.843 512.907L362.567 535.252C363.072 535.514 363.632 535.651 364.2 535.651C364.768 535.651 365.329 535.514 365.833 535.252L404.523 512.907C405.434 512.374 405.434 511.532 404.523 511.017L365.833 488.672Z",
    fill: "url(#paint19_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.818 488.861C365.314 488.607 364.757 488.475 364.193 488.475C363.629 488.475 363.073 488.607 362.569 488.861L324.154 511.017C323.96 511.082 323.791 511.207 323.672 511.373C323.552 511.54 323.488 511.74 323.488 511.945C323.488 512.15 323.552 512.349 323.672 512.516C323.791 512.682 323.96 512.807 324.154 512.873L362.569 535.045C363.07 535.299 363.623 535.431 364.185 535.431C364.746 535.431 365.3 535.299 365.8 535.045L404.181 512.89C404.373 512.82 404.539 512.693 404.657 512.525C404.774 512.357 404.837 512.158 404.837 511.953C404.837 511.749 404.774 511.549 404.657 511.382C404.539 511.214 404.373 511.087 404.181 511.017L365.818 488.861Z",
    fill: "url(#paint20_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.799 489.085C365.301 488.831 364.75 488.699 364.192 488.699C363.633 488.699 363.082 488.831 362.584 489.085L324.513 511.051C324.319 511.117 324.15 511.241 324.031 511.408C323.911 511.574 323.847 511.774 323.847 511.979C323.847 512.184 323.911 512.384 324.031 512.55C324.15 512.717 324.319 512.842 324.513 512.907L362.584 534.891C363.082 535.144 363.633 535.276 364.192 535.276C364.75 535.276 365.301 535.144 365.799 534.891L403.87 512.924C404.064 512.859 404.233 512.734 404.352 512.567C404.472 512.401 404.536 512.201 404.536 511.996C404.536 511.791 404.472 511.592 404.352 511.425C404.233 511.259 404.064 511.134 403.87 511.068L365.799 489.085Z",
    fill: "url(#paint21_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.799 489.239C365.302 488.994 364.755 488.866 364.2 488.866C363.646 488.866 363.099 488.994 362.602 489.239L324.788 511.017C324.594 511.082 324.425 511.207 324.306 511.374C324.187 511.54 324.122 511.74 324.122 511.945C324.122 512.15 324.187 512.349 324.306 512.516C324.425 512.682 324.594 512.807 324.788 512.873L362.602 534.667C363.099 534.913 363.646 535.041 364.2 535.041C364.755 535.041 365.302 534.913 365.799 534.667L403.613 512.873C403.801 512.804 403.963 512.678 404.078 512.514C404.193 512.35 404.254 512.154 404.254 511.953C404.254 511.753 404.193 511.557 404.078 511.393C403.963 511.228 403.801 511.103 403.613 511.034L365.799 489.239Z",
    fill: "url(#paint22_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.782 489.446C365.293 489.193 364.751 489.06 364.2 489.06C363.65 489.06 363.108 489.193 362.619 489.446L325.184 511.034C324.993 511.099 324.828 511.221 324.712 511.385C324.595 511.548 324.532 511.744 324.532 511.945C324.532 512.146 324.595 512.342 324.712 512.505C324.828 512.668 324.993 512.791 325.184 512.856L362.619 534.478C363.11 534.725 363.651 534.853 364.2 534.853C364.749 534.853 365.291 534.725 365.782 534.478L403.217 512.873C403.407 512.808 403.572 512.685 403.689 512.522C403.806 512.359 403.869 512.163 403.869 511.962C403.869 511.761 403.806 511.565 403.689 511.402C403.572 511.239 403.407 511.116 403.217 511.051L365.782 489.446Z",
    fill: "url(#paint23_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.763 489.635C365.279 489.387 364.743 489.258 364.199 489.258C363.656 489.258 363.12 489.387 362.635 489.635L325.509 511.034C325.319 511.099 325.154 511.221 325.037 511.385C324.92 511.548 324.857 511.744 324.857 511.945C324.857 512.146 324.92 512.341 325.037 512.505C325.154 512.668 325.319 512.791 325.509 512.856L362.635 534.272C363.12 534.519 363.656 534.648 364.199 534.648C364.743 534.648 365.279 534.519 365.763 534.272L402.855 512.856C403.048 512.796 403.216 512.676 403.335 512.513C403.454 512.351 403.519 512.155 403.519 511.953C403.519 511.752 403.454 511.556 403.335 511.393C403.216 511.231 403.048 511.111 402.855 511.051L365.763 489.635Z",
    fill: "url(#paint24_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.748 489.824C365.266 489.579 364.733 489.452 364.193 489.452C363.652 489.452 363.119 489.579 362.637 489.824L325.872 511.051C325.708 511.126 325.568 511.247 325.47 511.4C325.373 511.552 325.321 511.729 325.321 511.91C325.321 512.091 325.373 512.269 325.47 512.421C325.568 512.573 325.708 512.694 325.872 512.77L362.672 534.014C363.154 534.259 363.687 534.386 364.227 534.386C364.768 534.386 365.301 534.259 365.783 534.014L402.565 512.787C402.757 512.727 402.926 512.607 403.045 512.445C403.164 512.282 403.229 512.086 403.229 511.885C403.229 511.683 403.164 511.487 403.045 511.325C402.926 511.162 402.757 511.042 402.565 510.982L365.748 489.824Z",
    fill: "url(#paint25_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.731 490.013C365.253 489.774 364.726 489.649 364.192 489.649C363.658 489.649 363.132 489.774 362.654 490.013L326.181 511.051C326.017 511.126 325.877 511.247 325.779 511.4C325.682 511.552 325.63 511.729 325.63 511.91C325.63 512.091 325.682 512.269 325.779 512.421C325.877 512.573 326.017 512.694 326.181 512.77L362.654 533.825C363.132 534.064 363.658 534.188 364.192 534.188C364.726 534.188 365.253 534.064 365.731 533.825L402.204 512.77C402.374 512.7 402.521 512.581 402.623 512.428C402.726 512.275 402.781 512.095 402.781 511.91C402.781 511.726 402.726 511.546 402.623 511.393C402.521 511.24 402.374 511.121 402.204 511.051L365.731 490.013Z",
    fill: "url(#paint26_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.731 490.202C365.255 489.966 364.732 489.843 364.201 489.843C363.67 489.843 363.147 489.966 362.671 490.202L326.576 511.068C326.406 511.138 326.26 511.257 326.157 511.41C326.054 511.563 325.999 511.743 325.999 511.928C325.999 512.112 326.054 512.292 326.157 512.445C326.26 512.598 326.406 512.717 326.576 512.787L362.671 533.67C363.147 533.907 363.67 534.03 364.201 534.03C364.732 534.03 365.255 533.907 365.731 533.67L401.826 512.804C402.668 512.323 402.668 511.532 401.826 511.085L365.731 490.202Z",
    fill: "url(#paint27_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.714 490.408C365.243 490.177 364.726 490.057 364.201 490.057C363.677 490.057 363.16 490.177 362.689 490.408L326.852 511.034C326.681 511.103 326.535 511.222 326.432 511.375C326.329 511.528 326.274 511.709 326.274 511.893C326.274 512.078 326.329 512.258 326.432 512.411C326.535 512.564 326.681 512.683 326.852 512.753L362.689 533.378C363.16 533.609 363.677 533.729 364.201 533.729C364.726 533.729 365.243 533.609 365.714 533.378L401.534 512.753C401.712 512.69 401.866 512.574 401.975 512.42C402.084 512.266 402.142 512.082 402.142 511.893C402.142 511.704 402.084 511.52 401.975 511.367C401.866 511.213 401.712 511.096 401.534 511.034L365.714 490.408Z",
    fill: "url(#paint28_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.697 490.597C365.234 490.36 364.721 490.237 364.201 490.237C363.681 490.237 363.169 490.36 362.706 490.597L327.178 511.085C327 511.148 326.846 511.264 326.737 511.418C326.628 511.572 326.57 511.756 326.57 511.945C326.57 512.133 326.628 512.317 326.737 512.471C326.846 512.625 327 512.742 327.178 512.804L362.706 533.309C363.169 533.546 363.681 533.67 364.201 533.67C364.721 533.67 365.234 533.546 365.697 533.309L401.19 512.821C401.368 512.759 401.522 512.642 401.631 512.489C401.74 512.335 401.799 512.151 401.799 511.962C401.799 511.773 401.74 511.589 401.631 511.435C401.522 511.281 401.368 511.165 401.19 511.103L365.697 490.597Z",
    fill: "url(#paint29_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.68 490.804C365.219 490.571 364.71 490.45 364.193 490.45C363.677 490.45 363.167 490.571 362.706 490.804L327.591 511.085C327.413 511.148 327.259 511.264 327.15 511.418C327.041 511.572 326.982 511.756 326.982 511.945C326.982 512.133 327.041 512.317 327.15 512.471C327.259 512.625 327.413 512.742 327.591 512.804L362.792 533.12C363.252 533.357 363.762 533.481 364.279 533.481C364.796 533.481 365.306 533.357 365.766 533.12L400.95 512.821C401.775 512.34 401.775 511.567 400.95 511.103L365.68 490.804Z",
    fill: "url(#paint30_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.663 490.975C365.206 490.747 364.703 490.628 364.193 490.628C363.683 490.628 363.18 490.747 362.723 490.975L327.849 511.103C327.662 511.156 327.498 511.269 327.381 511.424C327.264 511.579 327.201 511.768 327.201 511.962C327.201 512.156 327.264 512.345 327.381 512.5C327.498 512.655 327.662 512.768 327.849 512.821L362.723 532.966C363.18 533.194 363.683 533.313 364.193 533.313C364.703 533.313 365.206 533.194 365.663 532.966L400.537 512.839C400.724 512.785 400.888 512.673 401.005 512.517C401.122 512.362 401.185 512.173 401.185 511.979C401.185 511.785 401.122 511.596 401.005 511.441C400.888 511.286 400.724 511.173 400.537 511.12L365.663 490.975Z",
    fill: "url(#paint31_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.662 491.164C365.208 490.936 364.708 490.817 364.201 490.817C363.693 490.817 363.193 490.936 362.74 491.164L328.175 511.103C327.988 511.156 327.823 511.269 327.707 511.424C327.59 511.579 327.526 511.768 327.526 511.962C327.526 512.156 327.59 512.345 327.707 512.5C327.823 512.655 327.988 512.768 328.175 512.821L362.74 532.777C363.193 533.005 363.693 533.124 364.201 533.124C364.708 533.124 365.208 533.005 365.662 532.777L400.192 512.839C400.379 512.785 400.543 512.672 400.66 512.517C400.777 512.362 400.841 512.173 400.841 511.979C400.841 511.785 400.777 511.596 400.66 511.441C400.543 511.286 400.379 511.173 400.192 511.12L365.662 491.164Z",
    fill: "url(#paint32_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.644 491.371C365.198 491.141 364.703 491.022 364.201 491.022C363.698 491.022 363.204 491.141 362.757 491.371L328.518 511.12C327.71 511.567 327.71 512.323 328.518 512.838L362.757 532.605C363.206 532.825 363.7 532.939 364.201 532.939C364.701 532.939 365.195 532.825 365.644 532.605L399.866 512.838C400.064 512.799 400.243 512.691 400.371 512.534C400.499 512.378 400.57 512.182 400.57 511.979C400.57 511.777 400.499 511.58 400.371 511.424C400.243 511.267 400.064 511.16 399.866 511.12L365.644 491.371Z",
    fill: "url(#paint33_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.627 491.56C365.183 491.331 364.691 491.211 364.192 491.211C363.692 491.211 363.2 491.331 362.756 491.56L328.844 511.12C328.646 511.16 328.467 511.267 328.339 511.424C328.211 511.58 328.141 511.777 328.141 511.979C328.141 512.182 328.211 512.378 328.339 512.535C328.467 512.691 328.646 512.799 328.844 512.838L362.756 532.416C363.2 532.645 363.692 532.764 364.192 532.764C364.691 532.764 365.183 532.645 365.627 532.416L399.522 512.856C400.312 512.392 400.312 511.652 399.522 511.137L365.627 491.56Z",
    fill: "url(#paint34_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.612 491.749C365.171 491.528 364.686 491.413 364.194 491.413C363.701 491.413 363.216 491.528 362.776 491.749L329.19 511.12C328.4 511.584 328.4 512.306 329.19 512.839L362.793 532.227C363.233 532.447 363.718 532.562 364.211 532.562C364.703 532.562 365.189 532.447 365.629 532.227L399.214 512.839C399.386 512.782 399.536 512.673 399.642 512.526C399.748 512.379 399.805 512.203 399.805 512.022C399.805 511.841 399.748 511.665 399.642 511.518C399.536 511.372 399.386 511.262 399.214 511.206L365.612 491.749Z",
    fill: "url(#paint35_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.611 491.938C365.174 491.717 364.691 491.602 364.201 491.602C363.712 491.602 363.229 491.717 362.792 491.938L329.516 511.137C329.35 511.197 329.207 511.307 329.105 511.451C329.004 511.596 328.95 511.768 328.95 511.945C328.95 512.121 329.004 512.293 329.105 512.438C329.207 512.582 329.35 512.692 329.516 512.753L362.792 532.055C363.229 532.275 363.712 532.39 364.201 532.39C364.691 532.39 365.174 532.275 365.611 532.055L398.869 512.856C399.041 512.799 399.191 512.69 399.297 512.543C399.403 512.397 399.461 512.22 399.461 512.039C399.461 511.858 399.403 511.682 399.297 511.535C399.191 511.389 399.041 511.279 398.869 511.223L365.611 491.938Z",
    fill: "url(#paint36_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.593 492.127C365.159 491.914 364.683 491.804 364.2 491.804C363.718 491.804 363.241 491.914 362.808 492.127L329.841 511.137C329.676 511.197 329.532 511.307 329.431 511.451C329.33 511.596 329.275 511.768 329.275 511.945C329.275 512.121 329.33 512.293 329.431 512.438C329.532 512.582 329.676 512.692 329.841 512.753L362.808 531.78C363.239 532 363.716 532.115 364.2 532.115C364.684 532.115 365.162 532 365.593 531.78L398.525 512.753C399.298 512.323 399.298 511.601 398.525 511.154L365.593 492.127Z",
    fill: "url(#paint37_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.577 492.333C365.152 492.113 364.681 491.998 364.202 491.998C363.723 491.998 363.252 492.113 362.827 492.333L330.17 511.154C330.008 511.213 329.868 511.321 329.769 511.462C329.671 511.604 329.618 511.772 329.618 511.945C329.618 512.117 329.671 512.285 329.769 512.427C329.868 512.568 330.008 512.676 330.17 512.735L362.827 531.642C363.254 531.854 363.725 531.964 364.202 531.964C364.679 531.964 365.15 531.854 365.577 531.642L398.234 512.735C398.402 512.68 398.548 512.572 398.652 512.429C398.755 512.285 398.811 512.113 398.811 511.936C398.811 511.759 398.755 511.587 398.652 511.443C398.548 511.3 398.402 511.193 398.234 511.137L365.577 492.333Z",
    fill: "url(#paint38_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.559 492.522C365.134 492.31 364.666 492.2 364.192 492.2C363.718 492.2 363.25 492.31 362.826 492.522L330.512 511.154C330.35 511.213 330.211 511.321 330.112 511.463C330.013 511.604 329.96 511.772 329.96 511.945C329.96 512.117 330.013 512.285 330.112 512.427C330.211 512.568 330.35 512.676 330.512 512.735L362.826 531.384C363.248 531.604 363.716 531.719 364.192 531.719C364.668 531.719 365.137 531.604 365.559 531.384L397.855 512.735C398.019 512.68 398.161 512.575 398.262 512.435C398.363 512.295 398.417 512.126 398.417 511.953C398.417 511.78 398.363 511.612 398.262 511.472C398.161 511.331 398.019 511.226 397.855 511.171L365.559 492.522Z",
    fill: "url(#paint39_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.542 492.711C365.123 492.5 364.661 492.39 364.192 492.39C363.724 492.39 363.262 492.5 362.843 492.711L330.856 511.171C330.1 511.601 330.1 512.289 330.856 512.718L362.843 531.195C363.262 531.407 363.724 531.517 364.192 531.517C364.661 531.517 365.123 531.407 365.542 531.195L397.529 512.736C397.692 512.68 397.835 512.575 397.936 512.435C398.037 512.295 398.091 512.126 398.091 511.953C398.091 511.781 398.037 511.612 397.936 511.472C397.835 511.332 397.692 511.226 397.529 511.171L365.542 492.711Z",
    fill: "url(#paint40_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.542 492.901C365.126 492.689 364.667 492.579 364.201 492.579C363.735 492.579 363.276 492.689 362.86 492.901L331.183 511.171C331.025 511.23 330.889 511.336 330.793 511.474C330.696 511.612 330.645 511.776 330.645 511.945C330.645 512.113 330.696 512.278 330.793 512.416C330.889 512.554 331.025 512.66 331.183 512.718L362.86 531.006C363.276 531.218 363.735 531.328 364.201 531.328C364.667 531.328 365.126 531.218 365.542 531.006L397.202 512.736C397.36 512.677 397.496 512.571 397.592 512.433C397.688 512.295 397.74 512.13 397.74 511.962C397.74 511.794 397.688 511.629 397.592 511.491C397.496 511.353 397.36 511.247 397.202 511.189L365.542 492.901Z",
    fill: "url(#paint41_linear_1606_3980)",
    fillOpacity: 0.15
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M400.397 470.797H328.207V511.515C328.224 511.694 328.288 511.865 328.394 512.01C328.5 512.156 328.643 512.269 328.809 512.34L362.841 532.055C363.288 532.284 363.783 532.403 364.285 532.403C364.787 532.403 365.282 532.284 365.728 532.055L399.778 512.357C399.942 512.281 400.084 512.163 400.19 512.015C400.295 511.868 400.361 511.695 400.379 511.515L400.397 470.797Z",
    fill: "#2C2067"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M399.781 482.742L365.714 502.422C365.265 502.643 364.771 502.757 364.27 502.757C363.77 502.757 363.276 502.643 362.826 502.422L328.76 482.725C328.597 482.656 328.455 482.545 328.349 482.403C328.244 482.261 328.178 482.093 328.158 481.917V487.555C328.177 487.733 328.242 487.904 328.348 488.049C328.453 488.194 328.595 488.308 328.76 488.38L362.844 507.991C363.29 508.221 363.785 508.34 364.287 508.34C364.79 508.34 365.284 508.221 365.731 507.991L399.781 488.38C399.946 488.309 400.089 488.195 400.195 488.05C400.301 487.905 400.366 487.734 400.382 487.555V481.917C400.364 482.096 400.299 482.266 400.193 482.411C400.087 482.556 399.945 482.67 399.781 482.742Z",
    fill: "#352685"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M399.78 497.85L365.714 517.531C365.264 517.751 364.77 517.865 364.27 517.865C363.769 517.865 363.275 517.751 362.826 517.531L328.742 497.833C328.579 497.764 328.438 497.653 328.332 497.511C328.226 497.369 328.16 497.201 328.141 497.025V502.663C328.157 502.842 328.222 503.013 328.328 503.158C328.434 503.304 328.577 503.418 328.742 503.488L362.826 523.168C363.273 523.398 363.768 523.517 364.27 523.517C364.772 523.517 365.267 523.398 365.714 523.168L399.78 503.505C399.945 503.429 400.087 503.311 400.192 503.164C400.298 503.016 400.363 502.843 400.382 502.663V497.025C400.363 497.204 400.298 497.374 400.192 497.519C400.087 497.664 399.945 497.778 399.78 497.85Z",
    fill: "#352685"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M365.729 450.291C365.283 450.062 364.788 449.943 364.285 449.943C363.783 449.943 363.288 450.062 362.842 450.291L328.758 469.954C328.53 469.954 328.311 470.045 328.15 470.206C327.989 470.367 327.898 470.586 327.898 470.814C327.898 471.042 327.989 471.26 328.15 471.422C328.311 471.583 328.53 471.673 328.758 471.673L362.842 491.371C363.291 491.591 363.785 491.705 364.285 491.705C364.786 491.705 365.28 491.591 365.729 491.371L399.779 471.622C399.977 471.582 400.156 471.474 400.284 471.318C400.412 471.161 400.483 470.965 400.483 470.762C400.483 470.56 400.412 470.364 400.284 470.207C400.156 470.05 399.977 469.943 399.779 469.903L365.729 450.291Z",
    fill: "#7564C9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M349.178 461.687C357.479 456.891 371.058 456.891 379.36 461.687C387.661 466.482 387.679 474.32 379.36 479.116C371.041 483.911 357.479 483.911 349.178 479.116C340.876 474.32 340.876 466.482 349.178 461.687Z",
    fill: "url(#paint42_radial_1606_3980)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M390.104 446.235C390.104 445.582 389.21 445.066 388.11 445.066H383.813C383.108 445.066 381.94 445.805 381.75 445.582C381.561 445.358 381.561 444.774 382.077 444.482L385.102 442.763C385.876 442.299 380.908 442.522 380.118 442.058V438.294C379.677 438.065 379.188 437.945 378.691 437.945C378.194 437.945 377.705 438.065 377.264 438.294L374.222 440.013C373.66 440.299 373.012 440.373 372.4 440.219L371.077 439.91C370.441 439.755 370.028 439.411 370.028 439.016V436.524C370.028 435.888 369.134 435.372 368.034 435.372H361.039C359.939 435.372 359.045 435.888 359.045 436.524V438.999C359.045 439.394 358.581 439.755 357.928 439.893C357.275 440.03 357.086 440.082 356.673 440.202C356.041 440.369 355.369 440.301 354.783 440.013L351.74 438.294C351.3 438.073 350.815 437.958 350.322 437.958C349.83 437.958 349.344 438.073 348.904 438.294L348.543 442.402C347.753 442.866 343.198 442.402 343.988 442.78L347.048 444.499C347.529 444.774 347.667 445.186 347.409 445.547C347.151 445.908 346.017 445.066 345.329 445.066H340.998C339.898 445.066 339.004 445.582 339.004 446.218V452.096C339.004 452.732 339.915 453.248 341.015 453.248H343.524V458.095C343.507 458.18 343.507 458.267 343.524 458.352C343.559 458.505 343.628 458.648 343.727 458.77C343.825 458.892 343.95 458.991 344.092 459.057L349.042 461.876C349.568 462.157 350.169 462.266 350.76 462.185C351.126 462.148 351.482 462.043 351.809 461.876L354.851 460.157C355.414 459.871 356.061 459.797 356.673 459.951L357.979 460.26C358.615 460.398 359.045 460.759 359.045 461.137V463.629C359.045 464.265 359.939 464.781 361.056 464.781H368.034C369.134 464.781 370.045 464.265 370.028 463.629V461.154C370.028 460.742 370.492 460.398 371.145 460.26L372.331 459.968C372.969 459.791 373.649 459.858 374.239 460.157L377.264 461.876C377.589 462.047 377.946 462.147 378.313 462.168C378.902 462.249 379.502 462.147 380.032 461.876L384.965 459.023C385.1 458.96 385.22 458.869 385.317 458.756C385.415 458.644 385.488 458.512 385.532 458.37V458.146V453.196H388.007C389.124 453.196 390.018 452.68 390.018 452.044L390.104 446.235ZM374.325 451.116C373.156 454.674 366.763 456.685 361.022 455.396C356.656 454.434 353.992 451.718 354.851 449.071C356.02 445.513 362.414 443.519 368.155 444.791C372.521 445.754 375.185 448.469 374.325 451.116Z",
    fill: "#5A3CFF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M385.704 439.549V436.403H381.183L380.186 435.819C379.743 435.598 379.255 435.483 378.76 435.483C378.264 435.483 377.776 435.598 377.333 435.819L376.336 436.403H370.097V434.083C370.097 433.447 369.203 432.931 368.103 432.931H361.108C360.008 432.931 359.114 433.447 359.114 434.083V436.386H352.771L351.809 435.836C351.37 435.611 350.884 435.494 350.391 435.494C349.898 435.494 349.412 435.611 348.973 435.836L348.027 436.386H343.473V439.463C343.48 439.646 343.538 439.824 343.642 439.976C343.745 440.128 343.889 440.248 344.057 440.322L347.117 442.041H382.094L385.119 440.322C385.269 440.257 385.399 440.155 385.498 440.026C385.597 439.897 385.662 439.744 385.686 439.583L385.704 439.549Z",
    fill: "#5A3CFF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M382.593 447.696H388.058C389.176 447.696 390.069 447.18 390.069 446.544V442.522C390.069 441.886 389.176 441.371 388.076 441.371H383.779C383.487 441.392 383.194 441.345 382.922 441.235C382.651 441.125 382.409 440.954 382.215 440.735C382.06 440.511 381.905 440.271 381.716 440.047C381.527 439.824 381.527 439.239 382.043 438.964L385.068 437.246C385.24 437.189 385.389 437.08 385.496 436.933C385.602 436.786 385.659 436.61 385.659 436.429C385.659 436.248 385.602 436.072 385.496 435.925C385.389 435.779 385.24 435.669 385.068 435.613L380.135 432.777C379.692 432.556 379.203 432.441 378.708 432.441C378.213 432.441 377.725 432.556 377.282 432.777L374.239 434.495C373.677 434.782 373.03 434.855 372.417 434.702L371.094 434.392C370.458 434.255 370.045 433.894 370.045 433.499V431.024C370.045 430.388 369.152 429.855 368.052 429.855H361.056C359.956 429.855 359.062 430.388 359.062 431.024V433.481C359.062 433.894 358.598 434.238 357.945 434.392L356.69 434.685C356.06 434.857 355.389 434.796 354.8 434.513L351.757 432.794C351.319 432.569 350.832 432.452 350.339 432.452C349.846 432.452 349.36 432.569 348.921 432.794L343.988 435.63C343.816 435.686 343.667 435.796 343.561 435.942C343.455 436.089 343.397 436.265 343.397 436.446C343.397 436.627 343.455 436.804 343.561 436.95C343.667 437.097 343.816 437.206 343.988 437.263L347.048 438.982C347.529 439.257 347.667 439.669 347.409 440.03L346.876 440.786C346.68 440.998 346.44 441.163 346.172 441.27C345.905 441.377 345.617 441.423 345.329 441.405H340.998C339.898 441.405 339.004 441.921 339.004 442.557V446.579C339.004 447.215 339.915 447.73 341.015 447.73H345.295C345.59 447.704 345.887 447.747 346.162 447.858C346.437 447.969 346.682 448.143 346.876 448.366C347.025 448.603 347.185 448.833 347.357 449.054C347.667 449.415 347.564 449.844 347.048 450.137L344.023 451.855C343.851 451.912 343.701 452.021 343.595 452.168C343.489 452.314 343.432 452.491 343.432 452.672C343.432 452.853 343.489 453.029 343.595 453.176C343.701 453.322 343.851 453.432 344.023 453.488L348.973 456.324C349.413 456.545 349.899 456.66 350.391 456.66C350.883 456.66 351.369 456.545 351.809 456.324L354.851 454.605C355.416 454.328 356.06 454.255 356.673 454.399C357.103 454.52 357.584 454.623 357.979 454.709C358.375 454.795 359.045 455.207 359.045 455.602V458.146C359.045 458.782 359.939 459.298 361.056 459.298H368.034C369.134 459.298 370.045 458.782 370.028 458.146V455.688C370.028 455.276 370.492 454.915 371.145 454.777L372.331 454.502C372.967 454.319 373.647 454.381 374.239 454.674L377.264 456.393C377.704 456.614 378.19 456.729 378.682 456.729C379.175 456.729 379.66 456.614 380.1 456.393L385.033 453.557C385.824 453.093 385.824 452.371 385.033 451.924L381.974 450.205C381.493 449.93 381.355 449.501 381.63 449.157C382.163 448.469 382.593 447.833 382.593 447.696ZM354.8 443.519C355.968 439.978 362.362 437.967 368.103 439.239C372.469 440.219 375.133 442.935 374.274 445.582C373.105 449.122 366.711 451.133 360.97 449.862C356.656 448.882 353.992 446.115 354.851 443.519H354.8Z",
    fill: "#5C629E"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M689.346 114.988C688.835 114.988 688.332 114.859 687.884 114.613C687.436 114.366 687.058 114.01 686.785 113.578L678.037 99.484C676.287 96.674 675.459 93.3876 675.669 90.084C675.878 86.7804 677.115 83.6249 679.205 81.0585L686.081 72.7051C686.596 72.1251 687.315 71.7666 688.089 71.7045C688.862 71.6424 689.629 71.8814 690.23 72.3717C690.832 72.862 691.22 73.5656 691.315 74.3356C691.41 75.1055 691.203 75.8823 690.739 76.5037L683.863 84.857C682.563 86.4507 681.794 88.4117 681.664 90.4647C681.535 92.5178 682.051 94.5598 683.141 96.3043L691.907 110.398C692.323 111.079 692.453 111.895 692.269 112.671C692.086 113.447 691.604 114.119 690.928 114.541C690.455 114.839 689.905 114.994 689.346 114.988Z",
    fill: "#F2B1B5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M682.006 85.8197C681.357 85.8186 680.722 85.6339 680.173 85.2868C679.625 84.9396 679.186 84.4443 678.907 83.8582C678.629 83.272 678.522 82.6189 678.598 81.9744C678.675 81.3299 678.933 80.7204 679.342 80.2164L685.667 72.4302C686.244 71.7214 687.079 71.2706 687.988 71.1771C688.897 71.0837 689.806 71.3551 690.514 71.9318C691.223 72.5084 691.674 73.343 691.767 74.252C691.861 75.161 691.589 76.0699 691.013 76.7788L684.67 84.5478C684.349 84.9443 683.943 85.2643 683.482 85.4843C683.021 85.7043 682.517 85.8189 682.006 85.8197Z",
    fill: "#5A3CFF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M690.994 186.404C688.691 186.404 686.732 186.868 686.543 184.548L684.291 148.109L686.543 108.92C686.573 108.335 686.72 107.761 686.974 107.232C687.228 106.703 687.584 106.23 688.022 105.84C688.46 105.45 688.971 105.151 689.525 104.96C690.08 104.769 690.667 104.689 691.252 104.726C693.71 104.864 701.17 106.978 701.032 109.436L694.346 148.006L695.446 183.808C695.652 186.266 693.813 186.198 691.355 186.387L690.994 186.404Z",
    fill: "#5A3CFF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M705.588 193.296C703.13 193.296 701.136 193.52 701.136 191.062L694.742 111.739C694.742 109.281 703.13 111.602 705.588 111.602C706.175 111.599 706.757 111.713 707.301 111.937C707.844 112.161 708.337 112.49 708.753 112.906C709.168 113.321 709.497 113.815 709.721 114.358C709.945 114.901 710.059 115.483 710.057 116.071V191.062C710.057 193.451 708.063 193.296 705.588 193.296Z",
    fill: "#5A3CFF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M696.085 65.0394L698.783 66.6035C707.721 71.7599 712.327 78.5148 711.709 88.8276C711.021 100.619 711.949 124.544 711.949 124.544C702.464 124.407 693.135 122.109 684.672 117.824C687.044 102.63 684.775 92.6261 684.775 82.4336C684.775 72.2411 689.622 61.3096 696.085 65.0394Z",
    fill: "#5A3CFF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M698.525 74.0116H696.102C695.596 74.0116 695.111 73.8106 694.753 73.4528C694.395 73.095 694.194 72.6097 694.194 72.1037V63.8191H700.416V72.1037C700.416 72.6068 700.217 73.0895 699.863 73.4468C699.509 73.8041 699.028 74.0071 698.525 74.0116Z",
    fill: "#F2B1B5"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M700.431 66.827L702.15 67.738L699.52 82.3822L696.031 73.7366L700.431 66.827Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M696.03 73.7366L694.208 64.4551H693.4L689.877 76.7445L696.03 73.7366Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M702.122 64.5767L695.38 65.9215C693.359 66.3246 691.261 65.9084 689.547 64.7646C687.833 63.6207 686.644 61.8429 686.241 59.8223L683.992 48.5456L701.202 45.113L704.403 61.1599C704.553 61.9154 704.398 62.6998 703.97 63.3406C703.542 63.9814 702.878 64.426 702.122 64.5767Z",
    fill: "#F2B1B5"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M696.306 51.6328C696.98 51.9527 697.576 52.415 698.054 52.9877C698.532 53.5604 698.88 54.2299 699.074 54.9501C699.331 55.947 699.073 56.3423 698.523 57.2189C698.208 57.6941 698.09 58.274 698.197 58.8346C698.208 58.8992 698.238 58.9591 698.283 59.0065C698.344 59.0304 698.411 59.0304 698.472 59.0065C699.039 59.0924 699.503 58.6111 699.847 58.1471C700.191 57.683 701.119 56.8408 701.91 57.5627C702.7 58.2846 702.202 59.2815 701.91 60.0549C701.617 60.8284 701.016 63.2003 702.116 63.991C703.216 64.7816 704.9 63.8019 705.691 63.3035L706.035 63.0628C708.372 61.2409 708.011 57.6142 708.372 55.0017C708.483 52.9803 708.297 50.9537 707.822 48.9859C707.547 46.9749 707.599 45.1186 706.103 43.5201C705.449 42.7595 704.534 42.2722 703.537 42.1544C702.541 42.0367 701.537 42.2971 700.724 42.8841C699.842 41.8896 698.61 41.2738 697.286 41.1653C695.953 41.071 694.614 41.1403 693.298 41.3716C690.959 41.6615 688.73 42.5364 686.818 43.9154C685.875 44.641 685 45.4523 684.206 46.3389C683.854 46.7384 683.615 47.225 683.516 47.7481C683.416 48.2712 683.458 48.8114 683.639 49.3124C683.949 50.5474 684.417 51.7373 685.031 52.8532C685.153 52.7378 685.237 52.5878 685.272 52.4235C685.413 51.3407 685.827 50.3116 686.475 49.4327C687.265 48.5733 688.004 48.7624 689.07 49.1406C689.378 49.2442 689.668 49.395 689.929 49.5874C690.6 50.1375 690.411 51.014 691.201 51.5125C691.863 51.873 692.639 51.9653 693.367 51.7703C694.092 51.5877 694.836 51.4897 695.584 51.4781C695.83 51.5036 696.072 51.5555 696.306 51.6328Z",
    fill: "#5A3CFF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M700.572 58.1297C700.508 57.8827 700.373 57.66 700.183 57.4889C699.994 57.3179 699.758 57.206 699.506 57.1672C699.092 57.1585 698.691 57.3128 698.389 57.5969L698.045 57.8547C697.507 58.3893 696.855 58.794 696.137 59.0383C695.419 59.2825 694.655 59.3598 693.903 59.2642C692.227 58.5143 690.368 58.2752 688.557 58.5766C687.966 58.659 687.418 58.9304 686.993 59.3501C686.663 59.8377 686.493 60.4165 686.509 61.0054C686.524 61.5942 686.724 62.1634 687.079 62.633C687.788 63.6521 688.723 64.4929 689.812 65.0893C690.9 65.6858 692.113 66.0217 693.353 66.0706C695.088 66.2849 696.84 65.8301 698.251 64.7987C699.637 63.4235 700.474 61.5903 700.606 59.6423C700.707 59.1418 700.695 58.6251 700.572 58.1297Z",
    fill: "#5A3CFF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M749.091 201.272V157.648L574.271 122.224V166.277H574.426C574.696 166.844 575.142 167.308 575.698 167.6L689.036 233.482C690.103 234.016 691.28 234.294 692.473 234.294C693.667 234.294 694.844 234.016 695.911 233.482L747.733 203.558C748.178 203.377 748.551 203.056 748.796 202.643C749.041 202.23 749.145 201.749 749.091 201.272Z",
    fill: "#2C2067"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M747.733 196.287L695.911 226.211C694.845 226.749 693.668 227.029 692.473 227.029C691.279 227.029 690.102 226.749 689.036 226.211L575.698 160.33C575.143 160.044 574.697 159.586 574.426 159.023H574.271V166.294H574.426C574.696 166.861 575.142 167.325 575.698 167.617L689.036 233.499C690.103 234.033 691.28 234.311 692.473 234.311C693.667 234.311 694.844 234.033 695.911 233.499L747.733 203.575C748.178 203.394 748.551 203.073 748.796 202.66C749.041 202.247 749.145 201.766 749.091 201.289V194.018C749.141 194.492 749.036 194.97 748.791 195.379C748.546 195.789 748.175 196.107 747.733 196.287Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M747.733 181.763L695.911 211.688C694.844 212.221 693.667 212.499 692.473 212.499C691.28 212.499 690.103 212.221 689.036 211.688L575.698 145.806C575.14 145.524 574.693 145.065 574.426 144.5H574.271V151.77H574.426C574.697 152.332 575.143 152.791 575.698 153.076L689.036 218.958C690.103 219.492 691.28 219.77 692.473 219.77C693.667 219.77 694.844 219.492 695.911 218.958L747.733 189.034C748.179 188.85 748.553 188.526 748.798 188.11C749.043 187.694 749.146 187.21 749.091 186.731V179.477C749.142 179.954 749.037 180.434 748.792 180.846C748.548 181.258 748.176 181.58 747.733 181.763Z",
    fill: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M747.733 167.222L695.911 197.146C694.845 197.684 693.668 197.964 692.473 197.964C691.279 197.964 690.102 197.684 689.036 197.146L575.698 131.265C575.143 130.979 574.697 130.521 574.426 129.958H574.271V137.229H574.426C574.696 137.796 575.142 138.26 575.698 138.552L689.036 204.434C690.103 204.968 691.28 205.246 692.473 205.246C693.667 205.246 694.844 204.968 695.911 204.434L747.733 174.544C748.178 174.363 748.551 174.042 748.796 173.63C749.041 173.217 749.145 172.735 749.091 172.258V164.988C749.133 165.456 749.024 165.926 748.78 166.328C748.535 166.731 748.168 167.044 747.733 167.222Z",
    fill: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M627.006 90.0824C628.071 89.5418 629.249 89.2601 630.443 89.2601C631.638 89.2601 632.815 89.5418 633.881 90.0824L747.751 156.033C748.168 156.169 748.531 156.434 748.788 156.789C749.046 157.144 749.184 157.571 749.184 158.009C749.184 158.448 749.046 158.875 748.788 159.23C748.531 159.585 748.168 159.85 747.751 159.986L695.929 189.91C694.862 190.444 693.685 190.722 692.492 190.722C691.298 190.722 690.121 190.444 689.054 189.91L575.717 124.029C575.302 123.888 574.942 123.62 574.687 123.264C574.432 122.908 574.295 122.481 574.295 122.043C574.295 121.606 574.432 121.179 574.687 120.823C574.942 120.467 575.302 120.199 575.717 120.058L627.006 90.0824Z",
    fill: "#7564C9"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M680.561 155.448L704.487 144.517C705.006 144.228 705.439 143.805 705.74 143.293C706.041 142.781 706.199 142.198 706.199 141.603C706.199 141.009 706.041 140.426 705.74 139.914C705.439 139.402 705.006 138.979 704.487 138.69L668.083 117.635L641.184 133.62L680.561 155.448Z",
    fill: "url(#paint43_linear_1606_3980)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M680.565 154.451L704.49 143.606C704.988 143.298 705.398 142.867 705.683 142.356C705.968 141.845 706.117 141.269 706.117 140.684C706.117 140.099 705.968 139.523 705.683 139.012C705.398 138.5 704.988 138.07 704.49 137.762L666.539 115.71C665.925 115.347 665.224 115.155 664.511 115.155C663.797 115.155 663.097 115.347 662.483 115.71L637.629 130.491L680.565 154.451Z",
    fill: "url(#paint44_linear_1606_3980)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M677.316 152.337L698.165 143.038C698.612 142.787 698.984 142.422 699.243 141.979C699.502 141.537 699.639 141.033 699.639 140.52C699.639 140.008 699.502 139.504 699.243 139.062C698.984 138.619 698.612 138.253 698.165 138.002L664.854 118.752L641.65 132.502L677.316 152.337Z",
    fill: "#5C629E"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M634.137 102.801L634.687 102.647C634.935 102.573 635.195 102.549 635.452 102.579C635.709 102.609 635.958 102.69 636.182 102.819L675.715 125.421C676.212 125.736 676.628 126.166 676.927 126.674C677.226 127.182 677.399 127.754 677.433 128.343L681.008 155.397C681.007 155.523 680.975 155.647 680.915 155.757C680.855 155.868 680.769 155.963 680.665 156.033L680.08 156.445L639.482 132.898C638.987 132.584 638.572 132.157 638.274 131.652C637.975 131.147 637.8 130.578 637.763 129.993L634.137 102.801Z",
    fill: "url(#paint45_linear_1606_3980)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M633.658 103.884C633.658 102.819 634.414 102.372 635.377 102.905L675.219 125.902C675.712 126.223 676.124 126.654 676.422 127.161C676.721 127.668 676.897 128.237 676.938 128.824L680.685 155.294C680.685 156.359 679.928 156.806 678.966 156.273L638.952 133.379C638.457 133.064 638.044 132.637 637.745 132.132C637.447 131.627 637.271 131.059 637.233 130.474L633.658 103.884Z",
    fill: "url(#paint46_linear_1606_3980)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M653.647 127.397C654.595 127.833 655.44 128.464 656.127 129.249C656.815 130.034 657.328 130.955 657.635 131.952C658.185 133.877 657.308 134.995 655.675 134.427C654.731 133.986 653.889 133.354 653.202 132.569C652.516 131.785 652 130.867 651.688 129.873C651.138 127.947 652.014 126.83 653.647 127.397Z",
    fill: "#5C629E"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M695.052 103.197H694.915C693.788 103.161 692.713 102.718 691.888 101.95C691.063 101.182 690.544 100.141 690.429 99.02L687.352 69.2332C687.311 68.8393 687.349 68.4413 687.462 68.0618C687.575 67.6824 687.762 67.329 688.012 67.0217C688.261 66.7145 688.569 66.4595 688.918 66.2712C689.266 66.0829 689.648 65.9651 690.042 65.9245C690.436 65.8839 690.834 65.9212 691.213 66.0344C691.593 66.1476 691.946 66.3344 692.253 66.5842C692.56 66.834 692.816 67.1418 693.004 67.4902C693.192 67.8385 693.31 68.2205 693.35 68.6144L695.929 93.7605L703.13 79.6835C703.493 78.9723 704.123 78.4343 704.882 78.1877C705.641 77.9411 706.467 78.0062 707.178 78.3686C707.889 78.731 708.427 79.3611 708.674 80.1202C708.921 80.8793 708.855 81.7052 708.493 82.4164L699.177 100.636C698.792 101.401 698.202 102.044 697.475 102.496C696.747 102.948 695.909 103.19 695.052 103.197Z",
    fill: "#F2B1B5"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M702.132 91.5262C701.58 91.5302 701.036 91.3942 700.551 91.1308C700.15 90.9223 699.794 90.6368 699.503 90.2906C699.213 89.9444 698.994 89.5444 698.858 89.1134C698.722 88.6823 698.673 88.2288 698.713 87.7787C698.752 87.3285 698.88 86.8906 699.09 86.4901L702.768 79.4946C703.204 78.7098 703.93 78.1269 704.79 77.8702C705.65 77.6136 706.577 77.7037 707.371 78.1213C708.166 78.5389 708.766 79.2508 709.043 80.1048C709.319 80.9588 709.251 81.8872 708.852 82.6915L705.191 89.687C704.899 90.2443 704.458 90.7105 703.919 91.0349C703.379 91.3592 702.761 91.5291 702.132 91.5262Z",
    fill: "#5A3CFF"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M692.698 68.924C692.597 68.9413 692.494 68.9384 692.395 68.9158C692.296 68.8931 692.202 68.851 692.119 68.7919C692.036 68.7328 691.965 68.6579 691.911 68.5714C691.857 68.4849 691.821 68.3886 691.804 68.2881L690.859 62.152C690.841 62.0525 690.844 61.9506 690.867 61.8523C690.89 61.754 690.933 61.6613 690.992 61.5796C691.051 61.4979 691.126 61.4289 691.212 61.3766C691.299 61.3244 691.395 61.29 691.495 61.2754C691.594 61.2582 691.696 61.2612 691.794 61.2841C691.893 61.307 691.985 61.3493 692.067 61.4085C692.149 61.4678 692.218 61.5428 692.27 61.6292C692.322 61.7155 692.357 61.8115 692.371 61.9113L693.334 68.0474C693.364 68.2477 693.314 68.4517 693.195 68.6156C693.076 68.7795 692.897 68.8902 692.698 68.924Z",
    fill: "#F2B1B5"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M692.526 71.8286C692.433 71.7892 692.348 71.7317 692.276 71.6593C692.205 71.587 692.148 71.5013 692.11 71.4071C692.071 71.3129 692.052 71.2121 692.053 71.1104C692.053 71.0087 692.074 70.9082 692.114 70.8145L694.486 65.0909C694.566 64.9015 694.716 64.7507 694.906 64.6704C695.095 64.5902 695.308 64.5869 695.5 64.6612C695.594 64.7006 695.679 64.7582 695.75 64.8305C695.822 64.9028 695.878 64.9885 695.916 65.0827C695.955 65.1769 695.974 65.2777 695.973 65.3794C695.973 65.4811 695.952 65.5817 695.912 65.6753L693.54 71.4161C693.457 71.6024 693.305 71.7494 693.116 71.8263C692.927 71.9031 692.716 71.904 692.526 71.8286Z",
    fill: "#F2B1B5"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M691.58 71.1584C691.48 71.1756 691.379 71.1726 691.28 71.1497C691.182 71.1268 691.089 71.0845 691.008 71.0253C690.926 70.966 690.857 70.891 690.805 70.8046C690.752 70.7183 690.718 70.6224 690.703 70.5225L689.741 64.3864C689.711 64.1861 689.761 63.9821 689.88 63.8182C689.999 63.6543 690.177 63.5436 690.377 63.5098C690.477 63.4926 690.58 63.4954 690.68 63.518C690.779 63.5407 690.873 63.5828 690.956 63.6419C691.039 63.701 691.11 63.776 691.164 63.8624C691.218 63.9489 691.254 64.0452 691.271 64.1457L692.233 70.2818C692.258 70.484 692.204 70.6879 692.082 70.8512C691.961 71.0145 691.781 71.1246 691.58 71.1584Z",
    fill: "#F2B1B5"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M690.258 72.2756C690.055 72.3051 689.849 72.2529 689.684 72.1304C689.52 72.0079 689.411 71.8252 689.381 71.6224L688.419 65.5035C688.402 65.4028 688.405 65.2996 688.429 65.2003C688.453 65.101 688.497 65.0076 688.558 64.9257C688.619 64.8437 688.696 64.775 688.784 64.7237C688.873 64.6723 688.971 64.6394 689.072 64.6269C689.171 64.6098 689.273 64.6128 689.372 64.6356C689.47 64.6585 689.563 64.7008 689.644 64.7601C689.726 64.8194 689.795 64.8944 689.847 64.9807C689.899 65.0671 689.934 65.163 689.949 65.2629L690.911 71.3818C690.928 71.4835 690.925 71.5877 690.901 71.688C690.877 71.7884 690.834 71.883 690.773 71.9663C690.712 72.0496 690.635 72.1198 690.547 72.1729C690.458 72.2261 690.36 72.261 690.258 72.2756Z",
    fill: "#F2B1B5"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M688.865 73.1349C688.765 73.1521 688.662 73.1493 688.562 73.1266C688.463 73.104 688.369 73.0619 688.286 73.0028C688.203 72.9436 688.132 72.8687 688.078 72.7822C688.024 72.6958 687.988 72.5995 687.971 72.4989L687.026 66.3628C686.996 66.1625 687.046 65.9585 687.165 65.7946C687.284 65.6307 687.462 65.52 687.662 65.4862C687.762 65.469 687.865 65.4718 687.965 65.4945C688.064 65.5171 688.158 65.5592 688.241 65.6183C688.324 65.6774 688.395 65.7524 688.449 65.8389C688.503 65.9253 688.539 66.0216 688.556 66.1222L689.501 72.2583C689.531 72.4586 689.481 72.6626 689.362 72.8265C689.243 72.9904 689.065 73.1011 688.865 73.1349Z",
    fill: "#F2B1B5"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M530.407 259.006L529.754 257.889L626.093 202.269C627.685 201.352 629.007 200.032 629.927 198.442C630.847 196.852 631.333 195.048 631.335 193.21V175.163H632.624V193.21C632.62 195.272 632.074 197.297 631.043 199.083C630.011 200.868 628.53 202.352 626.746 203.386L530.407 259.006Z",
    fill: "#5A3CFF"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M631.268 172.533C630.151 171.897 629.24 172.43 629.24 173.719C629.293 174.409 629.503 175.078 629.854 175.674C630.206 176.27 630.69 176.777 631.268 177.157C632.386 177.793 633.297 177.26 633.297 175.971C633.24 175.282 633.029 174.614 632.677 174.019C632.326 173.424 631.844 172.916 631.268 172.533Z",
    fill: "#5A3CFF"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M522.606 254.709L521.953 253.592L618.292 197.971C619.884 197.054 621.206 195.735 622.126 194.145C623.047 192.555 623.532 190.75 623.534 188.913V170.866H624.823V188.913C624.819 190.975 624.274 193 623.242 194.786C622.211 196.571 620.729 198.055 618.945 199.089L522.606 254.709Z",
    fill: "#5A3CFF"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M623.704 168.167C622.587 167.514 621.676 168.047 621.676 169.336C621.714 170.041 621.917 170.728 622.27 171.34C622.622 171.952 623.113 172.473 623.704 172.86C624.821 173.513 625.749 172.98 625.732 171.691C625.694 170.986 625.491 170.299 625.138 169.687C624.786 169.075 624.295 168.555 623.704 168.167Z",
    fill: "#5A3CFF"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M310.111 319.095L193.748 248.934C193.017 248.507 192.41 247.896 191.989 247.162C191.567 246.427 191.346 245.595 191.346 244.749C191.346 243.902 191.567 243.07 191.989 242.336C192.41 241.602 193.017 240.99 193.748 240.563L244.796 210.88C245.495 210.474 246.076 209.893 246.48 209.193C246.884 208.493 247.097 207.7 247.099 206.892V190.46L248.389 189.635V206.823C248.395 207.865 248.127 208.891 247.611 209.796C247.095 210.701 246.349 211.454 245.449 211.98L194.401 241.663C193.862 241.974 193.414 242.421 193.103 242.96C192.792 243.498 192.628 244.109 192.628 244.732C192.628 245.354 192.792 245.965 193.103 246.503C193.414 247.042 193.862 247.489 194.401 247.8L310.111 317.566V319.095Z",
    fill: "#231F20"
  }))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M316.453 310.828L193.748 236.919C193.017 236.492 192.41 235.881 191.989 235.147C191.567 234.413 191.346 233.581 191.346 232.734C191.346 231.888 191.567 231.056 191.989 230.321C192.41 229.587 193.017 228.976 193.748 228.549L244.796 198.865C245.495 198.46 246.076 197.878 246.48 197.179C246.884 196.479 247.097 195.686 247.099 194.878V187.04L248.389 186.215V194.809C248.395 195.851 248.127 196.876 247.611 197.781C247.095 198.686 246.349 199.44 245.449 199.965L194.401 229.649C193.862 229.959 193.414 230.407 193.103 230.945C192.792 231.484 192.628 232.095 192.628 232.717C192.628 233.339 192.792 233.95 193.103 234.489C193.414 235.027 193.862 235.475 194.401 235.785L317.313 309.694L316.453 310.828Z",
    fill: "#5A3CFF"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M269.977 198.814L304.216 178.91V176.796L287.492 168.872L252.789 186.782V188.896L269.977 198.814Z",
    fill: "url(#paint47_linear_1606_3980)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M269.977 196.7L304.216 176.796L287.492 166.758L252.789 186.782L269.977 196.7Z",
    fill: "#F9F7F9"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M262.361 189.91L262.275 147.886C262.358 146.474 262.768 145.102 263.472 143.876C264.176 142.65 265.155 141.604 266.332 140.821L286.029 129.288C288.264 127.982 290.086 129.03 290.086 131.626V174.802L264.63 190.89L262.361 189.91Z",
    fill: "url(#paint48_linear_1606_3980)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M264.596 190.89V147.92C264.676 146.508 265.084 145.135 265.788 143.908C266.493 142.682 267.473 141.637 268.652 140.856L288.35 129.323C290.584 128.016 292.406 129.065 292.406 131.66V174.836L264.596 190.89Z",
    fill: "#EBE9EC"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M268.652 140.821L288.35 129.288C290.584 127.982 292.406 129.03 292.406 131.626V165.641L264.596 181.729V147.886C264.676 146.474 265.084 145.1 265.788 143.874C266.493 142.647 267.473 141.602 268.652 140.821Z",
    fill: "#B6B6B6"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M324.151 63.2519C324.587 63.6476 324.935 64.1307 325.172 64.6696C325.409 65.2086 325.53 65.7914 325.526 66.3801V136.851C325.448 138.263 325.039 139.637 324.331 140.861C323.623 142.085 322.637 143.126 321.453 143.898L232.075 195.651C231.483 196.006 230.817 196.221 230.128 196.277C229.44 196.334 228.747 196.231 228.105 195.978L227.486 195.651C226.938 195.385 226.476 194.97 226.153 194.453C225.831 193.936 225.661 193.338 225.664 192.729V121.055C225.744 119.644 226.154 118.27 226.861 117.046C227.569 115.822 228.554 114.781 229.738 114.008L318.29 62.616C319.208 62.0848 320.271 61.8602 321.325 61.9745C322.379 62.0889 323.369 62.5364 324.151 63.2519Z",
    fill: "black"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M321.4 63.8191C323.652 62.53 325.474 63.5785 325.474 66.1738V137.074C325.399 138.487 324.99 139.862 324.282 141.086C323.574 142.311 322.587 143.351 321.4 144.121L232.023 195.685C229.771 196.975 227.949 195.909 227.949 193.331V122.465C228.025 121.052 228.433 119.677 229.141 118.452C229.849 117.228 230.836 116.188 232.023 115.418L321.4 63.8191Z",
    fill: "#110B2B"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M321.867 69.8693V123.565L232.197 174.888V120.729L321.867 69.8693Z",
    fill: "#201555"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M321.4 144.121L232.023 195.685C229.771 196.975 227.949 195.909 227.949 193.331V181.935L325.44 125.472V137.04C325.373 138.455 324.973 139.835 324.271 141.066C323.569 142.297 322.585 143.344 321.4 144.121Z",
    fill: "#0A0521"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M273.207 100.688L257.721 109.625V112.186L273.207 103.249V100.688Z",
    fill: "#FF9800"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M315.835 80.5774L266.814 109.127V111.67L315.835 83.1212V80.5774Z",
    fill: "#99A7D8"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M315.043 101.547L266.006 130.096V132.657L315.043 104.108V101.547Z",
    fill: "#99A7D8"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M315.919 121.399L266.898 149.948V152.492L315.919 123.96V121.399Z",
    fill: "#99A7D8"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M262.947 111.361L247.461 120.299V122.86L262.947 113.905V111.361Z",
    fill: "#99A7D8"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M259.648 118.236L252.326 122.499V125.043L259.648 120.78V118.236Z",
    fill: "#99A7D8"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M263.89 136.335L256.568 140.598V143.142L263.89 138.896V136.335Z",
    fill: "#FF9800"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M269.117 112.719L261.795 116.982V119.543L269.117 115.28V112.719Z",
    fill: "#FF9800"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M307.619 90.4604L273.432 110.158V112.719L307.619 93.0215V90.4604Z",
    fill: "#99A7D8"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M317.759 110.399L283.572 130.096V132.657L317.759 112.942V110.399Z",
    fill: "#99A7D8"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M307.876 100.825L273.689 120.522V123.083L307.876 103.369V100.825Z",
    fill: "#99A7D8"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M256.571 125.266L247.461 130.509V133.07L256.571 127.827V125.266Z",
    fill: "#99A7D8"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M255.193 131.196L252.014 133.07V135.631L255.193 133.757V131.196Z",
    fill: "#FF9800"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M275.031 140.082L271.834 141.939V144.5L275.031 142.626V140.082Z",
    fill: "url(#paint49_linear_1606_3980)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M279.842 137.212L276.645 139.086V141.647L279.842 139.773V137.212Z",
    fill: "#FF9800"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M284.397 124.768L281.217 126.641V129.185L284.397 127.312V124.768Z",
    fill: "url(#paint50_linear_1606_3980)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M271.729 121.64L256.242 130.577V133.138L271.729 124.201V121.64Z",
    fill: "#99A7D8"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M290.791 105.603L275.287 114.541V117.102L290.791 108.164V105.603Z",
    fill: "url(#paint51_linear_1606_3980)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M282.385 130.783L266.898 139.738V142.282L282.385 133.344V130.783Z",
    fill: "#99A7D8"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M273.877 115.297L258.391 124.235V126.796L273.877 117.858V115.297Z",
    fill: "#99A7D8"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M263.979 131.196L248.492 140.134V142.695L263.979 133.757V131.196Z",
    fill: "#99A7D8"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M280.358 126.968L264.871 135.923V138.467L280.358 129.529V126.968Z",
    fill: "#99A7D8"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M264.871 140.907L249.385 149.845V152.406L264.871 143.468V140.907Z",
    fill: "#99A7D8"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M270.578 142.695L255.092 151.633V154.194L270.578 145.256V142.695Z",
    fill: "#99A7D8"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M264.871 151.134L249.385 160.072V162.633L264.871 153.695V151.134Z",
    fill: "#99A7D8"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M241.889 118.408L239.242 119.955V122.499L241.889 120.969V118.408Z",
    fill: "#99A7D8"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M241.889 123.53L239.242 125.06V127.604L241.889 126.091V123.53Z",
    fill: "#99A7D8"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M241.889 128.635L239.242 130.165V132.726L241.889 131.196V128.635Z",
    fill: "#99A7D8"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M241.889 133.757L239.242 135.287V137.831L241.889 136.301V133.757Z",
    fill: "#99A7D8"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M241.889 138.862L239.242 140.392V142.953L241.889 141.423V138.862Z",
    fill: "#99A7D8"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M241.889 143.984L239.242 145.497V148.058L241.889 146.528V143.984Z",
    fill: "#99A7D8"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M241.889 149.089L239.242 150.618V153.179L241.889 151.65V149.089Z",
    fill: "#99A7D8"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M241.889 154.194L239.242 155.723V158.284L241.889 156.755V154.194Z",
    fill: "#99A7D8"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M241.889 159.316L239.242 160.845V163.389L241.889 161.877V159.316Z",
    fill: "#99A7D8"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M241.889 164.421L239.242 165.95V168.511L241.889 166.982V164.421Z",
    fill: "#99A7D8"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M290.791 90.4604L275.287 99.3982V101.959L290.791 93.0215V90.4604Z",
    fill: "#99A7D8"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter1_f_1606_3980)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M635.339 267.806C642.214 271.742 642.3 278.205 635.339 282.193L407.116 413.836C403.217 415.794 398.915 416.813 394.552 416.813C390.189 416.813 385.886 415.794 381.988 413.836L280.149 355.586C273.273 351.632 273.273 345.135 280.149 341.148L507.718 209.9C511.616 207.93 515.919 206.895 520.287 206.877C524.655 206.859 528.967 207.859 532.881 209.797L635.339 267.806Z",
    fill: "url(#paint52_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.703 267.755C641.578 271.674 641.578 278.068 634.703 282.107L407.151 413.458C403.263 415.412 398.972 416.43 394.621 416.43C390.27 416.43 385.979 415.412 382.091 413.458L280.561 355.345C273.686 351.392 273.686 344.912 280.561 340.941L507.443 210.072C511.332 208.11 515.623 207.08 519.978 207.062C524.333 207.044 528.633 208.039 532.538 209.969L634.703 267.755Z",
    fill: "url(#paint53_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.068 267.721C640.943 271.622 640.943 278.033 634.068 282.021L407.186 412.89C403.312 414.84 399.036 415.856 394.699 415.856C390.362 415.856 386.086 414.84 382.212 412.89L280.958 355.018C274.082 351.082 274.082 344.62 280.958 340.649L507.203 210.175C511.082 208.222 515.361 207.196 519.704 207.178C524.047 207.16 528.334 208.151 532.229 210.072L634.068 267.721Z",
    fill: "url(#paint54_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.535 267.669C640.411 271.553 640.411 277.982 633.535 281.935L407.221 412.426C403.358 414.371 399.093 415.384 394.768 415.384C390.443 415.384 386.179 414.371 382.316 412.426L281.37 354.675C274.495 350.756 274.495 344.362 281.37 340.357L506.963 210.261C510.828 208.313 515.093 207.289 519.421 207.271C523.749 207.253 528.022 208.242 531.903 210.158L633.535 267.669Z",
    fill: "url(#paint55_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.813 267.617C639.688 271.502 639.688 277.93 632.813 281.832L407.186 411.945C403.332 413.882 399.08 414.89 394.767 414.89C390.455 414.89 386.202 413.882 382.349 411.945L281.696 354.331C274.821 350.412 274.821 344.018 281.696 340.048L506.618 210.33C510.472 208.385 514.725 207.363 519.042 207.345C523.358 207.327 527.62 208.314 531.489 210.227L632.813 267.617Z",
    fill: "url(#paint56_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.193 267.566C639.068 271.433 639.068 277.879 632.193 281.746L407.288 411.481C403.449 413.415 399.211 414.423 394.912 414.423C390.614 414.423 386.375 413.415 382.537 411.481L282.176 354.039C275.301 350.137 275.301 343.726 282.176 339.807L506.342 210.502C510.186 208.565 514.427 207.548 518.731 207.53C523.035 207.512 527.285 208.494 531.144 210.398L632.193 267.566Z",
    fill: "url(#paint57_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.559 267.514C638.434 271.382 638.434 277.741 631.559 281.66L407.324 411C403.495 412.923 399.269 413.924 394.983 413.924C390.698 413.924 386.472 412.923 382.642 411L282.574 353.712C275.784 349.828 275.698 343.399 282.574 339.532L506.172 210.622C510.002 208.69 514.229 207.676 518.518 207.658C522.808 207.64 527.043 208.619 530.889 210.519L631.559 267.514Z",
    fill: "url(#paint58_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.922 267.48C637.797 271.33 637.797 277.672 630.922 281.574L407.289 410.484C403.47 412.404 399.256 413.404 394.982 413.404C390.708 413.404 386.494 412.404 382.676 410.484L282.985 353.386C276.11 349.501 276.11 343.073 282.985 339.223L505.931 210.656C509.748 208.723 513.964 207.707 518.242 207.689C522.521 207.671 526.745 208.652 530.578 210.553L630.922 267.48Z",
    fill: "url(#paint59_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.304 267.36C637.076 271.192 637.093 277.518 630.304 281.419L407.393 410.02C403.585 411.935 399.383 412.932 395.121 412.932C390.859 412.932 386.656 411.935 382.848 410.02L283.381 353.076C276.627 349.209 276.609 342.866 283.381 338.965L505.657 210.777C509.465 208.854 513.668 207.844 517.934 207.826C522.2 207.808 526.411 208.783 530.236 210.674L630.304 267.36Z",
    fill: "url(#paint60_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.666 267.36C636.421 271.193 636.455 277.483 629.666 281.368L407.425 409.59C403.631 411.498 399.443 412.492 395.196 412.492C390.949 412.492 386.761 411.498 382.966 409.59L283.792 352.87C277.054 349.02 277.037 342.695 283.792 338.81L505.379 210.983C509.179 209.072 513.369 208.068 517.622 208.05C521.875 208.032 526.074 209.001 529.889 210.88L629.666 267.36Z",
    fill: "url(#paint61_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.032 267.36C635.769 271.175 635.804 277.466 629.032 281.333L407.306 409.143C403.522 411.042 399.346 412.031 395.112 412.031C390.877 412.031 386.701 411.042 382.917 409.143L284.034 352.543C277.314 348.693 277.314 342.385 284.034 338.518L504.986 211.086C508.77 209.176 512.947 208.172 517.186 208.154C521.425 208.136 525.61 209.105 529.41 210.983L629.032 267.36Z",
    fill: "url(#paint62_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.379 267.36C635.099 271.158 635.116 277.415 628.379 281.282L407.495 408.645C403.722 410.54 399.558 411.526 395.335 411.526C391.112 411.526 386.948 410.54 383.174 408.645L284.618 352.251C277.915 348.418 277.898 342.128 284.618 338.277L504.917 211.224C508.691 209.321 512.856 208.321 517.083 208.303C521.309 208.285 525.482 209.25 529.273 211.121L628.379 267.36Z",
    fill: "url(#paint63_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.776 267.239C634.479 271.021 634.496 277.277 627.776 281.127L407.546 408.164C403.78 410.054 399.625 411.038 395.411 411.038C391.198 411.038 387.042 410.054 383.277 408.164L284.996 351.907C278.327 348.074 278.309 341.801 284.996 337.951L504.624 211.344C508.388 209.449 512.541 208.454 516.755 208.436C520.969 208.418 525.13 209.378 528.911 211.241L627.776 267.239Z",
    fill: "url(#paint64_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.159 267.188C633.828 270.969 633.845 277.191 627.159 280.938L407.53 407.614C403.779 409.5 399.638 410.483 395.439 410.483C391.239 410.483 387.098 409.5 383.347 407.614L285.375 351.529C278.706 347.714 278.706 341.457 285.375 337.624L504.35 211.344C508.104 209.454 512.245 208.461 516.447 208.443C520.65 208.425 524.799 209.383 528.568 211.241L627.159 267.188Z",
    fill: "url(#paint65_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.522 267.136C633.174 270.9 633.208 277.122 626.522 280.886L407.616 407.218C403.882 409.092 399.762 410.067 395.584 410.067C391.407 410.067 387.287 409.092 383.553 407.218L285.856 351.288C279.221 347.49 279.204 341.251 285.856 337.435L504.144 211.533C507.874 209.659 511.988 208.674 516.163 208.657C520.338 208.639 524.46 209.588 528.207 211.43L626.522 267.136Z",
    fill: "url(#paint66_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.887 267.085C632.521 270.849 632.556 277.036 625.887 280.835L407.599 406.737C403.866 408.613 399.746 409.59 395.567 409.59C391.389 409.59 387.269 408.613 383.536 406.737L286.149 350.996C279.531 347.198 279.514 340.993 286.149 337.246L503.8 211.774C507.53 209.897 511.644 208.911 515.82 208.893C519.995 208.875 524.118 209.826 527.864 211.67L625.887 267.085Z",
    fill: "url(#paint67_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.266 267.05C631.883 270.78 631.901 276.968 625.266 280.8L407.632 406.273C403.91 408.138 399.805 409.108 395.643 409.108C391.481 409.108 387.376 408.138 383.654 406.273L286.559 350.687C279.976 346.906 279.959 340.718 286.559 336.937L503.541 211.791C507.268 209.905 511.385 208.916 515.562 208.901C519.739 208.886 523.863 209.846 527.604 211.705L625.266 267.05Z",
    fill: "url(#paint68_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.63 266.999C631.23 270.728 631.247 276.882 624.63 280.749L407.717 405.809C404.01 407.67 399.919 408.639 395.771 408.639C391.623 408.639 387.533 407.67 383.826 405.809L287.023 350.429C280.44 346.665 280.44 340.494 287.023 336.679L503.351 211.928C507.063 210.072 511.155 209.106 515.305 209.106C519.455 209.106 523.548 210.072 527.26 211.928L624.63 266.999Z",
    fill: "url(#paint69_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.995 266.947C630.578 270.677 630.595 276.813 623.995 280.577L407.753 405.328C404.057 407.184 399.978 408.151 395.842 408.151C391.705 408.151 387.626 407.184 383.93 405.328L287.42 350.085C280.871 346.321 280.854 340.168 287.42 336.335L503.078 211.963C506.773 210.102 510.85 209.125 514.987 209.11C519.125 209.095 523.209 210.042 526.917 211.877L623.995 266.947Z",
    fill: "url(#paint70_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.375 266.896C629.924 270.608 629.958 276.727 623.375 280.491L407.786 404.864C404.101 406.715 400.034 407.68 395.909 407.68C391.785 407.68 387.718 406.715 384.032 404.864L287.779 349.862C281.248 346.115 281.231 339.979 287.779 336.215L502.801 212.186C506.485 210.329 510.551 209.354 514.677 209.339C518.802 209.324 522.875 210.269 526.572 212.1L623.375 266.896Z",
    fill: "url(#paint71_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.74 266.844C629.271 270.557 629.306 276.641 622.74 280.405L407.821 404.382C404.148 406.225 400.096 407.185 395.987 407.185C391.878 407.185 387.826 406.225 384.153 404.382L288.227 349.518C281.712 345.788 281.712 339.67 288.227 335.923L502.544 212.358C506.217 210.505 510.271 209.533 514.385 209.518C518.499 209.503 522.56 210.446 526.246 212.272L622.74 266.844Z",
    fill: "url(#paint72_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.122 266.81C628.636 270.488 628.653 276.572 622.122 280.319L407.856 403.918C404.193 405.754 400.153 406.71 396.056 406.71C391.96 406.71 387.919 405.754 384.257 403.918L288.64 349.192C282.143 345.462 282.126 339.36 288.64 335.63L502.287 212.358C505.954 210.527 509.996 209.574 514.095 209.574C518.194 209.574 522.236 210.527 525.903 212.358L622.122 266.81Z",
    fill: "url(#paint73_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.502 266.758C627.999 270.436 628.016 276.486 621.502 280.216L407.855 403.437C404.204 405.268 400.175 406.222 396.09 406.222C392.005 406.222 387.976 405.268 384.325 403.437L289 348.865C282.537 345.153 282.52 339.068 289 335.338L502.011 212.496C505.66 210.655 509.688 209.689 513.775 209.674C517.862 209.659 521.896 210.595 525.559 212.41L621.502 266.758Z",
    fill: "url(#paint74_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.849 266.706C627.329 270.367 627.346 276.418 620.849 280.13L407.924 402.973C404.283 404.799 400.266 405.751 396.193 405.751C392.12 405.751 388.103 404.799 384.462 402.973L289.447 348.573C282.984 344.877 282.984 338.81 289.447 335.097L501.805 212.65C505.442 210.811 509.457 209.845 513.532 209.827C517.607 209.809 521.631 210.74 525.284 212.547L620.849 266.706Z",
    fill: "url(#paint75_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.23 266.655C626.675 270.316 626.71 276.332 620.23 280.044L407.958 402.492C404.332 404.315 400.329 405.264 396.27 405.264C392.211 405.264 388.209 404.315 384.582 402.492L289.773 348.315C283.345 344.62 283.328 338.587 289.773 334.874L501.461 212.839C505.087 211.005 509.09 210.041 513.154 210.023C517.217 210.005 521.229 210.934 524.871 212.736L620.23 266.655Z",
    fill: "url(#paint76_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.595 266.62C626.023 270.247 626.057 276.263 619.595 279.958L407.941 401.993C404.326 403.812 400.335 404.759 396.288 404.759C392.241 404.759 388.25 403.812 384.635 401.993L290.204 347.937C283.792 344.259 283.775 338.243 290.204 334.547L501.186 212.925C504.8 211.1 508.788 210.14 512.836 210.122C516.884 210.104 520.881 211.029 524.511 212.822L619.595 266.62Z",
    fill: "url(#paint77_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.976 266.569C625.387 270.195 625.405 276.177 618.976 279.855L408.028 401.546C404.422 403.356 400.443 404.298 396.409 404.298C392.374 404.298 388.395 403.356 384.79 401.546L290.651 347.645C284.257 343.984 284.257 337.985 290.651 334.307L500.998 213.045C504.6 211.223 508.577 210.265 512.613 210.247C516.65 210.23 520.635 211.152 524.253 212.942L618.976 266.569Z",
    fill: "url(#paint78_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.341 266.517C624.735 270.127 624.752 276.108 618.341 279.769L408.063 401.082C404.469 402.89 400.501 403.832 396.478 403.832C392.455 403.832 388.488 402.89 384.893 401.082L291.064 347.37C284.687 343.726 284.67 337.727 291.064 334.049L500.758 213.131C504.349 211.314 508.314 210.358 512.339 210.341C516.364 210.323 520.337 211.243 523.944 213.028L618.341 266.517Z",
    fill: "url(#paint79_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.703 266.466C624.079 270.075 624.097 276.022 617.703 279.683L408.009 400.601C404.428 402.403 400.476 403.341 396.467 403.341C392.459 403.341 388.506 402.403 384.926 400.601L291.492 347.095C285.149 343.468 285.132 337.487 291.492 333.826L500.532 213.286C504.109 211.474 508.06 210.52 512.07 210.503C516.08 210.485 520.039 211.402 523.633 213.183L617.703 266.466Z",
    fill: "url(#paint80_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.087 266.414C623.429 270.024 623.463 275.936 617.087 279.597L408.08 400.137C404.509 401.93 400.569 402.864 396.573 402.864C392.577 402.864 388.637 401.93 385.066 400.137L291.821 346.854C285.478 343.227 285.478 337.263 291.821 333.619L500.191 213.458C503.759 211.657 507.698 210.709 511.695 210.692C515.692 210.674 519.639 211.585 523.223 213.355L617.087 266.414Z",
    fill: "url(#paint81_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.448 266.38C622.773 269.955 622.807 275.868 616.448 279.511L408.163 399.707C404.605 401.499 400.675 402.433 396.69 402.433C392.706 402.433 388.776 401.499 385.217 399.707L292.265 346.424C285.957 342.815 285.94 336.868 292.265 333.241L499.982 213.458C503.538 211.657 507.465 210.71 511.451 210.692C515.437 210.675 519.373 211.586 522.945 213.355L616.448 266.38Z",
    fill: "url(#paint82_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.813 266.328C622.138 269.903 622.155 275.782 615.813 279.408L408.199 399.174C404.653 400.958 400.738 401.887 396.769 401.887C392.799 401.887 388.885 400.958 385.339 399.174L292.678 346.132C286.387 342.54 286.37 336.61 292.678 332.983L499.725 213.595C503.271 211.803 507.186 210.861 511.16 210.843C515.134 210.825 519.057 211.732 522.619 213.492L615.813 266.328Z",
    fill: "url(#paint83_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.195 266.277C621.486 269.835 621.503 275.713 615.195 279.322L408.235 398.71C404.699 400.487 400.796 401.412 396.839 401.412C392.882 401.412 388.98 400.487 385.443 398.71L293.075 345.857C286.801 342.265 286.801 336.369 293.075 332.743L499.469 213.767C503.001 211.98 506.902 211.04 510.861 211.022C514.82 211.004 518.728 211.909 522.277 213.664L615.195 266.277Z",
    fill: "url(#paint84_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.627 266.225C620.9 269.783 620.935 275.627 614.627 279.236L408.371 398.229C404.846 400.001 400.955 400.923 397.009 400.923C393.064 400.923 389.173 400.001 385.648 398.229L293.589 345.531C287.333 341.955 287.333 336.077 293.589 332.468L499.312 213.87C502.835 212.092 506.724 211.156 510.67 211.139C514.617 211.121 518.513 212.021 522.052 213.767L614.627 266.225Z",
    fill: "url(#paint85_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.939 266.174C620.178 269.714 620.213 275.558 613.939 279.15L408.37 397.765C404.856 399.532 400.977 400.452 397.044 400.452C393.11 400.452 389.231 399.532 385.717 397.765L293.898 345.273C287.659 341.715 287.642 335.854 293.898 332.261L498.934 214.077C502.446 212.301 506.323 211.368 510.257 211.35C514.192 211.332 518.077 212.23 521.605 213.974L613.939 266.174Z",
    fill: "url(#paint86_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.304 266.139C619.526 269.663 619.561 275.472 613.304 279.065L408.372 397.284C404.872 399.047 401.007 399.966 397.088 399.966C393.168 399.966 389.304 399.047 385.804 397.284L294.329 344.929C288.124 341.371 288.107 335.527 294.329 331.952L498.677 214.077C502.178 212.306 506.043 211.375 509.966 211.357C513.889 211.339 517.763 212.235 521.28 213.974L613.304 266.139Z",
    fill: "url(#paint87_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.668 266.088C618.89 269.525 618.907 275.404 612.668 278.962L408.371 396.82C404.882 398.579 401.029 399.495 397.122 399.495C393.214 399.495 389.361 398.579 385.872 396.82L294.776 344.637C288.571 341.096 288.571 335.269 294.776 331.694L498.419 214.249C501.907 212.487 505.758 211.56 509.665 211.542C513.573 211.524 517.432 212.416 520.936 214.146L612.668 266.088Z",
    fill: "url(#paint88_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.049 266.036C618.237 269.474 618.254 275.318 612.049 278.876L408.371 396.27C404.891 398.016 401.05 398.925 397.156 398.925C393.262 398.925 389.422 398.016 385.941 396.27L295.102 344.362C288.932 340.838 288.915 335.029 295.102 331.471L498.179 214.369C501.655 212.61 505.494 211.685 509.39 211.667C513.286 211.65 517.133 212.539 520.626 214.266L612.049 266.036Z",
    fill: "url(#paint89_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.412 265.985C617.583 269.422 617.617 275.249 611.412 278.79L408.37 395.874C404.903 397.613 401.077 398.519 397.198 398.519C393.319 398.519 389.493 397.613 386.026 395.874L295.462 344.035C289.309 340.512 289.292 334.719 295.462 331.179L497.885 214.455C501.348 212.71 505.168 211.793 509.045 211.775C512.923 211.757 516.751 212.639 520.23 214.352L611.412 265.985Z",
    fill: "url(#paint90_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.795 265.95C616.931 269.388 616.966 275.163 610.795 278.704L408.475 395.393C405.011 397.142 401.184 398.054 397.303 398.054C393.422 398.054 389.595 397.142 386.131 395.393L295.842 343.709C289.706 340.271 289.706 334.427 295.842 330.904L497.595 214.558C501.055 212.804 504.876 211.882 508.755 211.864C512.634 211.846 516.464 212.733 519.939 214.455L610.795 265.95Z",
    fill: "url(#paint91_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.158 265.899C616.294 269.336 616.312 275.077 610.158 278.601L408.509 394.929C405.064 396.663 401.261 397.566 397.405 397.566C393.549 397.566 389.746 396.663 386.302 394.929L296.323 343.365C290.204 339.927 290.186 334.135 296.323 330.612L497.422 214.644C500.865 212.903 504.665 211.988 508.522 211.97C512.379 211.952 516.188 212.832 519.646 214.541L610.158 265.899Z",
    fill: "url(#paint92_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.471 265.847C615.59 269.285 615.607 275.008 609.471 278.515L408.371 394.448C404.938 396.177 401.147 397.077 397.302 397.077C393.458 397.077 389.667 396.177 386.233 394.448L296.649 343.159C290.565 339.721 290.548 333.946 296.649 330.422L497.079 214.85C500.511 213.117 504.299 212.205 508.144 212.187C511.989 212.169 515.786 213.046 519.234 214.747L609.471 265.847Z",
    fill: "url(#paint93_linear_1606_3980)",
    fillOpacity: 0.15
  }))), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M624.818 263.148V267.927C624.819 269.586 624.382 271.215 623.552 272.652C622.722 274.088 621.529 275.28 620.091 276.108L408.215 398.538C404.596 400.357 400.602 401.304 396.552 401.304C392.503 401.304 388.509 400.357 384.89 398.538L290.356 344.809C288.931 344.004 287.744 342.835 286.916 341.422C286.089 340.009 285.651 338.402 285.647 336.765C285.625 333.424 286.488 330.138 288.148 327.239C289.809 324.341 292.207 321.934 295.1 320.264L501.872 200.619C505.488 198.793 509.48 197.833 513.53 197.815C517.581 197.797 521.581 198.722 525.213 200.515L620.4 255.38C621.755 256.172 622.877 257.307 623.652 258.671C624.428 260.035 624.83 261.579 624.818 263.148Z",
    fill: "black"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M619.972 254.383C626.418 258.026 626.435 264.042 619.972 267.738L408.216 389.893C404.597 391.711 400.604 392.658 396.554 392.658C392.504 392.658 388.51 391.711 384.892 389.893L290.358 335.802C283.947 332.124 283.929 326.091 290.358 322.396L501.53 200.619C505.146 198.793 509.137 197.833 513.188 197.815C517.239 197.797 521.239 198.722 524.871 200.515L619.972 254.383Z",
    fill: "#110B2B"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M338.861 358.044C332.588 354.417 332.588 348.487 338.861 344.86C342.403 343.072 346.315 342.14 350.283 342.14C354.251 342.14 358.163 343.072 361.704 344.86C367.978 348.487 367.978 354.417 361.704 358.044C358.163 359.832 354.251 360.764 350.283 360.764C346.315 360.764 342.403 359.832 338.861 358.044Z",
    fill: "#EDF0F8"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M570.54 241.835C570.708 241.835 570.873 241.791 571.018 241.706C571.163 241.622 571.282 241.5 571.365 241.354C571.43 241.245 571.472 241.124 571.49 240.998C571.508 240.872 571.501 240.744 571.469 240.621C571.437 240.498 571.381 240.382 571.304 240.281C571.227 240.179 571.131 240.094 571.021 240.031L549.949 227.827C549.841 227.762 549.721 227.72 549.596 227.703C549.472 227.685 549.345 227.692 549.223 227.724C549.102 227.756 548.988 227.812 548.888 227.889C548.788 227.966 548.705 228.061 548.642 228.171C548.516 228.393 548.481 228.655 548.545 228.902C548.609 229.15 548.768 229.362 548.986 229.494L570.059 241.646C570.199 241.751 570.365 241.816 570.54 241.835Z",
    fill: "#99A7D8"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M546.372 227.827C546.562 227.806 546.742 227.728 546.889 227.604C547.035 227.48 547.14 227.315 547.192 227.13C547.244 226.945 547.239 226.749 547.179 226.567C547.118 226.385 547.005 226.226 546.853 226.108L542.161 223.393C541.939 223.268 541.678 223.237 541.433 223.304C541.189 223.372 540.981 223.533 540.854 223.754C540.79 223.862 540.748 223.981 540.73 224.106C540.712 224.231 540.72 224.357 540.752 224.479C540.784 224.601 540.84 224.715 540.916 224.814C540.993 224.914 541.089 224.998 541.198 225.06L545.873 227.827C546.036 227.879 546.21 227.879 546.372 227.827Z",
    fill: "#99A7D8"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M603.163 272.258L495.772 209.47L317.842 312.066L426.161 374.853L603.163 272.258Z",
    fill: "#201555"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter2_f_1606_3980)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M443.626 438.964C443.028 438.668 442.369 438.513 441.701 438.513C441.033 438.513 440.374 438.668 439.776 438.964L394.227 465.228C393.997 465.31 393.797 465.461 393.656 465.661C393.515 465.861 393.439 466.1 393.439 466.345C393.439 466.59 393.515 466.829 393.656 467.029C393.797 467.229 393.997 467.38 394.227 467.462L439.776 493.743C440.372 494.047 441.031 494.206 441.701 494.206C442.37 494.206 443.03 494.047 443.626 493.743L489.157 467.462C489.389 467.385 489.592 467.236 489.735 467.037C489.878 466.838 489.955 466.599 489.955 466.354C489.955 466.108 489.878 465.869 489.735 465.67C489.592 465.471 489.389 465.323 489.157 465.245L443.626 438.964Z",
    fill: "url(#paint94_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.609 439.239C443.019 438.935 442.365 438.776 441.701 438.776C441.037 438.776 440.383 438.935 439.793 439.239L394.623 465.245C394.396 465.326 394.2 465.476 394.062 465.672C393.923 465.869 393.849 466.104 393.849 466.345C393.849 466.586 393.923 466.821 394.062 467.017C394.2 467.214 394.396 467.364 394.623 467.445L439.844 493.554C440.437 493.85 441.09 494.004 441.752 494.004C442.415 494.004 443.068 493.85 443.66 493.554L488.847 467.462C489.074 467.381 489.27 467.231 489.408 467.035C489.547 466.838 489.621 466.603 489.621 466.362C489.621 466.121 489.547 465.887 489.408 465.69C489.27 465.493 489.074 465.343 488.847 465.262L443.609 439.239Z",
    fill: "url(#paint95_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.591 439.36C443.002 439.064 442.352 438.909 441.692 438.909C441.033 438.909 440.382 439.064 439.793 439.36L394.915 465.245C394.688 465.326 394.492 465.476 394.354 465.673C394.215 465.869 394.141 466.104 394.141 466.345C394.141 466.586 394.215 466.821 394.354 467.018C394.492 467.214 394.688 467.364 394.915 467.445L439.793 493.347C440.382 493.644 441.033 493.798 441.692 493.798C442.352 493.798 443.002 493.644 443.591 493.347L488.452 467.445C488.681 467.368 488.879 467.221 489.02 467.026C489.161 466.83 489.236 466.595 489.236 466.354C489.236 466.113 489.161 465.877 489.02 465.682C488.879 465.486 488.681 465.339 488.452 465.262L443.591 439.36Z",
    fill: "url(#paint96_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.575 439.549C442.99 439.261 442.346 439.111 441.693 439.111C441.04 439.111 440.397 439.261 439.811 439.549L395.26 465.331C395.029 465.403 394.827 465.547 394.684 465.742C394.541 465.937 394.463 466.172 394.463 466.414C394.463 466.656 394.541 466.891 394.684 467.086C394.827 467.281 395.029 467.425 395.26 467.497L439.811 493.279C440.394 493.575 441.039 493.729 441.693 493.729C442.347 493.729 442.992 493.575 443.575 493.279L488.109 467.497C488.338 467.42 488.536 467.273 488.677 467.077C488.818 466.881 488.893 466.646 488.893 466.405C488.893 466.164 488.818 465.929 488.677 465.733C488.536 465.537 488.338 465.391 488.109 465.314L443.575 439.549Z",
    fill: "url(#paint97_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.557 439.755C442.98 439.458 442.341 439.303 441.692 439.303C441.044 439.303 440.404 439.458 439.827 439.755L395.586 465.262C395.363 465.343 395.171 465.49 395.035 465.684C394.899 465.877 394.826 466.108 394.826 466.345C394.826 466.582 394.899 466.813 395.035 467.006C395.171 467.2 395.363 467.347 395.586 467.428L439.827 492.969C440.407 493.257 441.045 493.407 441.692 493.407C442.339 493.407 442.978 493.257 443.557 492.969L487.782 467.428C488.007 467.352 488.201 467.207 488.34 467.014C488.478 466.822 488.552 466.591 488.552 466.354C488.552 466.116 488.478 465.885 488.34 465.693C488.201 465.5 488.007 465.355 487.782 465.279L443.557 439.755Z",
    fill: "url(#paint98_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.559 439.944C442.982 439.655 442.347 439.505 441.702 439.505C441.058 439.505 440.422 439.655 439.846 439.944L395.931 465.279C395.712 465.359 395.523 465.504 395.39 465.695C395.257 465.885 395.185 466.112 395.185 466.345C395.185 466.578 395.257 466.805 395.39 466.995C395.523 467.186 395.712 467.331 395.931 467.411L439.846 492.763C440.422 493.052 441.058 493.202 441.702 493.202C442.347 493.202 442.982 493.052 443.559 492.763L487.44 467.428C487.664 467.352 487.859 467.207 487.997 467.014C488.135 466.822 488.209 466.591 488.209 466.354C488.209 466.117 488.135 465.885 487.997 465.693C487.859 465.5 487.664 465.355 487.44 465.279L443.559 439.944Z",
    fill: "url(#paint99_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.538 440.15C442.968 439.862 442.338 439.712 441.699 439.712C441.06 439.712 440.43 439.862 439.86 440.15L396.34 465.279C396.122 465.359 395.933 465.504 395.8 465.695C395.666 465.885 395.595 466.112 395.595 466.345C395.595 466.578 395.666 466.805 395.8 466.995C395.933 467.186 396.122 467.331 396.34 467.411L439.86 492.522C440.43 492.811 441.06 492.961 441.699 492.961C442.338 492.961 442.968 492.811 443.538 492.522L487.093 467.428C487.311 467.348 487.5 467.203 487.633 467.012C487.767 466.822 487.838 466.595 487.838 466.362C487.838 466.129 487.767 465.902 487.633 465.712C487.5 465.521 487.311 465.376 487.093 465.296L443.538 440.15Z",
    fill: "url(#paint100_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.521 440.34C442.954 440.051 442.327 439.901 441.691 439.901C441.054 439.901 440.427 440.051 439.86 440.34L396.598 465.296C396.383 465.375 396.198 465.518 396.067 465.706C395.937 465.893 395.867 466.116 395.867 466.345C395.867 466.574 395.937 466.797 396.067 466.984C396.198 467.172 396.383 467.314 396.598 467.393L439.86 492.368C440.427 492.656 441.054 492.806 441.691 492.806C442.327 492.806 442.954 492.656 443.521 492.368L486.766 467.411C486.987 467.335 487.178 467.193 487.313 467.003C487.449 466.814 487.522 466.587 487.522 466.354C487.522 466.121 487.449 465.893 487.313 465.704C487.178 465.514 486.987 465.372 486.766 465.296L443.521 440.34Z",
    fill: "url(#paint101_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.507 440.529C442.943 440.249 442.323 440.103 441.694 440.103C441.064 440.103 440.444 440.249 439.88 440.529L396.91 465.297C396.696 465.375 396.51 465.518 396.38 465.706C396.249 465.893 396.179 466.116 396.179 466.345C396.179 466.574 396.249 466.797 396.38 466.984C396.51 467.172 396.696 467.315 396.91 467.393L439.88 492.179C440.441 492.467 441.063 492.617 441.694 492.617C442.324 492.617 442.946 492.467 443.507 492.179L486.477 467.411C486.691 467.332 486.877 467.189 487.007 467.001C487.138 466.814 487.208 466.591 487.208 466.362C487.208 466.134 487.138 465.911 487.007 465.723C486.877 465.536 486.691 465.393 486.477 465.314L443.507 440.529Z",
    fill: "url(#paint102_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.489 440.735C442.934 440.447 442.318 440.297 441.693 440.297C441.067 440.297 440.451 440.447 439.896 440.735L397.287 465.314C397.069 465.384 396.878 465.521 396.743 465.707C396.608 465.892 396.535 466.115 396.535 466.345C396.535 466.574 396.608 466.798 396.743 466.983C396.878 467.169 397.069 467.306 397.287 467.376L439.896 491.989C440.454 492.269 441.069 492.415 441.693 492.415C442.316 492.415 442.931 492.269 443.489 491.989L486.081 467.393C486.297 467.319 486.485 467.178 486.618 466.992C486.75 466.806 486.822 466.582 486.822 466.354C486.822 466.125 486.75 465.901 486.618 465.715C486.485 465.529 486.297 465.388 486.081 465.314L443.489 440.735Z",
    fill: "url(#paint103_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.47 440.958C442.919 440.679 442.309 440.533 441.691 440.533C441.073 440.533 440.464 440.679 439.912 440.958L397.63 465.348C397.411 465.418 397.221 465.556 397.085 465.741C396.95 465.926 396.877 466.15 396.877 466.379C396.877 466.609 396.95 466.832 397.085 467.018C397.221 467.203 397.411 467.341 397.63 467.411L439.912 491.818C440.464 492.097 441.073 492.243 441.691 492.243C442.309 492.243 442.919 492.097 443.47 491.818L485.718 467.393C485.937 467.323 486.127 467.186 486.263 467C486.398 466.815 486.471 466.592 486.471 466.362C486.471 466.133 486.398 465.909 486.263 465.724C486.127 465.538 485.937 465.401 485.718 465.331L443.47 440.958Z",
    fill: "url(#paint104_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.47 441.113C442.917 440.841 442.308 440.7 441.691 440.7C441.075 440.7 440.466 440.841 439.912 441.113L397.956 465.314C397.744 465.388 397.56 465.526 397.43 465.709C397.3 465.892 397.23 466.112 397.23 466.336C397.23 466.561 397.3 466.78 397.43 466.964C397.56 467.147 397.744 467.285 397.956 467.359L439.93 491.594C440.478 491.873 441.085 492.019 441.7 492.019C442.315 492.019 442.922 491.873 443.47 491.594L485.409 467.376C485.621 467.302 485.806 467.164 485.936 466.981C486.066 466.798 486.136 466.578 486.136 466.354C486.136 466.129 486.066 465.909 485.936 465.726C485.806 465.543 485.621 465.405 485.409 465.331L443.47 441.113Z",
    fill: "url(#paint105_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.453 441.319C442.908 441.04 442.304 440.895 441.691 440.895C441.079 440.895 440.475 441.04 439.929 441.319L398.3 465.382C398.086 465.452 397.899 465.587 397.766 465.769C397.633 465.952 397.562 466.171 397.562 466.396C397.562 466.622 397.633 466.841 397.766 467.024C397.899 467.206 398.086 467.341 398.3 467.411L439.929 491.474C440.477 491.745 441.08 491.886 441.691 491.886C442.302 491.886 442.905 491.745 443.453 491.474L485.065 467.411C485.28 467.341 485.467 467.206 485.599 467.024C485.732 466.841 485.803 466.622 485.803 466.396C485.803 466.171 485.732 465.952 485.599 465.769C485.467 465.587 485.28 465.452 485.065 465.382L443.453 441.319Z",
    fill: "url(#paint106_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.435 441.508C442.9 441.246 442.312 441.109 441.717 441.109C441.121 441.109 440.533 441.246 439.998 441.508L398.747 465.331C398.532 465.4 398.345 465.536 398.212 465.718C398.08 465.9 398.008 466.12 398.008 466.345C398.008 466.57 398.08 466.79 398.212 466.972C398.345 467.154 398.532 467.29 398.747 467.359L439.998 491.199C440.533 491.461 441.121 491.598 441.717 491.598C442.312 491.598 442.9 491.461 443.435 491.199L484.687 467.359C484.895 467.286 485.075 467.15 485.203 466.97C485.331 466.79 485.399 466.574 485.399 466.354C485.399 466.133 485.331 465.918 485.203 465.737C485.075 465.557 484.895 465.421 484.687 465.348L443.435 441.508Z",
    fill: "url(#paint107_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.418 441.715C442.885 441.446 442.296 441.306 441.699 441.306C441.102 441.306 440.514 441.446 439.981 441.715L398.987 465.348C398.777 465.417 398.594 465.55 398.464 465.729C398.334 465.908 398.264 466.124 398.264 466.345C398.264 466.566 398.334 466.782 398.464 466.961C398.594 467.14 398.777 467.273 398.987 467.342L439.981 491.01C440.514 491.279 441.102 491.419 441.699 491.419C442.296 491.419 442.885 491.279 443.418 491.01L484.394 467.359C484.605 467.291 484.788 467.157 484.918 466.978C485.048 466.799 485.118 466.584 485.118 466.362C485.118 466.141 485.048 465.925 484.918 465.746C484.788 465.567 484.605 465.434 484.394 465.365L443.418 441.715Z",
    fill: "url(#paint108_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.404 441.904C442.872 441.629 442.283 441.486 441.685 441.486C441.087 441.486 440.498 441.629 439.966 441.904L399.299 465.348C399.089 465.417 398.906 465.55 398.776 465.729C398.646 465.908 398.576 466.124 398.576 466.345C398.576 466.566 398.646 466.782 398.776 466.961C398.906 467.14 399.089 467.273 399.299 467.342L439.983 490.804C440.515 491.078 441.104 491.221 441.702 491.221C442.3 491.221 442.89 491.078 443.421 490.804L484.002 467.342C484.206 467.27 484.383 467.136 484.508 466.959C484.633 466.782 484.7 466.57 484.7 466.354C484.7 466.137 484.633 465.926 484.508 465.749C484.383 465.572 484.206 465.438 484.002 465.365L443.404 441.904Z",
    fill: "url(#paint109_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.401 442.093C442.867 441.828 442.279 441.69 441.682 441.69C441.086 441.69 440.498 441.828 439.963 442.093L399.658 465.365C399.451 465.433 399.272 465.564 399.144 465.74C399.017 465.916 398.948 466.128 398.948 466.345C398.948 466.562 399.017 466.774 399.144 466.95C399.272 467.126 399.451 467.257 399.658 467.325L439.998 490.614C440.531 490.883 441.12 491.024 441.717 491.024C442.314 491.024 442.902 490.883 443.435 490.614L483.741 467.342C483.946 467.27 484.122 467.136 484.248 466.959C484.373 466.782 484.44 466.57 484.44 466.354C484.44 466.137 484.373 465.925 484.248 465.748C484.122 465.571 483.946 465.438 483.741 465.365L443.401 442.093Z",
    fill: "url(#paint110_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.386 442.299C442.854 442.027 442.265 441.886 441.667 441.886C441.07 441.886 440.481 442.027 439.948 442.299L400.003 465.365C399.797 465.433 399.617 465.564 399.49 465.74C399.363 465.916 399.294 466.128 399.294 466.345C399.294 466.562 399.363 466.774 399.49 466.95C399.617 467.126 399.797 467.257 400.003 467.325L440 490.425C440.532 490.697 441.121 490.839 441.719 490.839C442.316 490.839 442.905 490.697 443.437 490.425L483.417 467.325C483.617 467.253 483.79 467.121 483.913 466.948C484.035 466.774 484.101 466.566 484.101 466.354C484.101 466.141 484.035 465.933 483.913 465.76C483.79 465.586 483.617 465.454 483.417 465.382L443.386 442.299Z",
    fill: "url(#paint111_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.367 442.488C442.847 442.225 442.273 442.088 441.691 442.088C441.109 442.088 440.535 442.225 440.015 442.488L400.328 465.383C400.126 465.45 399.95 465.579 399.825 465.752C399.7 465.924 399.633 466.132 399.633 466.345C399.633 466.558 399.7 466.766 399.825 466.939C399.95 467.111 400.126 467.241 400.328 467.308L440.015 490.219C440.535 490.482 441.109 490.619 441.691 490.619C442.273 490.619 442.847 490.482 443.367 490.219L483.037 467.325C483.237 467.253 483.41 467.122 483.533 466.948C483.655 466.774 483.721 466.566 483.721 466.354C483.721 466.141 483.655 465.934 483.533 465.76C483.41 465.586 483.237 465.454 483.037 465.383L443.367 442.488Z",
    fill: "url(#paint112_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.352 442.677C442.837 442.419 442.269 442.284 441.693 442.284C441.117 442.284 440.549 442.419 440.034 442.677L400.674 465.382C400.472 465.45 400.296 465.579 400.171 465.751C400.046 465.924 399.979 466.132 399.979 466.345C399.979 466.558 400.046 466.766 400.171 466.939C400.296 467.111 400.472 467.24 400.674 467.308L440.034 490.03C440.548 490.293 441.116 490.429 441.693 490.429C442.27 490.429 442.838 490.293 443.352 490.03L482.695 467.325C482.897 467.258 483.073 467.129 483.198 466.956C483.323 466.783 483.39 466.575 483.39 466.362C483.39 466.149 483.323 465.941 483.198 465.769C483.073 465.596 482.897 465.467 482.695 465.4L443.352 442.677Z",
    fill: "url(#paint113_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.332 442.883C442.825 442.621 442.262 442.484 441.691 442.484C441.12 442.484 440.557 442.621 440.049 442.883L401.015 465.4C400.817 465.466 400.645 465.593 400.523 465.763C400.401 465.932 400.335 466.136 400.335 466.345C400.335 466.554 400.401 466.758 400.523 466.927C400.645 467.097 400.817 467.224 401.015 467.29L440.049 489.824C440.557 490.086 441.12 490.223 441.691 490.223C442.262 490.223 442.825 490.086 443.332 489.824L482.349 467.308C482.545 467.237 482.715 467.107 482.835 466.936C482.955 466.766 483.019 466.562 483.019 466.354C483.019 466.145 482.955 465.941 482.835 465.771C482.715 465.6 482.545 465.47 482.349 465.4L443.332 442.883Z",
    fill: "url(#paint114_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.334 443.073C442.824 442.818 442.262 442.686 441.693 442.686C441.123 442.686 440.561 442.818 440.051 443.073L401.361 465.417C401.163 465.483 400.99 465.61 400.868 465.78C400.746 465.95 400.681 466.153 400.681 466.362C400.681 466.571 400.746 466.775 400.868 466.945C400.99 467.114 401.163 467.241 401.361 467.308L440.051 489.652C440.561 489.906 441.123 490.039 441.693 490.039C442.262 490.039 442.824 489.906 443.334 489.652L482.007 467.308C482.918 466.775 482.918 465.933 482.007 465.417L443.334 443.073Z",
    fill: "url(#paint115_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.316 443.279C442.812 443.025 442.256 442.893 441.692 442.893C441.128 442.893 440.571 443.025 440.067 443.279L401.687 465.417C400.793 465.933 400.793 466.775 401.687 467.273L440.067 489.446C440.571 489.7 441.128 489.832 441.692 489.832C442.256 489.832 442.812 489.7 443.316 489.446L481.68 467.29C481.872 467.22 482.038 467.093 482.155 466.925C482.272 466.758 482.335 466.558 482.335 466.354C482.335 466.149 482.272 465.949 482.155 465.782C482.038 465.614 481.872 465.487 481.68 465.417L443.316 443.279Z",
    fill: "url(#paint116_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.3 443.468C442.802 443.214 442.251 443.082 441.693 443.082C441.134 443.082 440.583 443.214 440.086 443.468L402.031 465.417C401.837 465.483 401.669 465.607 401.549 465.774C401.43 465.94 401.365 466.14 401.365 466.345C401.365 466.55 401.43 466.75 401.549 466.916C401.669 467.083 401.837 467.208 402.031 467.273L440.086 489.239C440.583 489.493 441.134 489.625 441.693 489.625C442.251 489.625 442.802 489.493 443.3 489.239L481.337 467.29C481.531 467.225 481.7 467.1 481.819 466.933C481.939 466.767 482.003 466.567 482.003 466.362C482.003 466.157 481.939 465.958 481.819 465.791C481.7 465.625 481.531 465.5 481.337 465.434L443.3 443.468Z",
    fill: "url(#paint117_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.28 443.657C442.786 443.412 442.242 443.284 441.691 443.284C441.139 443.284 440.595 443.412 440.101 443.657L402.373 465.434C402.185 465.503 402.022 465.629 401.908 465.793C401.793 465.958 401.731 466.153 401.731 466.354C401.731 466.554 401.793 466.75 401.908 466.914C402.022 467.079 402.185 467.204 402.373 467.273L440.101 489.085C440.595 489.33 441.139 489.458 441.691 489.458C442.242 489.458 442.786 489.33 443.28 489.085L480.991 467.308C481.179 467.238 481.342 467.113 481.456 466.949C481.571 466.784 481.633 466.589 481.633 466.388C481.633 466.188 481.571 465.992 481.456 465.827C481.342 465.663 481.179 465.538 480.991 465.469L443.28 443.657Z",
    fill: "url(#paint118_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.266 443.863C442.779 443.613 442.24 443.482 441.693 443.482C441.146 443.482 440.607 443.613 440.12 443.863L402.702 465.434C402.512 465.499 402.347 465.622 402.23 465.785C402.113 465.948 402.05 466.144 402.05 466.345C402.05 466.546 402.113 466.742 402.23 466.905C402.347 467.068 402.512 467.191 402.702 467.256L440.12 488.861C440.607 489.112 441.146 489.242 441.693 489.242C442.24 489.242 442.779 489.112 443.266 488.861L480.667 467.273C480.857 467.208 481.022 467.086 481.139 466.922C481.256 466.759 481.318 466.563 481.318 466.362C481.318 466.161 481.256 465.965 481.139 465.802C481.022 465.639 480.857 465.516 480.667 465.451L443.266 443.863Z",
    fill: "url(#paint119_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.264 444.052C442.778 443.802 442.239 443.671 441.692 443.671C441.145 443.671 440.605 443.802 440.119 444.052L403.044 465.434C402.854 465.499 402.689 465.622 402.572 465.785C402.455 465.948 402.393 466.144 402.393 466.345C402.393 466.546 402.455 466.742 402.572 466.905C402.689 467.068 402.854 467.191 403.044 467.256L440.119 488.655C440.605 488.905 441.145 489.036 441.692 489.036C442.239 489.036 442.778 488.905 443.264 488.655L480.322 467.256C480.506 467.188 480.665 467.064 480.777 466.903C480.889 466.742 480.949 466.55 480.949 466.354C480.949 466.157 480.889 465.965 480.777 465.804C480.665 465.643 480.506 465.52 480.322 465.451L443.264 444.052Z",
    fill: "url(#paint120_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.249 444.258C442.767 444.014 442.234 443.886 441.693 443.886C441.153 443.886 440.62 444.014 440.138 444.258L403.39 465.451C402.53 465.95 402.53 466.758 403.39 467.17L440.138 488.397C440.622 488.634 441.154 488.757 441.693 488.757C442.232 488.757 442.764 488.634 443.249 488.397L479.979 467.187C480.839 466.689 480.839 465.881 479.979 465.468L443.249 444.258Z",
    fill: "url(#paint121_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.231 444.396C442.754 444.157 442.227 444.033 441.693 444.033C441.159 444.033 440.632 444.157 440.154 444.396L403.733 465.451C403.569 465.527 403.429 465.648 403.331 465.8C403.234 465.952 403.182 466.13 403.182 466.311C403.182 466.492 403.234 466.669 403.331 466.821C403.429 466.974 403.569 467.095 403.733 467.17L440.154 488.191C440.632 488.43 441.159 488.554 441.693 488.554C442.227 488.554 442.754 488.43 443.231 488.191L479.635 467.17C479.806 467.1 479.952 466.981 480.055 466.828C480.158 466.675 480.213 466.495 480.213 466.311C480.213 466.126 480.158 465.946 480.055 465.793C479.952 465.64 479.806 465.521 479.635 465.451L443.231 444.396Z",
    fill: "url(#paint122_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.212 444.637C442.739 444.403 442.218 444.282 441.691 444.282C441.163 444.282 440.643 444.403 440.17 444.637L404.075 465.468C403.904 465.538 403.758 465.657 403.655 465.81C403.552 465.963 403.497 466.143 403.497 466.328C403.497 466.512 403.552 466.692 403.655 466.845C403.758 466.999 403.904 467.118 404.075 467.187L440.17 488.036C440.643 488.27 441.163 488.391 441.691 488.391C442.218 488.391 442.739 488.27 443.212 488.036L479.307 467.204C479.471 467.129 479.611 467.008 479.708 466.856C479.806 466.703 479.858 466.526 479.858 466.345C479.858 466.164 479.806 465.987 479.708 465.834C479.611 465.682 479.471 465.561 479.307 465.486L443.212 444.637Z",
    fill: "url(#paint123_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.197 444.843C442.731 444.606 442.216 444.482 441.693 444.482C441.17 444.482 440.655 444.606 440.189 444.843L404.404 465.469C404.233 465.538 404.087 465.657 403.984 465.81C403.881 465.963 403.826 466.144 403.826 466.328C403.826 466.512 403.881 466.693 403.984 466.846C404.087 466.999 404.233 467.118 404.404 467.187L440.189 487.813C440.655 488.05 441.17 488.173 441.693 488.173C442.216 488.173 442.731 488.05 443.197 487.813L478.965 467.187C479.143 467.125 479.297 467.008 479.406 466.855C479.516 466.701 479.574 466.517 479.574 466.328C479.574 466.139 479.516 465.955 479.406 465.801C479.297 465.647 479.143 465.531 478.965 465.469L443.197 444.843Z",
    fill: "url(#paint124_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.197 445.032C442.731 444.795 442.215 444.671 441.693 444.671C441.17 444.671 440.655 444.795 440.189 445.032L404.747 465.485C404.569 465.548 404.415 465.664 404.306 465.818C404.197 465.972 404.138 466.156 404.138 466.345C404.138 466.534 404.197 466.718 404.306 466.872C404.415 467.025 404.569 467.142 404.747 467.204L440.189 487.675C440.655 487.912 441.17 488.036 441.693 488.036C442.215 488.036 442.731 487.912 443.197 487.675L478.621 467.221C478.799 467.159 478.953 467.043 479.062 466.889C479.171 466.735 479.23 466.551 479.23 466.362C479.23 466.173 479.171 465.989 479.062 465.835C478.953 465.682 478.799 465.565 478.621 465.503L443.197 445.032Z",
    fill: "url(#paint125_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.179 445.221C442.715 444.998 442.206 444.883 441.692 444.883C441.177 444.883 440.669 444.998 440.205 445.221L405.073 465.486C404.895 465.548 404.741 465.664 404.632 465.818C404.523 465.972 404.464 466.156 404.464 466.345C404.464 466.534 404.523 466.718 404.632 466.872C404.741 467.026 404.895 467.142 405.073 467.204L440.205 487.486C440.669 487.709 441.177 487.824 441.692 487.824C442.206 487.824 442.715 487.709 443.179 487.486L478.294 467.222C478.472 467.159 478.626 467.043 478.735 466.889C478.844 466.735 478.902 466.551 478.902 466.362C478.902 466.173 478.844 465.989 478.735 465.836C478.626 465.682 478.472 465.565 478.294 465.503L443.179 445.221Z",
    fill: "url(#paint126_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.163 445.427C442.706 445.199 442.203 445.08 441.693 445.08C441.183 445.08 440.68 445.199 440.223 445.427L405.418 465.503C405.231 465.556 405.067 465.669 404.95 465.824C404.833 465.979 404.769 466.168 404.769 466.362C404.769 466.556 404.833 466.745 404.95 466.9C405.067 467.056 405.231 467.168 405.418 467.222L440.223 487.366C440.677 487.602 441.181 487.726 441.693 487.726C442.205 487.726 442.709 487.602 443.163 487.366L477.951 467.29C478.138 467.237 478.302 467.124 478.419 466.969C478.536 466.814 478.599 466.625 478.599 466.431C478.599 466.237 478.536 466.048 478.419 465.893C478.302 465.738 478.138 465.625 477.951 465.572L443.163 445.427Z",
    fill: "url(#paint127_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.144 445.616C442.694 445.387 442.197 445.267 441.692 445.267C441.187 445.267 440.689 445.387 440.239 445.616L405.76 465.503C405.573 465.556 405.409 465.669 405.292 465.824C405.175 465.979 405.112 466.168 405.112 466.362C405.112 466.556 405.175 466.745 405.292 466.9C405.409 467.055 405.573 467.168 405.76 467.222L440.239 487.125C440.689 487.355 441.187 487.474 441.692 487.474C442.197 487.474 442.694 487.355 443.144 487.125L477.52 467.239C477.707 467.185 477.871 467.073 477.988 466.918C478.105 466.763 478.168 466.574 478.168 466.379C478.168 466.185 478.105 465.996 477.988 465.841C477.871 465.686 477.707 465.573 477.52 465.52L443.144 445.616Z",
    fill: "url(#paint128_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.127 445.822C442.683 445.593 442.191 445.474 441.692 445.474C441.192 445.474 440.7 445.593 440.256 445.822L406.104 465.52C405.296 465.967 405.296 466.723 406.104 467.239L440.256 486.953C440.703 487.173 441.194 487.288 441.692 487.288C442.189 487.288 442.68 487.173 443.127 486.953L477.262 467.239C478.07 466.775 478.07 466.036 477.262 465.52L443.127 445.822Z",
    fill: "url(#paint129_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.126 446.012C442.68 445.792 442.189 445.677 441.691 445.677C441.194 445.677 440.703 445.792 440.256 446.012L406.43 465.52C406.232 465.56 406.053 465.667 405.925 465.824C405.796 465.981 405.726 466.177 405.726 466.379C405.726 466.582 405.796 466.778 405.925 466.935C406.053 467.091 406.232 467.199 406.43 467.239L440.256 486.764C440.7 486.993 441.192 487.113 441.691 487.113C442.191 487.113 442.683 486.993 443.126 486.764L476.935 467.256C477.134 467.216 477.312 467.109 477.441 466.952C477.569 466.795 477.639 466.599 477.639 466.396C477.639 466.194 477.569 465.998 477.441 465.841C477.312 465.684 477.134 465.577 476.935 465.537L443.126 446.012Z",
    fill: "url(#paint130_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.112 446.201C442.672 445.98 442.186 445.865 441.694 445.865C441.201 445.865 440.716 445.98 440.276 446.201L406.776 465.537C406.003 465.984 406.003 466.706 406.776 467.17L440.276 486.506C440.716 486.727 441.201 486.842 441.694 486.842C442.186 486.842 442.672 486.727 443.112 486.506L476.594 467.17C476.766 467.113 476.916 467.004 477.022 466.858C477.128 466.711 477.185 466.535 477.185 466.354C477.185 466.173 477.128 465.996 477.022 465.85C476.916 465.703 476.766 465.594 476.594 465.537L443.112 446.201Z",
    fill: "url(#paint131_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.093 446.407C442.659 446.186 442.179 446.072 441.692 446.072C441.205 446.072 440.725 446.186 440.291 446.407L407.118 465.537C406.952 465.597 406.809 465.707 406.708 465.852C406.606 465.996 406.552 466.168 406.552 466.345C406.552 466.521 406.606 466.694 406.708 466.838C406.809 466.983 406.952 467.093 407.118 467.153L440.291 486.317C440.728 486.529 441.207 486.639 441.692 486.639C442.177 486.639 442.656 486.529 443.093 486.317L476.248 467.17C476.414 467.11 476.558 467 476.659 466.855C476.76 466.711 476.815 466.539 476.815 466.362C476.815 466.186 476.76 466.013 476.659 465.869C476.558 465.724 476.414 465.615 476.248 465.554L443.093 446.407Z",
    fill: "url(#paint132_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.075 446.596C442.644 446.384 442.171 446.273 441.691 446.273C441.211 446.273 440.738 446.384 440.307 446.596L407.461 465.503C406.688 465.933 406.688 466.654 407.461 467.101L440.307 486.008C440.735 486.228 441.21 486.343 441.691 486.343C442.172 486.343 442.647 486.228 443.075 486.008L475.904 467.101C476.677 466.672 476.677 465.95 475.904 465.503L443.075 446.596Z",
    fill: "url(#paint133_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.059 446.802C442.637 446.582 442.168 446.467 441.692 446.467C441.216 446.467 440.748 446.582 440.326 446.802L407.789 465.554C407.627 465.614 407.487 465.721 407.389 465.863C407.29 466.004 407.237 466.173 407.237 466.345C407.237 466.517 407.29 466.686 407.389 466.827C407.487 466.969 407.627 467.076 407.789 467.136L440.326 485.922C440.75 486.134 441.218 486.244 441.692 486.244C442.167 486.244 442.634 486.134 443.059 485.922L475.578 467.153C476.335 466.706 476.335 466.001 475.578 465.572L443.059 446.802Z",
    fill: "url(#paint134_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.059 446.991C442.635 446.779 442.167 446.669 441.693 446.669C441.218 446.669 440.751 446.779 440.326 446.991L408.133 465.554C407.377 466.001 407.377 466.706 408.133 467.136L440.326 485.647C440.748 485.867 441.217 485.982 441.693 485.982C442.168 485.982 442.637 485.867 443.059 485.647L475.235 467.067C475.399 467.012 475.541 466.907 475.642 466.766C475.743 466.626 475.797 466.458 475.797 466.285C475.797 466.112 475.743 465.943 475.642 465.803C475.541 465.663 475.399 465.558 475.235 465.503L443.059 446.991Z",
    fill: "url(#paint135_linear_1606_3980)",
    fillOpacity: 0.15
  }))), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M478.48 424.509H405.053V465.915C405.071 466.094 405.136 466.264 405.242 466.409C405.348 466.554 405.49 466.668 405.654 466.74L440.305 486.747C440.759 486.984 441.263 487.107 441.775 487.107C442.287 487.107 442.791 486.984 443.244 486.747L477.878 466.74C478.045 466.667 478.189 466.55 478.295 466.402C478.4 466.253 478.464 466.079 478.48 465.898V424.509Z",
    fill: "#2C2067"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M477.878 436.661L443.244 456.651C442.791 456.887 442.287 457.011 441.775 457.011C441.263 457.011 440.759 456.887 440.305 456.651L405.654 436.644C405.49 436.572 405.348 436.458 405.242 436.313C405.136 436.168 405.071 435.997 405.053 435.819V441.56C405.071 441.738 405.136 441.909 405.242 442.053C405.348 442.198 405.49 442.313 405.654 442.385L440.305 462.392C440.762 462.62 441.265 462.739 441.775 462.739C442.285 462.739 442.788 462.62 443.244 462.392L477.878 442.402C478.043 442.326 478.185 442.208 478.29 442.06C478.396 441.913 478.461 441.74 478.48 441.56V435.802C478.464 435.985 478.4 436.161 478.294 436.312C478.189 436.463 478.045 436.583 477.878 436.661Z",
    fill: "#352685"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M477.878 452.027L443.244 472.017C442.788 472.245 442.285 472.364 441.775 472.364C441.265 472.364 440.762 472.245 440.305 472.017L405.654 452.01C405.488 451.937 405.344 451.82 405.238 451.672C405.132 451.523 405.068 451.349 405.053 451.168V456.909C405.068 457.09 405.132 457.264 405.238 457.412C405.344 457.561 405.488 457.678 405.654 457.751L440.305 477.758C440.762 477.986 441.265 478.105 441.775 478.105C442.285 478.105 442.788 477.986 443.244 477.758L477.878 457.751C478.045 457.678 478.189 457.561 478.295 457.412C478.4 457.264 478.464 457.09 478.48 456.909V451.168C478.462 451.351 478.398 451.526 478.292 451.677C478.187 451.827 478.044 451.948 477.878 452.027Z",
    fill: "#352685"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M443.244 403.677C442.788 403.449 442.285 403.33 441.775 403.33C441.265 403.33 440.761 403.449 440.305 403.677L405.654 423.667C405.467 423.721 405.303 423.833 405.186 423.988C405.069 424.143 405.006 424.332 405.006 424.527C405.006 424.721 405.069 424.91 405.186 425.065C405.303 425.22 405.467 425.333 405.654 425.386L440.305 445.393C440.761 445.621 441.265 445.74 441.775 445.74C442.285 445.74 442.788 445.621 443.244 445.393L477.878 425.386C478.065 425.333 478.229 425.22 478.346 425.065C478.463 424.91 478.526 424.721 478.526 424.527C478.526 424.332 478.463 424.143 478.346 423.988C478.229 423.833 478.065 423.721 477.878 423.667L443.244 403.677Z",
    fill: "#7564C9"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M423.463 416.74C433.054 411.206 448.763 411.206 458.354 416.74C467.945 422.275 467.945 431.35 458.354 436.885C448.763 442.419 433.054 442.419 423.463 436.885C413.872 431.35 413.872 422.275 423.463 416.74Z",
    fill: "url(#paint136_radial_1606_3980)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M462.256 405.843H459.935C458.843 404.679 457.579 403.688 456.188 402.904C448.11 398.246 434.892 398.246 426.831 402.904C425.44 403.688 424.176 404.679 423.084 405.843H420.764V411.343C420.764 414.42 422.757 417.514 426.831 419.937C434.892 424.612 448.11 424.612 456.188 419.937C460.245 417.6 462.273 414.506 462.256 411.343V405.843Z",
    fill: "#E5E9F4"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M426.831 402.904C425.44 403.688 424.176 404.679 423.084 405.843H420.764V411.343C420.764 414.42 422.757 417.514 426.831 419.937L427.209 420.161V414.626L431.197 401.065C429.682 401.525 428.219 402.141 426.831 402.904Z",
    fill: "#FFC107"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M426.832 397.369C434.893 392.711 448.111 392.711 456.189 397.369C464.268 402.027 464.268 409.659 456.189 414.334C448.111 419.009 434.893 418.992 426.832 414.334C418.771 409.676 418.685 402.027 426.832 397.369Z",
    fill: "#FAFBFD"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M441.513 393.88C436.407 393.753 431.353 394.937 426.834 397.318C418.756 401.976 418.756 409.607 426.834 414.282L427.212 414.489L441.513 407.613V393.88Z",
    fill: "#FFCD39"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M421.041 407.734H441.512V393.88C436.406 393.753 431.353 394.937 426.834 397.318C421.952 400.171 420.045 404.056 421.041 407.734Z",
    fill: "#5A3CFF"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter3_f_1606_3980)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.1798 310.621C64.5857 310.321 63.9292 310.164 63.2633 310.164C62.5975 310.164 61.941 310.321 61.3469 310.621L15.7986 336.885C15.5661 336.962 15.3638 337.111 15.2204 337.31C15.0771 337.509 15 337.748 15 337.993C15 338.239 15.0771 338.478 15.2204 338.677C15.3638 338.876 15.5661 339.024 15.7986 339.102L61.3469 365.331C61.9398 365.636 62.5967 365.794 63.2633 365.794C63.9299 365.794 64.5869 365.636 65.1798 365.331L110.694 339.05C110.926 338.973 111.128 338.824 111.272 338.625C111.415 338.426 111.492 338.187 111.492 337.942C111.492 337.697 111.415 337.458 111.272 337.259C111.128 337.06 110.926 336.911 110.694 336.833L65.1798 310.621Z",
    fill: "url(#paint137_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1633 310.811C64.571 310.514 63.9178 310.36 63.2554 310.36C62.5931 310.36 61.9399 310.514 61.3476 310.811L16.1431 336.902C15.9165 336.983 15.7206 337.133 15.5821 337.33C15.4436 337.526 15.3693 337.761 15.3693 338.002C15.3693 338.243 15.4436 338.478 15.5821 338.675C15.7206 338.871 15.9165 339.021 16.1431 339.102L61.3476 365.211C61.9399 365.507 62.5931 365.661 63.2554 365.661C63.9178 365.661 64.571 365.507 65.1633 365.211L110.368 339.119C110.6 339.042 110.803 338.893 110.946 338.694C111.089 338.495 111.166 338.256 111.166 338.011C111.166 337.765 111.089 337.526 110.946 337.327C110.803 337.128 110.6 336.98 110.368 336.902L65.1633 310.811Z",
    fill: "url(#paint138_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1623 311.017C64.573 310.721 63.9226 310.566 63.263 310.566C62.6035 310.566 61.953 310.721 61.3638 311.017L16.4859 336.902C16.2573 336.979 16.0587 337.126 15.918 337.321C15.7773 337.517 15.7016 337.752 15.7016 337.993C15.7016 338.235 15.7773 338.47 15.918 338.665C16.0587 338.861 16.2573 339.008 16.4859 339.085L61.3638 365.004C61.953 365.301 62.6035 365.455 63.263 365.455C63.9226 365.455 64.573 365.301 65.1623 365.004L110.023 339.102C110.252 339.025 110.45 338.878 110.591 338.683C110.732 338.487 110.807 338.252 110.807 338.011C110.807 337.77 110.732 337.534 110.591 337.339C110.45 337.143 110.252 336.996 110.023 336.919L65.1623 311.017Z",
    fill: "url(#paint139_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1464 311.206C64.5632 310.91 63.9184 310.756 63.2643 310.756C62.6103 310.756 61.9655 310.91 61.3823 311.206L16.8138 336.988C16.5912 337.069 16.3989 337.216 16.263 337.409C16.127 337.603 16.0541 337.834 16.0541 338.071C16.0541 338.307 16.127 338.538 16.263 338.732C16.3989 338.926 16.5912 339.073 16.8138 339.154L61.3823 364.936C61.9655 365.232 62.6103 365.386 63.2643 365.386C63.9184 365.386 64.5632 365.232 65.1464 364.936L109.681 339.154C109.909 339.077 110.108 338.93 110.248 338.734C110.389 338.538 110.465 338.303 110.465 338.062C110.465 337.821 110.389 337.586 110.248 337.39C110.108 337.194 109.909 337.048 109.681 336.971L65.1464 311.206Z",
    fill: "url(#paint140_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1279 311.412C64.5511 311.115 63.9118 310.96 63.263 310.96C62.6142 310.96 61.9749 311.115 61.3981 311.412L17.1562 336.919C16.9336 337 16.7413 337.147 16.6054 337.341C16.4695 337.534 16.3965 337.765 16.3965 338.002C16.3965 338.239 16.4695 338.47 16.6054 338.663C16.7413 338.857 16.9336 339.004 17.1562 339.085L61.3981 364.609C61.9749 364.906 62.6142 365.061 63.263 365.061C63.9118 365.061 64.5511 364.906 65.1279 364.609L109.301 339.085C109.526 339.009 109.721 338.864 109.859 338.671C109.997 338.479 110.071 338.248 110.071 338.011C110.071 337.773 109.997 337.542 109.859 337.35C109.721 337.157 109.526 337.012 109.301 336.936L65.1279 311.412Z",
    fill: "url(#paint141_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1113 311.601C64.5351 311.312 63.8995 311.162 63.255 311.162C62.6105 311.162 61.9749 311.312 61.3987 311.601L17.5005 336.936C17.2738 337.008 17.0758 337.149 16.9352 337.341C16.7946 337.533 16.7188 337.764 16.7188 338.002C16.7188 338.24 16.7946 338.471 16.9352 338.663C17.0758 338.854 17.2738 338.996 17.5005 339.068L61.4159 364.42C61.989 364.709 62.6218 364.859 63.2636 364.859C63.9053 364.859 64.5381 364.709 65.1113 364.42L109.009 339.085C109.234 339.009 109.429 338.864 109.567 338.671C109.705 338.479 109.779 338.248 109.779 338.011C109.779 337.774 109.705 337.542 109.567 337.35C109.429 337.157 109.234 337.012 109.009 336.936L65.1113 311.601Z",
    fill: "url(#paint142_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0939 311.79C64.5237 311.502 63.8937 311.351 63.2547 311.351C62.6158 311.351 61.9858 311.502 61.4156 311.79L17.8269 336.936C17.6083 337.016 17.4196 337.161 17.2862 337.352C17.1529 337.542 17.0814 337.769 17.0814 338.002C17.0814 338.235 17.1529 338.462 17.2862 338.652C17.4196 338.843 17.6083 338.988 17.8269 339.068L61.4156 364.231C61.9858 364.519 62.6158 364.67 63.2547 364.67C63.8937 364.67 64.5237 364.519 65.0939 364.231L108.665 339.068C108.886 338.992 109.077 338.85 109.213 338.66C109.348 338.471 109.421 338.244 109.421 338.011C109.421 337.778 109.348 337.55 109.213 337.361C109.077 337.171 108.886 337.029 108.665 336.953L65.0939 311.79Z",
    fill: "url(#paint143_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0951 312.048C64.5279 311.76 63.9007 311.609 63.2645 311.609C62.6283 311.609 62.0011 311.76 61.434 312.048L18.2062 336.936C17.9858 337.012 17.7944 337.154 17.6589 337.344C17.5235 337.533 17.4506 337.76 17.4506 337.993C17.4506 338.226 17.5235 338.453 17.6589 338.643C17.7944 338.833 17.9858 338.975 18.2062 339.05L61.4684 364.025C62.0355 364.313 62.6627 364.463 63.2989 364.463C63.9351 364.463 64.5623 364.313 65.1294 364.025L108.357 339.068C108.578 338.992 108.769 338.85 108.905 338.66C109.04 338.471 109.113 338.244 109.113 338.011C109.113 337.778 109.04 337.55 108.905 337.361C108.769 337.171 108.578 337.029 108.357 336.953L65.0951 312.048Z",
    fill: "url(#paint144_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0774 312.186C64.514 311.905 63.8933 311.76 63.2641 311.76C62.6349 311.76 62.0142 311.905 61.4508 312.186L18.4808 336.953C18.2662 337.032 18.0811 337.175 17.9503 337.363C17.8195 337.55 17.7494 337.773 17.7494 338.002C17.7494 338.231 17.8195 338.454 17.9503 338.641C18.0811 338.829 18.2662 338.971 18.4808 339.05L61.4508 363.836C62.0142 364.116 62.6349 364.261 63.2641 364.261C63.8933 364.261 64.514 364.116 65.0774 363.836L108.047 339.05C108.264 338.976 108.452 338.835 108.584 338.649C108.717 338.463 108.789 338.239 108.789 338.011C108.789 337.782 108.717 337.558 108.584 337.372C108.452 337.186 108.264 337.045 108.047 336.971L65.0774 312.186Z",
    fill: "url(#paint145_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.061 312.375C64.5036 312.095 63.8885 311.949 63.2649 311.949C62.6412 311.949 62.0261 312.095 61.4687 312.375L18.8596 336.953C17.8627 337.538 17.8627 338.466 18.8596 339.033L61.4687 363.612C62.0261 363.892 62.6412 364.037 63.2649 364.037C63.8885 364.037 64.5036 363.892 65.061 363.612L107.584 339.05C107.801 338.976 107.988 338.835 108.121 338.649C108.254 338.463 108.325 338.239 108.325 338.01C108.325 337.782 108.254 337.558 108.121 337.372C107.988 337.186 107.801 337.045 107.584 336.971L65.061 312.375Z",
    fill: "url(#paint146_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0412 312.581C64.4867 312.301 63.8745 312.156 63.2536 312.156C62.6327 312.156 62.0205 312.301 61.4661 312.581L19.1836 336.971C18.965 337.041 18.7743 337.178 18.6391 337.364C18.5038 337.549 18.4309 337.772 18.4309 338.002C18.4309 338.231 18.5038 338.455 18.6391 338.64C18.7743 338.826 18.965 338.963 19.1836 339.033L61.4661 363.44C62.0205 363.72 62.6327 363.865 63.2536 363.865C63.8745 363.865 64.4867 363.72 65.0412 363.44L107.306 339.033C107.519 338.959 107.703 338.821 107.833 338.638C107.963 338.455 108.033 338.235 108.033 338.01C108.033 337.786 107.963 337.566 107.833 337.383C107.703 337.2 107.519 337.062 107.306 336.988L65.0412 312.581Z",
    fill: "url(#paint147_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0238 312.77C64.4731 312.499 63.8673 312.357 63.2534 312.357C62.6394 312.357 62.0337 312.499 61.483 312.77L19.5271 336.971C19.3148 337.045 19.1307 337.183 19.0004 337.366C18.8701 337.549 18.8002 337.769 18.8002 337.993C18.8002 338.218 18.8701 338.438 19.0004 338.621C19.1307 338.804 19.3148 338.942 19.5271 339.016L61.483 363.251C62.0337 363.523 62.6394 363.664 63.2534 363.664C63.8673 363.664 64.4731 363.523 65.0238 363.251L106.962 339.033C107.175 338.959 107.359 338.821 107.489 338.638C107.619 338.455 107.689 338.235 107.689 338.011C107.689 337.786 107.619 337.566 107.489 337.383C107.359 337.2 107.175 337.062 106.962 336.988L65.0238 312.77Z",
    fill: "url(#paint148_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0257 312.976C64.4804 312.697 63.8765 312.552 63.2639 312.552C62.6513 312.552 62.0475 312.697 61.5021 312.976L19.9244 336.988C18.9446 337.538 18.9446 338.449 19.9244 339.016L61.5537 363.079C62.0991 363.358 62.7029 363.504 63.3155 363.504C63.9281 363.504 64.5319 363.358 65.0773 363.079L106.689 339.016C106.902 338.942 107.086 338.804 107.216 338.621C107.346 338.437 107.416 338.218 107.416 337.993C107.416 337.768 107.346 337.549 107.216 337.366C107.086 337.183 106.902 337.045 106.689 336.971L65.0257 312.976Z",
    fill: "url(#paint149_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0073 313.165C64.4724 312.903 63.8844 312.766 63.2885 312.766C62.6927 312.766 62.1047 312.903 61.5697 313.165L20.3185 336.988C20.1102 337.061 19.9298 337.197 19.8021 337.377C19.6744 337.557 19.6058 337.772 19.6058 337.993C19.6058 338.214 19.6744 338.429 19.8021 338.609C19.9298 338.79 20.1102 338.926 20.3185 338.999L61.5697 362.856C62.1047 363.118 62.6927 363.255 63.2885 363.255C63.8844 363.255 64.4724 363.118 65.0073 362.856L106.259 339.016C106.467 338.943 106.647 338.807 106.775 338.627C106.903 338.447 106.971 338.231 106.971 338.01C106.971 337.79 106.903 337.574 106.775 337.394C106.647 337.214 106.467 337.078 106.259 337.005L65.0073 313.165Z",
    fill: "url(#paint150_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9892 313.354C64.4562 313.085 63.8675 312.945 63.2704 312.945C62.6734 312.945 62.0847 313.085 61.5516 313.354L20.5411 337.005C20.3307 337.074 20.1473 337.207 20.0173 337.386C19.8874 337.565 19.8173 337.781 19.8173 338.002C19.8173 338.223 19.8874 338.439 20.0173 338.618C20.1473 338.797 20.3307 338.93 20.5411 338.999L61.5344 362.667C62.0675 362.936 62.6562 363.076 63.2532 363.076C63.8503 363.076 64.439 362.936 64.972 362.667L105.931 339.016C106.139 338.943 106.32 338.807 106.448 338.627C106.575 338.447 106.644 338.231 106.644 338.011C106.644 337.79 106.575 337.575 106.448 337.394C106.32 337.214 106.139 337.078 105.931 337.005L64.9892 313.354Z",
    fill: "url(#paint151_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9723 313.561C64.44 313.289 63.851 313.147 63.2535 313.147C62.6559 313.147 62.0669 313.289 61.5347 313.561L20.885 337.005C20.6808 337.077 20.5039 337.211 20.3788 337.388C20.2538 337.565 20.1866 337.777 20.1866 337.993C20.1866 338.21 20.2538 338.422 20.3788 338.599C20.5039 338.775 20.6808 338.909 20.885 338.982L61.5347 362.461C62.0669 362.732 62.6559 362.874 63.2535 362.874C63.851 362.874 64.44 362.732 64.9723 362.461L105.622 338.999C105.826 338.927 106.003 338.793 106.128 338.616C106.253 338.439 106.32 338.227 106.32 338.011C106.32 337.794 106.253 337.582 106.128 337.406C106.003 337.229 105.826 337.095 105.622 337.022L64.9723 313.561Z",
    fill: "url(#paint152_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9579 313.767C64.4248 313.498 63.8361 313.358 63.2391 313.358C62.642 313.358 62.0533 313.498 61.5203 313.767L21.2316 337.022C21.0253 337.09 20.8456 337.221 20.7182 337.397C20.5909 337.573 20.5223 337.785 20.5223 338.002C20.5223 338.219 20.5909 338.431 20.7182 338.607C20.8456 338.783 21.0253 338.914 21.2316 338.982L61.5546 362.271C62.0877 362.54 62.6764 362.68 63.2734 362.68C63.8705 362.68 64.4592 362.54 64.9922 362.271L105.315 338.999C105.52 338.927 105.696 338.793 105.822 338.616C105.947 338.439 106.014 338.227 106.014 338.011C106.014 337.794 105.947 337.582 105.822 337.406C105.696 337.229 105.52 337.095 105.315 337.022L64.9579 313.767Z",
    fill: "url(#paint153_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9549 313.956C64.4252 313.676 63.8352 313.53 63.2361 313.53C62.637 313.53 62.047 313.676 61.5173 313.956L21.6411 337.022C21.4348 337.09 21.2552 337.221 21.1278 337.397C21.0004 337.573 20.9319 337.785 20.9319 338.002C20.9319 338.219 21.0004 338.431 21.1278 338.607C21.2552 338.783 21.4348 338.914 21.6411 338.982L61.5689 362.065C62.0985 362.345 62.6886 362.492 63.2877 362.492C63.8868 362.492 64.4768 362.345 65.0065 362.065L104.986 338.982C105.186 338.91 105.359 338.778 105.482 338.605C105.604 338.431 105.67 338.223 105.67 338.011C105.67 337.798 105.604 337.59 105.482 337.417C105.359 337.243 105.186 337.111 104.986 337.04L64.9549 313.956Z",
    fill: "url(#paint154_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9408 314.145C64.4212 313.882 63.8472 313.745 63.2649 313.745C62.6827 313.745 62.1086 313.882 61.5891 314.145L21.902 337.039C21.6997 337.106 21.5237 337.236 21.399 337.408C21.2743 337.581 21.2072 337.789 21.2072 338.002C21.2072 338.215 21.2743 338.423 21.399 338.595C21.5237 338.768 21.6997 338.897 21.902 338.964L61.5891 361.893C62.1086 362.156 62.6827 362.293 63.2649 362.293C63.8472 362.293 64.4212 362.156 64.9408 361.893L104.593 338.999C104.794 338.927 104.967 338.795 105.089 338.622C105.212 338.448 105.278 338.24 105.278 338.028C105.278 337.815 105.212 337.608 105.089 337.434C104.967 337.26 104.794 337.128 104.593 337.057L64.9408 314.145Z",
    fill: "url(#paint155_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9222 314.334C64.4064 314.079 63.8389 313.947 63.2636 313.947C62.6883 313.947 62.1208 314.079 61.6049 314.334L22.2444 337.04C22.0421 337.107 21.8662 337.236 21.7414 337.408C21.6167 337.581 21.5496 337.789 21.5496 338.002C21.5496 338.215 21.6167 338.423 21.7414 338.596C21.8662 338.768 22.0421 338.897 22.2444 338.965L61.6049 361.687C62.1208 361.942 62.6883 362.074 63.2636 362.074C63.8389 362.074 64.4064 361.942 64.9222 361.687L104.266 338.965C104.462 338.894 104.631 338.764 104.751 338.594C104.871 338.423 104.936 338.219 104.936 338.011C104.936 337.802 104.871 337.598 104.751 337.428C104.631 337.257 104.462 337.127 104.266 337.057L64.9222 314.334Z",
    fill: "url(#paint156_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9061 314.54C64.3956 314.278 63.83 314.141 63.256 314.141C62.6821 314.141 62.1164 314.278 61.606 314.54L22.5892 337.057C22.391 337.123 22.2187 337.25 22.0966 337.42C21.9745 337.589 21.9088 337.793 21.9088 338.002C21.9088 338.211 21.9745 338.415 22.0966 338.584C22.2187 338.754 22.391 338.881 22.5892 338.947L61.606 361.481C62.1164 361.743 62.6821 361.88 63.256 361.88C63.83 361.88 64.3956 361.743 64.9061 361.481L103.923 338.965C104.119 338.894 104.289 338.764 104.409 338.593C104.529 338.423 104.593 338.219 104.593 338.011C104.593 337.802 104.529 337.598 104.409 337.428C104.289 337.257 104.119 337.127 103.923 337.057L64.9061 314.54Z",
    fill: "url(#paint157_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.888 314.729C64.3811 314.475 63.822 314.343 63.2551 314.343C62.6882 314.343 62.1291 314.475 61.6222 314.729L22.9148 337.074C22.7166 337.14 22.5443 337.267 22.4222 337.437C22.3001 337.607 22.2344 337.81 22.2344 338.019C22.2344 338.228 22.3001 338.432 22.4222 338.602C22.5443 338.771 22.7166 338.898 22.9148 338.965L61.6222 361.309C62.1291 361.563 62.6882 361.695 63.2551 361.695C63.822 361.695 64.3811 361.563 64.888 361.309L103.578 338.965C103.77 338.895 103.936 338.767 104.054 338.6C104.171 338.432 104.234 338.232 104.234 338.028C104.234 337.823 104.171 337.624 104.054 337.456C103.936 337.288 103.77 337.161 103.578 337.091L64.888 314.729Z",
    fill: "url(#paint158_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8889 314.919C64.3828 314.672 63.8274 314.544 63.2646 314.544C62.7018 314.544 62.1464 314.672 61.6403 314.919L23.2595 337.057C23.0673 337.127 22.9013 337.254 22.7839 337.422C22.6666 337.589 22.6037 337.789 22.6037 337.993C22.6037 338.198 22.6666 338.398 22.7839 338.565C22.9013 338.733 23.0673 338.86 23.2595 338.93L61.6403 361.103C62.1464 361.349 62.7018 361.477 63.2646 361.477C63.8274 361.477 64.3828 361.349 64.8889 361.103L103.235 338.947C103.428 338.877 103.594 338.75 103.711 338.582C103.828 338.415 103.891 338.215 103.891 338.011C103.891 337.806 103.828 337.606 103.711 337.439C103.594 337.271 103.428 337.144 103.235 337.074L64.8889 314.919Z",
    fill: "url(#paint159_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8705 315.125C64.3727 314.871 63.822 314.739 63.2634 314.739C62.7048 314.739 62.1541 314.871 61.6563 315.125L23.6021 337.074C23.4079 337.139 23.2393 337.264 23.1198 337.431C23.0003 337.597 22.936 337.797 22.936 338.002C22.936 338.207 23.0003 338.407 23.1198 338.573C23.2393 338.74 23.4079 338.865 23.6021 338.93L61.6563 360.896C62.1541 361.15 62.7048 361.282 63.2634 361.282C63.822 361.282 64.3727 361.15 64.8705 360.896L102.908 338.93C103.096 338.861 103.258 338.736 103.373 338.571C103.488 338.407 103.549 338.211 103.549 338.011C103.549 337.81 103.488 337.614 103.373 337.45C103.258 337.286 103.096 337.16 102.908 337.091L64.8705 315.125Z",
    fill: "url(#paint160_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8531 315.314C64.359 315.068 63.8149 314.941 63.2632 314.941C62.7116 314.941 62.1674 315.068 61.6733 315.314L23.8597 337.074C23.6715 337.143 23.5091 337.268 23.3943 337.433C23.2795 337.597 23.218 337.793 23.218 337.993C23.218 338.194 23.2795 338.39 23.3943 338.554C23.5091 338.718 23.6715 338.844 23.8597 338.913L61.6733 360.707C62.1674 360.953 62.7116 361.08 63.2632 361.08C63.8149 361.08 64.359 360.953 64.8531 360.707L102.564 338.93C102.752 338.861 102.914 338.736 103.029 338.571C103.144 338.407 103.205 338.211 103.205 338.01C103.205 337.81 103.144 337.614 103.029 337.45C102.914 337.285 102.752 337.16 102.564 337.091L64.8531 315.314Z",
    fill: "url(#paint161_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8363 315.486C64.3476 315.233 63.8053 315.1 63.255 315.1C62.7046 315.1 62.1623 315.233 61.6737 315.486L24.2726 337.091C24.0825 337.156 23.9174 337.279 23.8006 337.442C23.6837 337.605 23.6209 337.801 23.6209 338.002C23.6209 338.203 23.6837 338.399 23.8006 338.562C23.9174 338.725 24.0825 338.848 24.2726 338.913L61.6737 360.501C62.1623 360.754 62.7046 360.886 63.255 360.886C63.8053 360.886 64.3476 360.754 64.8363 360.501L102.22 338.93C102.408 338.861 102.571 338.736 102.686 338.571C102.8 338.407 102.862 338.211 102.862 338.011C102.862 337.81 102.8 337.614 102.686 337.45C102.571 337.285 102.408 337.16 102.22 337.091L64.8363 315.486Z",
    fill: "url(#paint162_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8195 315.709C64.3353 315.462 63.7992 315.333 63.2554 315.333C62.7116 315.333 62.1756 315.462 61.6913 315.709L24.6168 337.091C24.4244 337.151 24.2563 337.271 24.137 337.433C24.0176 337.596 23.9532 337.792 23.9532 337.993C23.9532 338.195 24.0176 338.391 24.137 338.553C24.2563 338.716 24.4244 338.836 24.6168 338.896L61.6913 360.312C62.1756 360.559 62.7116 360.688 63.2554 360.688C63.7992 360.688 64.3353 360.559 64.8195 360.312L101.894 338.913C102.086 338.853 102.254 338.733 102.374 338.571C102.493 338.408 102.558 338.212 102.558 338.011C102.558 337.809 102.493 337.613 102.374 337.451C102.254 337.288 102.086 337.168 101.894 337.108L64.8195 315.709Z",
    fill: "url(#paint163_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8193 315.898C64.335 315.661 63.8029 315.538 63.2638 315.538C62.7246 315.538 62.1926 315.661 61.7083 315.898L24.9603 337.108C24.1009 337.589 24.1009 338.397 24.9603 338.827L61.7083 360.175C62.1926 360.411 62.7246 360.535 63.2638 360.535C63.8029 360.535 64.335 360.411 64.8193 360.175L101.55 338.965C101.742 338.904 101.911 338.785 102.03 338.622C102.149 338.46 102.214 338.264 102.214 338.062C102.214 337.861 102.149 337.664 102.03 337.502C101.911 337.34 101.742 337.22 101.55 337.16L64.8193 315.898Z",
    fill: "url(#paint164_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8021 316.104C64.3245 315.865 63.7978 315.741 63.2638 315.741C62.7298 315.741 62.2031 315.865 61.7255 316.104L25.2869 337.108C25.1223 337.183 24.9829 337.305 24.8851 337.457C24.7874 337.609 24.7354 337.786 24.7354 337.967C24.7354 338.148 24.7874 338.326 24.8851 338.478C24.9829 338.63 25.1223 338.751 25.2869 338.827L61.7255 359.848C62.2031 360.087 62.7298 360.211 63.2638 360.211C63.7978 360.211 64.3245 360.087 64.8021 359.848L101.206 338.827C101.377 338.757 101.523 338.638 101.626 338.485C101.729 338.332 101.784 338.152 101.784 337.967C101.784 337.783 101.729 337.603 101.626 337.45C101.523 337.297 101.377 337.178 101.206 337.108L64.8021 316.104Z",
    fill: "url(#paint165_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7858 316.293C64.3127 316.06 63.7922 315.939 63.2646 315.939C62.7371 315.939 62.2166 316.06 61.7435 316.293L25.6487 337.125C25.4779 337.195 25.3318 337.314 25.2289 337.467C25.126 337.62 25.0711 337.8 25.0711 337.985C25.0711 338.169 25.126 338.349 25.2289 338.502C25.3318 338.656 25.4779 338.774 25.6487 338.844L61.7435 359.693C62.2166 359.927 62.7371 360.048 63.2646 360.048C63.7922 360.048 64.3127 359.927 64.7858 359.693L100.881 338.861C101.051 338.792 101.197 338.673 101.3 338.52C101.403 338.367 101.458 338.186 101.458 338.002C101.458 337.818 101.403 337.637 101.3 337.484C101.197 337.331 101.051 337.212 100.881 337.143L64.7858 316.293Z",
    fill: "url(#paint166_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7676 316.5C64.2968 316.269 63.7794 316.149 63.2551 316.149C62.7308 316.149 62.2134 316.269 61.7426 316.5L25.9743 337.125C25.8036 337.195 25.6574 337.314 25.5545 337.467C25.4517 337.62 25.3967 337.8 25.3967 337.985C25.3967 338.169 25.4517 338.35 25.5545 338.503C25.6574 338.656 25.8036 338.775 25.9743 338.844L61.7426 359.47C62.2134 359.701 62.7308 359.821 63.2551 359.821C63.7794 359.821 64.2968 359.701 64.7676 359.47L100.536 338.844C100.714 338.782 100.868 338.665 100.977 338.512C101.086 338.358 101.145 338.174 101.145 337.985C101.145 337.796 101.086 337.612 100.977 337.458C100.868 337.304 100.714 337.188 100.536 337.125L64.7676 316.5Z",
    fill: "url(#paint167_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7505 316.689C64.2877 316.452 63.7751 316.328 63.2552 316.328C62.7352 316.328 62.2227 316.452 61.7598 316.689L26.301 337.142C26.123 337.205 25.9688 337.321 25.8598 337.475C25.7507 337.629 25.6921 337.813 25.6921 338.002C25.6921 338.191 25.7507 338.375 25.8598 338.528C25.9688 338.682 26.123 338.799 26.301 338.861L61.7598 359.332C62.2227 359.569 62.7352 359.693 63.2552 359.693C63.7751 359.693 64.2877 359.569 64.7505 359.332L100.192 338.878C100.37 338.816 100.524 338.7 100.633 338.546C100.742 338.392 100.801 338.208 100.801 338.019C100.801 337.83 100.742 337.646 100.633 337.492C100.524 337.339 100.37 337.222 100.192 337.16L64.7505 316.689Z",
    fill: "url(#paint168_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7492 316.878C64.2852 316.655 63.7771 316.54 63.2624 316.54C62.7478 316.54 62.2397 316.655 61.7757 316.878L26.6434 337.143C26.4654 337.205 26.3113 337.321 26.2022 337.475C26.0931 337.629 26.0346 337.813 26.0346 338.002C26.0346 338.191 26.0931 338.375 26.2022 338.529C26.3113 338.682 26.4654 338.799 26.6434 338.861L61.7757 359.143C62.2397 359.366 62.7478 359.481 63.2624 359.481C63.7771 359.481 64.2852 359.366 64.7492 359.143L99.8471 338.861C100.034 338.808 100.198 338.695 100.315 338.54C100.432 338.385 100.495 338.196 100.495 338.002C100.495 337.808 100.432 337.619 100.315 337.464C100.198 337.309 100.034 337.196 99.8471 337.143L64.7492 316.878Z",
    fill: "url(#paint169_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7332 317.084C64.277 316.856 63.7738 316.737 63.2636 316.737C62.7534 316.737 62.2503 316.856 61.7941 317.084L26.9883 337.16C26.8016 337.213 26.6373 337.326 26.5203 337.481C26.4033 337.636 26.3401 337.825 26.3401 338.019C26.3401 338.213 26.4033 338.402 26.5203 338.557C26.6373 338.713 26.8016 338.825 26.9883 338.879L61.7941 358.971C62.2503 359.2 62.7534 359.319 63.2636 359.319C63.7738 359.319 64.277 359.2 64.7332 358.971L99.5217 338.861C99.7085 338.808 99.8728 338.695 99.9898 338.54C100.107 338.385 100.17 338.196 100.17 338.002C100.17 337.808 100.107 337.619 99.9898 337.464C99.8728 337.309 99.7085 337.196 99.5217 337.143L64.7332 317.084Z",
    fill: "url(#paint170_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7147 317.204C64.2649 316.975 63.7672 316.855 63.2623 316.855C62.7574 316.855 62.2597 316.975 61.8099 317.204L27.3308 337.16C27.144 337.213 26.9797 337.326 26.8627 337.481C26.7457 337.636 26.6825 337.825 26.6825 338.019C26.6825 338.213 26.7457 338.402 26.8627 338.557C26.9797 338.712 27.144 338.825 27.3308 338.878L61.8099 358.782C62.2597 359.012 62.7574 359.131 63.2623 359.131C63.7672 359.131 64.2649 359.012 64.7147 358.782L99.0907 338.878C99.2892 338.839 99.4678 338.731 99.5961 338.575C99.7244 338.418 99.7945 338.222 99.7945 338.019C99.7945 337.817 99.7244 337.62 99.5961 337.464C99.4678 337.307 99.2892 337.2 99.0907 337.16L64.7147 317.204Z",
    fill: "url(#paint171_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6984 317.462C64.2489 317.242 63.7551 317.128 63.2546 317.128C62.7541 317.128 62.2603 317.242 61.8108 317.462L27.6582 337.177C27.4597 337.217 27.2811 337.324 27.1528 337.481C27.0245 337.638 26.9544 337.834 26.9544 338.036C26.9544 338.239 27.0245 338.435 27.1528 338.592C27.2811 338.748 27.4597 338.856 27.6582 338.896L61.8108 358.628C62.2603 358.848 62.7541 358.962 63.2546 358.962C63.7551 358.962 64.2489 358.848 64.6984 358.628L98.8338 338.913C99.0323 338.873 99.2109 338.766 99.3392 338.609C99.4675 338.452 99.5376 338.256 99.5376 338.054C99.5376 337.851 99.4675 337.655 99.3392 337.498C99.2109 337.341 99.0323 337.234 98.8338 337.194L64.6984 317.462Z",
    fill: "url(#paint172_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6111 317.669C64.1704 317.44 63.6811 317.32 63.1845 317.32C62.6879 317.32 62.1986 317.44 61.7579 317.669L28.0007 337.177C27.8021 337.217 27.6235 337.324 27.4952 337.481C27.3669 337.638 27.2968 337.834 27.2968 338.036C27.2968 338.239 27.3669 338.435 27.4952 338.592C27.6235 338.748 27.8021 338.856 28.0007 338.896L61.8267 358.421C62.2673 358.65 62.7566 358.77 63.2533 358.77C63.7499 358.77 64.2392 358.65 64.6799 358.421L98.4887 338.896C98.6606 338.839 98.8103 338.73 98.9165 338.583C99.0226 338.437 99.0797 338.26 99.0797 338.079C99.0797 337.898 99.0226 337.722 98.9165 337.575C98.8103 337.429 98.6606 337.319 98.4887 337.263L64.6111 317.669Z",
    fill: "url(#paint173_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6136 317.858C64.1735 317.637 63.6879 317.522 63.1956 317.522C62.7032 317.522 62.2177 317.637 61.7776 317.858L28.3469 337.177C27.5734 337.641 27.5734 338.363 28.3469 338.81L61.8463 358.163C62.2864 358.384 62.772 358.499 63.2643 358.499C63.7567 358.499 64.2422 358.384 64.6823 358.163L98.1646 338.827C98.3365 338.77 98.4862 338.661 98.5923 338.514C98.6985 338.368 98.7556 338.192 98.7556 338.011C98.7556 337.83 98.6985 337.653 98.5923 337.507C98.4862 337.36 98.3365 337.251 98.1646 337.194L64.6136 317.858Z",
    fill: "url(#paint174_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6118 318.064C64.1777 317.843 63.6978 317.729 63.2109 317.729C62.7241 317.729 62.2442 317.843 61.8101 318.064L28.6888 337.194C28.5229 337.254 28.3796 337.364 28.2783 337.509C28.177 337.653 28.1226 337.825 28.1226 338.002C28.1226 338.178 28.177 338.351 28.2783 338.495C28.3796 338.64 28.5229 338.75 28.6888 338.81L61.8617 357.957C62.2957 358.178 62.7757 358.293 63.2625 358.293C63.7493 358.293 64.2293 358.178 64.6633 357.957L97.819 338.827C97.9909 338.77 98.1406 338.661 98.2468 338.514C98.3529 338.368 98.41 338.192 98.41 338.011C98.41 337.83 98.3529 337.653 98.2468 337.507C98.1406 337.36 97.9909 337.251 97.819 337.194L64.6118 318.064Z",
    fill: "url(#paint175_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6116 318.253C64.1806 318.033 63.7035 317.918 63.2194 317.918C62.7353 317.918 62.2582 318.033 61.8272 318.253L28.9809 337.16C28.815 337.22 28.6716 337.33 28.5703 337.474C28.469 337.619 28.4147 337.791 28.4147 337.968C28.4147 338.144 28.469 338.316 28.5703 338.461C28.6716 338.605 28.815 338.715 28.9809 338.775L61.8444 357.682C62.2724 357.902 62.7467 358.017 63.228 358.017C63.7093 358.017 64.1836 357.902 64.6116 357.682L97.4407 338.775C98.2142 338.328 98.2142 337.624 97.4407 337.177L64.6116 318.253Z",
    fill: "url(#paint176_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6121 318.442C64.1848 318.23 63.7141 318.12 63.2371 318.12C62.76 318.12 62.2894 318.23 61.862 318.442L29.3595 337.211C29.1976 337.271 29.0579 337.378 28.9591 337.52C28.8604 337.661 28.8075 337.829 28.8075 338.002C28.8075 338.174 28.8604 338.343 28.9591 338.484C29.0579 338.625 29.1976 338.733 29.3595 338.793L61.8792 357.579C62.3066 357.791 62.7772 357.901 63.2543 357.901C63.7313 357.901 64.2019 357.791 64.6293 357.579L97.1318 338.81C97.2997 338.754 97.4457 338.647 97.5492 338.503C97.6528 338.36 97.7085 338.187 97.7085 338.011C97.7085 337.834 97.6528 337.661 97.5492 337.518C97.4457 337.374 97.2997 337.267 97.1318 337.211L64.6121 318.442Z",
    fill: "url(#paint177_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6141 318.648C64.1928 318.437 63.7278 318.326 63.2563 318.326C62.7848 318.326 62.3198 318.437 61.8984 318.648L29.7053 337.211C29.5434 337.271 29.4036 337.379 29.3049 337.52C29.2062 337.661 29.1532 337.83 29.1532 338.002C29.1532 338.175 29.2062 338.343 29.3049 338.484C29.4036 338.626 29.5434 338.733 29.7053 338.793L61.8984 357.373C62.3198 357.585 62.7848 357.695 63.2563 357.695C63.7278 357.695 64.1928 357.585 64.6141 357.373L96.8073 338.793C96.9711 338.738 97.1135 338.633 97.2144 338.492C97.3152 338.352 97.3695 338.183 97.3695 338.011C97.3695 337.838 97.3152 337.669 97.2144 337.529C97.1135 337.389 96.9711 337.284 96.8073 337.229L64.6141 318.648Z",
    fill: "url(#paint178_linear_1606_3980)",
    fillOpacity: 0.15
  }))), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M100.056 296.167H26.6289V337.573C26.6473 337.751 26.7126 337.921 26.8183 338.066C26.924 338.211 27.0662 338.326 27.2305 338.398L61.8815 358.456C62.3347 358.684 62.8351 358.803 63.3425 358.803C63.8499 358.803 64.3503 358.684 64.8035 358.456L99.4545 338.466C99.619 338.39 99.761 338.272 99.8664 338.125C99.9719 337.977 100.037 337.805 100.056 337.624V296.167Z",
    fill: "#2C2067"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M99.4545 308.319L64.8035 328.308C64.3503 328.536 63.8499 328.655 63.3425 328.655C62.8351 328.655 62.3347 328.536 61.8815 328.308L27.2305 308.301C27.0662 308.229 26.924 308.115 26.8183 307.97C26.7126 307.825 26.6473 307.655 26.6289 307.476V313.217C26.6473 313.396 26.7126 313.566 26.8183 313.711C26.924 313.856 27.0662 313.97 27.2305 314.042L61.8815 334.049C62.3347 334.277 62.8351 334.396 63.3425 334.396C63.8499 334.396 64.3503 334.277 64.8035 334.049L99.4545 314.059C99.618 313.982 99.7591 313.864 99.8644 313.716C99.9696 313.569 100.036 313.397 100.056 313.217V307.476C100.037 307.657 99.9719 307.829 99.8664 307.977C99.761 308.124 99.619 308.242 99.4545 308.319Z",
    fill: "#5A3CFF"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M99.4545 323.667L64.8035 343.674C64.3503 343.902 63.8499 344.021 63.3425 344.021C62.8351 344.021 62.3347 343.902 61.8815 343.674L27.2305 323.667C27.0659 323.591 26.924 323.473 26.8185 323.326C26.7131 323.178 26.6477 323.006 26.6289 322.825V328.566C26.6477 328.746 26.7131 328.919 26.8185 329.066C26.924 329.214 27.0659 329.332 27.2305 329.408L61.8815 349.415C62.3347 349.643 62.8351 349.762 63.3425 349.762C63.8499 349.762 64.3503 349.643 64.8035 349.415L99.4545 329.408C99.6211 329.335 99.7649 329.218 99.8708 329.07C99.9767 328.921 100.041 328.747 100.056 328.566V322.825C100.041 323.007 99.9767 323.181 99.8708 323.329C99.7649 323.477 99.6211 323.594 99.4545 323.667Z",
    fill: "#5A3CFF"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8033 275.335C64.3517 275.101 63.8507 274.979 63.3423 274.979C62.8339 274.979 62.3329 275.101 61.8813 275.335L27.2303 295.307C27.0435 295.36 26.8792 295.473 26.7623 295.628C26.6453 295.783 26.582 295.972 26.582 296.166C26.582 296.361 26.6453 296.55 26.7623 296.705C26.8792 296.86 27.0435 296.973 27.2303 297.026L61.8813 317.033C62.3345 317.261 62.8349 317.38 63.3423 317.38C63.8497 317.38 64.3501 317.261 64.8033 317.033L99.4543 297.026C99.6411 296.973 99.8054 296.86 99.9223 296.705C100.039 296.55 100.103 296.361 100.103 296.166C100.103 295.972 100.039 295.783 99.9223 295.628C99.8054 295.473 99.6411 295.36 99.4543 295.307L64.8033 275.335Z",
    fill: "#7564C9"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M46.7555 286.679C56.3464 281.144 72.0562 281.144 81.6471 286.679C91.2381 292.213 91.2381 301.271 81.6471 306.823C72.0562 312.375 56.3464 312.358 46.7555 306.823C37.1646 301.289 37.113 292.213 46.7555 286.679Z",
    fill: "url(#paint179_radial_1606_3980)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0816 278.222H79.3597C78.3955 276.571 76.991 275.22 75.3033 274.321C71.7208 272.515 67.7648 271.574 63.753 271.574C59.7411 271.574 55.7851 272.515 52.2026 274.321C50.513 275.211 49.1119 276.564 48.1634 278.222H47.4243V280.68C47.2868 283.19 48.851 285.716 52.151 287.555C55.7336 289.361 59.6895 290.302 63.7014 290.302C67.7133 290.302 71.6692 289.361 75.2517 287.555C78.569 285.647 80.1331 283.121 79.9956 280.68L80.0816 278.222Z",
    fill: "url(#paint180_linear_1606_3980)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2871 284.874C81.6467 281.213 81.6467 275.232 75.2871 271.571C71.7046 269.765 67.7487 268.824 63.7368 268.824C59.7249 268.824 55.769 269.765 52.1865 271.571C45.8441 275.232 45.8441 281.213 52.1865 284.874C55.769 286.68 59.7249 287.62 63.7368 287.62C67.7487 287.62 71.7046 286.68 75.2871 284.874Z",
    fill: "#5A3CFF"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4629 267.016V275.953C57.5304 276.467 57.7223 276.956 58.0218 277.378C58.3214 277.801 58.7195 278.143 59.1817 278.377C60.5627 279.072 62.0873 279.434 63.6334 279.434C65.1795 279.434 66.7041 279.072 68.0851 278.377C68.5867 278.172 69.0272 277.841 69.3643 277.417C69.7014 276.992 69.9238 276.488 70.0101 275.953V267.016H57.4629Z",
    fill: "#FF9800"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3242 271.278C66.9016 271.999 65.3295 272.374 63.735 272.374C62.1404 272.374 60.5683 271.999 59.1458 271.278C58.4023 270.906 57.7993 270.303 57.427 269.56V268.855H57.2207V271.622C57.3036 272.162 57.5179 272.673 57.8445 273.11C58.1712 273.548 58.6003 273.899 59.0942 274.132C60.5202 274.84 62.091 275.209 63.6834 275.209C65.2758 275.209 66.8466 274.84 68.2726 274.132C68.7724 273.905 69.2073 273.556 69.5376 273.118C69.8679 272.679 70.083 272.165 70.1633 271.622V269.078L69.957 269.181V269.594C69.5984 270.31 69.0283 270.898 68.3242 271.278Z",
    fill: "#FFE188"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3234 272.069C66.8973 272.778 65.3266 273.146 63.7342 273.146C62.1418 273.146 60.571 272.778 59.145 272.069C58.6511 271.836 58.222 271.485 57.8953 271.048C57.5686 270.61 57.3544 270.099 57.2715 269.56V272.396C57.3627 272.932 57.5802 273.44 57.9059 273.876C58.2316 274.312 58.6563 274.665 59.145 274.905C60.571 275.614 62.1418 275.982 63.7342 275.982C65.3266 275.982 66.8973 275.614 68.3234 274.905C68.8223 274.677 69.2564 274.328 69.5865 273.89C69.9166 273.452 70.1323 272.938 70.2141 272.396V269.56C70.1338 270.103 69.9187 270.617 69.5884 271.055C69.2581 271.494 68.8232 271.842 68.3234 272.069Z",
    fill: "url(#paint181_linear_1606_3980)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0801 227.724L47.749 223.96C48.6508 223.452 49.6726 223.197 50.707 223.222C51.7415 223.246 52.7503 223.548 53.6273 224.097L57.7353 226.71L51.4788 230.233L47.2162 227.518C46.3994 226.93 45.4009 226.649 44.3974 226.727L41.0801 227.724Z",
    fill: "url(#paint182_linear_1606_3980)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3671 244.139L50.0876 240.34C47.9561 238.86 46.3335 236.759 45.4413 234.322C44.5492 231.886 44.4311 229.233 45.1031 226.727C43.896 226.805 42.7215 227.151 41.6655 227.741C40.8039 228.325 40.1139 229.128 39.6667 230.068C39.2194 231.008 39.0313 232.05 39.1217 233.087L43.3671 244.139Z",
    fill: "url(#paint183_linear_1606_3980)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9884 246.734L39.0383 233.688C38.9023 233.314 38.8325 232.918 38.832 232.519C38.8313 231.427 39.1188 230.355 39.6655 229.409C40.2122 228.464 40.9988 227.679 41.9456 227.135C42.8925 226.591 43.9662 226.307 45.0582 226.311C46.1503 226.314 47.222 226.606 48.1651 227.157L51.8262 229.649L51.3965 230.302L47.7526 228.979C46.0338 227.999 44.8994 227.26 43.1806 228.308C42.3244 228.727 41.5956 229.367 41.0698 230.161C40.544 230.956 40.2402 231.877 40.1899 232.829C40.1896 233.133 40.242 233.436 40.3446 233.723L44.7103 246.459L43.9884 246.734Z",
    fill: "#FFDA6A"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7373 259.023C85.8734 251.254 88.3313 231.935 79.7373 227.002C71.1433 222.069 57.1179 222.069 48.5582 227.002C39.9986 231.935 42.8002 251.065 48.5582 259.023C52.8896 265.039 58.4757 269.766 64.1306 269.766C69.7854 269.766 75.8872 263.922 79.7373 259.023Z",
    fill: "url(#paint184_linear_1606_3980)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1059 241.921C85.7717 237.521 85.7717 230.319 78.1059 225.919C70.44 221.519 57.9272 221.519 50.3129 225.919C42.6986 230.319 42.6814 237.521 50.3129 241.921C57.9443 246.321 70.44 246.321 78.1059 241.921Z",
    fill: "#FFDA6A"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6416 241.388C85.0497 237.195 85.0497 230.319 77.6416 226.125C70.2336 221.932 58.1333 221.932 50.8627 226.108C43.5922 230.285 43.4891 237.177 50.8627 241.371C58.2364 245.565 70.2336 245.582 77.6416 241.388Z",
    fill: "url(#paint185_linear_1606_3980)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4375 265.434C73.2618 265.35 76.0685 264.958 78.8081 264.266C80.3894 263.853 84.1879 262.014 85.1504 259.195C86.2333 255.998 87.1786 251.443 85.3395 248.057C84.6221 246.82 83.6282 245.765 82.4356 244.974C81.2429 244.184 79.8838 243.681 78.4643 243.503L77.9487 246.287C78.5693 246.006 79.2493 245.881 79.9294 245.923C80.6095 245.965 81.2689 246.172 81.8503 246.528C82.6538 247.097 83.3311 247.825 83.8398 248.668C84.3485 249.511 84.6777 250.45 84.8067 251.426C85.1886 253.088 85.1696 254.816 84.7512 256.469C84.3327 258.122 83.5269 259.652 82.4004 260.931C82.4004 260.931 75.422 264.523 71.1422 264.266L70.4375 265.434Z",
    fill: "#FFDA6A"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5527 243.503L83.5201 239.859C83.5201 239.859 98.1642 251.203 81.9903 262.77C82.8388 261.906 83.6096 260.968 84.2935 259.969C86.4764 255.998 89.0202 247.559 78.5527 243.503Z",
    fill: "#FF9800"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2305 264.265L76.3869 261.154C76.3869 261.154 81.0448 262.306 82.6089 260.742C82.6433 260.742 80.0823 264.265 71.2305 264.265Z",
    fill: "#FF9800"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter4_f_1606_3980)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.956 353.935C142.358 353.639 141.699 353.484 141.031 353.484C140.363 353.484 139.704 353.639 139.106 353.935L93.3857 380.302C93.1551 380.384 92.9556 380.535 92.8145 380.735C92.6734 380.935 92.5977 381.174 92.5977 381.419C92.5977 381.664 92.6734 381.903 92.8145 382.103C92.9556 382.303 93.1551 382.454 93.3857 382.536L139.106 408.92C139.702 409.225 140.362 409.384 141.031 409.384C141.7 409.384 142.36 409.225 142.956 408.92L188.642 382.519C188.872 382.437 189.072 382.285 189.213 382.085C189.354 381.885 189.43 381.647 189.43 381.402C189.43 381.157 189.354 380.918 189.213 380.718C189.072 380.518 188.872 380.367 188.642 380.285L142.956 353.935Z",
    fill: "url(#paint186_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.94 354.142C142.347 353.837 141.69 353.678 141.024 353.678C140.357 353.678 139.7 353.837 139.107 354.142L93.7308 380.319C93.5043 380.4 93.3083 380.55 93.1698 380.747C93.0313 380.944 92.957 381.178 92.957 381.419C92.957 381.66 93.0313 381.895 93.1698 382.092C93.3083 382.288 93.5043 382.438 93.7308 382.519L139.107 408.731C139.702 409.028 140.359 409.182 141.024 409.182C141.689 409.182 142.345 409.028 142.94 408.731L188.368 382.519C188.601 382.442 188.803 382.293 188.946 382.094C189.09 381.895 189.167 381.656 189.167 381.411C189.167 381.165 189.09 380.926 188.946 380.727C188.803 380.528 188.601 380.38 188.368 380.302L142.94 354.142Z",
    fill: "url(#paint187_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.922 354.331C142.332 354.035 141.682 353.88 141.022 353.88C140.363 353.88 139.712 354.035 139.123 354.331L94.0733 380.319C93.8467 380.4 93.6508 380.55 93.5123 380.747C93.3738 380.944 93.2994 381.178 93.2994 381.419C93.2994 381.66 93.3738 381.895 93.5123 382.092C93.6508 382.289 93.8467 382.438 94.0733 382.519L139.123 408.525C139.712 408.821 140.363 408.975 141.022 408.975C141.682 408.975 142.332 408.821 142.922 408.525L187.954 382.519C188.181 382.438 188.377 382.289 188.515 382.092C188.654 381.895 188.728 381.66 188.728 381.419C188.728 381.178 188.654 380.944 188.515 380.747C188.377 380.55 188.181 380.4 187.954 380.319L142.922 354.331Z",
    fill: "url(#paint188_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.922 354.537C142.336 354.241 141.688 354.087 141.031 354.087C140.374 354.087 139.727 354.241 139.141 354.537L94.4517 380.319C93.4032 380.921 93.4032 381.9 94.4517 382.485L139.141 408.267C139.727 408.563 140.374 408.717 141.031 408.717C141.688 408.717 142.336 408.563 142.922 408.267L187.611 382.485C187.839 382.408 188.038 382.261 188.179 382.065C188.319 381.87 188.395 381.635 188.395 381.393C188.395 381.152 188.319 380.917 188.179 380.721C188.038 380.526 187.839 380.379 187.611 380.302L142.922 354.537Z",
    fill: "url(#paint189_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.904 354.726C142.322 354.438 141.681 354.288 141.031 354.288C140.381 354.288 139.74 354.438 139.157 354.726L94.7607 380.336C94.5381 380.417 94.3458 380.564 94.2099 380.758C94.074 380.951 94.001 381.182 94.001 381.419C94.001 381.656 94.074 381.887 94.2099 382.08C94.3458 382.274 94.5381 382.421 94.7607 382.502L139.157 408.129C139.737 408.426 140.379 408.581 141.031 408.581C141.682 408.581 142.324 408.426 142.904 408.129L187.284 382.519C187.506 382.439 187.699 382.291 187.835 382.098C187.97 381.904 188.043 381.673 188.043 381.436C188.043 381.2 187.97 380.969 187.835 380.775C187.699 380.581 187.506 380.434 187.284 380.353L142.904 354.726Z",
    fill: "url(#paint190_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.886 355.018C142.31 354.721 141.67 354.566 141.021 354.566C140.373 354.566 139.733 354.721 139.157 355.018L95.0865 380.353C94.862 380.43 94.667 380.574 94.529 380.767C94.3909 380.96 94.3166 381.191 94.3166 381.428C94.3166 381.665 94.3909 381.896 94.529 382.089C94.667 382.281 94.862 382.426 95.0865 382.502L139.174 407.94C139.75 408.229 140.386 408.379 141.03 408.379C141.675 408.379 142.31 408.229 142.886 407.94L186.939 382.519C187.97 381.935 187.97 380.972 186.939 380.371L142.886 355.018Z",
    fill: "url(#paint191_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.87 355.121C142.297 354.833 141.664 354.682 141.023 354.682C140.381 354.682 139.748 354.833 139.175 355.121L95.4314 380.353C95.2128 380.433 95.0241 380.578 94.8907 380.769C94.7574 380.959 94.6859 381.186 94.6859 381.419C94.6859 381.652 94.7574 381.879 94.8907 382.069C95.0241 382.26 95.2128 382.405 95.4314 382.485L139.175 407.751C139.748 408.04 140.381 408.19 141.023 408.19C141.664 408.19 142.297 408.04 142.87 407.751L186.648 382.519C186.867 382.439 187.055 382.294 187.189 382.104C187.322 381.913 187.394 381.686 187.394 381.453C187.394 381.221 187.322 380.994 187.189 380.803C187.055 380.613 186.867 380.468 186.648 380.388L142.87 355.121Z",
    fill: "url(#paint192_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.852 355.311C142.282 355.031 141.656 354.886 141.021 354.886C140.387 354.886 139.76 355.031 139.191 355.311L95.7738 380.371C95.5533 380.446 95.362 380.589 95.2265 380.778C95.0911 380.968 95.0182 381.195 95.0182 381.428C95.0182 381.661 95.0911 381.888 95.2265 382.077C95.362 382.267 95.5533 382.409 95.7738 382.485L139.191 407.545C139.758 407.833 140.385 407.984 141.021 407.984C141.657 407.984 142.285 407.833 142.852 407.545L186.251 382.519C186.472 382.444 186.663 382.301 186.799 382.112C186.934 381.922 187.007 381.695 187.007 381.462C187.007 381.229 186.934 381.002 186.799 380.812C186.663 380.623 186.472 380.48 186.251 380.405L142.852 355.311Z",
    fill: "url(#paint193_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.852 355.517C142.288 355.229 141.664 355.078 141.03 355.078C140.397 355.078 139.772 355.229 139.208 355.517L96.1179 380.371C95.1038 380.955 95.1038 381.9 96.1179 382.468L139.208 407.356C139.775 407.636 140.398 407.782 141.03 407.782C141.662 407.782 142.286 407.636 142.852 407.356L185.925 382.519C186.14 382.44 186.325 382.297 186.456 382.11C186.586 381.922 186.657 381.699 186.657 381.471C186.657 381.242 186.586 381.019 186.456 380.832C186.325 380.644 186.14 380.501 185.925 380.422L142.852 355.517Z",
    fill: "url(#paint194_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.835 355.706C142.274 355.426 141.657 355.28 141.03 355.28C140.404 355.28 139.786 355.426 139.225 355.706L96.4445 380.371C96.23 380.45 96.0448 380.592 95.914 380.78C95.7832 380.967 95.7131 381.19 95.7131 381.419C95.7131 381.648 95.7832 381.871 95.914 382.058C96.0448 382.246 96.23 382.389 96.4445 382.468L139.225 407.149C139.783 407.437 140.402 407.588 141.03 407.588C141.658 407.588 142.277 407.437 142.835 407.149L185.581 382.519C186.578 381.952 186.578 381.024 185.581 380.439L142.835 355.706Z",
    fill: "url(#paint195_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.818 355.912C142.26 355.632 141.645 355.487 141.021 355.487C140.398 355.487 139.783 355.632 139.225 355.912L96.7881 380.388C96.5695 380.458 96.3789 380.595 96.2436 380.781C96.1083 380.966 96.0354 381.19 96.0354 381.419C96.0354 381.648 96.1083 381.872 96.2436 382.057C96.3789 382.243 96.5695 382.38 96.7881 382.45L139.242 406.96C139.797 407.24 140.409 407.386 141.03 407.386C141.651 407.386 142.263 407.24 142.818 406.96L185.238 382.519C185.456 382.449 185.647 382.311 185.782 382.126C185.917 381.941 185.99 381.717 185.99 381.488C185.99 381.258 185.917 381.035 185.782 380.849C185.647 380.664 185.456 380.526 185.238 380.456L142.818 355.912Z",
    fill: "url(#paint196_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.802 356.101C142.251 355.822 141.642 355.676 141.023 355.676C140.405 355.676 139.796 355.822 139.244 356.101L97.1339 380.388C96.9153 380.458 96.7246 380.595 96.5894 380.781C96.4541 380.966 96.3812 381.19 96.3812 381.419C96.3812 381.649 96.4541 381.872 96.5894 382.058C96.7246 382.243 96.9153 382.381 97.1339 382.45L139.244 406.754C139.796 407.034 140.405 407.179 141.023 407.179C141.642 407.179 142.251 407.034 142.802 406.754L184.93 382.519C185.149 382.449 185.339 382.312 185.475 382.126C185.61 381.941 185.683 381.717 185.683 381.488C185.683 381.258 185.61 381.035 185.475 380.85C185.339 380.664 185.149 380.527 184.93 380.457L142.802 356.101Z",
    fill: "url(#paint197_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.784 356.308C142.25 356.043 141.662 355.905 141.065 355.905C140.469 355.905 139.881 356.043 139.347 356.308L97.5625 380.371C97.348 380.44 97.161 380.576 97.0284 380.758C96.8958 380.94 96.8243 381.159 96.8243 381.385C96.8243 381.61 96.8958 381.83 97.0284 382.012C97.161 382.194 97.348 382.33 97.5625 382.399L139.347 406.462C139.881 406.727 140.469 406.865 141.065 406.865C141.662 406.865 142.25 406.727 142.784 406.462L184.551 382.399C185.531 381.832 185.531 380.921 184.551 380.371L142.784 356.308Z",
    fill: "url(#paint198_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.785 356.496C142.249 356.236 141.661 356.101 141.066 356.101C140.471 356.101 139.883 356.236 139.347 356.496L97.821 380.405C97.6065 380.474 97.4195 380.61 97.2869 380.792C97.1542 380.974 97.0828 381.194 97.0828 381.419C97.0828 381.644 97.1542 381.864 97.2869 382.046C97.4195 382.229 97.6065 382.364 97.821 382.433L139.278 406.376C139.814 406.636 140.402 406.771 140.997 406.771C141.593 406.771 142.18 406.636 142.716 406.376L184.225 382.519C184.44 382.45 184.627 382.314 184.759 382.132C184.892 381.95 184.963 381.73 184.963 381.505C184.963 381.28 184.892 381.06 184.759 380.878C184.627 380.696 184.44 380.56 184.225 380.491L142.785 356.496Z",
    fill: "url(#paint199_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.766 356.737C142.231 356.472 141.643 356.334 141.047 356.334C140.45 356.334 139.862 356.472 139.328 356.737L98.1456 380.422C97.9352 380.491 97.7519 380.624 97.6219 380.803C97.4919 380.982 97.4219 381.198 97.4219 381.419C97.4219 381.64 97.4919 381.856 97.6219 382.035C97.7519 382.214 97.9352 382.348 98.1456 382.416L139.294 406.17C139.828 406.435 140.416 406.573 141.012 406.573C141.609 406.573 142.197 406.435 142.731 406.17L183.879 382.519C184.088 382.446 184.268 382.31 184.396 382.13C184.523 381.95 184.592 381.735 184.592 381.514C184.592 381.293 184.523 381.078 184.396 380.898C184.268 380.717 184.088 380.581 183.879 380.508L142.766 356.737Z",
    fill: "url(#paint200_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.75 356.892C142.217 356.623 141.629 356.483 141.032 356.483C140.435 356.483 139.846 356.623 139.313 356.892L98.4913 380.422C98.2809 380.491 98.0976 380.624 97.9676 380.803C97.8376 380.982 97.7676 381.198 97.7676 381.419C97.7676 381.64 97.8376 381.856 97.9676 382.035C98.0976 382.214 98.2809 382.348 98.4913 382.416L139.296 405.981C139.829 406.25 140.417 406.39 141.014 406.39C141.612 406.39 142.2 406.25 142.733 405.981L183.538 382.519C183.748 382.451 183.931 382.317 184.061 382.138C184.191 381.959 184.261 381.744 184.261 381.522C184.261 381.301 184.191 381.085 184.061 380.906C183.931 380.727 183.748 380.594 183.538 380.525L142.75 356.892Z",
    fill: "url(#paint201_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.733 357.081C142.199 356.816 141.611 356.678 141.015 356.678C140.418 356.678 139.83 356.816 139.296 357.081L98.8353 380.439C98.6311 380.512 98.4542 380.646 98.3291 380.823C98.2041 381 98.1369 381.211 98.1369 381.428C98.1369 381.644 98.2041 381.856 98.3291 382.033C98.4542 382.21 98.6311 382.344 98.8353 382.416L139.313 405.775C139.844 406.049 140.434 406.192 141.032 406.192C141.63 406.192 142.219 406.049 142.751 405.775L183.211 382.416C183.416 382.344 183.592 382.21 183.717 382.033C183.843 381.856 183.91 381.644 183.91 381.428C183.91 381.211 183.843 381 183.717 380.823C183.592 380.646 183.416 380.512 183.211 380.439L142.733 357.081Z",
    fill: "url(#paint202_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.716 357.287C142.186 357.007 141.596 356.861 140.997 356.861C140.398 356.861 139.808 357.007 139.278 357.287L99.1785 380.439C98.9722 380.507 98.7925 380.638 98.6652 380.814C98.5378 380.99 98.4693 381.202 98.4693 381.419C98.4693 381.636 98.5378 381.848 98.6652 382.024C98.7925 382.2 98.9722 382.331 99.1785 382.399L139.33 405.586C139.862 405.857 140.451 405.999 141.049 405.999C141.646 405.999 142.235 405.857 142.767 405.586L182.901 382.416C183.847 381.866 183.847 380.989 182.901 380.457L142.716 357.287Z",
    fill: "url(#paint203_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.716 357.476C142.185 357.202 141.595 357.059 140.997 357.059C140.399 357.059 139.81 357.202 139.279 357.476L99.5227 380.457C99.3225 380.528 99.1492 380.66 99.0268 380.834C98.9043 381.008 98.8385 381.215 98.8385 381.428C98.8385 381.64 98.9043 381.848 99.0268 382.022C99.1492 382.196 99.3225 382.327 99.5227 382.399L139.347 405.379C139.876 405.662 140.466 405.81 141.066 405.81C141.666 405.81 142.256 405.662 142.785 405.379L182.592 382.399C182.793 382.327 182.966 382.196 183.088 382.022C183.211 381.848 183.277 381.64 183.277 381.428C183.277 381.215 183.211 381.008 183.088 380.834C182.966 380.66 182.793 380.528 182.592 380.457L142.716 357.476Z",
    fill: "url(#paint204_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.699 357.682C142.183 357.42 141.611 357.283 141.032 357.283C140.452 357.283 139.881 357.42 139.365 357.682L99.8321 380.457C99.6299 380.524 99.4539 380.653 99.3292 380.826C99.2044 380.998 99.1373 381.206 99.1373 381.419C99.1373 381.632 99.2044 381.84 99.3292 382.013C99.4539 382.185 99.6299 382.315 99.8321 382.382L139.365 405.19C139.881 405.453 140.452 405.59 141.032 405.59C141.611 405.59 142.183 405.453 142.699 405.19L182.231 382.399C182.434 382.332 182.61 382.203 182.734 382.03C182.859 381.857 182.926 381.649 182.926 381.436C182.926 381.223 182.859 381.015 182.734 380.843C182.61 380.67 182.434 380.541 182.231 380.474L142.699 357.682Z",
    fill: "url(#paint205_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.682 357.872C142.169 357.609 141.6 357.472 141.023 357.472C140.447 357.472 139.878 357.609 139.365 357.872L100.193 380.474C99.9971 380.545 99.8275 380.674 99.7076 380.845C99.5877 381.015 99.5234 381.219 99.5234 381.428C99.5234 381.636 99.5877 381.84 99.7076 382.011C99.8275 382.181 99.9971 382.311 100.193 382.382L139.365 405.001C139.881 405.256 140.448 405.388 141.023 405.388C141.599 405.388 142.166 405.256 142.682 405.001L181.836 382.382C182.033 382.311 182.202 382.181 182.322 382.011C182.442 381.84 182.506 381.636 182.506 381.428C182.506 381.219 182.442 381.015 182.322 380.845C182.202 380.674 182.033 380.545 181.836 380.474L142.682 357.872Z",
    fill: "url(#paint206_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.664 358.061C142.154 357.806 141.592 357.674 141.022 357.674C140.453 357.674 139.891 357.806 139.381 358.061L100.536 380.405C100.338 380.471 100.166 380.598 100.044 380.768C99.9214 380.938 99.8557 381.141 99.8557 381.35C99.8557 381.56 99.9214 381.763 100.044 381.933C100.166 382.103 100.338 382.229 100.536 382.296L139.381 404.64C139.888 404.902 140.451 405.039 141.022 405.039C141.594 405.039 142.157 404.902 142.664 404.64L181.492 382.296C181.69 382.229 181.862 382.103 181.984 381.933C182.106 381.763 182.172 381.56 182.172 381.35C182.172 381.141 182.106 380.938 181.984 380.768C181.862 380.598 181.69 380.471 181.492 380.405L142.664 358.061Z",
    fill: "url(#paint207_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.648 358.267C142.144 358.013 141.588 357.881 141.023 357.881C140.459 357.881 139.903 358.013 139.399 358.267L100.881 380.491C100.689 380.561 100.523 380.688 100.405 380.856C100.288 381.024 100.225 381.223 100.225 381.428C100.225 381.632 100.288 381.832 100.405 382C100.523 382.167 100.689 382.295 100.881 382.365L139.399 404.606C139.903 404.86 140.459 404.992 141.023 404.992C141.588 404.992 142.144 404.86 142.648 404.606L181.149 382.365C181.349 382.303 181.525 382.179 181.65 382.01C181.774 381.842 181.842 381.637 181.842 381.428C181.842 381.218 181.774 381.014 181.65 380.845C181.525 380.677 181.349 380.552 181.149 380.491L142.648 358.267Z",
    fill: "url(#paint208_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.647 358.456C142.147 358.202 141.593 358.07 141.032 358.07C140.47 358.07 139.917 358.202 139.416 358.456L101.224 380.491C100.331 381.007 100.331 381.849 101.224 382.347L139.416 404.4C139.917 404.653 140.47 404.785 141.032 404.785C141.593 404.785 142.147 404.653 142.647 404.4L180.822 382.365C181.016 382.299 181.185 382.174 181.304 382.008C181.424 381.841 181.488 381.641 181.488 381.436C181.488 381.231 181.424 381.032 181.304 380.865C181.185 380.699 181.016 380.574 180.822 380.508L142.647 358.456Z",
    fill: "url(#paint209_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.63 358.662C142.137 358.403 141.589 358.268 141.032 358.268C140.475 358.268 139.926 358.403 139.433 358.662L101.62 380.491C101.425 380.557 101.257 380.681 101.137 380.848C101.018 381.014 100.953 381.214 100.953 381.419C100.953 381.624 101.018 381.824 101.137 381.99C101.257 382.157 101.425 382.282 101.62 382.347L139.433 404.21C139.93 404.456 140.477 404.584 141.032 404.584C141.586 404.584 142.133 404.456 142.63 404.21L180.444 382.364C180.638 382.299 180.807 382.174 180.926 382.008C181.046 381.841 181.11 381.641 181.11 381.436C181.11 381.231 181.046 381.032 180.926 380.865C180.807 380.699 180.638 380.574 180.444 380.508L142.63 358.662Z",
    fill: "url(#paint210_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.612 358.851C142.118 358.606 141.574 358.478 141.022 358.478C140.471 358.478 139.927 358.606 139.432 358.851L101.894 380.508C101.704 380.573 101.539 380.696 101.422 380.859C101.305 381.022 101.242 381.218 101.242 381.419C101.242 381.62 101.305 381.816 101.422 381.979C101.539 382.142 101.704 382.265 101.894 382.33L139.432 404.021C139.927 404.267 140.471 404.394 141.022 404.394C141.574 404.394 142.118 404.267 142.612 404.021L180.134 382.347C180.324 382.282 180.489 382.16 180.606 381.996C180.723 381.833 180.785 381.637 180.785 381.436C180.785 381.235 180.723 381.04 180.606 380.876C180.489 380.713 180.324 380.59 180.134 380.525L142.612 358.851Z",
    fill: "url(#paint211_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.594 359.058C142.107 358.807 141.568 358.677 141.021 358.677C140.474 358.677 139.935 358.807 139.448 359.058L102.236 380.508C102.046 380.573 101.881 380.696 101.764 380.859C101.647 381.022 101.585 381.218 101.585 381.419C101.585 381.62 101.647 381.816 101.764 381.979C101.881 382.143 102.046 382.265 102.236 382.33L139.448 403.815C139.935 404.065 140.474 404.196 141.021 404.196C141.568 404.196 142.107 404.065 142.594 403.815L179.771 382.347C179.961 382.282 180.127 382.16 180.243 381.996C180.36 381.833 180.423 381.637 180.423 381.436C180.423 381.235 180.36 381.04 180.243 380.876C180.127 380.713 179.961 380.59 179.771 380.525L142.594 359.058Z",
    fill: "url(#paint212_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.578 359.247C142.096 359.002 141.563 358.875 141.022 358.875C140.482 358.875 139.949 359.002 139.467 359.247L102.581 380.525C102.397 380.594 102.238 380.717 102.126 380.878C102.014 381.039 101.954 381.231 101.954 381.428C101.954 381.624 102.014 381.816 102.126 381.977C102.238 382.139 102.397 382.262 102.581 382.33L139.467 403.626C139.951 403.863 140.483 403.986 141.022 403.986C141.562 403.986 142.094 403.863 142.578 403.626L179.446 382.33C179.639 382.27 179.807 382.15 179.926 381.988C180.045 381.825 180.11 381.629 180.11 381.428C180.11 381.226 180.045 381.03 179.926 380.868C179.807 380.705 179.639 380.585 179.446 380.525L142.578 359.247Z",
    fill: "url(#paint213_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.577 359.436C142.097 359.194 141.567 359.068 141.03 359.068C140.493 359.068 139.963 359.194 139.483 359.436L102.924 380.525C102.065 381.024 102.065 381.832 102.924 382.244L139.483 403.351C139.963 403.593 140.493 403.719 141.03 403.719C141.567 403.719 142.097 403.593 142.577 403.351L179.118 382.261C179.283 382.186 179.422 382.065 179.52 381.913C179.618 381.76 179.67 381.583 179.67 381.402C179.67 381.221 179.618 381.044 179.52 380.891C179.422 380.739 179.283 380.618 179.118 380.543L142.577 359.436Z",
    fill: "url(#paint214_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.559 359.642C142.084 359.406 141.56 359.283 141.029 359.283C140.499 359.283 139.975 359.406 139.5 359.642L103.25 380.543C102.408 381.024 102.408 381.815 103.25 382.261L139.5 403.179C139.975 403.415 140.499 403.538 141.029 403.538C141.56 403.538 142.084 403.415 142.559 403.179L178.774 382.261C179.617 381.78 179.617 380.989 178.774 380.543L142.559 359.642Z",
    fill: "url(#paint215_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.544 359.831C142.071 359.597 141.55 359.476 141.022 359.476C140.495 359.476 139.974 359.597 139.501 359.831L103.596 380.542C103.425 380.612 103.279 380.731 103.176 380.884C103.073 381.037 103.018 381.217 103.018 381.402C103.018 381.586 103.073 381.767 103.176 381.92C103.279 382.073 103.425 382.192 103.596 382.261L139.501 402.99C139.974 403.223 140.495 403.345 141.022 403.345C141.55 403.345 142.071 403.223 142.544 402.99L178.432 382.278C178.603 382.209 178.749 382.09 178.852 381.937C178.955 381.784 179.01 381.603 179.01 381.419C179.01 381.235 178.955 381.054 178.852 380.901C178.749 380.748 178.603 380.629 178.432 380.56L142.544 359.831Z",
    fill: "url(#paint216_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.526 360.037C142.06 359.8 141.545 359.677 141.022 359.677C140.499 359.677 139.984 359.8 139.518 360.037L103.939 380.56C103.761 380.622 103.607 380.738 103.498 380.892C103.389 381.046 103.33 381.23 103.33 381.419C103.33 381.608 103.389 381.792 103.498 381.946C103.607 382.1 103.761 382.216 103.939 382.278L139.518 402.818C139.984 403.055 140.499 403.179 141.022 403.179C141.545 403.179 142.06 403.055 142.526 402.818L178.054 382.296C178.232 382.233 178.386 382.117 178.495 381.963C178.604 381.809 178.663 381.625 178.663 381.436C178.663 381.248 178.604 381.064 178.495 380.91C178.386 380.756 178.232 380.639 178.054 380.577L142.526 360.037Z",
    fill: "url(#paint217_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.511 360.175C142.047 359.952 141.539 359.837 141.024 359.837C140.509 359.837 140.001 359.952 139.537 360.175L104.285 380.56C103.46 381.041 103.46 381.814 104.285 382.278L139.537 402.646C140.001 402.869 140.509 402.984 141.024 402.984C141.539 402.984 142.047 402.869 142.511 402.646L177.763 382.296C177.941 382.233 178.096 382.117 178.205 381.963C178.314 381.809 178.372 381.625 178.372 381.436C178.372 381.248 178.314 381.064 178.205 380.91C178.096 380.756 177.941 380.639 177.763 380.577L142.511 360.175Z",
    fill: "url(#paint218_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.492 360.433C142.037 360.2 141.533 360.079 141.022 360.079C140.511 360.079 140.007 360.2 139.552 360.433L104.626 380.577C104.44 380.63 104.275 380.743 104.158 380.898C104.041 381.053 103.978 381.242 103.978 381.436C103.978 381.631 104.041 381.82 104.158 381.975C104.275 382.13 104.44 382.242 104.626 382.296L139.552 402.44C140.009 402.668 140.512 402.787 141.022 402.787C141.532 402.787 142.035 402.668 142.492 402.44L177.418 382.278C178.225 381.814 178.225 381.058 177.418 380.56L142.492 360.433Z",
    fill: "url(#paint219_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.491 360.622C142.037 360.394 141.537 360.275 141.03 360.275C140.522 360.275 140.022 360.394 139.569 360.622L104.952 380.577C104.765 380.63 104.601 380.743 104.484 380.898C104.367 381.053 104.304 381.242 104.304 381.436C104.304 381.631 104.367 381.82 104.484 381.975C104.601 382.13 104.765 382.242 104.952 382.296L139.569 402.285C140.022 402.514 140.522 402.632 141.03 402.632C141.537 402.632 142.037 402.514 142.491 402.285L177.073 382.313C177.26 382.26 177.424 382.147 177.541 381.992C177.658 381.837 177.721 381.648 177.721 381.454C177.721 381.259 177.658 381.07 177.541 380.915C177.424 380.76 177.26 380.648 177.073 380.594L142.491 360.622Z",
    fill: "url(#paint220_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.474 360.811C142.022 360.59 141.525 360.476 141.022 360.476C140.518 360.476 140.022 360.59 139.569 360.811L105.296 380.594C105.098 380.634 104.919 380.741 104.791 380.898C104.663 381.055 104.592 381.251 104.592 381.453C104.592 381.656 104.663 381.852 104.791 382.009C104.919 382.166 105.098 382.273 105.296 382.313L139.569 402.096C140.019 402.326 140.517 402.445 141.022 402.445C141.526 402.445 142.024 402.326 142.474 402.096L176.73 382.313C176.928 382.273 177.107 382.166 177.235 382.009C177.363 381.852 177.434 381.656 177.434 381.453C177.434 381.251 177.363 381.055 177.235 380.898C177.107 380.741 176.928 380.634 176.73 380.594L142.474 360.811Z",
    fill: "url(#paint221_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.459 361.017C142.015 360.788 141.523 360.668 141.024 360.668C140.524 360.668 140.032 360.788 139.588 361.017L105.642 380.594C104.851 381.058 104.851 381.797 105.642 382.313L139.588 401.924C140.035 402.144 140.526 402.259 141.024 402.259C141.521 402.259 142.012 402.144 142.459 401.924L176.336 382.261C177.127 381.797 177.127 381.058 176.336 380.542L142.459 361.017Z",
    fill: "url(#paint222_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.442 361.206C142.002 360.985 141.516 360.87 141.024 360.87C140.531 360.87 140.046 360.985 139.606 361.206L105.986 380.611C105.814 380.668 105.664 380.777 105.558 380.924C105.452 381.07 105.395 381.247 105.395 381.428C105.395 381.609 105.452 381.785 105.558 381.932C105.664 382.078 105.814 382.188 105.986 382.244L139.606 401.649C140.043 401.878 140.53 401.998 141.024 401.998C141.517 401.998 142.004 401.878 142.442 401.649L176.061 382.261C176.26 382.221 176.438 382.114 176.567 381.957C176.695 381.801 176.765 381.604 176.765 381.402C176.765 381.199 176.695 381.003 176.567 380.846C176.438 380.69 176.26 380.582 176.061 380.542L142.442 361.206Z",
    fill: "url(#paint223_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.422 361.412C141.988 361.192 141.508 361.077 141.021 361.077C140.534 361.077 140.054 361.192 139.62 361.412L106.327 380.611C106.161 380.671 106.018 380.781 105.916 380.926C105.815 381.07 105.761 381.243 105.761 381.419C105.761 381.596 105.815 381.768 105.916 381.912C106.018 382.057 106.161 382.167 106.327 382.227L139.62 401.426C140.054 401.646 140.534 401.761 141.021 401.761C141.508 401.761 141.988 401.646 142.422 401.426L175.715 382.21C175.881 382.15 176.024 382.04 176.125 381.895C176.227 381.751 176.281 381.578 176.281 381.402C176.281 381.225 176.227 381.053 176.125 380.909C176.024 380.764 175.881 380.654 175.715 380.594L142.422 361.412Z",
    fill: "url(#paint224_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.425 361.601C141.993 361.381 141.516 361.266 141.032 361.266C140.548 361.266 140.071 361.381 139.64 361.601L106.656 380.628C106.488 380.684 106.342 380.791 106.239 380.935C106.135 381.078 106.08 381.251 106.08 381.428C106.08 381.605 106.135 381.777 106.239 381.921C106.342 382.064 106.488 382.171 106.656 382.227L139.64 401.271C140.073 401.484 140.55 401.594 141.032 401.594C141.515 401.594 141.991 401.484 142.425 401.271L175.374 382.244C175.54 382.184 175.683 382.074 175.784 381.93C175.886 381.785 175.94 381.613 175.94 381.436C175.94 381.26 175.886 381.088 175.784 380.943C175.683 380.799 175.54 380.689 175.374 380.628L142.425 361.601Z",
    fill: "url(#paint225_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.406 361.79C141.976 361.578 141.503 361.468 141.023 361.468C140.543 361.468 140.069 361.578 139.639 361.79L106.982 380.697C106.814 380.753 106.668 380.86 106.564 381.004C106.461 381.147 106.405 381.32 106.405 381.497C106.405 381.673 106.461 381.846 106.564 381.989C106.668 382.133 106.814 382.24 106.982 382.296L139.639 401.203C140.067 401.423 140.541 401.538 141.023 401.538C141.504 401.538 141.978 401.423 142.406 401.203L175.064 382.296C175.226 382.236 175.365 382.129 175.464 381.987C175.563 381.846 175.616 381.678 175.616 381.505C175.616 381.333 175.563 381.164 175.464 381.023C175.365 380.882 175.226 380.774 175.064 380.714L142.406 361.79Z",
    fill: "url(#paint226_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.388 361.997C141.964 361.785 141.496 361.675 141.022 361.675C140.547 361.675 140.08 361.785 139.655 361.997L107.342 380.628C106.585 381.075 106.585 381.78 107.342 382.21L139.655 400.876C140.08 401.088 140.547 401.198 141.022 401.198C141.496 401.198 141.964 401.088 142.388 400.876L174.616 382.227C175.372 381.78 175.372 381.075 174.616 380.646L142.388 361.997Z",
    fill: "url(#paint227_linear_1606_3980)",
    fillOpacity: 0.15
  }))), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M177.952 339.429H104.25V380.989C104.265 381.171 104.329 381.345 104.435 381.493C104.541 381.641 104.685 381.758 104.852 381.832L139.623 401.907C140.079 402.136 140.582 402.254 141.093 402.254C141.603 402.254 142.106 402.136 142.562 401.907L177.333 381.832C177.5 381.758 177.644 381.641 177.75 381.493C177.856 381.345 177.92 381.171 177.935 380.989L177.952 339.429Z",
    fill: "#2C2067"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M177.351 351.581L142.58 371.708C142.123 371.936 141.62 372.055 141.11 372.055C140.6 372.055 140.097 371.936 139.64 371.708L104.869 351.581C104.7 351.51 104.554 351.394 104.448 351.246C104.342 351.097 104.279 350.921 104.268 350.739V356.514C104.282 356.693 104.346 356.865 104.452 357.011C104.559 357.156 104.703 357.27 104.869 357.339L139.64 377.431C140.097 377.66 140.6 377.779 141.11 377.779C141.62 377.779 142.123 377.66 142.58 377.431L177.351 357.356C177.515 357.278 177.656 357.16 177.761 357.013C177.866 356.865 177.932 356.694 177.953 356.514V350.739C177.932 350.918 177.866 351.09 177.761 351.238C177.656 351.385 177.515 351.503 177.351 351.581Z",
    fill: "#5A3CFF"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M177.351 367.05L142.58 387.108C142.126 387.345 141.622 387.468 141.11 387.468C140.598 387.468 140.094 387.345 139.64 387.108L104.869 367.05C104.7 366.98 104.554 366.864 104.448 366.715C104.342 366.566 104.279 366.39 104.268 366.208V371.966C104.279 372.148 104.342 372.324 104.448 372.473C104.554 372.622 104.7 372.738 104.869 372.808L139.64 392.832C140.097 393.06 140.6 393.179 141.11 393.179C141.62 393.179 142.123 393.06 142.58 392.832L177.351 372.756C177.517 372.677 177.659 372.556 177.765 372.406C177.87 372.255 177.935 372.08 177.953 371.897V366.191C177.935 366.374 177.87 366.549 177.765 366.699C177.659 366.85 177.517 366.971 177.351 367.05Z",
    fill: "#5A3CFF"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M142.579 318.511C142.123 318.282 141.62 318.164 141.11 318.164C140.6 318.164 140.097 318.282 139.64 318.511L104.869 338.586C104.682 338.64 104.518 338.753 104.401 338.908C104.284 339.063 104.221 339.252 104.221 339.446C104.221 339.64 104.284 339.829 104.401 339.984C104.518 340.139 104.682 340.252 104.869 340.305L139.64 360.398C140.097 360.626 140.6 360.745 141.11 360.745C141.62 360.745 142.123 360.626 142.579 360.398L177.351 340.322C177.538 340.269 177.702 340.156 177.819 340.001C177.936 339.846 177.999 339.657 177.999 339.463C177.999 339.269 177.936 339.08 177.819 338.925C177.702 338.77 177.538 338.657 177.351 338.604L142.579 318.511Z",
    fill: "#7564C9"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M156.276 346.321C164.87 341.371 164.87 333.258 156.276 328.308C147.682 323.358 133.571 323.358 124.994 328.308C116.417 333.258 116.4 341.371 124.994 346.321C133.588 351.271 147.648 351.271 156.276 346.321Z",
    fill: "url(#paint228_radial_1606_3980)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M145.929 328.497L145.001 329.288H136.803L135.909 328.463C134.61 327.27 133.574 325.819 132.867 324.203C132.159 322.587 131.796 320.842 131.801 319.078V315.486H150.553V318.683C150.554 320.559 150.139 322.411 149.34 324.108C148.541 325.805 147.376 327.304 145.929 328.497Z",
    fill: "#5A3CFF"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M142.336 331.78H139.276C138.92 331.78 138.566 331.71 138.237 331.573C137.908 331.437 137.608 331.237 137.356 330.985C137.104 330.732 136.904 330.433 136.767 330.104C136.631 329.774 136.561 329.421 136.561 329.064H145.051C145.051 329.421 144.981 329.774 144.845 330.104C144.708 330.433 144.508 330.732 144.256 330.985C144.004 331.237 143.704 331.437 143.375 331.573C143.045 331.71 142.692 331.78 142.336 331.78Z",
    fill: "#363650"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M147.736 311.722C145.687 310.688 143.423 310.15 141.128 310.15C138.832 310.15 136.569 310.688 134.519 311.722C130.892 313.819 130.892 317.239 134.519 319.336C136.569 320.37 138.832 320.908 141.128 320.908C143.423 320.908 145.687 320.37 147.736 319.336C151.363 317.205 151.363 313.767 147.736 311.722Z",
    fill: "#2842A2"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.83,
    d: "M141.152 280.422C137.468 280.423 133.883 281.613 130.93 283.816C127.977 286.018 125.814 289.116 124.763 292.646C123.712 296.177 123.83 299.953 125.098 303.412C126.366 306.87 128.717 309.827 131.801 311.842V315.692C131.918 316.492 132.234 317.251 132.72 317.896C133.207 318.542 133.849 319.055 134.586 319.388C136.629 320.413 138.883 320.947 141.169 320.947C143.455 320.947 145.709 320.413 147.752 319.388C148.475 319.058 149.101 318.548 149.571 317.907C150.04 317.266 150.337 316.515 150.433 315.727V311.876C153.517 309.862 155.868 306.905 157.137 303.446C158.405 299.987 158.522 296.212 157.471 292.681C156.421 289.15 154.258 286.053 151.305 283.85C148.352 281.648 144.767 280.457 141.083 280.457L141.152 280.422Z",
    fill: "#5A3CFF"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M131.645 299.381C131.645 296.418 132.823 293.576 134.918 291.481C137.013 289.385 139.855 288.208 142.818 288.208C148.541 288.208 148.094 283.43 140.807 283.43C139.073 283.423 137.355 283.758 135.751 284.415C134.147 285.072 132.688 286.039 131.457 287.26C130.227 288.481 129.249 289.932 128.579 291.531C127.91 293.13 127.561 294.845 127.555 296.579C127.555 301.254 131.645 303.299 131.645 299.381Z",
    fill: "white"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M147.751 320.849C145.708 321.874 143.454 322.408 141.168 322.408C138.882 322.408 136.628 321.874 134.585 320.849C133.855 320.521 133.217 320.016 132.731 319.38C132.245 318.743 131.925 317.996 131.801 317.205V318.494C131.92 319.291 132.237 320.046 132.724 320.688C133.21 321.331 133.85 321.841 134.585 322.172C136.628 323.197 138.882 323.731 141.168 323.731C143.454 323.731 145.708 323.197 147.751 322.172C148.472 321.84 149.097 321.329 149.566 320.689C150.035 320.048 150.333 319.299 150.433 318.511V317.205C150.332 317.99 150.033 318.736 149.564 319.374C149.095 320.012 148.471 320.519 147.751 320.849Z",
    fill: "#6D6D88"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M147.699 324.578C145.656 325.603 143.402 326.137 141.116 326.137C138.83 326.137 136.576 325.603 134.533 324.578C133.621 324.091 132.847 323.381 132.281 322.516C132.517 323.347 132.833 324.153 133.227 324.922C133.632 325.276 134.069 325.593 134.533 325.867C136.576 326.892 138.83 327.426 141.116 327.426C143.402 327.426 145.656 326.892 147.699 325.867C148.081 325.647 148.444 325.394 148.782 325.111C149.254 324.284 149.634 323.408 149.916 322.499C149.373 323.375 148.608 324.093 147.699 324.578Z",
    fill: "#6D6D88"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M141.083 278.996C140.714 278.996 140.36 278.849 140.099 278.588C139.838 278.327 139.691 277.973 139.691 277.603V266.913C139.7 266.548 139.85 266.2 140.11 265.944C140.369 265.688 140.718 265.542 141.083 265.537C141.452 265.537 141.807 265.684 142.068 265.945C142.329 266.206 142.475 266.56 142.475 266.93V277.621C142.467 277.985 142.317 278.333 142.057 278.589C141.797 278.846 141.448 278.991 141.083 278.996ZM152.513 281.11L157.91 271.897C158.093 271.577 158.143 271.198 158.05 270.841C157.957 270.485 157.728 270.179 157.412 269.989C157.255 269.894 157.08 269.831 156.898 269.805C156.716 269.779 156.53 269.789 156.353 269.835C156.175 269.882 156.008 269.963 155.862 270.076C155.716 270.188 155.595 270.328 155.504 270.488L150.107 279.7C150.012 279.858 149.949 280.032 149.923 280.214C149.896 280.396 149.907 280.582 149.953 280.76C150 280.938 150.081 281.104 150.193 281.25C150.305 281.396 150.445 281.518 150.605 281.608C150.818 281.736 151.062 281.802 151.31 281.797C151.554 281.799 151.793 281.737 152.005 281.616C152.216 281.495 152.392 281.321 152.513 281.11ZM159.388 289.085L168.687 283.808C168.846 283.717 168.986 283.595 169.098 283.45C169.21 283.304 169.292 283.138 169.34 282.961C169.388 282.784 169.401 282.599 169.377 282.417C169.353 282.235 169.294 282.06 169.203 281.9C169.111 281.741 168.99 281.602 168.844 281.49C168.699 281.378 168.533 281.295 168.356 281.247C168.179 281.2 167.994 281.187 167.812 281.211C167.63 281.234 167.454 281.293 167.295 281.385L158.013 286.662C157.741 286.811 157.527 287.047 157.404 287.332C157.282 287.618 157.258 287.936 157.337 288.236C157.416 288.537 157.593 288.802 157.84 288.99C158.087 289.178 158.39 289.278 158.701 289.274C158.98 289.26 159.249 289.165 159.474 288.999L159.388 289.085ZM124.772 288.363C124.868 288.207 124.931 288.033 124.959 287.852C124.987 287.671 124.978 287.486 124.933 287.308C124.888 287.13 124.808 286.963 124.698 286.817C124.588 286.67 124.449 286.547 124.291 286.455L115.129 280.972C114.813 280.781 114.433 280.723 114.073 280.812C113.714 280.9 113.404 281.128 113.213 281.445C113.021 281.762 112.964 282.142 113.052 282.501C113.141 282.86 113.369 283.17 113.686 283.361L122.864 288.844C123.08 288.98 123.331 289.051 123.586 289.051C123.826 289.05 124.063 288.986 124.271 288.865C124.479 288.745 124.652 288.571 124.772 288.363ZM131.802 281.488C132.124 281.304 132.36 281.001 132.46 280.643C132.56 280.286 132.515 279.904 132.335 279.58L127.178 270.247C126.997 269.926 126.697 269.69 126.343 269.59C125.988 269.49 125.609 269.535 125.287 269.714C124.967 269.895 124.73 270.194 124.628 270.548C124.525 270.901 124.564 271.28 124.737 271.605L129.894 280.938C130.075 281.263 130.377 281.503 130.735 281.606C131.092 281.709 131.475 281.667 131.802 281.488Z",
    fill: "url(#paint229_linear_1606_3980)"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter5_f_1606_3980)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M769.751 250.446C769.155 250.142 768.495 249.983 767.826 249.983C767.156 249.983 766.497 250.142 765.901 250.446L720.37 276.71C719.304 277.328 719.304 278.325 720.37 278.927L765.883 305.173C766.482 305.47 767.141 305.624 767.808 305.624C768.476 305.624 769.135 305.47 769.734 305.173L815.247 278.892C815.48 278.815 815.682 278.666 815.826 278.467C815.969 278.268 816.046 278.029 816.046 277.784C816.046 277.539 815.969 277.3 815.826 277.101C815.682 276.902 815.48 276.753 815.247 276.675L769.751 250.446Z",
    fill: "url(#paint230_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.734 250.635C769.142 250.339 768.488 250.185 767.826 250.185C767.164 250.185 766.511 250.339 765.918 250.635L720.697 276.727C720.47 276.808 720.274 276.957 720.136 277.154C719.997 277.351 719.923 277.586 719.923 277.827C719.923 278.067 719.997 278.302 720.136 278.499C720.274 278.696 720.47 278.845 720.697 278.927L765.884 305.018C766.474 305.323 767.128 305.482 767.792 305.482C768.456 305.482 769.11 305.323 769.7 305.018L814.887 278.944C815.119 278.866 815.322 278.717 815.465 278.518C815.608 278.32 815.686 278.081 815.686 277.835C815.686 277.59 815.608 277.351 815.465 277.152C815.322 276.953 815.119 276.804 814.887 276.727L769.734 250.635Z",
    fill: "url(#paint231_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.716 250.842C769.13 250.546 768.482 250.391 767.825 250.391C767.168 250.391 766.521 250.546 765.934 250.842L721.039 276.727C720.811 276.804 720.612 276.951 720.472 277.146C720.331 277.342 720.255 277.577 720.255 277.818C720.255 278.059 720.331 278.295 720.472 278.49C720.612 278.686 720.811 278.833 721.039 278.91L765.883 304.829C766.469 305.125 767.117 305.28 767.774 305.28C768.43 305.28 769.078 305.125 769.664 304.829L814.525 278.927C814.754 278.85 814.952 278.703 815.093 278.508C815.234 278.312 815.309 278.077 815.309 277.836C815.309 277.594 815.234 277.359 815.093 277.164C814.952 276.968 814.754 276.821 814.525 276.744L769.716 250.842Z",
    fill: "url(#paint232_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.701 251.031C769.117 250.735 768.473 250.581 767.819 250.581C767.165 250.581 766.52 250.735 765.936 251.031L721.385 276.727C721.157 276.804 720.958 276.95 720.817 277.146C720.677 277.342 720.601 277.577 720.601 277.818C720.601 278.059 720.677 278.294 720.817 278.49C720.958 278.686 721.157 278.833 721.385 278.91L765.936 304.692C766.522 304.98 767.166 305.13 767.819 305.13C768.471 305.13 769.115 304.98 769.701 304.692L814.252 278.91C814.481 278.833 814.679 278.686 814.82 278.49C814.961 278.294 815.036 278.059 815.036 277.818C815.036 277.577 814.961 277.342 814.82 277.146C814.679 276.95 814.481 276.804 814.252 276.727L769.701 251.031Z",
    fill: "url(#paint233_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.682 251.22C769.102 250.932 768.464 250.782 767.817 250.782C767.17 250.782 766.531 250.932 765.952 251.22L721.71 276.744C721.485 276.82 721.29 276.965 721.152 277.157C721.014 277.35 720.94 277.581 720.94 277.818C720.94 278.055 721.014 278.286 721.152 278.479C721.29 278.672 721.485 278.816 721.71 278.892L765.883 304.434C766.46 304.731 767.099 304.886 767.748 304.886C768.397 304.886 769.036 304.731 769.613 304.434L813.838 278.91C814.062 278.833 814.257 278.689 814.395 278.496C814.533 278.303 814.607 278.072 814.607 277.835C814.607 277.598 814.533 277.367 814.395 277.174C814.257 276.982 814.062 276.837 813.838 276.761L769.682 251.22Z",
    fill: "url(#paint234_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.68 251.426C769.104 251.137 768.468 250.987 767.824 250.987C767.179 250.987 766.544 251.137 765.968 251.426L722.052 276.744C721.828 276.82 721.633 276.965 721.495 277.157C721.357 277.35 721.282 277.581 721.282 277.818C721.282 278.055 721.357 278.286 721.495 278.479C721.633 278.672 721.828 278.816 722.052 278.893L765.968 304.245C766.544 304.534 767.179 304.684 767.824 304.684C768.468 304.684 769.104 304.534 769.68 304.245L813.561 278.91C813.786 278.834 813.981 278.689 814.119 278.496C814.257 278.304 814.331 278.072 814.331 277.835C814.331 277.598 814.257 277.367 814.119 277.175C813.981 276.982 813.786 276.837 813.561 276.761L769.68 251.426Z",
    fill: "url(#paint235_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.664 251.615C769.094 251.327 768.464 251.176 767.825 251.176C767.186 251.176 766.556 251.327 765.986 251.615L722.397 276.761C722.177 276.837 721.985 276.979 721.85 277.169C721.714 277.358 721.642 277.585 721.642 277.818C721.642 278.051 721.714 278.278 721.85 278.468C721.985 278.657 722.177 278.8 722.397 278.875L765.986 304.056C766.556 304.344 767.186 304.494 767.825 304.494C768.464 304.494 769.094 304.344 769.664 304.056L813.219 278.892C813.439 278.817 813.63 278.675 813.766 278.485C813.901 278.296 813.974 278.068 813.974 277.835C813.974 277.602 813.901 277.375 813.766 277.186C813.63 276.996 813.439 276.854 813.219 276.778L769.664 251.615Z",
    fill: "url(#paint236_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.649 251.89C769.082 251.602 768.455 251.452 767.818 251.452C767.182 251.452 766.555 251.602 765.988 251.89L722.743 276.761C722.522 276.837 722.331 276.979 722.196 277.169C722.06 277.358 721.987 277.585 721.987 277.818C721.987 278.051 722.06 278.278 722.196 278.468C722.331 278.657 722.522 278.8 722.743 278.875L766.005 303.85C766.569 304.138 767.194 304.288 767.827 304.288C768.461 304.288 769.085 304.138 769.649 303.85L812.894 278.893C813.114 278.817 813.306 278.675 813.441 278.485C813.577 278.296 813.65 278.068 813.65 277.835C813.65 277.602 813.577 277.375 813.441 277.186C813.306 276.996 813.114 276.854 812.894 276.778L769.649 251.89Z",
    fill: "url(#paint237_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.631 252.01C769.07 251.722 768.448 251.572 767.818 251.572C767.187 251.572 766.565 251.722 766.004 252.01L723.034 276.778C722.82 276.857 722.635 277 722.504 277.188C722.373 277.375 722.303 277.598 722.303 277.827C722.303 278.055 722.373 278.279 722.504 278.466C722.635 278.654 722.82 278.796 723.034 278.875L766.004 303.66C766.568 303.941 767.188 304.086 767.818 304.086C768.447 304.086 769.068 303.941 769.631 303.66L812.601 278.875C812.815 278.796 813.001 278.654 813.131 278.466C813.262 278.279 813.332 278.055 813.332 277.827C813.332 277.598 813.262 277.375 813.131 277.188C813.001 277 812.815 276.857 812.601 276.778L769.631 252.01Z",
    fill: "url(#paint238_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.615 252.199C769.057 251.92 768.442 251.774 767.819 251.774C767.195 251.774 766.58 251.92 766.023 252.199L723.413 276.778C723.197 276.853 723.009 276.993 722.877 277.18C722.744 277.366 722.672 277.589 722.672 277.818C722.672 278.047 722.744 278.27 722.877 278.457C723.009 278.643 723.197 278.783 723.413 278.858L766.023 303.454C766.577 303.742 767.194 303.892 767.819 303.892C768.444 303.892 769.06 303.742 769.615 303.454L812.293 278.875C812.509 278.801 812.697 278.66 812.83 278.474C812.962 278.287 813.034 278.064 813.034 277.835C813.034 277.606 812.962 277.383 812.83 277.197C812.697 277.01 812.509 276.87 812.293 276.795L769.615 252.199Z",
    fill: "url(#paint239_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.615 252.406C769.06 252.126 768.448 251.981 767.827 251.981C767.206 251.981 766.594 252.126 766.04 252.406L723.757 276.795C723.539 276.865 723.348 277.003 723.213 277.188C723.077 277.374 723.005 277.597 723.005 277.827C723.005 278.056 723.077 278.28 723.213 278.465C723.348 278.65 723.539 278.788 723.757 278.858L766.04 303.265C766.594 303.545 767.206 303.69 767.827 303.69C768.448 303.69 769.06 303.545 769.615 303.265L811.88 278.858C812.099 278.788 812.289 278.65 812.425 278.465C812.56 278.28 812.633 278.056 812.633 277.827C812.633 277.597 812.56 277.374 812.425 277.188C812.289 277.003 812.099 276.865 811.88 276.795L769.615 252.406Z",
    fill: "url(#paint240_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.595 252.595C769.046 252.316 768.44 252.17 767.824 252.17C767.209 252.17 766.602 252.316 766.054 252.595L724.081 276.795C723.868 276.869 723.684 277.008 723.554 277.191C723.424 277.374 723.354 277.593 723.354 277.818C723.354 278.043 723.424 278.262 723.554 278.446C723.684 278.629 723.868 278.767 724.081 278.841L766.054 303.076C766.604 303.347 767.21 303.488 767.824 303.488C768.438 303.488 769.044 303.347 769.595 303.076L811.533 278.858C811.746 278.784 811.93 278.646 812.06 278.463C812.19 278.279 812.26 278.06 812.26 277.835C812.26 277.61 812.19 277.391 812.06 277.208C811.93 277.025 811.746 276.887 811.533 276.813L769.595 252.595Z",
    fill: "url(#paint241_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.578 252.801C769.043 252.54 768.455 252.404 767.86 252.404C767.264 252.404 766.676 252.54 766.141 252.801L724.511 276.864C724.297 276.933 724.11 277.069 723.977 277.251C723.845 277.433 723.773 277.653 723.773 277.878C723.773 278.104 723.845 278.323 723.977 278.505C724.11 278.688 724.297 278.823 724.511 278.892L766.141 302.956C766.675 303.221 767.263 303.359 767.86 303.359C768.456 303.359 769.044 303.221 769.578 302.956L811.191 278.892C811.405 278.823 811.592 278.688 811.725 278.505C811.857 278.323 811.929 278.104 811.929 277.878C811.929 277.653 811.857 277.433 811.725 277.251C811.592 277.069 811.405 276.933 811.191 276.864L769.578 252.801Z",
    fill: "url(#paint242_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.561 252.99C769.026 252.728 768.438 252.591 767.842 252.591C767.246 252.591 766.658 252.728 766.123 252.99L724.872 276.813C724.664 276.886 724.483 277.022 724.356 277.202C724.228 277.382 724.159 277.597 724.159 277.818C724.159 278.039 724.228 278.254 724.356 278.434C724.483 278.615 724.664 278.751 724.872 278.824L766.123 302.681C766.658 302.943 767.246 303.08 767.842 303.08C768.438 303.08 769.026 302.943 769.561 302.681L810.812 278.841C811.02 278.768 811.201 278.632 811.328 278.452C811.456 278.271 811.525 278.056 811.525 277.835C811.525 277.615 811.456 277.399 811.328 277.219C811.201 277.039 811.02 276.903 810.812 276.83L769.561 252.99Z",
    fill: "url(#paint243_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.545 253.179C769.012 252.91 768.424 252.77 767.826 252.77C767.229 252.77 766.641 252.91 766.108 253.179L725.131 276.83C724.921 276.899 724.738 277.032 724.608 277.211C724.478 277.39 724.408 277.606 724.408 277.827C724.408 278.048 724.478 278.264 724.608 278.443C724.738 278.622 724.921 278.755 725.131 278.824L766.108 302.474C766.641 302.743 767.229 302.884 767.826 302.884C768.424 302.884 769.012 302.743 769.545 302.474L810.573 278.841C810.781 278.768 810.962 278.632 811.09 278.452C811.217 278.272 811.286 278.056 811.286 277.835C811.286 277.615 811.217 277.399 811.09 277.219C810.962 277.039 810.781 276.903 810.573 276.83L769.545 253.179Z",
    fill: "url(#paint244_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.543 253.386C769.011 253.114 768.422 252.972 767.824 252.972C767.227 252.972 766.638 253.114 766.105 253.386L725.439 276.83C725.234 276.902 725.057 277.036 724.932 277.213C724.807 277.39 724.74 277.602 724.74 277.818C724.74 278.035 724.807 278.246 724.932 278.423C725.057 278.6 725.234 278.734 725.439 278.807L766.105 302.285C766.638 302.557 767.227 302.699 767.824 302.699C768.422 302.699 769.011 302.557 769.543 302.285L810.175 278.824C810.38 278.751 810.557 278.618 810.682 278.441C810.807 278.264 810.874 278.052 810.874 277.835C810.874 277.619 810.807 277.407 810.682 277.23C810.557 277.053 810.38 276.92 810.175 276.847L769.543 253.386Z",
    fill: "url(#paint245_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.526 253.609C768.993 253.34 768.404 253.2 767.807 253.2C767.21 253.2 766.621 253.34 766.088 253.609L725.748 276.882C725.542 276.949 725.362 277.081 725.235 277.257C725.108 277.432 725.039 277.644 725.039 277.861C725.039 278.078 725.108 278.29 725.235 278.466C725.362 278.642 725.542 278.773 725.748 278.841L766.088 302.131C766.621 302.4 767.21 302.54 767.807 302.54C768.404 302.54 768.993 302.4 769.526 302.131L809.832 278.858C810.036 278.786 810.213 278.652 810.338 278.475C810.463 278.298 810.53 278.087 810.53 277.87C810.53 277.653 810.463 277.442 810.338 277.265C810.213 277.088 810.036 276.954 809.832 276.882L769.526 253.609Z",
    fill: "url(#paint246_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.51 253.764C768.977 253.492 768.388 253.35 767.791 253.35C767.193 253.35 766.604 253.492 766.072 253.764L726.076 276.847C725.875 276.919 725.702 277.05 725.58 277.224C725.457 277.398 725.391 277.606 725.391 277.818C725.391 278.031 725.457 278.238 725.58 278.412C725.702 278.586 725.875 278.718 726.076 278.789L766.072 301.89C766.602 302.17 767.192 302.316 767.791 302.316C768.39 302.316 768.98 302.17 769.51 301.89L809.506 278.807C809.706 278.735 809.88 278.603 810.002 278.429C810.125 278.256 810.19 278.048 810.19 277.835C810.19 277.623 810.125 277.415 810.002 277.241C809.88 277.068 809.706 276.936 809.506 276.864L769.51 253.764Z",
    fill: "url(#paint247_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.492 253.97C768.961 253.693 768.372 253.548 767.773 253.548C767.175 253.548 766.585 253.693 766.054 253.97L726.384 276.847C726.184 276.919 726.011 277.05 725.889 277.224C725.766 277.398 725.7 277.606 725.7 277.818C725.7 278.031 725.766 278.238 725.889 278.412C726.011 278.586 726.184 278.718 726.384 278.789L766.14 301.735C766.671 302.012 767.261 302.157 767.859 302.157C768.458 302.157 769.047 302.012 769.578 301.735L809.248 278.841C809.448 278.769 809.621 278.638 809.744 278.464C809.866 278.29 809.932 278.082 809.932 277.87C809.932 277.657 809.866 277.45 809.744 277.276C809.621 277.102 809.448 276.97 809.248 276.899L769.492 253.97Z",
    fill: "url(#paint248_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.476 254.159C768.961 253.9 768.393 253.766 767.817 253.766C767.241 253.766 766.673 253.9 766.158 254.159L726.798 276.864C726.596 276.931 726.42 277.061 726.295 277.233C726.17 277.406 726.103 277.614 726.103 277.827C726.103 278.04 726.17 278.248 726.295 278.42C726.42 278.593 726.596 278.722 726.798 278.789L766.158 301.512C766.674 301.767 767.242 301.899 767.817 301.899C768.392 301.899 768.96 301.767 769.476 301.512L808.853 278.789C809.05 278.719 809.219 278.589 809.339 278.418C809.459 278.248 809.523 278.044 809.523 277.835C809.523 277.627 809.459 277.423 809.339 277.253C809.219 277.082 809.05 276.952 808.853 276.882L769.476 254.159Z",
    fill: "url(#paint249_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.476 254.365C768.966 254.103 768.4 253.966 767.826 253.966C767.252 253.966 766.687 254.103 766.176 254.365L727.142 276.864C726.946 276.935 726.776 277.065 726.657 277.235C726.537 277.406 726.472 277.61 726.472 277.818C726.472 278.027 726.537 278.23 726.657 278.401C726.776 278.572 726.946 278.701 727.142 278.772L766.176 301.306C766.687 301.568 767.252 301.705 767.826 301.705C768.4 301.705 768.966 301.568 769.476 301.306L808.476 278.789C808.672 278.719 808.842 278.589 808.962 278.418C809.082 278.248 809.146 278.044 809.146 277.835C809.146 277.627 809.082 277.423 808.962 277.253C808.842 277.082 808.672 276.952 808.476 276.881L769.476 254.365Z",
    fill: "url(#paint250_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.458 254.554C768.951 254.3 768.392 254.168 767.825 254.168C767.258 254.168 766.699 254.3 766.192 254.554L727.485 276.899C726.574 277.414 726.574 278.256 727.485 278.789L766.192 301.134C766.699 301.388 767.258 301.52 767.825 301.52C768.392 301.52 768.951 301.388 769.458 301.134L808.148 278.789C808.346 278.723 808.518 278.596 808.641 278.426C808.763 278.257 808.828 278.053 808.828 277.844C808.828 277.635 808.763 277.431 808.641 277.262C808.518 277.092 808.346 276.965 808.148 276.899L769.458 254.554Z",
    fill: "url(#paint251_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.442 254.743C768.939 254.49 768.382 254.357 767.818 254.357C767.254 254.357 766.698 254.49 766.194 254.743L727.813 276.882C727.621 276.952 727.455 277.079 727.337 277.247C727.22 277.414 727.157 277.614 727.157 277.818C727.157 278.023 727.22 278.222 727.337 278.39C727.455 278.558 727.621 278.685 727.813 278.755L766.194 300.91C766.698 301.164 767.254 301.297 767.818 301.297C768.382 301.297 768.939 301.164 769.442 300.91L807.806 278.772C807.998 278.702 808.164 278.575 808.282 278.407C808.399 278.24 808.462 278.04 808.462 277.835C808.462 277.631 808.399 277.431 808.282 277.264C808.164 277.096 807.998 276.969 807.806 276.899L769.442 254.743Z",
    fill: "url(#paint252_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.424 254.949C768.926 254.696 768.376 254.564 767.817 254.564C767.258 254.564 766.708 254.696 766.21 254.949L728.156 276.899C727.961 276.964 727.793 277.089 727.673 277.256C727.554 277.422 727.49 277.622 727.49 277.827C727.49 278.032 727.554 278.231 727.673 278.398C727.793 278.564 727.961 278.689 728.156 278.755L766.21 300.721C766.708 300.975 767.258 301.107 767.817 301.107C768.376 301.107 768.926 300.975 769.424 300.721L807.461 278.755C808.355 278.256 808.355 277.414 807.461 276.899L769.424 254.949Z",
    fill: "url(#paint253_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.408 255.139C768.914 254.893 768.37 254.766 767.818 254.766C767.266 254.766 766.722 254.893 766.228 255.139L728.501 276.899C728.312 276.968 728.15 277.093 728.035 277.257C727.92 277.422 727.859 277.618 727.859 277.818C727.859 278.019 727.92 278.214 728.035 278.379C728.15 278.543 728.312 278.669 728.501 278.738L766.228 300.532C766.722 300.777 767.266 300.905 767.818 300.905C768.37 300.905 768.914 300.777 769.408 300.532L807.136 278.755C807.324 278.686 807.486 278.56 807.601 278.396C807.716 278.232 807.777 278.036 807.777 277.835C807.777 277.635 807.716 277.439 807.601 277.275C807.486 277.11 807.324 276.985 807.136 276.916L769.408 255.139Z",
    fill: "url(#paint254_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.407 255.328C768.918 255.075 768.376 254.942 767.825 254.942C767.275 254.942 766.733 255.075 766.244 255.328L728.843 276.916C728.653 276.981 728.488 277.103 728.371 277.267C728.254 277.43 728.191 277.626 728.191 277.827C728.191 278.028 728.254 278.224 728.371 278.387C728.488 278.55 728.653 278.673 728.843 278.738L766.244 300.326C766.735 300.572 767.276 300.701 767.825 300.701C768.374 300.701 768.916 300.572 769.407 300.326L806.79 278.738C806.981 278.673 807.146 278.55 807.263 278.387C807.379 278.224 807.442 278.028 807.442 277.827C807.442 277.626 807.379 277.43 807.263 277.267C807.146 277.103 806.981 276.981 806.79 276.916L769.407 255.328Z",
    fill: "url(#paint255_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.321 255.534C768.836 255.287 768.3 255.158 767.757 255.158C767.213 255.158 766.677 255.287 766.192 255.534L729.101 276.916C728.917 276.984 728.758 277.107 728.645 277.269C728.533 277.43 728.473 277.622 728.473 277.818C728.473 278.015 728.533 278.206 728.645 278.368C728.758 278.529 728.917 278.652 729.101 278.721L766.192 300.137C766.677 300.384 767.213 300.513 767.757 300.513C768.3 300.513 768.836 300.384 769.321 300.137L806.378 278.738C806.57 278.678 806.739 278.558 806.858 278.395C806.977 278.233 807.042 278.037 807.042 277.835C807.042 277.634 806.977 277.438 806.858 277.275C806.739 277.113 806.57 276.993 806.378 276.933L769.321 255.534Z",
    fill: "url(#paint256_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.322 255.723C768.838 255.486 768.306 255.363 767.767 255.363C767.228 255.363 766.696 255.486 766.211 255.723L729.463 276.933C728.604 277.414 728.604 278.222 729.463 278.652L766.263 300.017C766.745 300.261 767.278 300.389 767.819 300.389C768.359 300.389 768.892 300.261 769.374 300.017L806.105 278.824C806.297 278.764 806.465 278.644 806.585 278.482C806.704 278.319 806.768 278.123 806.768 277.921C806.768 277.72 806.704 277.524 806.585 277.361C806.465 277.199 806.297 277.079 806.105 277.019L769.322 255.723Z",
    fill: "url(#paint257_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.322 255.929C768.844 255.69 768.318 255.566 767.784 255.566C767.25 255.566 766.723 255.69 766.245 255.929L729.79 276.933C728.947 277.431 728.947 278.222 729.79 278.652L766.211 299.69C766.689 299.929 767.215 300.053 767.749 300.053C768.283 300.053 768.81 299.929 769.288 299.69L805.709 278.669C805.88 278.599 806.026 278.48 806.129 278.327C806.232 278.174 806.287 277.994 806.287 277.81C806.287 277.625 806.232 277.445 806.129 277.292C806.026 277.139 805.88 277.02 805.709 276.95L769.322 255.929Z",
    fill: "url(#paint258_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.323 256.118C768.849 255.885 768.329 255.763 767.801 255.763C767.274 255.763 766.753 255.885 766.28 256.118L730.185 276.95C730.015 277.02 729.869 277.139 729.766 277.292C729.663 277.445 729.608 277.625 729.608 277.81C729.608 277.994 729.663 278.174 729.766 278.327C729.869 278.48 730.015 278.599 730.185 278.669L766.28 299.518C766.753 299.752 767.274 299.873 767.801 299.873C768.329 299.873 768.849 299.752 769.323 299.518L805.417 278.686C806.26 278.188 806.26 277.397 805.417 276.967L769.323 256.118Z",
    fill: "url(#paint259_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.322 256.307C768.851 256.077 768.333 255.957 767.809 255.957C767.285 255.957 766.767 256.077 766.296 256.307L730.511 276.933C730.34 277.003 730.194 277.122 730.091 277.275C729.988 277.428 729.933 277.608 729.933 277.792C729.933 277.977 729.988 278.157 730.091 278.31C730.194 278.463 730.34 278.582 730.511 278.652L766.296 299.277C766.767 299.508 767.285 299.628 767.809 299.628C768.333 299.628 768.851 299.508 769.322 299.277L805.073 278.652C805.251 278.589 805.405 278.473 805.514 278.319C805.623 278.165 805.681 277.981 805.681 277.792C805.681 277.604 805.623 277.42 805.514 277.266C805.405 277.112 805.251 276.996 805.073 276.933L769.322 256.307Z",
    fill: "url(#paint260_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.321 256.514C768.858 256.277 768.345 256.153 767.825 256.153C767.305 256.153 766.793 256.277 766.33 256.514L730.871 276.967C730.046 277.431 730.046 278.205 730.871 278.686L766.33 299.157C766.793 299.394 767.305 299.517 767.825 299.517C768.345 299.517 768.858 299.394 769.321 299.157L804.745 278.703C804.923 278.641 805.077 278.525 805.186 278.371C805.295 278.217 805.354 278.033 805.354 277.844C805.354 277.655 805.295 277.471 805.186 277.317C805.077 277.163 804.923 277.047 804.745 276.985L769.321 256.514Z",
    fill: "url(#paint261_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.322 256.703C768.858 256.48 768.35 256.365 767.836 256.365C767.321 256.365 766.813 256.48 766.349 256.703L731.234 276.967C730.409 277.431 730.409 278.205 731.234 278.686L766.349 298.968C766.813 299.191 767.321 299.306 767.836 299.306C768.35 299.306 768.858 299.191 769.322 298.968L804.437 278.686C804.624 278.633 804.789 278.52 804.905 278.365C805.022 278.21 805.086 278.021 805.086 277.827C805.086 277.633 805.022 277.444 804.905 277.289C804.789 277.133 804.624 277.021 804.437 276.967L769.322 256.703Z",
    fill: "url(#paint262_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.32 256.909C768.866 256.673 768.362 256.549 767.85 256.549C767.339 256.549 766.834 256.673 766.381 256.909L731.506 276.967C730.698 277.449 730.698 278.205 731.506 278.686L766.312 298.779C766.768 299.007 767.271 299.126 767.781 299.126C768.292 299.126 768.795 299.007 769.251 298.779L804.04 278.703C804.226 278.65 804.391 278.537 804.508 278.382C804.625 278.227 804.688 278.038 804.688 277.844C804.688 277.65 804.625 277.461 804.508 277.306C804.391 277.151 804.226 277.038 804.04 276.985L769.32 256.909Z",
    fill: "url(#paint263_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.32 257.047C768.87 256.817 768.372 256.698 767.867 256.698C767.362 256.698 766.865 256.817 766.415 257.047L731.884 276.985C731.698 277.038 731.533 277.151 731.416 277.306C731.299 277.461 731.236 277.65 731.236 277.844C731.236 278.038 731.299 278.227 731.416 278.382C731.533 278.537 731.698 278.65 731.884 278.703L766.363 298.607C766.813 298.836 767.311 298.956 767.816 298.956C768.321 298.956 768.818 298.836 769.268 298.607L803.644 278.703C803.831 278.65 803.995 278.537 804.112 278.382C804.229 278.227 804.292 278.038 804.292 277.844C804.292 277.65 804.229 277.461 804.112 277.306C803.995 277.151 803.831 277.038 803.644 276.985L769.32 257.047Z",
    fill: "url(#paint264_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.32 257.287C768.871 257.067 768.377 256.953 767.876 256.953C767.376 256.953 766.882 257.067 766.433 257.287L732.229 276.985C732.03 277.025 731.851 277.132 731.723 277.289C731.595 277.445 731.525 277.642 731.525 277.844C731.525 278.047 731.595 278.243 731.723 278.399C731.851 278.556 732.03 278.664 732.229 278.703L766.381 298.298C766.828 298.527 767.323 298.647 767.825 298.647C768.327 298.647 768.822 298.527 769.269 298.298L803.404 278.6C803.603 278.56 803.781 278.453 803.91 278.296C804.038 278.14 804.108 277.943 804.108 277.741C804.108 277.538 804.038 277.342 803.91 277.186C803.781 277.029 803.603 276.921 803.404 276.882L769.32 257.287Z",
    fill: "url(#paint265_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.321 257.493C768.88 257.264 768.391 257.145 767.894 257.145C767.397 257.145 766.908 257.264 766.467 257.493L732.641 277.002C732.443 277.042 732.264 277.149 732.136 277.306C732.008 277.462 731.938 277.659 731.938 277.861C731.938 278.064 732.008 278.26 732.136 278.417C732.264 278.573 732.443 278.681 732.641 278.721L766.485 298.246C766.928 298.467 767.416 298.582 767.911 298.582C768.406 298.582 768.895 298.467 769.338 298.246L803.147 278.721C803.345 278.681 803.524 278.573 803.652 278.417C803.78 278.26 803.851 278.064 803.851 277.861C803.851 277.659 803.78 277.462 803.652 277.306C803.524 277.149 803.345 277.042 803.147 277.002L769.321 257.493Z",
    fill: "url(#paint266_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.321 257.682C768.881 257.462 768.395 257.347 767.903 257.347C767.41 257.347 766.925 257.462 766.485 257.682L732.985 277.002C732.813 277.058 732.664 277.168 732.557 277.314C732.451 277.461 732.394 277.637 732.394 277.818C732.394 277.999 732.451 278.176 732.557 278.322C732.664 278.469 732.813 278.578 732.985 278.635L766.485 297.988C766.925 298.209 767.41 298.324 767.903 298.324C768.395 298.324 768.881 298.209 769.321 297.988L802.803 278.652C802.975 278.595 803.125 278.486 803.231 278.339C803.337 278.193 803.394 278.016 803.394 277.835C803.394 277.654 803.337 277.478 803.231 277.331C803.125 277.185 802.975 277.075 802.803 277.019L769.321 257.682Z",
    fill: "url(#paint267_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.217 257.872C768.781 257.66 768.302 257.55 767.816 257.55C767.331 257.55 766.852 257.66 766.416 257.872L733.226 277.019C733.06 277.079 732.916 277.189 732.815 277.334C732.714 277.478 732.659 277.65 732.659 277.827C732.659 278.003 732.714 278.176 732.815 278.32C732.916 278.465 733.06 278.574 733.226 278.635L766.398 297.782C766.832 298.003 767.312 298.117 767.799 298.117C768.286 298.117 768.766 298.003 769.2 297.782L802.356 278.635C802.522 278.574 802.665 278.465 802.766 278.32C802.868 278.176 802.922 278.003 802.922 277.827C802.922 277.65 802.868 277.478 802.766 277.334C802.665 277.189 802.522 277.079 802.356 277.019L769.217 257.872Z",
    fill: "url(#paint268_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.202 258.078C768.774 257.858 768.3 257.743 767.819 257.743C767.337 257.743 766.863 257.858 766.435 258.078L733.589 276.985C732.815 277.432 732.815 278.153 733.589 278.583L766.435 297.49C766.863 297.71 767.337 297.825 767.819 297.825C768.3 297.825 768.774 297.71 769.202 297.49L802.048 278.583C802.216 278.527 802.362 278.42 802.466 278.277C802.569 278.133 802.625 277.961 802.625 277.784C802.625 277.607 802.569 277.435 802.466 277.291C802.362 277.148 802.216 277.04 802.048 276.985L769.202 258.078Z",
    fill: "url(#paint269_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.2 258.267C768.773 258.055 768.302 257.944 767.825 257.944C767.348 257.944 766.877 258.055 766.45 258.267L733.913 277.036C733.751 277.096 733.611 277.203 733.513 277.345C733.414 277.486 733.361 277.654 733.361 277.827C733.361 277.999 733.414 278.168 733.513 278.309C733.611 278.45 733.751 278.558 733.913 278.617L766.45 297.404C766.877 297.616 767.348 297.726 767.825 297.726C768.302 297.726 768.773 297.616 769.2 297.404L801.703 278.635C801.87 278.579 802.016 278.472 802.12 278.328C802.223 278.185 802.279 278.012 802.279 277.835C802.279 277.659 802.223 277.486 802.12 277.343C802.016 277.199 801.87 277.092 801.703 277.036L769.2 258.267Z",
    fill: "url(#paint270_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.185 258.473C768.761 258.261 768.293 258.151 767.818 258.151C767.344 258.151 766.876 258.261 766.452 258.473L734.259 277.036C734.097 277.096 733.957 277.203 733.858 277.345C733.76 277.486 733.707 277.654 733.707 277.827C733.707 277.999 733.76 278.168 733.858 278.309C733.957 278.45 734.097 278.558 734.259 278.617L766.469 297.198C766.891 297.409 767.356 297.52 767.827 297.52C768.299 297.52 768.764 297.409 769.185 297.198L801.361 278.617C801.525 278.562 801.667 278.457 801.768 278.317C801.869 278.177 801.923 278.008 801.923 277.835C801.923 277.663 801.869 277.494 801.768 277.354C801.667 277.213 801.525 277.108 801.361 277.053L769.185 258.473Z",
    fill: "url(#paint271_linear_1606_3980)",
    fillOpacity: 0.15
  }))), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M804.609 235.991H731.182V277.397C731.203 277.575 731.27 277.744 731.375 277.888C731.48 278.032 731.621 278.148 731.783 278.222L766.451 298.298C766.905 298.526 767.405 298.645 767.912 298.645C768.42 298.645 768.92 298.526 769.373 298.298L804.007 278.308C804.173 278.233 804.316 278.116 804.421 277.968C804.527 277.82 804.592 277.647 804.609 277.466V235.991Z",
    fill: "#2C2067"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M804.006 248.143L769.321 268.133C768.867 268.361 768.367 268.48 767.86 268.48C767.352 268.48 766.852 268.361 766.399 268.133L731.73 248.126C731.568 248.051 731.428 247.936 731.322 247.792C731.217 247.647 731.151 247.478 731.129 247.301V253.025C731.148 253.205 731.213 253.378 731.319 253.525C731.424 253.673 731.566 253.79 731.73 253.867L766.399 273.874C766.852 274.102 767.352 274.221 767.86 274.221C768.367 274.221 768.867 274.102 769.321 273.874L803.954 253.884C804.122 253.808 804.267 253.688 804.373 253.537C804.479 253.385 804.542 253.209 804.556 253.025V247.301C804.544 247.477 804.487 247.646 804.391 247.794C804.294 247.941 804.162 248.061 804.006 248.143Z",
    fill: "#5A3CFF"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M804.006 263.492L769.321 283.499C768.867 283.727 768.367 283.846 767.86 283.846C767.352 283.846 766.852 283.727 766.399 283.499L731.73 263.492C731.568 263.413 731.428 263.295 731.323 263.147C731.217 263 731.151 262.829 731.129 262.65V268.391C731.151 268.57 731.217 268.741 731.323 268.888C731.428 269.035 731.568 269.154 731.73 269.233L766.399 289.24C766.852 289.468 767.352 289.587 767.86 289.587C768.367 289.587 768.867 289.468 769.321 289.24L803.954 269.233C804.123 269.163 804.269 269.046 804.376 268.898C804.482 268.749 804.544 268.573 804.556 268.391V262.65C804.549 262.827 804.494 262.999 804.397 263.147C804.301 263.295 804.165 263.414 804.006 263.492Z",
    fill: "#5A3CFF"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M769.322 215.142C768.869 214.914 768.368 214.795 767.861 214.795C767.354 214.795 766.853 214.914 766.4 215.142L731.732 235.132C731.554 235.194 731.4 235.311 731.291 235.465C731.182 235.619 731.123 235.803 731.123 235.991C731.123 236.18 731.182 236.364 731.291 236.518C731.4 236.672 731.554 236.788 731.732 236.851L766.4 256.858C766.853 257.086 767.354 257.205 767.861 257.205C768.368 257.205 768.869 257.086 769.322 256.858L803.956 236.851C804.143 236.797 804.307 236.685 804.424 236.53C804.541 236.374 804.604 236.186 804.604 235.991C804.604 235.797 804.541 235.608 804.424 235.453C804.307 235.298 804.143 235.185 803.956 235.132L769.322 215.142Z",
    fill: "#7564C9"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M749.4 228.222C758.991 222.688 774.701 222.688 784.292 228.222C793.883 233.757 793.883 242.815 784.292 248.367C774.701 253.918 758.991 253.901 749.4 248.367C739.809 242.832 739.809 233.757 749.4 228.222Z",
    fill: "url(#paint272_radial_1606_3980)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M766.298 165.985L766.247 180.371L762.139 178.051V163.527L766.298 165.985Z",
    fill: "url(#paint273_linear_1606_3980)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M792.612 218.374L789.724 218.906C788.38 217.449 786.814 216.213 785.083 215.245C775.063 209.453 758.648 209.453 748.61 215.245C746.88 216.213 745.313 217.449 743.97 218.906L741.082 218.374V221.519C741.082 225.352 743.557 229.185 748.593 232.09C758.631 237.882 775.046 237.882 785.066 232.09C790.102 229.185 792.612 225.352 792.594 221.519L792.612 218.374Z",
    fill: "#E5E9F4"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M748.697 207.579C758.735 201.787 775.15 201.787 785.17 207.579C795.191 213.372 795.208 222.86 785.17 228.652C775.132 234.444 758.735 234.427 748.697 228.652C738.66 222.877 738.574 213.372 748.697 207.579Z",
    fill: "#FAFBFD"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M751.102 209.023C759.696 204.022 773.928 204.022 782.59 209.023C791.253 214.025 791.184 222.207 782.59 227.208C773.996 232.21 759.765 232.21 751.102 227.208C742.439 222.207 742.456 214.077 751.102 209.023Z",
    fill: "#D3DAED"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M753.629 210.639C757.734 208.62 762.247 207.57 766.821 207.57C771.395 207.57 775.909 208.62 780.013 210.639C787.266 214.747 787.266 221.45 780.013 225.558C775.909 227.577 771.395 228.627 766.821 228.627C762.247 228.627 757.734 227.577 753.629 225.558C746.376 221.467 746.376 214.764 753.629 210.639Z",
    fill: "#FAFBFD"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M756.07 212.031C759.415 210.386 763.094 209.53 766.822 209.53C770.549 209.53 774.228 210.386 777.573 212.031C783.502 215.383 783.502 220.849 777.573 224.2C774.228 225.846 770.549 226.702 766.822 226.702C763.094 226.702 759.415 225.846 756.07 224.2C750.141 220.849 750.141 215.383 756.07 212.031Z",
    fill: "#D3DAED"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M758.442 213.836C761.043 212.672 763.86 212.07 766.709 212.07C769.559 212.07 772.376 212.672 774.977 213.836C779.532 216.191 779.532 220.041 774.977 222.43C772.376 223.594 769.559 224.196 766.709 224.196C763.86 224.196 761.043 223.594 758.442 222.43C753.853 220.041 753.853 216.191 758.442 213.836Z",
    fill: "#FAFBFD"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M766.711 221.811C770.66 221.811 773.861 220.157 773.861 218.116C773.861 216.075 770.66 214.42 766.711 214.42C762.762 214.42 759.561 216.075 759.561 218.116C759.561 220.157 762.762 221.811 766.711 221.811Z",
    fill: "#D3DAED"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M766.811 218.752C766.499 218.752 766.2 218.629 765.978 218.411C765.756 218.192 765.63 217.895 765.625 217.583V163.819C765.63 163.507 765.756 163.21 765.978 162.991C766.2 162.773 766.499 162.65 766.811 162.65C767.121 162.65 767.418 162.773 767.637 162.992C767.857 163.212 767.98 163.509 767.98 163.819V217.514C767.989 217.673 767.966 217.833 767.911 217.983C767.857 218.133 767.772 218.27 767.663 218.386C767.553 218.501 767.421 218.594 767.275 218.657C767.128 218.72 766.97 218.752 766.811 218.752Z",
    fill: "#5A3CFF"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M766.811 165.847L766.845 180.233L773.187 176.71V162.186L766.811 165.847Z",
    fill: "url(#paint274_linear_1606_3980)"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter6_f_1606_3980)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M696.103 294.757C695.536 294.469 694.908 294.319 694.272 294.319C693.636 294.319 693.009 294.469 692.442 294.757L649.007 319.766C648.787 319.841 648.596 319.984 648.46 320.173C648.325 320.363 648.252 320.59 648.252 320.823C648.252 321.056 648.325 321.283 648.46 321.472C648.596 321.662 648.787 321.804 649.007 321.88L692.39 346.94C692.957 347.228 693.584 347.379 694.221 347.379C694.857 347.379 695.484 347.228 696.051 346.94L739.399 321.897C739.62 321.822 739.811 321.679 739.946 321.49C740.082 321.3 740.155 321.073 740.155 320.84C740.155 320.607 740.082 320.38 739.946 320.19C739.811 320.001 739.62 319.858 739.399 319.783L696.103 294.757Z",
    fill: "url(#paint275_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.086 294.86C695.52 294.58 694.896 294.434 694.264 294.434C693.632 294.434 693.009 294.58 692.443 294.86L649.369 319.783C649.155 319.862 648.97 320.005 648.839 320.192C648.708 320.38 648.638 320.603 648.638 320.831C648.638 321.06 648.708 321.283 648.839 321.471C648.97 321.658 649.155 321.801 649.369 321.88L692.443 346.751C693.009 347.031 693.632 347.177 694.264 347.177C694.896 347.177 695.52 347.031 696.086 346.751L739.142 321.897C739.357 321.818 739.542 321.675 739.673 321.488C739.804 321.3 739.874 321.077 739.874 320.849C739.874 320.62 739.804 320.397 739.673 320.209C739.542 320.022 739.357 319.879 739.142 319.8L696.086 294.86Z",
    fill: "url(#paint276_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.068 295.118C695.508 294.838 694.89 294.692 694.263 294.692C693.637 294.692 693.019 294.838 692.459 295.118L649.695 319.783C649.48 319.862 649.295 320.005 649.165 320.192C649.034 320.38 648.964 320.603 648.964 320.831C648.964 321.06 649.034 321.283 649.165 321.471C649.295 321.658 649.48 321.801 649.695 321.88L692.459 346.562C693.019 346.842 693.637 346.987 694.263 346.987C694.89 346.987 695.508 346.842 696.068 346.562L738.815 321.88C739.031 321.805 739.219 321.665 739.352 321.478C739.485 321.292 739.556 321.069 739.556 320.84C739.556 320.611 739.485 320.388 739.352 320.201C739.219 320.015 739.031 319.875 738.815 319.8L696.068 295.118Z",
    fill: "url(#paint277_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.051 295.307C695.497 295.028 694.885 294.882 694.264 294.882C693.643 294.882 693.031 295.028 692.476 295.307L650.022 319.8C649.803 319.87 649.613 320.008 649.477 320.193C649.342 320.378 649.269 320.602 649.269 320.832C649.269 321.061 649.342 321.285 649.477 321.47C649.613 321.655 649.803 321.793 650.022 321.863L692.476 346.424C693.031 346.704 693.643 346.85 694.264 346.85C694.885 346.85 695.497 346.704 696.051 346.424L738.488 321.932C738.705 321.857 738.893 321.717 739.025 321.53C739.158 321.344 739.23 321.121 739.23 320.892C739.23 320.663 739.158 320.44 739.025 320.253C738.893 320.067 738.705 319.926 738.488 319.852L696.051 295.307Z",
    fill: "url(#paint278_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.05 295.496C695.499 295.217 694.889 295.071 694.271 295.071C693.653 295.071 693.044 295.217 692.492 295.496L650.347 319.8C650.129 319.87 649.938 320.008 649.803 320.193C649.668 320.378 649.595 320.602 649.595 320.832C649.595 321.061 649.668 321.285 649.803 321.47C649.938 321.655 650.129 321.793 650.347 321.863L692.492 346.184C693.044 346.463 693.653 346.609 694.271 346.609C694.889 346.609 695.499 346.463 696.05 346.184L738.161 321.863C738.373 321.789 738.557 321.651 738.688 321.467C738.818 321.284 738.888 321.065 738.888 320.84C738.888 320.615 738.818 320.396 738.688 320.213C738.557 320.029 738.373 319.891 738.161 319.817L696.05 295.496Z",
    fill: "url(#paint279_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.034 295.685C695.486 295.406 694.879 295.261 694.264 295.261C693.649 295.261 693.042 295.406 692.494 295.685L650.675 319.749C650.461 319.818 650.274 319.953 650.141 320.136C650.009 320.318 649.937 320.537 649.937 320.763C649.937 320.988 650.009 321.208 650.141 321.39C650.274 321.572 650.461 321.708 650.675 321.777L692.494 345.926C693.042 346.205 693.649 346.351 694.264 346.351C694.879 346.351 695.486 346.205 696.034 345.926L737.853 321.863C738.065 321.789 738.249 321.651 738.38 321.467C738.51 321.284 738.58 321.065 738.58 320.84C738.58 320.615 738.51 320.396 738.38 320.213C738.249 320.029 738.065 319.891 737.853 319.817L696.034 295.685Z",
    fill: "url(#paint280_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.015 295.875C695.482 295.607 694.893 295.468 694.296 295.468C693.7 295.468 693.111 295.607 692.578 295.875L651.051 319.817C650.837 319.887 650.65 320.022 650.517 320.204C650.385 320.387 650.313 320.606 650.313 320.832C650.313 321.057 650.385 321.276 650.517 321.459C650.65 321.641 650.837 321.776 651.051 321.846L692.578 345.823C693.113 346.083 693.701 346.218 694.296 346.218C694.892 346.218 695.48 346.083 696.015 345.823L737.524 321.863C737.739 321.794 737.926 321.658 738.058 321.476C738.191 321.294 738.262 321.074 738.262 320.849C738.262 320.623 738.191 320.404 738.058 320.222C737.926 320.039 737.739 319.904 737.524 319.835L696.015 295.875Z",
    fill: "url(#paint281_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.001 296.063C695.468 295.793 694.879 295.652 694.282 295.652C693.685 295.652 693.096 295.793 692.563 296.063L651.312 319.852C651.102 319.92 650.918 320.054 650.788 320.233C650.658 320.412 650.588 320.627 650.588 320.849C650.588 321.07 650.658 321.285 650.788 321.465C650.918 321.644 651.102 321.777 651.312 321.846L692.563 345.651C693.098 345.916 693.686 346.054 694.282 346.054C694.879 346.054 695.467 345.916 696.001 345.651L737.252 321.863C737.46 321.79 737.641 321.654 737.769 321.473C737.896 321.293 737.965 321.078 737.965 320.857C737.965 320.636 737.896 320.421 737.769 320.241C737.641 320.061 737.46 319.925 737.252 319.852L696.001 296.063Z",
    fill: "url(#paint282_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696 296.235C695.467 295.966 694.878 295.826 694.281 295.826C693.684 295.826 693.095 295.966 692.562 296.235L651.655 319.835C651.444 319.903 651.261 320.036 651.131 320.215C651.001 320.395 650.931 320.61 650.931 320.831C650.931 321.053 651.001 321.268 651.131 321.447C651.261 321.626 651.444 321.76 651.655 321.828L692.562 345.445C693.095 345.714 693.684 345.854 694.281 345.854C694.878 345.854 695.467 345.714 696 345.445L736.873 321.846C737.083 321.777 737.266 321.644 737.396 321.465C737.526 321.285 737.596 321.07 737.596 320.849C737.596 320.627 737.526 320.412 737.396 320.233C737.266 320.054 737.083 319.92 736.873 319.852L696 296.235Z",
    fill: "url(#paint283_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.982 296.424C695.447 296.162 694.859 296.025 694.263 296.025C693.667 296.025 693.079 296.162 692.544 296.424L651.963 319.834C651.753 319.903 651.57 320.036 651.44 320.215C651.31 320.395 651.24 320.61 651.24 320.831C651.24 321.053 651.31 321.268 651.44 321.447C651.57 321.626 651.753 321.76 651.963 321.828L692.544 345.256C693.077 345.527 693.666 345.669 694.263 345.669C694.861 345.669 695.45 345.527 695.982 345.256L736.546 321.828C736.75 321.756 736.927 321.622 737.052 321.445C737.177 321.268 737.244 321.057 737.244 320.84C737.244 320.623 737.177 320.412 737.052 320.235C736.927 320.058 736.75 319.924 736.546 319.852L695.982 296.424Z",
    fill: "url(#paint284_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.967 296.579C695.434 296.31 694.845 296.17 694.248 296.17C693.651 296.17 693.062 296.31 692.529 296.579L652.275 319.852C652.068 319.919 651.889 320.051 651.761 320.227C651.634 320.402 651.565 320.614 651.565 320.831C651.565 321.049 651.634 321.26 651.761 321.436C651.889 321.612 652.068 321.743 652.275 321.811L692.563 345.066C693.094 345.343 693.684 345.488 694.282 345.488C694.881 345.488 695.47 345.343 696.001 345.066L736.272 321.828C736.479 321.76 736.658 321.629 736.786 321.453C736.913 321.277 736.982 321.066 736.982 320.848C736.982 320.631 736.913 320.42 736.786 320.244C736.658 320.068 736.479 319.937 736.272 319.869L695.967 296.579Z",
    fill: "url(#paint285_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.947 296.803C695.415 296.528 694.826 296.385 694.228 296.385C693.63 296.385 693.04 296.528 692.509 296.803L652.53 319.852C652.323 319.919 652.144 320.051 652.016 320.227C651.889 320.403 651.82 320.614 651.82 320.831C651.82 321.049 651.889 321.26 652.016 321.436C652.144 321.612 652.323 321.743 652.53 321.811L692.509 344.877C693.038 345.16 693.628 345.308 694.228 345.308C694.827 345.308 695.418 345.16 695.947 344.877L735.909 321.811C736.109 321.74 736.282 321.608 736.405 321.434C736.527 321.26 736.593 321.053 736.593 320.84C736.593 320.627 736.527 320.42 736.405 320.246C736.282 320.072 736.109 319.94 735.909 319.869L695.947 296.803Z",
    fill: "url(#paint286_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.946 296.992C695.427 296.729 694.853 296.592 694.271 296.592C693.688 296.592 693.114 296.729 692.595 296.992L652.925 319.869C652.723 319.936 652.547 320.065 652.422 320.238C652.297 320.411 652.23 320.618 652.23 320.831C652.23 321.045 652.297 321.252 652.422 321.425C652.547 321.598 652.723 321.727 652.925 321.794L692.595 344.706C693.117 344.961 693.69 345.093 694.271 345.093C694.851 345.093 695.425 344.961 695.946 344.706L735.582 321.811C735.782 321.74 735.956 321.608 736.078 321.434C736.2 321.26 736.266 321.053 736.266 320.84C736.266 320.627 736.2 320.42 736.078 320.246C735.956 320.072 735.782 319.94 735.582 319.869L695.946 296.992Z",
    fill: "url(#paint287_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.932 297.181C695.415 296.918 694.844 296.781 694.264 296.781C693.685 296.781 693.114 296.918 692.597 297.181L653.254 319.869C653.052 319.936 652.876 320.065 652.751 320.238C652.626 320.411 652.559 320.618 652.559 320.831C652.559 321.045 652.626 321.252 652.751 321.425C652.876 321.598 653.052 321.727 653.254 321.794L692.597 344.517C693.116 344.771 693.686 344.904 694.264 344.904C694.842 344.904 695.413 344.771 695.932 344.517L735.258 321.794C735.454 321.723 735.624 321.594 735.744 321.423C735.864 321.252 735.928 321.049 735.928 320.84C735.928 320.631 735.864 320.428 735.744 320.257C735.624 320.086 735.454 319.957 735.258 319.886L695.932 297.181Z",
    fill: "url(#paint288_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.913 297.353C695.4 297.098 694.835 296.966 694.262 296.966C693.69 296.966 693.125 297.098 692.612 297.353L653.579 319.886C653.38 319.952 653.208 320.079 653.086 320.249C652.964 320.419 652.898 320.622 652.898 320.831C652.898 321.04 652.964 321.244 653.086 321.414C653.208 321.583 653.38 321.71 653.579 321.777L692.612 344.327C693.125 344.582 693.69 344.714 694.262 344.714C694.835 344.714 695.4 344.582 695.913 344.327L734.947 321.794C735.143 321.723 735.312 321.594 735.432 321.423C735.552 321.252 735.617 321.049 735.617 320.84C735.617 320.631 735.552 320.428 735.432 320.257C735.312 320.087 735.143 319.957 734.947 319.886L695.913 297.353Z",
    fill: "url(#paint289_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.895 297.542C695.388 297.288 694.829 297.155 694.262 297.155C693.695 297.155 693.136 297.288 692.629 297.542L653.887 319.886C653.689 319.952 653.517 320.079 653.395 320.249C653.273 320.419 653.207 320.622 653.207 320.831C653.207 321.04 653.273 321.244 653.395 321.414C653.517 321.583 653.689 321.71 653.887 321.777L692.629 344.121C693.136 344.375 693.695 344.507 694.262 344.507C694.829 344.507 695.388 344.375 695.895 344.121L734.619 321.777C734.818 321.71 734.99 321.583 735.112 321.414C735.234 321.244 735.3 321.04 735.3 320.831C735.3 320.622 735.234 320.419 735.112 320.249C734.99 320.079 734.818 319.952 734.619 319.886L695.895 297.542Z",
    fill: "url(#paint290_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.88 297.731C695.38 297.477 694.826 297.345 694.265 297.345C693.703 297.345 693.15 297.477 692.649 297.731L654.165 319.903C653.971 319.969 653.802 320.094 653.683 320.26C653.563 320.427 653.499 320.626 653.499 320.831C653.499 321.036 653.563 321.236 653.683 321.403C653.802 321.569 653.971 321.694 654.165 321.759L692.597 343.949C693.098 344.203 693.652 344.335 694.213 344.335C694.774 344.335 695.328 344.203 695.829 343.949L734.244 321.777C734.436 321.707 734.602 321.579 734.72 321.412C734.837 321.244 734.9 321.045 734.9 320.84C734.9 320.635 734.837 320.436 734.72 320.268C734.602 320.101 734.436 319.973 734.244 319.903L695.88 297.731Z",
    fill: "url(#paint291_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.878 297.92C695.377 297.666 694.824 297.534 694.262 297.534C693.701 297.534 693.148 297.666 692.647 297.92L654.541 319.903C654.347 319.969 654.178 320.094 654.059 320.26C653.939 320.427 653.875 320.626 653.875 320.831C653.875 321.036 653.939 321.236 654.059 321.403C654.178 321.569 654.347 321.694 654.541 321.759L692.647 343.76C693.148 344.014 693.701 344.146 694.262 344.146C694.824 344.146 695.377 344.014 695.878 343.76L733.967 321.777C734.861 321.261 734.861 320.419 733.967 319.92L695.878 297.92Z",
    fill: "url(#paint292_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.86 298.109C695.367 297.85 694.819 297.715 694.262 297.715C693.705 297.715 693.157 297.85 692.663 298.109L654.85 319.903C654.656 319.969 654.487 320.094 654.368 320.26C654.248 320.427 654.184 320.627 654.184 320.831C654.184 321.036 654.248 321.236 654.368 321.403C654.487 321.569 654.656 321.694 654.85 321.76L692.663 343.571C693.157 343.83 693.705 343.965 694.262 343.965C694.819 343.965 695.367 343.83 695.86 343.571L733.674 321.76C733.862 321.69 734.025 321.565 734.14 321.401C734.254 321.236 734.316 321.041 734.316 320.84C734.316 320.64 734.254 320.444 734.14 320.279C734.025 320.115 733.862 319.99 733.674 319.921L695.86 298.109Z",
    fill: "url(#paint293_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.844 298.298C695.356 298.045 694.813 297.913 694.263 297.913C693.713 297.913 693.17 298.045 692.682 298.298L655.195 319.921C655.005 319.985 654.84 320.108 654.723 320.271C654.606 320.435 654.543 320.631 654.543 320.832C654.543 321.032 654.606 321.228 654.723 321.392C654.84 321.555 655.005 321.678 655.195 321.742L692.682 343.399C693.173 343.646 693.714 343.774 694.263 343.774C694.812 343.774 695.354 343.646 695.844 343.399L733.331 321.76C733.52 321.69 733.682 321.565 733.797 321.401C733.912 321.236 733.973 321.041 733.973 320.84C733.973 320.64 733.912 320.444 733.797 320.279C733.682 320.115 733.52 319.99 733.331 319.921L695.844 298.298Z",
    fill: "url(#paint294_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.827 298.47C695.342 298.222 694.806 298.093 694.263 298.093C693.719 298.093 693.183 298.222 692.698 298.47L655.504 319.92C655.314 319.985 655.148 320.108 655.032 320.271C654.915 320.435 654.852 320.631 654.852 320.831C654.852 321.032 654.915 321.228 655.032 321.391C655.148 321.555 655.314 321.678 655.504 321.742L692.698 343.21C693.183 343.458 693.719 343.587 694.263 343.587C694.806 343.587 695.342 343.458 695.827 343.21L733.004 321.742C733.163 321.662 733.297 321.539 733.391 321.388C733.484 321.236 733.533 321.061 733.533 320.883C733.533 320.705 733.484 320.53 733.391 320.378C733.297 320.227 733.163 320.104 733.004 320.024L695.827 298.47Z",
    fill: "url(#paint295_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.828 298.659C695.341 298.422 694.806 298.299 694.264 298.299C693.722 298.299 693.187 298.422 692.7 298.659L655.883 319.938C655.719 320.013 655.579 320.134 655.482 320.286C655.384 320.439 655.332 320.616 655.332 320.797C655.332 320.978 655.384 321.155 655.482 321.308C655.579 321.46 655.719 321.581 655.883 321.656L692.7 342.987C693.184 343.234 693.72 343.363 694.264 343.363C694.808 343.363 695.344 343.234 695.828 342.987L732.679 321.708C732.839 321.628 732.972 321.505 733.066 321.353C733.159 321.201 733.209 321.027 733.209 320.849C733.209 320.67 733.159 320.496 733.066 320.344C732.972 320.192 732.839 320.069 732.679 319.989L695.828 298.659Z",
    fill: "url(#paint296_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.811 298.848C695.332 298.606 694.802 298.48 694.264 298.48C693.727 298.48 693.197 298.606 692.718 298.848L656.159 319.938C655.994 320.013 655.855 320.134 655.757 320.287C655.659 320.439 655.607 320.616 655.607 320.797C655.607 320.978 655.659 321.155 655.757 321.308C655.855 321.46 655.994 321.581 656.159 321.656L692.718 342.763C693.197 343.005 693.727 343.131 694.264 343.131C694.802 343.131 695.332 343.005 695.811 342.763L732.353 321.674C733.213 321.175 733.213 320.367 732.353 319.955L695.811 298.848Z",
    fill: "url(#paint297_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.793 299.037C695.317 298.801 694.794 298.678 694.263 298.678C693.732 298.678 693.208 298.801 692.733 299.037L656.484 319.955C656.313 320.025 656.167 320.143 656.064 320.297C655.961 320.45 655.906 320.63 655.906 320.814C655.906 320.999 655.961 321.179 656.064 321.332C656.167 321.485 656.313 321.604 656.484 321.674L692.733 342.609C693.206 342.854 693.73 342.982 694.263 342.982C694.795 342.982 695.32 342.854 695.793 342.609L732.025 321.691C732.867 321.21 732.867 320.419 732.025 319.972L695.793 299.037Z",
    fill: "url(#paint298_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.774 299.226C695.304 298.995 694.786 298.875 694.262 298.875C693.738 298.875 693.22 298.995 692.749 299.226L656.809 319.955C656.638 320.024 656.492 320.143 656.389 320.296C656.287 320.449 656.232 320.63 656.232 320.814C656.232 320.999 656.287 321.179 656.389 321.332C656.492 321.485 656.638 321.604 656.809 321.674L692.767 342.419C693.237 342.65 693.755 342.77 694.279 342.77C694.803 342.77 695.321 342.65 695.792 342.419L731.732 321.691C731.903 321.621 732.049 321.502 732.152 321.349C732.254 321.196 732.309 321.016 732.309 320.831C732.309 320.647 732.254 320.467 732.152 320.314C732.049 320.161 731.903 320.042 731.732 319.972L695.774 299.226Z",
    fill: "url(#paint299_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.775 299.415C695.304 299.185 694.787 299.065 694.262 299.065C693.738 299.065 693.221 299.185 692.75 299.415L657.119 320.041C656.941 320.103 656.787 320.22 656.678 320.374C656.569 320.528 656.51 320.712 656.51 320.9C656.51 321.089 656.569 321.273 656.678 321.427C656.787 321.581 656.941 321.697 657.119 321.76L692.767 342.385C693.236 342.613 693.75 342.732 694.271 342.732C694.792 342.732 695.306 342.613 695.775 342.385L731.388 321.76C731.566 321.697 731.721 321.581 731.83 321.427C731.939 321.273 731.997 321.089 731.997 320.9C731.997 320.712 731.939 320.528 731.83 320.374C731.721 320.22 731.566 320.103 731.388 320.041L695.775 299.415Z",
    fill: "url(#paint300_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.76 299.604C695.297 299.367 694.785 299.244 694.265 299.244C693.745 299.244 693.232 299.367 692.769 299.604L657.448 319.972C656.623 320.453 656.623 321.227 657.448 321.691L692.769 342.093C693.236 342.318 693.747 342.435 694.265 342.435C694.782 342.435 695.294 342.318 695.76 342.093L731.064 321.708C731.889 321.227 731.889 320.453 731.064 319.989L695.76 299.604Z",
    fill: "url(#paint301_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.742 299.776C695.283 299.548 694.777 299.429 694.264 299.429C693.751 299.429 693.245 299.548 692.786 299.776L657.774 319.972C657.596 320.035 657.442 320.151 657.333 320.305C657.223 320.459 657.165 320.643 657.165 320.831C657.165 321.02 657.223 321.204 657.333 321.358C657.442 321.512 657.596 321.628 657.774 321.691L692.786 341.904C693.245 342.133 693.751 342.252 694.264 342.252C694.777 342.252 695.283 342.133 695.742 341.904L730.737 321.691C730.924 321.638 731.088 321.525 731.205 321.37C731.322 321.215 731.385 321.026 731.385 320.831C731.385 320.637 731.322 320.448 731.205 320.293C731.088 320.138 730.924 320.025 730.737 319.972L695.742 299.776Z",
    fill: "url(#paint302_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.723 300.017C695.27 299.789 694.769 299.67 694.262 299.67C693.755 299.67 693.254 299.789 692.801 300.017L658.098 320.041C657.912 320.094 657.747 320.207 657.63 320.362C657.513 320.517 657.45 320.706 657.45 320.9C657.45 321.094 657.513 321.283 657.63 321.438C657.747 321.594 657.912 321.706 658.098 321.76L692.801 341.801C693.254 342.029 693.755 342.148 694.262 342.148C694.769 342.148 695.27 342.029 695.723 341.801L730.408 321.777C730.595 321.723 730.759 321.611 730.876 321.456C730.993 321.301 731.057 321.112 731.057 320.917C731.057 320.723 730.993 320.534 730.876 320.379C730.759 320.224 730.595 320.111 730.408 320.058L695.723 300.017Z",
    fill: "url(#paint303_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.725 300.154C695.275 299.925 694.778 299.805 694.273 299.805C693.768 299.805 693.27 299.925 692.82 300.154L658.444 319.989C658.258 320.042 658.093 320.155 657.976 320.31C657.859 320.465 657.796 320.654 657.796 320.849C657.796 321.043 657.859 321.232 657.976 321.387C658.093 321.542 658.258 321.655 658.444 321.708L692.82 341.56C693.27 341.79 693.768 341.909 694.273 341.909C694.778 341.909 695.275 341.79 695.725 341.56L730.101 321.708C730.3 321.668 730.478 321.561 730.607 321.404C730.735 321.247 730.805 321.051 730.805 320.849C730.805 320.646 730.735 320.45 730.607 320.293C730.478 320.136 730.3 320.029 730.101 319.989L695.725 300.154Z",
    fill: "url(#paint304_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.706 300.343C695.26 300.114 694.765 299.995 694.262 299.995C693.76 299.995 693.265 300.114 692.819 300.343L658.735 320.006C658.536 320.046 658.358 320.154 658.229 320.31C658.101 320.467 658.031 320.663 658.031 320.866C658.031 321.068 658.101 321.265 658.229 321.421C658.358 321.578 658.536 321.685 658.735 321.725L692.819 341.268C693.265 341.497 693.76 341.617 694.262 341.617C694.765 341.617 695.26 341.497 695.706 341.268L729.79 321.674C729.989 321.634 730.167 321.526 730.296 321.37C730.424 321.213 730.494 321.017 730.494 320.814C730.494 320.612 730.424 320.415 730.296 320.259C730.167 320.102 729.989 319.995 729.79 319.955L695.706 300.343Z",
    fill: "url(#paint305_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.691 300.532C695.251 300.303 694.761 300.184 694.265 300.184C693.768 300.184 693.279 300.303 692.838 300.532L659.064 320.006C658.273 320.47 658.273 321.209 659.064 321.725L692.838 341.216C693.279 341.445 693.768 341.565 694.265 341.565C694.761 341.565 695.251 341.445 695.691 341.216L729.449 321.674C730.239 321.209 730.239 320.47 729.449 319.955L695.691 300.532Z",
    fill: "url(#paint306_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.672 300.722C695.235 300.501 694.752 300.386 694.263 300.386C693.773 300.386 693.29 300.501 692.853 300.722L659.319 320.024C658.546 320.471 658.546 321.192 659.319 321.742L692.784 341.062C693.222 341.282 693.704 341.397 694.194 341.397C694.683 341.397 695.166 341.282 695.603 341.062L729.051 321.742C729.279 321.742 729.498 321.652 729.659 321.491C729.82 321.33 729.911 321.111 729.911 320.883C729.911 320.655 729.82 320.437 729.659 320.275C729.498 320.114 729.279 320.024 729.051 320.024L695.672 300.722Z",
    fill: "url(#paint307_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.655 300.893C695.222 300.681 694.746 300.57 694.263 300.57C693.78 300.57 693.304 300.681 692.871 300.893L659.715 320.024C659.549 320.084 659.406 320.194 659.305 320.338C659.203 320.483 659.149 320.655 659.149 320.831C659.149 321.008 659.203 321.18 659.305 321.325C659.406 321.469 659.549 321.579 659.715 321.639L692.871 340.787C693.302 341.007 693.779 341.122 694.263 341.122C694.747 341.122 695.224 341.007 695.655 340.787L728.794 321.656C728.96 321.596 729.103 321.486 729.204 321.342C729.306 321.197 729.36 321.025 729.36 320.849C729.36 320.672 729.306 320.5 729.204 320.355C729.103 320.211 728.96 320.101 728.794 320.041L695.655 300.893Z",
    fill: "url(#paint308_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.655 301.082C695.222 300.87 694.745 300.759 694.263 300.759C693.78 300.759 693.304 300.87 692.871 301.082L660.024 319.989C659.856 320.045 659.71 320.152 659.607 320.296C659.503 320.439 659.448 320.612 659.448 320.788C659.448 320.965 659.503 321.138 659.607 321.281C659.71 321.425 659.856 321.532 660.024 321.588L692.871 340.495C693.302 340.715 693.779 340.83 694.263 340.83C694.747 340.83 695.224 340.715 695.655 340.495L728.484 321.588C728.652 321.532 728.798 321.425 728.902 321.281C729.005 321.138 729.061 320.965 729.061 320.788C729.061 320.612 729.005 320.439 728.902 320.296C728.798 320.152 728.652 320.045 728.484 319.989L695.655 301.082Z",
    fill: "url(#paint309_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.639 301.272C695.212 301.059 694.741 300.949 694.264 300.949C693.787 300.949 693.316 301.059 692.889 301.272L660.352 320.041C660.19 320.1 660.051 320.208 659.952 320.349C659.853 320.491 659.8 320.659 659.8 320.831C659.8 321.004 659.853 321.172 659.952 321.314C660.051 321.455 660.19 321.563 660.352 321.622L692.889 340.409C693.316 340.621 693.787 340.731 694.264 340.731C694.741 340.731 695.212 340.621 695.639 340.409L728.159 321.639C728.327 321.584 728.473 321.476 728.576 321.333C728.68 321.189 728.736 321.017 728.736 320.84C728.736 320.663 728.68 320.491 728.576 320.347C728.473 320.204 728.327 320.097 728.159 320.041L695.639 301.272Z",
    fill: "url(#paint310_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.623 301.46C695.201 301.249 694.736 301.139 694.265 301.139C693.793 301.139 693.328 301.249 692.907 301.46L660.68 320.041C659.923 320.488 659.923 321.192 660.68 321.622L692.907 340.219C693.328 340.431 693.793 340.541 694.265 340.541C694.736 340.541 695.201 340.431 695.623 340.219L727.833 321.622C727.997 321.567 728.139 321.462 728.24 321.322C728.341 321.181 728.395 321.013 728.395 320.84C728.395 320.667 728.341 320.499 728.24 320.358C728.139 320.218 727.997 320.113 727.833 320.058L695.623 301.46Z",
    fill: "url(#paint311_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.605 301.736C695.189 301.524 694.73 301.414 694.264 301.414C693.798 301.414 693.339 301.524 692.923 301.736L661.04 320.058C660.882 320.117 660.746 320.222 660.649 320.36C660.553 320.499 660.502 320.663 660.502 320.831C660.502 321 660.553 321.164 660.649 321.303C660.746 321.441 660.882 321.546 661.04 321.605L692.958 340.03C693.373 340.242 693.833 340.352 694.298 340.352C694.764 340.352 695.224 340.242 695.639 340.03L727.54 321.622C727.704 321.567 727.846 321.462 727.947 321.322C728.048 321.181 728.102 321.013 728.102 320.84C728.102 320.667 728.048 320.499 727.947 320.358C727.846 320.218 727.704 320.113 727.54 320.058L695.605 301.736Z",
    fill: "url(#paint312_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.605 301.839C695.189 301.627 694.73 301.517 694.264 301.517C693.798 301.517 693.339 301.627 692.923 301.839L661.332 320.058C661.174 320.116 661.038 320.222 660.942 320.36C660.845 320.499 660.794 320.663 660.794 320.831C660.794 321 660.845 321.164 660.942 321.302C661.038 321.441 661.174 321.546 661.332 321.605L692.923 339.858C693.341 340.062 693.799 340.168 694.264 340.168C694.729 340.168 695.187 340.062 695.605 339.858L727.196 321.605C727.356 321.55 727.495 321.448 727.593 321.31C727.691 321.173 727.744 321.009 727.744 320.84C727.744 320.671 727.691 320.507 727.593 320.37C727.495 320.232 727.356 320.129 727.196 320.075L695.605 301.839Z",
    fill: "url(#paint313_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.587 302.028C695.178 301.815 694.724 301.704 694.263 301.704C693.803 301.704 693.349 301.815 692.94 302.028L661.64 320.075C661.481 320.13 661.342 320.232 661.244 320.37C661.145 320.507 661.093 320.671 661.093 320.84C661.093 321.009 661.145 321.173 661.244 321.311C661.342 321.448 661.481 321.551 661.64 321.605L692.94 339.67C693.351 339.873 693.804 339.978 694.263 339.978C694.722 339.978 695.175 339.873 695.587 339.67L726.869 321.605C727.029 321.551 727.167 321.448 727.266 321.311C727.364 321.173 727.417 321.009 727.417 320.84C727.417 320.671 727.364 320.507 727.266 320.37C727.167 320.232 727.029 320.13 726.869 320.075L695.587 302.028Z",
    fill: "url(#paint314_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.57 302.2C695.164 301.996 694.717 301.889 694.263 301.889C693.81 301.889 693.362 301.996 692.957 302.2L662.019 320.075C661.857 320.125 661.715 320.225 661.614 320.361C661.513 320.497 661.459 320.662 661.459 320.831C661.459 321.001 661.513 321.166 661.614 321.302C661.715 321.438 661.857 321.538 662.019 321.588L692.957 339.48C693.362 339.684 693.81 339.791 694.263 339.791C694.717 339.791 695.164 339.684 695.57 339.48L726.508 321.605C727.23 321.175 727.23 320.505 726.508 320.092L695.57 302.2Z",
    fill: "url(#paint315_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.553 302.389C695.154 302.185 694.712 302.079 694.264 302.079C693.816 302.079 693.374 302.185 692.975 302.389L662.294 320.092C662.138 320.146 662.003 320.247 661.908 320.381C661.812 320.515 661.761 320.675 661.761 320.84C661.761 321.005 661.812 321.165 661.908 321.299C662.003 321.433 662.138 321.534 662.294 321.588L692.975 339.291C693.374 339.495 693.816 339.601 694.264 339.601C694.712 339.601 695.154 339.495 695.553 339.291L726.216 321.588C726.372 321.534 726.507 321.433 726.603 321.299C726.699 321.165 726.75 321.005 726.75 320.84C726.75 320.675 726.699 320.515 726.603 320.381C726.507 320.247 726.372 320.146 726.216 320.092L695.553 302.389Z",
    fill: "url(#paint316_linear_1606_3980)",
    fillOpacity: 0.15
  }))), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M729.308 280.972H659.318V320.505C659.332 320.676 659.392 320.839 659.492 320.979C659.592 321.118 659.728 321.227 659.886 321.295L692.904 340.357C693.335 340.577 693.812 340.692 694.296 340.692C694.78 340.692 695.257 340.577 695.688 340.357L728.689 321.313C728.847 321.24 728.982 321.127 729.082 320.985C729.182 320.843 729.242 320.678 729.256 320.505L729.308 280.972Z",
    fill: "#2C2067"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M728.74 292.557L695.739 311.601C695.308 311.822 694.831 311.936 694.347 311.936C693.863 311.936 693.386 311.822 692.955 311.601L659.936 292.54C659.78 292.47 659.645 292.36 659.545 292.221C659.446 292.082 659.385 291.919 659.369 291.749V297.215C659.383 297.386 659.443 297.55 659.543 297.689C659.643 297.828 659.779 297.938 659.936 298.006L692.955 317.067C693.386 317.287 693.863 317.402 694.347 317.402C694.831 317.402 695.308 317.287 695.739 317.067L728.74 298.023C728.898 297.95 729.033 297.837 729.133 297.695C729.232 297.554 729.293 297.388 729.307 297.215V291.749C729.293 291.922 729.232 292.088 729.133 292.23C729.033 292.372 728.898 292.485 728.74 292.557Z",
    fill: "#5A3CFF"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M728.74 307.184L695.739 326.228C695.308 326.449 694.831 326.563 694.347 326.563C693.863 326.563 693.386 326.449 692.955 326.228L659.936 307.167C659.779 307.099 659.643 306.989 659.543 306.85C659.443 306.711 659.383 306.547 659.369 306.376V311.842C659.384 312.015 659.444 312.181 659.544 312.323C659.643 312.465 659.779 312.577 659.936 312.65L692.955 331.711C693.388 331.924 693.864 332.034 694.347 332.034C694.829 332.034 695.306 331.924 695.739 331.711L728.74 312.65C728.898 312.577 729.033 312.465 729.133 312.323C729.232 312.181 729.293 312.015 729.307 311.842V306.376C729.293 306.549 729.232 306.715 729.133 306.857C729.033 306.999 728.898 307.112 728.74 307.184Z",
    fill: "#5A3CFF"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M695.742 261.12C695.31 260.904 694.833 260.791 694.35 260.791C693.866 260.791 693.39 260.904 692.957 261.12L659.939 280.164C659.773 280.225 659.63 280.335 659.529 280.479C659.427 280.624 659.373 280.796 659.373 280.972C659.373 281.149 659.427 281.321 659.529 281.466C659.63 281.61 659.773 281.72 659.939 281.78L692.957 300.842C693.391 301.054 693.867 301.165 694.35 301.165C694.832 301.165 695.309 301.054 695.742 300.842L728.743 281.78C728.911 281.724 729.057 281.617 729.16 281.474C729.264 281.33 729.319 281.158 729.319 280.981C729.319 280.804 729.264 280.632 729.16 280.488C729.057 280.345 728.911 280.237 728.743 280.182L695.742 261.12Z",
    fill: "#7564C9"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M695.07 270.797C694.843 270.692 694.597 270.638 694.348 270.638C694.098 270.638 693.852 270.692 693.626 270.797L676.507 280.56C676.417 280.586 676.339 280.64 676.283 280.715C676.227 280.789 676.197 280.879 676.197 280.972C676.197 281.065 676.227 281.156 676.283 281.23C676.339 281.305 676.417 281.359 676.507 281.385L693.557 291.234C693.783 291.338 694.03 291.393 694.279 291.393C694.528 291.393 694.775 291.338 695.001 291.234L712.017 281.402C712.104 281.371 712.179 281.314 712.233 281.239C712.286 281.163 712.314 281.073 712.314 280.981C712.314 280.889 712.286 280.799 712.233 280.723C712.179 280.648 712.104 280.591 712.017 280.56L695.07 270.797Z",
    fill: "url(#paint317_linear_1606_3980)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M676.507 281.385L678.397 282.485L693.557 273.736C693.783 273.631 694.03 273.577 694.279 273.577C694.528 273.577 694.775 273.631 695.001 273.736L710.144 282.485L712.017 281.402C712.104 281.371 712.179 281.314 712.233 281.239C712.286 281.163 712.314 281.073 712.314 280.981C712.314 280.889 712.286 280.799 712.233 280.723C712.179 280.648 712.104 280.591 712.017 280.56L695.07 270.797C694.843 270.692 694.597 270.638 694.348 270.638C694.098 270.638 693.852 270.692 693.626 270.797L676.507 280.56C676.417 280.586 676.339 280.64 676.283 280.715C676.227 280.789 676.197 280.879 676.197 280.972C676.197 281.065 676.227 281.156 676.283 281.23C676.339 281.305 676.417 281.359 676.507 281.385Z",
    fill: "white"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M705.932 288.088C712.549 284.307 712.549 278.085 705.932 274.338C702.213 272.464 698.107 271.488 693.943 271.488C689.779 271.488 685.673 272.464 681.955 274.338C675.372 278.136 675.372 284.358 681.955 288.088C685.673 289.962 689.779 290.938 693.943 290.938C698.107 290.938 702.213 289.962 705.932 288.088Z",
    fill: "url(#paint318_linear_1606_3980)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.932 287.384C712.549 283.585 712.549 277.38 705.932 273.633C702.213 271.759 698.107 270.783 693.943 270.783C689.779 270.783 685.673 271.759 681.955 273.633C675.372 277.432 675.372 283.637 681.955 287.384C685.673 289.257 689.779 290.233 693.943 290.233C698.107 290.233 702.213 289.257 705.932 287.384Z",
    fill: "url(#paint319_linear_1606_3980)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.932 286.679C712.549 282.88 712.549 276.658 705.932 272.928C702.213 271.055 698.107 270.079 693.943 270.079C689.779 270.079 685.673 271.055 681.955 272.928C675.372 276.727 675.372 282.949 681.955 286.679C685.673 288.553 689.779 289.529 693.943 289.529C698.107 289.529 702.213 288.553 705.932 286.679Z",
    fill: "url(#paint320_linear_1606_3980)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.932 285.957C712.549 282.158 712.549 275.953 705.932 272.206C702.213 270.333 698.107 269.357 693.943 269.357C689.779 269.357 685.673 270.333 681.955 272.206C675.372 276.005 675.372 282.21 681.955 285.957C685.673 287.831 689.779 288.807 693.943 288.807C698.107 288.807 702.213 287.831 705.932 285.957Z",
    fill: "url(#paint321_linear_1606_3980)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.932 285.252C712.549 281.454 712.549 275.249 705.932 271.502C702.213 269.628 698.107 268.652 693.943 268.652C689.779 268.652 685.673 269.628 681.955 271.502C675.372 275.3 675.372 281.505 681.955 285.252C685.673 287.126 689.779 288.102 693.943 288.102C698.107 288.102 702.213 287.126 705.932 285.252Z",
    fill: "url(#paint322_linear_1606_3980)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.932 284.547C712.549 280.749 712.549 274.527 705.932 270.797C702.213 268.923 698.107 267.947 693.943 267.947C689.779 267.947 685.673 268.923 681.955 270.797C675.372 274.596 675.372 280.818 681.955 284.547C685.673 286.421 689.779 287.397 693.943 287.397C698.107 287.397 702.213 286.421 705.932 284.547Z",
    fill: "url(#paint323_linear_1606_3980)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.932 283.826C712.549 280.027 712.549 273.822 705.932 270.075C702.213 268.201 698.107 267.225 693.943 267.225C689.779 267.225 685.673 268.201 681.955 270.075C675.372 273.874 675.372 280.079 681.955 283.826C685.673 285.699 689.779 286.675 693.943 286.675C698.107 286.675 702.213 285.699 705.932 283.826Z",
    fill: "url(#paint324_linear_1606_3980)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.932 283.121C712.549 279.322 712.549 273.117 705.932 269.37C702.213 267.497 698.107 266.52 693.943 266.52C689.779 266.52 685.673 267.497 681.955 269.37C675.372 273.169 675.372 279.374 681.955 283.121C685.673 284.995 689.779 285.971 693.943 285.971C698.107 285.971 702.213 284.995 705.932 283.121Z",
    fill: "url(#paint325_linear_1606_3980)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.932 282.416C712.549 278.618 712.549 272.396 705.932 268.666C702.213 266.792 698.107 265.816 693.943 265.816C689.779 265.816 685.673 266.792 681.955 268.666C675.372 272.464 675.372 278.686 681.955 282.416C685.673 284.29 689.779 285.266 693.943 285.266C698.107 285.266 702.213 284.29 705.932 282.416Z",
    fill: "url(#paint326_linear_1606_3980)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.932 281.694C712.549 277.896 712.549 271.691 705.932 267.944C702.213 266.07 698.107 265.094 693.943 265.094C689.779 265.094 685.673 266.07 681.955 267.944C675.372 271.742 675.372 277.947 681.955 281.694C685.673 283.568 689.779 284.544 693.943 284.544C698.107 284.544 702.213 283.568 705.932 281.694Z",
    fill: "url(#paint327_linear_1606_3980)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.932 280.989C712.549 277.191 712.549 270.986 705.932 267.239C702.213 265.365 698.107 264.389 693.943 264.389C689.779 264.389 685.673 265.365 681.955 267.239C675.372 271.038 675.372 277.242 681.955 280.989C685.673 282.863 689.779 283.839 693.943 283.839C698.107 283.839 702.213 282.863 705.932 280.989Z",
    fill: "url(#paint328_linear_1606_3980)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.932 280.285C712.549 276.486 712.549 270.264 705.932 266.534C702.213 264.66 698.107 263.684 693.943 263.684C689.779 263.684 685.673 264.66 681.955 266.534C675.372 270.333 675.372 276.555 681.955 280.285C685.673 282.159 689.779 283.135 693.943 283.135C698.107 283.135 702.213 282.159 705.932 280.285Z",
    fill: "url(#paint329_linear_1606_3980)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.932 279.563C712.549 275.764 712.549 269.56 705.932 265.813C702.213 263.939 698.107 262.963 693.943 262.963C689.779 262.963 685.673 263.939 681.955 265.813C675.372 269.611 675.372 275.816 681.955 279.563C685.673 281.437 689.779 282.413 693.943 282.413C698.107 282.413 702.213 281.437 705.932 279.563Z",
    fill: "url(#paint330_linear_1606_3980)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.932 278.858C712.549 275.06 712.549 268.838 705.932 265.108C702.213 263.234 698.107 262.258 693.943 262.258C689.779 262.258 685.673 263.234 681.955 265.108C675.372 268.889 675.372 275.111 681.955 278.858C685.673 280.732 689.779 281.708 693.943 281.708C698.107 281.708 702.213 280.732 705.932 278.858Z",
    fill: "url(#paint331_linear_1606_3980)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.932 278.153C712.549 274.355 712.549 268.133 705.932 264.403C702.213 262.529 698.107 261.553 693.943 261.553C689.779 261.553 685.673 262.529 681.955 264.403C675.372 268.202 675.372 274.424 681.955 278.153C685.676 280.018 689.781 280.989 693.943 280.989C698.106 280.989 702.211 280.018 705.932 278.153Z",
    fill: "url(#paint332_linear_1606_3980)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.932 277.432C712.549 273.633 712.549 267.428 705.932 263.681C702.213 261.807 698.107 260.831 693.943 260.831C689.779 260.831 685.673 261.807 681.955 263.681C675.372 267.48 675.372 273.685 681.955 277.432C685.673 279.305 689.779 280.281 693.943 280.281C698.107 280.281 702.213 279.305 705.932 277.432Z",
    fill: "url(#paint333_linear_1606_3980)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.932 276.727C712.549 272.928 712.549 266.706 705.932 262.976C702.213 261.103 698.107 260.127 693.943 260.127C689.779 260.127 685.673 261.103 681.955 262.976C675.372 266.758 675.372 272.98 681.955 276.727C685.673 278.601 689.779 279.577 693.943 279.577C698.107 279.577 702.213 278.601 705.932 276.727Z",
    fill: "url(#paint334_linear_1606_3980)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.932 275.953C712.549 272.155 712.549 265.933 705.932 262.203C702.213 260.329 698.107 259.353 693.943 259.353C689.779 259.353 685.673 260.329 681.955 262.203C675.372 266.002 675.372 272.224 681.955 275.953C685.676 277.818 689.781 278.789 693.943 278.789C698.106 278.789 702.211 277.818 705.932 275.953Z",
    fill: "url(#paint335_linear_1606_3980)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.932 275.3C712.549 271.502 712.549 265.297 705.932 261.55C702.213 259.676 698.107 258.7 693.943 258.7C689.779 258.7 685.673 259.676 681.955 261.55C675.372 265.348 675.372 271.553 681.955 275.3C685.673 277.174 689.779 278.15 693.943 278.15C698.107 278.15 702.213 277.174 705.932 275.3Z",
    fill: "url(#paint336_linear_1606_3980)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.932 274.596C712.549 270.797 712.549 264.575 705.932 260.845C702.211 258.98 698.106 258.01 693.943 258.01C689.781 258.01 685.676 258.98 681.955 260.845C675.372 264.644 675.372 270.866 681.955 274.596C685.673 276.469 689.779 277.445 693.943 277.445C698.107 277.445 702.213 276.469 705.932 274.596Z",
    fill: "url(#paint337_linear_1606_3980)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.932 273.874C712.549 270.092 712.549 263.87 705.932 260.123C702.213 258.249 698.107 257.273 693.943 257.273C689.779 257.273 685.673 258.249 681.955 260.123C675.372 263.922 675.372 270.144 681.955 273.874C685.673 275.747 689.779 276.723 693.943 276.723C698.107 276.723 702.213 275.747 705.932 273.874Z",
    fill: "url(#paint338_linear_1606_3980)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.932 273.169C712.549 269.371 712.549 263.166 705.932 259.419C702.213 257.545 698.107 256.569 693.943 256.569C689.779 256.569 685.673 257.545 681.955 259.419C675.372 263.217 675.372 269.422 681.955 273.169C685.673 275.043 689.779 276.019 693.943 276.019C698.107 276.019 702.213 275.043 705.932 273.169Z",
    fill: "url(#paint339_linear_1606_3980)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.932 272.516C712.549 268.717 712.549 262.495 705.932 258.765C702.211 256.901 698.106 255.93 693.943 255.93C689.781 255.93 685.676 256.901 681.955 258.765C675.372 262.564 675.372 268.786 681.955 272.516C685.673 274.39 689.779 275.366 693.943 275.366C698.107 275.366 702.213 274.39 705.932 272.516Z",
    fill: "url(#paint340_linear_1606_3980)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.932 271.742C712.549 267.961 712.549 261.739 705.932 257.992C702.213 256.118 698.107 255.142 693.943 255.142C689.779 255.142 685.673 256.118 681.955 257.992C675.372 261.79 675.372 268.013 681.955 271.742C685.673 273.616 689.779 274.592 693.943 274.592C698.107 274.592 702.213 273.616 705.932 271.742Z",
    fill: "url(#paint341_linear_1606_3980)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.932 271.038C712.549 267.239 712.549 261.034 705.932 257.287C702.213 255.414 698.107 254.437 693.943 254.437C689.779 254.437 685.673 255.414 681.955 257.287C675.372 261.086 675.372 267.291 681.955 271.038C685.673 272.912 689.779 273.888 693.943 273.888C698.107 273.888 702.213 272.912 705.932 271.038Z",
    fill: "url(#paint342_linear_1606_3980)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.932 270.333C712.549 266.534 712.549 260.312 705.932 256.583C702.213 254.709 698.107 253.733 693.943 253.733C689.779 253.733 685.673 254.709 681.955 256.583C675.372 260.381 675.372 266.603 681.955 270.333C685.673 272.207 689.779 273.183 693.943 273.183C698.107 273.183 702.213 272.207 705.932 270.333Z",
    fill: "url(#paint343_linear_1606_3980)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.932 269.611C712.549 265.812 712.549 259.608 705.932 255.861C702.213 253.987 698.107 253.011 693.943 253.011C689.779 253.011 685.673 253.987 681.955 255.861C675.372 259.659 675.372 265.864 681.955 269.611C685.673 271.485 689.779 272.461 693.943 272.461C698.107 272.461 702.213 271.485 705.932 269.611Z",
    fill: "url(#paint344_linear_1606_3980)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.932 268.906C712.549 265.108 712.549 258.903 705.932 255.156C702.213 253.282 698.107 252.306 693.943 252.306C689.779 252.306 685.673 253.282 681.955 255.156C675.372 258.955 675.372 265.159 681.955 268.906C685.673 270.78 689.779 271.756 693.943 271.756C698.107 271.756 702.213 270.78 705.932 268.906Z",
    fill: "url(#paint345_linear_1606_3980)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.932 268.202C712.549 264.403 712.549 258.181 705.932 254.451C702.213 252.577 698.107 251.601 693.943 251.601C689.779 251.601 685.673 252.577 681.955 254.451C675.372 258.25 675.372 264.472 681.955 268.202C685.673 270.075 689.779 271.052 693.943 271.052C698.107 271.052 702.213 270.075 705.932 268.202Z",
    fill: "url(#paint346_linear_1606_3980)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.932 267.48C712.549 263.681 712.549 257.476 705.932 253.729C702.213 251.856 698.107 250.879 693.943 250.879C689.779 250.879 685.673 251.856 681.955 253.729C675.372 257.528 675.372 263.733 681.955 267.48C685.673 269.354 689.779 270.33 693.943 270.33C698.107 270.33 702.213 269.354 705.932 267.48Z",
    fill: "url(#paint347_linear_1606_3980)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.932 266.775C712.549 262.976 712.549 256.772 705.932 253.025C702.213 251.151 698.107 250.175 693.943 250.175C689.779 250.175 685.673 251.151 681.955 253.025C675.372 256.823 675.372 263.028 681.955 266.775C685.673 268.649 689.779 269.625 693.943 269.625C698.107 269.625 702.213 268.649 705.932 266.775Z",
    fill: "url(#paint348_linear_1606_3980)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.932 266.07C712.549 262.272 712.549 256.05 705.932 252.32C702.213 250.446 698.107 249.47 693.943 249.47C689.779 249.47 685.673 250.446 681.955 252.32C675.372 256.119 675.372 262.341 681.955 266.07C685.673 267.944 689.779 268.92 693.943 268.92C698.107 268.92 702.213 267.944 705.932 266.07Z",
    fill: "url(#paint349_linear_1606_3980)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.932 265.348C712.549 261.55 712.549 255.345 705.932 251.598C702.213 249.724 698.107 248.748 693.943 248.748C689.779 248.748 685.673 249.724 681.955 251.598C675.372 255.397 675.372 261.601 681.955 265.348C685.673 267.222 689.779 268.198 693.943 268.198C698.107 268.198 702.213 267.222 705.932 265.348Z",
    fill: "url(#paint350_linear_1606_3980)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.932 264.644C712.549 260.845 712.549 254.64 705.932 250.893C702.213 249.019 698.107 248.043 693.943 248.043C689.779 248.043 685.673 249.019 681.955 250.893C675.372 254.692 675.372 260.897 681.955 264.644C685.673 266.517 689.779 267.494 693.943 267.494C698.107 267.494 702.213 266.517 705.932 264.644Z",
    fill: "url(#paint351_linear_1606_3980)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.932 263.922C712.549 260.123 712.549 253.901 705.932 250.171C702.213 248.298 698.107 247.322 693.943 247.322C689.779 247.322 685.673 248.298 681.955 250.171C675.372 253.97 675.372 260.192 681.955 263.922C685.673 265.796 689.779 266.772 693.943 266.772C698.107 266.772 702.213 265.796 705.932 263.922Z",
    fill: "url(#paint352_linear_1606_3980)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.932 263.217C712.549 259.419 712.549 253.214 705.932 249.467C702.213 247.593 698.107 246.617 693.943 246.617C689.779 246.617 685.673 247.593 681.955 249.467C675.372 253.265 675.372 259.47 681.955 263.217C685.673 265.091 689.779 266.067 693.943 266.067C698.107 266.067 702.213 265.091 705.932 263.217Z",
    fill: "url(#paint353_linear_1606_3980)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.932 262.512C712.549 258.714 712.549 252.492 705.932 248.762C702.213 246.888 698.107 245.912 693.943 245.912C689.779 245.912 685.673 246.888 681.955 248.762C675.372 252.543 675.372 258.765 681.955 262.512C685.673 264.386 689.779 265.362 693.943 265.362C698.107 265.362 702.213 264.386 705.932 262.512Z",
    fill: "url(#paint354_linear_1606_3980)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.932 261.808C712.549 258.009 712.549 251.787 705.932 248.057C702.213 246.183 698.107 245.207 693.943 245.207C689.779 245.207 685.673 246.183 681.955 248.057C675.372 251.856 675.372 258.078 681.955 261.808C685.673 263.681 689.779 264.657 693.943 264.657C698.107 264.657 702.213 263.681 705.932 261.808Z",
    fill: "url(#paint355_linear_1606_3980)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.932 261.086C712.549 257.287 712.549 251.082 705.932 247.335C702.213 245.462 698.107 244.486 693.943 244.486C689.779 244.486 685.673 245.462 681.955 247.335C675.372 251.134 675.372 257.339 681.955 261.086C685.673 262.96 689.779 263.936 693.943 263.936C698.107 263.936 702.213 262.96 705.932 261.086Z",
    fill: "url(#paint356_linear_1606_3980)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.932 260.381C712.549 256.583 712.549 250.36 705.932 246.631C702.213 244.757 698.107 243.781 693.943 243.781C689.779 243.781 685.673 244.757 681.955 246.631C675.372 250.412 675.372 256.634 681.955 260.381C685.673 262.255 689.779 263.231 693.943 263.231C698.107 263.231 702.213 262.255 705.932 260.381Z",
    fill: "url(#paint357_linear_1606_3980)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.932 259.676C712.549 255.878 712.549 249.656 705.932 245.926C702.213 244.052 698.107 243.076 693.943 243.076C689.779 243.076 685.673 244.052 681.955 245.926C675.372 249.724 675.372 255.946 681.955 259.676C685.676 261.541 689.781 262.512 693.943 262.512C698.106 262.512 702.211 261.541 705.932 259.676Z",
    fill: "url(#paint358_linear_1606_3980)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.932 258.955C712.549 255.156 712.549 248.951 705.932 245.204C702.213 243.33 698.107 242.354 693.943 242.354C689.779 242.354 685.673 243.33 681.955 245.204C675.372 249.003 675.372 255.208 681.955 258.955C685.673 260.828 689.779 261.804 693.943 261.804C698.107 261.804 702.213 260.828 705.932 258.955Z",
    fill: "url(#paint359_linear_1606_3980)"
  }))), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M717.02 245.015H714.665C713.437 243.635 711.984 242.473 710.368 241.578C701.482 236.421 686.958 236.421 678.072 241.578C676.456 242.473 675.003 243.635 673.775 245.015H671.472V249.948C671.042 253.626 673.19 257.373 678.055 260.261C686.941 265.417 701.465 265.417 710.351 260.261C715.181 257.459 717.364 253.712 716.934 249.948L717.02 245.015Z",
    fill: "#FFC107"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M682.697 239.498C681.923 239.773 681.167 240.048 680.445 240.374V261.361C681.167 261.67 681.923 261.962 682.697 262.22V239.498Z",
    fill: "#FFAD33"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M675.939 242.987V258.765C676.615 259.301 677.327 259.79 678.071 260.226H678.191V241.474H678.071C677.327 241.929 676.615 242.435 675.939 242.987Z",
    fill: "#FFAD33"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M687.197 238.346C686.441 238.483 685.684 238.655 684.945 238.844V262.908C685.684 263.097 686.441 263.269 687.197 263.406V238.346Z",
    fill: "#FFAD33"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M711.967 242.592V259.161C712.781 258.578 713.535 257.916 714.218 257.184V244.551C713.539 243.82 712.784 243.164 711.967 242.592Z",
    fill: "#FFAD33"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M716.471 253.609C716.919 252.438 717.084 251.178 716.952 249.931V245.015H716.402L716.471 253.609Z",
    fill: "#FFAD33"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M705.213 239.326C704.473 239.085 703.734 238.879 702.961 238.69V263.028C703.734 262.856 704.473 262.633 705.213 262.409V239.326Z",
    fill: "#FFAD33"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M673.689 256.6V245.015H671.471V249.948C671.359 251.15 671.498 252.362 671.88 253.507C672.262 254.652 672.878 255.706 673.689 256.6Z",
    fill: "#FFAD33"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M709.713 241.199C708.982 240.809 708.23 240.459 707.461 240.151V261.584C708.23 261.271 708.982 260.915 709.713 260.519V241.199Z",
    fill: "#FFAD33"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M691.699 237.779C690.943 237.779 690.186 237.899 689.447 238.002V263.784C690.186 263.887 690.943 263.956 691.699 263.991V237.779Z",
    fill: "#FFAD33"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M696.205 263.922V237.744C695.466 237.744 694.709 237.744 693.953 237.744V264.059C694.709 264.025 695.414 264.008 696.205 263.922Z",
    fill: "#FFAD33"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M700.707 238.243C699.968 238.105 699.211 238.002 698.455 237.933V263.801C699.211 263.715 699.968 263.63 700.707 263.492V238.243Z",
    fill: "#FFAD33"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M710.369 235.012C701.483 229.855 686.959 229.855 678.073 235.012C669.187 240.168 669.187 248.521 678.073 253.643C686.959 258.765 701.483 258.8 710.369 253.643C719.255 248.487 719.255 240.134 710.369 235.012Z",
    fill: "#FFCD39"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M708.753 235.51C700.76 230.904 687.68 230.904 679.688 235.51C671.695 240.116 671.695 247.696 679.688 252.303C687.68 256.909 700.76 256.926 708.753 252.303C716.745 247.679 716.745 240.134 708.753 235.51Z",
    fill: "#FFAD33"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M706.981 236.421C703.014 234.463 698.65 233.444 694.227 233.444C689.804 233.444 685.44 234.463 681.474 236.421C674.444 240.409 674.444 246.906 681.474 250.893C685.44 252.852 689.804 253.87 694.227 253.87C698.65 253.87 703.014 252.852 706.981 250.893C713.993 246.974 713.993 240.477 706.981 236.421Z",
    fill: "#FFCD39"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M695.93 248.796H689.571C688.127 248.796 686.924 248.109 686.924 247.267V246.476H690.705V246.614H695.862C696.859 246.614 697.666 246.132 697.666 245.548C697.666 244.964 697.151 244.86 696.498 244.86H691.977C689.244 244.86 687.01 243.571 687.01 241.99V241.578C687.01 239.859 689.519 238.329 692.613 238.329H698.852C700.296 238.329 701.499 239.016 701.499 239.859V240.752H697.718V240.512H692.561C691.547 240.512 690.74 240.993 690.74 241.578V241.973C690.74 242.351 691.272 242.66 691.926 242.66H696.601C699.316 242.66 701.551 243.949 701.551 245.531C701.551 247.112 699.007 248.796 695.93 248.796Z",
    fill: "#FF9800"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M696.102 237.281H692.338V250.172H696.102V237.281Z",
    fill: "#FF9800"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M473.807 256.325H441.631V271.983C441.631 274.355 443.195 276.727 446.306 278.532C449.832 280.311 453.726 281.239 457.676 281.239C461.625 281.239 465.52 280.311 469.046 278.532C472.174 276.727 473.738 274.355 473.738 271.983L473.807 256.325Z",
    fill: "#EDF0F8"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M474.29 270.024L484.002 230.629C490.572 204.498 494.567 177.786 495.93 150.876C495.93 149.158 496.085 147.439 496.154 145.617C497.622 102.139 488.129 58.9913 468.55 20.1444L458.477 0.0344238H456.896L446.824 20.1444C427.244 58.9913 417.752 102.139 419.22 145.617C419.22 147.336 419.358 149.054 419.443 150.876C420.807 177.786 424.802 204.498 431.372 230.629L441.152 270.024H474.29Z",
    fill: "#5A3CFF"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M423.859 175.954L390.634 204.675L374.443 306.634L438.967 253.128L426.111 178.205L423.859 175.954Z",
    fill: "#3A16FE"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M426.111 178.205L392.886 206.944L374.443 306.634L441.219 255.379L426.111 178.205Z",
    fill: "white"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M490.929 175.954L524.153 204.675L540.344 306.634L475.82 253.128L488.677 178.205L490.929 175.954Z",
    fill: "#3A16FE"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M488.675 178.205L521.899 206.944L540.342 306.634L473.566 255.379L488.675 178.205Z",
    fill: "white"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M481.423 50.189C477.774 39.9104 473.497 29.8652 468.618 20.11L458.546 0H456.965L446.893 20.11C442.034 29.8831 437.78 39.9456 434.156 50.2405C449.627 54.496 465.962 54.4782 481.423 50.189Z",
    fill: "white"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M421.678 163.217C421.163 162.925 420.716 162.598 420.234 162.289C420.389 164.128 420.544 165.95 420.716 167.772C431.028 173.393 444.349 176.229 457.67 176.229C470.991 176.229 484.363 173.375 494.796 167.738C494.968 165.899 495.14 164.077 495.277 162.238C494.779 162.564 494.28 162.891 493.748 163.2C473.827 174.647 441.496 174.647 421.678 163.217Z",
    fill: "white"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M478.173 112.152C477.364 116.985 474.868 121.376 471.128 124.543C467.388 127.71 462.646 129.448 457.745 129.448C452.844 129.448 448.102 127.71 444.361 124.543C440.621 121.376 438.125 116.985 437.317 112.152C436.909 109.231 437.133 106.256 437.973 103.429C438.813 100.602 440.25 97.9879 442.186 95.7631C444.122 93.5383 446.512 91.7546 449.197 90.5323C451.881 89.31 454.796 88.6775 457.745 88.6775C460.694 88.6775 463.609 89.31 466.293 90.5323C468.977 91.7546 471.368 93.5383 473.304 95.7631C475.24 97.9879 476.676 100.602 477.516 103.429C478.356 106.256 478.58 109.231 478.173 112.152Z",
    fill: "white"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M474.769 111.705C474.199 115.815 472.161 119.579 469.032 122.304C465.903 125.028 461.894 126.529 457.745 126.529C453.596 126.529 449.586 125.028 446.457 122.304C443.328 119.579 441.29 115.815 440.72 111.705C440.382 109.271 440.57 106.794 441.271 104.439C441.971 102.084 443.169 99.907 444.782 98.0541C446.396 96.2013 448.387 94.7158 450.623 93.6979C452.859 92.68 455.288 92.1533 457.745 92.1533C460.201 92.1533 462.63 92.68 464.866 93.6979C467.102 94.7158 469.094 96.2013 470.707 98.0541C472.321 99.907 473.518 102.084 474.219 104.439C474.919 106.794 475.107 109.271 474.769 111.705Z",
    fill: "#99A7D8"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M457.84 92.712L440.652 109.9C440.652 110.467 440.652 111.052 440.79 111.619C441.308 115.108 442.935 118.338 445.431 120.832L469.373 96.8887C466.168 94.1352 462.066 92.6496 457.84 92.712Z",
    fill: "#C2CAE8"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M473.396 102.458C472.817 101.228 472.09 100.073 471.23 99.02L447.477 122.774C448.602 123.589 449.819 124.27 451.103 124.802L473.396 102.458Z",
    fill: "#C2CAE8"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M477.316 257.82C476.068 259.351 474.54 260.628 472.812 261.584C463.892 266.741 449.419 266.741 440.533 261.584C439.932 261.24 439.382 260.862 438.814 260.484L439.605 263.647C444.935 266.298 450.81 267.67 456.762 267.652C462.715 267.634 468.582 266.227 473.895 263.544C474.721 263.065 475.514 262.531 476.267 261.945L477.316 257.82Z",
    fill: "white"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M526.972 86.2838C515.039 81.2432 502.501 77.7765 489.674 75.9709L490.052 77.8273C502.357 79.59 514.385 82.929 525.838 87.7619C543.713 95.634 553.562 106.102 553.562 117.222C553.562 128.343 543.713 138.81 525.838 146.682C488.299 163.2 427.402 163.2 390.052 146.682C372.28 138.81 362.552 128.343 362.552 117.222C362.552 106.102 372.349 95.634 390.052 87.7447C401.191 83.0351 412.88 79.7492 424.841 77.9647L425.563 76.0569C412.96 77.8541 400.643 81.2743 388.918 86.2322C370.389 94.4309 360.18 105.431 360.18 117.171C360.18 128.91 370.389 139.945 388.918 148.109C407.825 156.514 432.851 160.725 457.859 160.725C482.868 160.725 507.876 156.514 526.955 148.109C545.587 139.91 555.848 128.91 555.848 117.171C555.848 105.431 545.655 94.4824 526.972 86.2838Z",
    fill: "url(#paint360_linear_1606_3980)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M367.329 122.74C367.329 123.739 367.033 124.716 366.478 125.547C365.922 126.378 365.133 127.026 364.21 127.408C363.286 127.791 362.27 127.891 361.29 127.696C360.31 127.501 359.409 127.019 358.703 126.313C357.996 125.606 357.515 124.706 357.32 123.725C357.125 122.745 357.225 121.729 357.607 120.806C357.99 119.882 358.637 119.093 359.468 118.538C360.3 117.983 361.276 117.686 362.276 117.686C363.616 117.686 364.901 118.219 365.849 119.166C366.797 120.114 367.329 121.399 367.329 122.74Z",
    fill: "url(#paint361_linear_1606_3980)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M399.109 154.933C401.207 154.933 402.908 153.232 402.908 151.134C402.908 149.036 401.207 147.336 399.109 147.336C397.011 147.336 395.311 149.036 395.311 151.134C395.311 153.232 397.011 154.933 399.109 154.933Z",
    fill: "url(#paint362_linear_1606_3980)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M483.365 158.731C483.365 159.217 483.221 159.693 482.951 160.097C482.681 160.501 482.297 160.816 481.848 161.002C481.399 161.188 480.904 161.237 480.428 161.142C479.951 161.047 479.513 160.813 479.169 160.469C478.825 160.126 478.591 159.688 478.496 159.211C478.402 158.734 478.45 158.24 478.636 157.791C478.822 157.342 479.137 156.958 479.542 156.688C479.946 156.418 480.421 156.273 480.907 156.273C481.559 156.273 482.184 156.532 482.645 156.993C483.106 157.454 483.365 158.079 483.365 158.731Z",
    fill: "url(#paint363_linear_1606_3980)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M513.652 58.1298C503.981 54.0637 493.824 51.2675 483.435 49.8108L483.745 51.3233C493.709 52.7624 503.448 55.4715 512.723 59.3845C527.213 65.7613 535.205 74.2349 535.205 83.2415C535.205 92.248 527.213 100.739 512.723 107.116C482.318 120.505 432.971 120.505 402.72 107.116C388.317 100.739 380.376 92.2652 380.376 83.2415C380.376 74.2178 388.317 65.7613 402.72 59.3845C411.738 55.56 421.204 52.8918 430.891 51.4436L431.476 49.8967C421.267 51.3574 411.29 54.1304 401.792 58.147C386.787 64.7987 378.52 73.6162 378.52 83.2415C378.52 92.8667 386.787 101.701 401.792 108.353C417.175 115.228 437.406 118.563 457.653 118.563C477.901 118.563 498.182 115.125 513.634 108.353C528.725 101.701 537.044 92.8839 537.044 83.2415C537.044 73.599 528.691 64.7815 513.652 58.1298Z",
    fill: "url(#paint364_linear_1606_3980)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M408.806 114.266C411.065 114.266 412.896 112.434 412.896 110.175C412.896 107.916 411.065 106.084 408.806 106.084C406.546 106.084 404.715 107.916 404.715 110.175C404.715 112.434 406.546 114.266 408.806 114.266Z",
    fill: "url(#paint365_linear_1606_3980)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M486.44 116.105C486.44 116.713 486.26 117.308 485.922 117.814C485.584 118.32 485.103 118.715 484.541 118.947C483.979 119.18 483.36 119.241 482.764 119.122C482.167 119.004 481.619 118.711 481.188 118.28C480.758 117.85 480.465 117.302 480.346 116.705C480.228 116.108 480.288 115.49 480.521 114.928C480.754 114.365 481.149 113.885 481.654 113.547C482.16 113.209 482.755 113.028 483.364 113.028C484.18 113.028 484.962 113.352 485.539 113.929C486.116 114.506 486.44 115.289 486.44 116.105Z",
    fill: "url(#paint366_linear_1606_3980)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M529.669 98.7452C529.669 99.1395 529.552 99.525 529.333 99.8529C529.114 100.181 528.803 100.436 528.438 100.587C528.074 100.738 527.673 100.778 527.286 100.701C526.9 100.624 526.544 100.434 526.266 100.155C525.987 99.8762 525.797 99.5209 525.72 99.1341C525.643 98.7474 525.683 98.3465 525.833 97.9822C525.984 97.6178 526.24 97.3064 526.568 97.0874C526.896 96.8683 527.281 96.7513 527.675 96.7513C527.937 96.7513 528.197 96.8029 528.438 96.9031C528.68 97.0033 528.9 97.1502 529.085 97.3353C529.27 97.5205 529.417 97.7403 529.517 97.9822C529.618 98.2241 529.669 98.4833 529.669 98.7452Z",
    fill: "url(#paint367_linear_1606_3980)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M534.705 212.599C535.237 212.599 535.668 212.168 535.668 211.636C535.668 211.104 535.237 210.674 534.705 210.674C534.174 210.674 533.743 211.104 533.743 211.636C533.743 212.168 534.174 212.599 534.705 212.599Z",
    fill: "url(#paint368_linear_1606_3980)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M398.131 308.559C398.663 308.559 399.094 308.128 399.094 307.597C399.094 307.065 398.663 306.634 398.131 306.634C397.6 306.634 397.169 307.065 397.169 307.597C397.169 308.128 397.6 308.559 398.131 308.559Z",
    fill: "url(#paint369_linear_1606_3980)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M509.783 176.916C510.314 176.916 510.745 176.485 510.745 175.954C510.745 175.422 510.314 174.991 509.783 174.991C509.251 174.991 508.82 175.422 508.82 175.954C508.82 176.485 509.251 176.916 509.783 176.916Z",
    fill: "url(#paint370_linear_1606_3980)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M531.596 153.3C531.592 153.558 531.487 153.805 531.304 153.988C531.122 154.171 530.875 154.275 530.617 154.28C530.36 154.275 530.115 154.17 529.935 153.987C529.755 153.803 529.654 153.557 529.654 153.3C529.654 153.045 529.755 152.8 529.936 152.619C530.116 152.439 530.361 152.337 530.617 152.337C530.873 152.337 531.12 152.438 531.303 152.618C531.487 152.798 531.592 153.043 531.596 153.3Z",
    fill: "url(#paint371_linear_1606_3980)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M498.852 295.84C499.384 295.84 499.815 295.409 499.815 294.877C499.815 294.346 499.384 293.915 498.852 293.915C498.321 293.915 497.89 294.346 497.89 294.877C497.89 295.409 498.321 295.84 498.852 295.84Z",
    fill: "url(#paint372_linear_1606_3980)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M509.785 126.091C509.785 126.347 509.684 126.591 509.503 126.772C509.323 126.952 509.078 127.054 508.823 127.054C508.567 127.054 508.323 126.952 508.142 126.772C507.962 126.591 507.86 126.347 507.86 126.091C507.86 125.836 507.962 125.591 508.142 125.411C508.323 125.23 508.567 125.129 508.823 125.129C509.078 125.129 509.323 125.23 509.503 125.411C509.684 125.591 509.785 125.836 509.785 126.091Z",
    fill: "url(#paint373_linear_1606_3980)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M416.796 200.498C417.328 200.498 417.759 200.067 417.759 199.536C417.759 199.004 417.328 198.573 416.796 198.573C416.265 198.573 415.834 199.004 415.834 199.536C415.834 200.067 416.265 200.498 416.796 200.498Z",
    fill: "url(#paint374_linear_1606_3980)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M393.851 270.024C393.851 270.279 393.749 270.524 393.569 270.704C393.388 270.885 393.143 270.986 392.888 270.986C392.631 270.986 392.384 270.885 392.201 270.705C392.018 270.525 391.913 270.281 391.908 270.024C391.922 269.768 392.032 269.528 392.218 269.352C392.403 269.176 392.65 269.078 392.905 269.078C393.153 269.087 393.389 269.189 393.564 269.365C393.74 269.54 393.842 269.776 393.851 270.024Z",
    fill: "url(#paint375_linear_1606_3980)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M504.989 275.386C505.521 275.386 505.952 274.955 505.952 274.424C505.952 273.892 505.521 273.461 504.989 273.461C504.457 273.461 504.026 273.892 504.026 274.424C504.026 274.955 504.457 275.386 504.989 275.386Z",
    fill: "url(#paint376_linear_1606_3980)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M373.293 198.573C373.824 198.573 374.255 198.142 374.255 197.611C374.255 197.079 373.824 196.648 373.293 196.648C372.761 196.648 372.33 197.079 372.33 197.611C372.33 198.142 372.761 198.573 373.293 198.573Z",
    fill: "url(#paint377_linear_1606_3980)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M407.826 163.2C408.358 163.2 408.789 162.769 408.789 162.238C408.789 161.706 408.358 161.275 407.826 161.275C407.295 161.275 406.864 161.706 406.864 162.238C406.864 162.769 407.295 163.2 407.826 163.2Z",
    fill: "url(#paint378_linear_1606_3980)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M506.552 245.015C506.552 245.083 506.538 245.15 506.512 245.212C506.486 245.275 506.448 245.332 506.401 245.38C506.353 245.428 506.296 245.466 506.233 245.491C506.171 245.517 506.104 245.531 506.036 245.531C505.899 245.531 505.768 245.476 505.671 245.38C505.575 245.283 505.52 245.152 505.52 245.015C505.52 244.878 505.575 244.747 505.671 244.65C505.768 244.554 505.899 244.499 506.036 244.499C506.104 244.499 506.171 244.513 506.233 244.539C506.296 244.565 506.353 244.603 506.401 244.65C506.448 244.698 506.486 244.755 506.512 244.818C506.538 244.88 506.552 244.947 506.552 245.015Z",
    fill: "url(#paint379_linear_1606_3980)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M481.941 291.01C481.941 291.112 481.911 291.212 481.854 291.296C481.798 291.381 481.717 291.447 481.623 291.486C481.529 291.525 481.425 291.536 481.325 291.516C481.225 291.496 481.133 291.447 481.061 291.375C480.989 291.303 480.94 291.211 480.92 291.111C480.9 291.011 480.91 290.907 480.949 290.813C480.988 290.718 481.054 290.638 481.139 290.581C481.224 290.525 481.324 290.494 481.426 290.494C481.494 290.492 481.562 290.504 481.626 290.529C481.689 290.554 481.747 290.592 481.796 290.64C481.844 290.688 481.882 290.746 481.907 290.81C481.932 290.874 481.944 290.942 481.941 291.01Z",
    fill: "url(#paint380_linear_1606_3980)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M427.436 253.145C427.436 253.247 427.406 253.347 427.35 253.431C427.293 253.516 427.212 253.582 427.118 253.621C427.024 253.66 426.92 253.671 426.82 253.651C426.72 253.631 426.628 253.582 426.556 253.51C426.484 253.437 426.435 253.346 426.415 253.246C426.395 253.146 426.405 253.042 426.444 252.948C426.483 252.853 426.55 252.773 426.634 252.716C426.719 252.66 426.819 252.629 426.921 252.629C426.989 252.629 427.056 252.643 427.118 252.669C427.181 252.694 427.238 252.732 427.285 252.78C427.333 252.828 427.371 252.885 427.397 252.948C427.423 253.01 427.436 253.077 427.436 253.145Z",
    fill: "url(#paint381_linear_1606_3980)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M488.988 218.219C488.992 218.326 488.963 218.431 488.906 218.521C488.848 218.612 488.765 218.683 488.667 218.725C488.569 218.767 488.461 218.779 488.356 218.759C488.251 218.739 488.154 218.688 488.079 218.613C488.003 218.537 487.952 218.441 487.932 218.336C487.912 218.231 487.924 218.122 487.967 218.024C488.009 217.926 488.08 217.843 488.17 217.786C488.26 217.729 488.366 217.7 488.473 217.703C488.609 217.703 488.74 217.758 488.837 217.854C488.934 217.951 488.988 218.082 488.988 218.219Z",
    fill: "url(#paint382_linear_1606_3980)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M403.544 228.927C403.544 229.064 403.489 229.195 403.392 229.292C403.296 229.388 403.165 229.443 403.028 229.443C402.905 229.42 402.794 229.356 402.714 229.26C402.634 229.164 402.59 229.043 402.59 228.918C402.59 228.794 402.634 228.673 402.714 228.577C402.794 228.481 402.905 228.417 403.028 228.394C403.097 228.394 403.166 228.408 403.229 228.435C403.293 228.462 403.351 228.502 403.399 228.551C403.447 228.601 403.484 228.66 403.509 228.724C403.534 228.789 403.546 228.858 403.544 228.927Z",
    fill: "url(#paint383_linear_1606_3980)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M506.038 139.429C506.016 139.552 505.951 139.663 505.856 139.743C505.76 139.823 505.639 139.867 505.514 139.867C505.389 139.867 505.269 139.823 505.173 139.743C505.077 139.663 505.012 139.552 504.99 139.429C505.012 139.306 505.077 139.195 505.173 139.115C505.269 139.035 505.389 138.992 505.514 138.992C505.639 138.992 505.76 139.035 505.856 139.115C505.951 139.195 506.016 139.306 506.038 139.429Z",
    fill: "url(#paint384_linear_1606_3980)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M508.375 219.233C508.353 219.356 508.288 219.467 508.192 219.547C508.096 219.627 507.975 219.67 507.851 219.67C507.726 219.67 507.605 219.627 507.509 219.547C507.413 219.467 507.349 219.356 507.326 219.233C507.349 219.11 507.413 218.999 507.509 218.919C507.605 218.839 507.726 218.795 507.851 218.795C507.975 218.795 508.096 218.839 508.192 218.919C508.288 218.999 508.353 219.11 508.375 219.233Z",
    fill: "url(#paint385_linear_1606_3980)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M389.69 248.899C389.668 249.022 389.603 249.133 389.508 249.213C389.412 249.293 389.291 249.337 389.166 249.337C389.041 249.337 388.921 249.293 388.825 249.213C388.729 249.133 388.664 249.022 388.642 248.899C388.664 248.777 388.729 248.666 388.825 248.586C388.921 248.506 389.041 248.462 389.166 248.462C389.291 248.462 389.412 248.506 389.508 248.586C389.603 248.666 389.668 248.777 389.69 248.899Z",
    fill: "url(#paint386_linear_1606_3980)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M408.374 127.054C408.377 127.123 408.365 127.192 408.34 127.256C408.315 127.321 408.278 127.38 408.229 127.43C408.181 127.479 408.124 127.519 408.06 127.546C407.996 127.573 407.928 127.587 407.859 127.587C407.736 127.564 407.625 127.5 407.545 127.404C407.465 127.308 407.421 127.187 407.421 127.062C407.421 126.938 407.465 126.817 407.545 126.721C407.625 126.625 407.736 126.56 407.859 126.538C407.995 126.538 408.127 126.592 408.223 126.689C408.32 126.786 408.374 126.917 408.374 127.054Z",
    fill: "url(#paint387_linear_1606_3980)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M381.784 159.247C381.784 159.384 381.73 159.515 381.633 159.611C381.536 159.708 381.405 159.762 381.269 159.762C381.132 159.762 381.001 159.708 380.904 159.611C380.807 159.515 380.753 159.384 380.753 159.247C380.753 159.11 380.807 158.979 380.904 158.882C381.001 158.786 381.132 158.731 381.269 158.731C381.405 158.731 381.536 158.786 381.633 158.882C381.73 158.979 381.784 159.11 381.784 159.247Z",
    fill: "url(#paint388_linear_1606_3980)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M513.531 159.763C513.531 159.865 513.501 159.964 513.444 160.049C513.387 160.134 513.307 160.2 513.213 160.239C513.118 160.278 513.015 160.288 512.915 160.268C512.815 160.248 512.723 160.199 512.651 160.127C512.579 160.055 512.529 159.963 512.51 159.863C512.49 159.763 512.5 159.659 512.539 159.565C512.578 159.471 512.644 159.39 512.729 159.334C512.814 159.277 512.913 159.247 513.015 159.247C513.152 159.247 513.283 159.301 513.38 159.398C513.477 159.495 513.531 159.626 513.531 159.763Z",
    fill: "url(#paint389_linear_1606_3980)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M392.443 182.966C392.447 183.072 392.418 183.177 392.362 183.267C392.306 183.357 392.224 183.428 392.127 183.471C392.03 183.514 391.922 183.527 391.817 183.508C391.713 183.49 391.616 183.44 391.54 183.367C391.464 183.293 391.411 183.198 391.389 183.094C391.367 182.99 391.377 182.882 391.417 182.784C391.457 182.686 391.525 182.601 391.613 182.542C391.701 182.483 391.804 182.451 391.91 182.451C391.98 182.449 392.048 182.46 392.113 182.485C392.178 182.51 392.236 182.548 392.286 182.596C392.336 182.644 392.375 182.701 392.402 182.765C392.429 182.829 392.443 182.897 392.443 182.966Z",
    fill: "url(#paint390_linear_1606_3980)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M421.284 290.495C421.287 290.601 421.258 290.707 421.201 290.797C421.144 290.887 421.061 290.958 420.963 291C420.865 291.043 420.756 291.055 420.651 291.035C420.546 291.015 420.45 290.964 420.374 290.888C420.299 290.813 420.248 290.716 420.228 290.611C420.208 290.506 420.22 290.398 420.262 290.3C420.304 290.202 420.375 290.119 420.466 290.061C420.556 290.004 420.661 289.975 420.768 289.979C420.836 289.979 420.903 289.992 420.965 290.018C421.028 290.044 421.085 290.082 421.133 290.13C421.18 290.178 421.218 290.235 421.244 290.297C421.27 290.36 421.284 290.427 421.284 290.495Z",
    fill: "url(#paint391_linear_1606_3980)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M536.184 242.42C536.187 242.488 536.175 242.556 536.15 242.62C536.125 242.683 536.087 242.741 536.038 242.79C535.99 242.838 535.932 242.876 535.869 242.901C535.805 242.926 535.737 242.938 535.668 242.935C535.532 242.935 535.401 242.881 535.304 242.784C535.207 242.688 535.153 242.556 535.153 242.42C535.153 242.283 535.207 242.152 535.304 242.055C535.401 241.958 535.532 241.904 535.668 241.904C535.737 241.902 535.805 241.913 535.869 241.938C535.932 241.964 535.99 242.001 536.038 242.05C536.087 242.098 536.125 242.156 536.15 242.22C536.175 242.283 536.187 242.351 536.184 242.42Z",
    fill: "url(#paint392_linear_1606_3980)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M437.132 286.438C437.136 286.545 437.107 286.65 437.049 286.74C436.992 286.831 436.909 286.902 436.811 286.944C436.713 286.987 436.605 286.998 436.5 286.978C436.395 286.958 436.298 286.907 436.223 286.832C436.147 286.756 436.096 286.66 436.076 286.555C436.056 286.45 436.068 286.341 436.111 286.243C436.153 286.145 436.224 286.062 436.314 286.005C436.404 285.948 436.51 285.919 436.616 285.923C436.753 285.923 436.884 285.977 436.981 286.074C437.078 286.17 437.132 286.301 437.132 286.438Z",
    fill: "url(#paint393_linear_1606_3980)"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter7_f_1606_3980)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M670.028 427.208C670.028 423.77 667.553 422.275 664.51 424.028L543.386 493.949C541.782 494.997 540.446 496.409 539.488 498.069C538.529 499.729 537.975 501.591 537.869 503.505V545.599C537.869 549.036 540.344 550.532 543.386 548.778L664.476 478.858C666.081 477.809 667.416 476.398 668.375 474.737C669.333 473.077 669.888 471.215 669.993 469.301L670.028 427.208Z",
    fill: "url(#paint394_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.028 427.208C670.028 423.77 667.553 422.275 664.51 424.028L543.386 493.966C541.782 495.014 540.446 496.426 539.488 498.086C538.529 499.746 537.975 501.608 537.869 503.522V544.516C537.869 547.953 540.344 549.466 543.386 547.713L664.476 477.809C666.081 476.76 667.416 475.349 668.375 473.689C669.333 472.029 669.888 470.167 669.993 468.253L670.028 427.208Z",
    fill: "url(#paint395_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.028 427.208C670.028 423.77 667.553 422.258 664.51 424.011L543.386 493.949C541.782 494.997 540.446 496.409 539.488 498.069C538.529 499.729 537.975 501.591 537.869 503.505V543.433C537.869 546.871 540.344 548.366 543.386 546.613L664.476 476.761C666.081 475.712 667.416 474.301 668.375 472.641C669.333 470.981 669.888 469.118 669.993 467.204L670.028 427.208Z",
    fill: "url(#paint396_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.028 427.294C670.028 423.856 667.553 422.361 664.51 424.114L543.386 494.035C541.782 495.083 540.446 496.495 539.488 498.155C538.529 499.815 537.975 501.677 537.869 503.591V542.453C537.869 545.891 540.344 547.386 543.386 545.633L664.476 475.695C666.081 474.646 667.416 473.235 668.375 471.575C669.333 469.915 669.888 468.052 669.993 466.138L670.028 427.294Z",
    fill: "url(#paint397_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.028 427.311C670.028 423.873 667.553 422.378 664.51 424.131L543.386 494.069C541.782 495.118 540.446 496.529 539.488 498.189C538.529 499.849 537.975 501.712 537.869 503.626V541.439C537.869 544.877 540.344 546.372 543.386 544.619L664.476 474.647C666.081 473.598 667.416 472.187 668.375 470.527C669.333 468.866 669.888 467.004 669.993 465.09L670.028 427.311Z",
    fill: "url(#paint398_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.028 427.345C670.028 423.908 667.553 422.395 664.51 424.148L543.386 494.086C541.782 495.135 540.446 496.546 539.488 498.206C538.529 499.866 537.975 501.729 537.869 503.643V540.339C537.869 543.777 540.344 545.289 543.386 543.536L664.476 473.615C666.081 472.567 667.416 471.155 668.375 469.495C669.333 467.835 669.888 465.973 669.993 464.059L670.028 427.345Z",
    fill: "url(#paint399_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.028 427.362C670.028 423.925 667.553 422.429 664.51 424.183L543.386 494.103C541.782 495.152 540.446 496.563 539.488 498.223C538.529 499.884 537.975 501.746 537.869 503.66V539.291C537.869 542.728 540.344 544.224 543.386 542.47L664.476 472.55C666.081 471.501 667.416 470.09 668.375 468.43C669.333 466.77 669.888 464.907 669.993 462.993L670.028 427.362Z",
    fill: "url(#paint400_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.028 427.38C670.028 423.942 667.553 422.447 664.51 424.2L543.386 494.138C541.782 495.183 540.447 496.591 539.488 498.248C538.529 499.906 537.975 501.765 537.869 503.677V538.242C537.869 541.68 540.344 543.175 543.386 541.422L664.476 471.484C666.081 470.435 667.416 469.024 668.375 467.364C669.333 465.704 669.888 463.842 669.993 461.928L670.028 427.38Z",
    fill: "url(#paint401_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.028 427.397C670.028 423.959 667.553 422.464 664.51 424.217L543.386 494.241C541.782 495.29 540.446 496.701 539.488 498.361C538.529 500.021 537.975 501.883 537.869 503.797V537.211C537.869 540.649 540.344 542.144 543.386 540.391L664.476 470.436C666.081 469.387 667.416 467.976 668.375 466.315C669.333 464.655 669.888 462.793 669.993 460.879L670.028 427.397Z",
    fill: "url(#paint402_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.028 427.431C670.028 423.994 667.553 422.498 664.51 424.234L543.386 494.241C541.782 495.29 540.446 496.701 539.488 498.361C538.529 500.021 537.975 501.883 537.869 503.797V536.197C537.869 539.635 540.344 541.147 543.386 539.394L664.476 469.387C666.081 468.339 667.416 466.927 668.375 465.267C669.333 463.607 669.888 461.745 669.993 459.831L670.028 427.431Z",
    fill: "url(#paint403_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.028 427.448C670.028 424.011 667.553 422.515 664.51 424.269L543.386 494.241C541.783 495.291 540.448 496.702 539.49 498.362C538.531 500.022 537.976 501.884 537.869 503.797V535.131C537.869 538.569 540.344 540.064 543.386 538.311L664.476 468.339C666.081 467.29 667.416 465.879 668.375 464.219C669.333 462.558 669.888 460.696 669.993 458.782L670.028 427.448Z",
    fill: "url(#paint404_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.028 427.465C670.028 424.028 667.553 422.532 664.51 424.286L543.386 494.241C541.782 495.29 540.446 496.701 539.488 498.361C538.529 500.021 537.975 501.883 537.869 503.797V534.048C537.869 537.486 540.344 538.981 543.386 537.228L664.476 467.273C666.081 466.224 667.416 464.813 668.375 463.153C669.333 461.493 669.888 459.63 669.993 457.716L670.028 427.465Z",
    fill: "url(#paint405_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.028 427.5C670.028 424.062 667.553 422.55 664.51 424.303L543.386 494.241C541.782 495.29 540.446 496.701 539.488 498.361C538.529 500.021 537.975 501.883 537.869 503.797V533.017C537.869 536.455 540.344 537.95 543.386 536.197L664.476 466.225C666.081 465.176 667.416 463.765 668.375 462.104C669.333 460.444 669.888 458.582 669.993 456.668L670.028 427.5Z",
    fill: "url(#paint406_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.028 427.517C670.028 424.079 667.553 422.584 664.51 424.337L543.386 494.241C541.782 495.29 540.446 496.701 539.488 498.361C538.529 500.021 537.975 501.883 537.869 503.797V531.9C537.869 535.337 540.344 536.85 543.386 535.097L664.476 465.176C666.081 464.127 667.416 462.716 668.375 461.056C669.333 459.396 669.888 457.533 669.993 455.619L670.028 427.517Z",
    fill: "url(#paint407_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.028 427.534C670.028 424.097 667.553 422.601 664.51 424.354L543.386 494.241C541.782 495.29 540.446 496.701 539.488 498.361C538.529 500.021 537.975 501.883 537.869 503.797V530.817C537.869 534.255 540.344 535.75 543.386 533.997L664.476 464.128C666.081 463.079 667.416 461.668 668.375 460.007C669.333 458.347 669.888 456.485 669.993 454.571L670.028 427.534Z",
    fill: "url(#paint408_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.028 427.569C670.028 424.131 667.553 422.618 664.51 424.372L543.386 494.241C541.782 495.29 540.446 496.701 539.488 498.361C538.529 500.021 537.975 501.883 537.869 503.797V529.751C537.869 533.189 540.344 534.684 543.386 532.931L664.476 463.062C666.081 462.013 667.416 460.602 668.375 458.942C669.333 457.282 669.888 455.419 669.993 453.505L670.028 427.569Z",
    fill: "url(#paint409_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.028 427.586C670.028 424.148 667.553 422.653 664.51 424.406L543.386 494.327C541.782 495.375 540.446 496.787 539.488 498.447C538.529 500.107 537.975 501.969 537.869 503.883V528.772C537.869 532.209 540.344 533.705 543.386 531.951L664.476 462.013C666.081 460.965 667.416 459.553 668.375 457.893C669.333 456.233 669.888 454.371 669.993 452.457L670.028 427.586Z",
    fill: "url(#paint410_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.028 427.603C670.028 424.165 667.553 422.67 664.51 424.423L543.386 494.361C541.784 495.408 540.45 496.817 539.492 498.474C538.533 500.131 537.977 501.99 537.869 503.901V527.706C537.869 531.144 540.344 532.639 543.386 530.903L664.476 460.965C666.081 459.916 667.416 458.505 668.375 456.845C669.333 455.185 669.888 453.322 669.993 451.408L670.028 427.603Z",
    fill: "url(#paint411_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.028 427.62C670.028 424.183 667.553 422.687 664.51 424.44L543.386 494.378C541.782 495.427 540.446 496.838 539.488 498.499C538.529 500.159 537.975 502.021 537.869 503.935V526.658C537.869 530.095 540.344 531.59 543.386 529.837L664.476 459.865C666.081 458.816 667.416 457.405 668.375 455.745C669.333 454.085 669.888 452.222 669.993 450.308L670.028 427.62Z",
    fill: "url(#paint412_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.028 427.655C670.028 424.217 667.553 422.722 664.51 424.458L543.386 494.396C541.782 495.444 540.446 496.856 539.488 498.516C538.529 500.176 537.975 502.038 537.869 503.952V525.609C537.869 529.047 540.344 530.542 543.386 528.789L664.476 458.851C666.081 457.802 667.416 456.391 668.375 454.731C669.333 453.071 669.888 451.208 669.993 449.294L670.028 427.655Z",
    fill: "url(#paint413_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.028 427.672C670.028 424.234 667.553 422.739 664.51 424.492L543.386 494.43C541.782 495.475 540.447 496.883 539.488 498.54C538.529 500.198 537.975 502.058 537.869 503.969V524.595C537.869 528.032 540.344 529.528 543.386 527.775L664.476 457.802C666.081 456.754 667.416 455.342 668.375 453.682C669.333 452.022 669.888 450.16 669.993 448.246L670.028 427.672Z",
    fill: "url(#paint414_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.028 427.689C670.028 424.251 667.553 422.756 664.51 424.509L543.386 494.447C541.782 495.496 540.446 496.907 539.488 498.567C538.529 500.227 537.975 502.09 537.869 504.004V523.46C537.869 526.898 540.344 528.393 543.386 526.657L664.476 456.754C666.081 455.705 667.416 454.294 668.375 452.634C669.333 450.974 669.888 449.111 669.993 447.197L670.028 427.689Z",
    fill: "url(#paint415_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.028 427.723C670.028 424.286 667.553 422.773 664.51 424.526L543.386 494.464C541.782 495.513 540.446 496.924 539.488 498.584C538.529 500.244 537.975 502.107 537.869 504.021V522.446C537.869 525.884 540.344 527.379 543.386 525.626L664.476 455.705C666.081 454.657 667.416 453.245 668.375 451.585C669.333 449.925 669.888 448.063 669.993 446.149L670.028 427.723Z",
    fill: "url(#paint416_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.028 427.741C670.028 424.303 667.553 422.808 664.51 424.561L543.386 494.482C541.782 495.53 540.446 496.941 539.488 498.602C538.529 500.262 537.975 502.124 537.869 504.038V521.398C537.869 524.836 540.344 526.331 543.386 524.578L664.476 454.708C666.081 453.66 667.416 452.249 668.375 450.588C669.333 448.928 669.888 447.066 669.993 445.152L670.028 427.741Z",
    fill: "url(#paint417_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.028 427.758C670.028 424.32 667.553 422.825 664.51 424.578L543.386 494.516C541.782 495.564 540.446 496.976 539.488 498.636C538.529 500.296 537.975 502.158 537.869 504.072V520.349C537.869 523.787 540.344 525.282 543.386 523.529L664.476 453.591C666.081 452.543 667.416 451.131 668.375 449.471C669.333 447.811 669.888 445.949 669.993 444.035L670.028 427.758Z",
    fill: "url(#paint418_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.028 427.792C670.028 424.354 667.553 422.842 664.51 424.595L543.386 494.533C541.782 495.582 540.446 496.993 539.488 498.653C538.529 500.313 537.975 502.176 537.869 504.09V519.284C537.869 522.721 540.344 524.217 543.386 522.481L664.476 452.543C666.081 451.494 667.416 450.083 668.375 448.423C669.333 446.763 669.888 444.9 669.993 442.986L670.028 427.792Z",
    fill: "url(#paint419_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.028 427.809C670.028 424.372 667.553 422.876 664.51 424.63L543.386 494.55C541.782 495.599 540.446 497.01 539.488 498.67C538.529 500.331 537.975 502.193 537.869 504.107V518.304C537.869 521.742 540.344 523.237 543.386 521.484L664.476 451.494C666.081 450.446 667.416 449.034 668.375 447.374C669.333 445.714 669.888 443.852 669.993 441.938L670.028 427.809Z",
    fill: "url(#paint420_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.028 427.826C670.028 424.389 667.553 422.894 664.51 424.647L543.386 494.585C541.782 495.633 540.446 497.045 539.488 498.705C538.529 500.365 537.975 502.227 537.869 504.141V517.187C537.869 520.625 540.344 522.12 543.386 520.367L664.476 450.429C666.081 449.38 667.416 447.969 668.375 446.309C669.333 444.649 669.888 442.786 669.993 440.872L670.028 427.826Z",
    fill: "url(#paint421_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.028 427.844C670.028 424.406 667.553 422.911 664.51 424.664L543.386 494.602C541.782 495.651 540.446 497.062 539.488 498.722C538.529 500.382 537.975 502.244 537.869 504.158V516.19C537.869 519.628 540.344 521.123 543.386 519.37L664.476 449.38C666.081 448.332 667.416 446.92 668.375 445.26C669.333 443.6 669.888 441.738 669.993 439.824L670.028 427.844Z",
    fill: "url(#paint422_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.028 427.878C670.028 424.441 667.553 422.945 664.51 424.681L543.386 494.619C541.782 495.668 540.446 497.079 539.488 498.739C538.529 500.399 537.975 502.262 537.869 504.176V515.073C537.869 518.51 540.344 520.006 543.386 518.27L664.476 448.332C666.081 447.283 667.416 445.872 668.375 444.212C669.333 442.552 669.888 440.689 669.993 438.775L670.028 427.878Z",
    fill: "url(#paint423_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.028 427.895C670.028 424.458 667.553 422.962 664.51 424.715L543.386 494.653C541.782 495.698 540.447 497.106 539.488 498.764C538.529 500.421 537.975 502.281 537.869 504.193V514.024C537.869 517.462 540.344 518.957 543.386 517.204L664.476 447.283C666.081 446.235 667.416 444.823 668.375 443.163C669.333 441.503 669.888 439.641 669.993 437.727L670.028 427.895Z",
    fill: "url(#paint424_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.028 427.912C670.028 424.475 667.553 422.979 664.51 424.733L543.386 494.671C541.782 495.719 540.446 497.13 539.488 498.791C538.529 500.451 537.975 502.313 537.869 504.227V512.976C537.869 516.413 540.344 517.909 543.386 516.156L664.476 446.218C666.081 445.169 667.416 443.758 668.375 442.097C669.333 440.437 669.888 438.575 669.993 436.661L670.028 427.912Z",
    fill: "url(#paint425_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.028 427.947C670.028 424.509 667.553 423.014 664.51 424.75L543.386 494.688C541.782 495.736 540.446 497.148 539.488 498.808C538.529 500.468 537.975 502.33 537.869 504.244V511.927C537.869 515.365 540.344 516.86 543.386 515.107L664.476 445.169C666.081 444.121 667.416 442.709 668.375 441.049C669.333 439.389 669.888 437.527 669.993 435.613L670.028 427.947Z",
    fill: "url(#paint426_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.028 427.964C670.028 424.526 667.553 423.031 664.51 424.784L543.386 494.705C541.783 495.755 540.448 497.166 539.49 498.826C538.531 500.486 537.976 502.348 537.869 504.261V510.862C537.869 514.299 540.344 515.795 543.386 514.059L664.476 444.121C666.081 443.072 667.416 441.661 668.375 440.001C669.333 438.34 669.888 436.478 669.993 434.564L670.028 427.964Z",
    fill: "url(#paint427_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.028 427.981C670.028 424.544 667.553 423.048 664.51 424.801L543.386 494.739C541.782 495.788 540.446 497.199 539.488 498.859C538.529 500.52 537.975 502.382 537.869 504.296V509.813C537.869 513.251 540.344 514.746 543.386 512.993L664.476 443.072C666.081 442.024 667.416 440.612 668.375 438.952C669.333 437.292 669.888 435.43 669.993 433.516L670.028 427.981Z",
    fill: "url(#paint428_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.028 428.016C670.028 424.578 667.553 423.065 664.51 424.819L543.386 494.757C541.782 495.805 540.446 497.216 539.488 498.877C538.529 500.537 537.975 502.399 537.869 504.313V508.765C537.869 512.202 540.344 513.698 543.386 511.945L664.476 442.007C666.081 440.958 667.416 439.547 668.375 437.887C669.333 436.226 669.888 434.364 669.993 432.45L670.028 428.016Z",
    fill: "url(#paint429_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.028 428.033C670.028 424.595 667.553 423.1 664.51 424.853L543.386 494.774C541.782 495.822 540.446 497.234 539.488 498.894C538.529 500.554 537.975 502.416 537.869 504.33V507.768C537.869 511.206 540.344 512.701 543.386 510.948L664.476 440.958C666.081 439.91 667.416 438.498 668.375 436.838C669.333 435.178 669.888 433.316 669.993 431.402L670.028 428.033Z",
    fill: "url(#paint430_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.028 428.05C670.028 424.612 667.553 423.117 664.51 424.87L543.386 494.808C541.782 495.857 540.446 497.268 539.488 498.928C538.529 500.588 537.975 502.451 537.869 504.365V506.651C537.869 510.088 540.344 511.584 543.386 509.848L664.476 439.91C666.081 438.861 667.416 437.45 668.375 435.79C669.333 434.13 669.888 432.267 669.993 430.353L670.028 428.05Z",
    fill: "url(#paint431_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.028 428.084C670.028 424.647 667.553 423.134 664.51 424.887L543.386 494.825C541.782 495.874 540.446 497.285 539.488 498.945C538.529 500.606 537.975 502.468 537.869 504.382V505.602C537.869 509.04 540.344 510.535 543.386 508.782L664.476 438.861C666.08 437.812 667.415 436.4 668.373 434.74C669.331 433.08 669.886 431.218 669.993 429.305L670.028 428.084Z",
    fill: "url(#paint432_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.028 428.101C670.028 424.664 667.553 423.168 664.51 424.922L543.386 494.842C541.782 495.891 540.446 497.302 539.488 498.962C538.529 500.623 537.975 502.485 537.869 504.399V504.554C537.869 507.991 540.344 509.487 543.386 507.733L664.476 437.795C666.081 436.747 667.416 435.335 668.375 433.675C669.333 432.015 669.888 430.153 669.993 428.239L670.028 428.101Z",
    fill: "url(#paint433_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.028 428.119C670.028 424.681 667.553 423.186 664.51 424.939L543.386 494.877C541.782 495.922 540.447 497.33 539.488 498.987C538.529 500.645 537.975 502.504 537.869 504.416V503.505C537.869 506.943 540.344 508.438 543.386 506.685L664.476 436.747C666.081 435.698 667.416 434.287 668.375 432.627C669.333 430.967 669.888 429.104 669.993 427.19L670.028 428.119Z",
    fill: "url(#paint434_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.028 428.136C670.028 424.698 667.553 423.203 664.51 424.956L543.386 494.894C541.782 495.943 540.446 497.354 539.488 499.014C538.529 500.674 537.975 502.537 537.869 504.451V502.44C537.869 505.877 540.344 507.372 543.386 505.636L664.476 435.699C666.081 434.65 667.416 433.239 668.375 431.578C669.333 429.918 669.888 428.056 669.993 426.142L670.028 428.136Z",
    fill: "url(#paint435_linear_1606_3980)",
    fillOpacity: 0.15
  }))), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M670.026 312.134C670.026 308.697 667.551 307.184 664.508 308.937L543.385 378.875C541.78 379.924 540.444 381.335 539.486 382.995C538.527 384.655 537.973 386.518 537.867 388.432V484.685C537.867 488.122 540.342 489.618 543.385 487.864L664.474 417.944C666.079 416.895 667.414 415.484 668.373 413.824C669.331 412.163 669.886 410.301 669.991 408.387L670.026 312.134Z",
    fill: "white"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M662.344 328.188C662.344 325.197 660.23 323.977 657.634 325.472L554.764 385.338C553.395 386.235 552.255 387.441 551.437 388.859C550.619 390.277 550.145 391.868 550.055 393.502V470.573C550.055 473.564 552.169 474.784 554.764 473.289L657.6 413.458C658.969 412.564 660.109 411.362 660.927 409.946C661.746 408.531 662.219 406.943 662.31 405.311L662.344 328.188Z",
    fill: "#201555"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M542.319 487.246V390.993C542.429 389.08 542.985 387.219 543.943 385.559C544.901 383.9 546.234 382.488 547.836 381.436L668.96 311.515C669.267 311.333 669.589 311.178 669.923 311.051C669.459 308.37 667.207 307.408 664.508 308.954L543.385 378.892C541.78 379.941 540.444 381.352 539.486 383.012C538.527 384.673 537.973 386.535 537.867 388.449V484.702C537.867 487.813 539.844 489.291 542.422 488.328C542.35 487.972 542.316 487.609 542.319 487.246Z",
    fill: "#362490"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    style: {
      mixBlendMode: "overlay"
    }
  }, _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M554.764 394.533L603.956 366.139V402.801L554.764 431.196V394.533Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    style: {
      mixBlendMode: "overlay"
    }
  }, _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M554.764 438.621L659.215 378.171V383.55L554.764 444.001V438.621Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    style: {
      mixBlendMode: "overlay"
    }
  }, _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M554.764 449.38L659.215 388.93V394.31L554.764 454.76V449.38Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    style: {
      mixBlendMode: "overlay"
    }
  }, _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M554.764 460.123L614.629 425.438V430.835L554.764 465.52V460.123Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    style: {
      mixBlendMode: "overlay"
    }
  }, _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M608.08 371.381L659.214 341.732V359.195L608.08 388.827V371.381Z",
    fill: "white"
  }))), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M544.157 347.765L525.508 336.868C525.357 336.785 525.18 336.764 525.013 336.809C524.847 336.854 524.704 336.961 524.615 337.108C524.533 337.257 524.513 337.432 524.558 337.596C524.602 337.759 524.709 337.899 524.855 337.985L543.522 348.882C544.12 349.234 544.617 349.737 544.962 350.34C545.307 350.943 545.488 351.625 545.488 352.32C545.488 353.015 545.307 353.697 544.962 354.3C544.617 354.903 544.12 355.405 543.522 355.757L498.162 382.347C495.184 384.101 492.714 386.6 490.996 389.599C489.278 392.598 488.371 395.993 488.365 399.449H489.654C489.661 396.219 490.51 393.046 492.116 390.243C493.723 387.44 496.032 385.104 498.816 383.465L544.175 356.875C544.966 356.409 545.622 355.744 546.077 354.947C546.533 354.149 546.773 353.247 546.773 352.328C546.773 351.41 546.533 350.508 546.077 349.71C545.622 348.913 544.966 348.248 544.175 347.782L544.157 347.765Z",
    fill: "#5A3CFF"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M498.005 521.055C495.467 521.041 493.038 520.026 491.245 518.229C489.452 516.433 488.441 514.002 488.432 511.464V390.838C488.438 387.382 489.344 383.987 491.063 380.988C492.781 377.989 495.25 375.49 498.229 373.736L543.588 347.146C544.187 346.794 544.683 346.292 545.028 345.689C545.373 345.086 545.555 344.403 545.555 343.709C545.555 343.014 545.373 342.331 545.028 341.728C544.683 341.126 544.187 340.623 543.588 340.271L524.922 329.374C524.776 329.288 524.669 329.148 524.624 328.984C524.579 328.821 524.6 328.646 524.681 328.497C524.771 328.35 524.913 328.243 525.08 328.198C525.246 328.153 525.424 328.174 525.575 328.257L544.155 339.171C544.946 339.637 545.602 340.302 546.058 341.099C546.514 341.897 546.753 342.799 546.753 343.717C546.753 344.636 546.514 345.538 546.058 346.335C545.602 347.133 544.946 347.797 544.155 348.264L498.796 374.853C496.012 376.493 493.703 378.829 492.097 381.632C490.49 384.435 489.642 387.608 489.635 390.838V511.429C489.636 512.883 490.02 514.311 490.747 515.569C491.475 516.827 492.521 517.872 493.78 518.598C495.039 519.325 496.468 519.707 497.921 519.707C499.375 519.706 500.803 519.324 502.062 518.597L515.692 510.725C517.429 509.72 518.872 508.276 519.876 506.539C520.881 504.802 521.411 502.831 521.415 500.824V451.581C521.418 449.817 521.885 448.084 522.769 446.558C523.653 445.031 524.923 443.764 526.452 442.883L539.618 435.355C539.766 435.271 539.941 435.249 540.106 435.294C540.27 435.339 540.41 435.448 540.494 435.596C540.578 435.744 540.601 435.92 540.555 436.084C540.51 436.248 540.402 436.388 540.254 436.472L527.088 444.001C525.758 444.77 524.653 445.875 523.884 447.206C523.115 448.536 522.708 450.044 522.705 451.581V500.859C522.701 503.091 522.113 505.284 520.997 507.217C519.881 509.15 518.277 510.757 516.345 511.876L502.698 519.748C501.276 520.589 499.657 521.04 498.005 521.055Z",
    fill: "#5A3CFF"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M298.524 128.721H298.816L312.824 127.415C315.651 127.149 318.374 126.212 320.766 124.681C323.158 123.151 325.149 121.071 326.574 118.614L332.195 108.869C332.397 108.521 332.528 108.137 332.582 107.739C332.636 107.34 332.61 106.935 332.507 106.547C332.404 106.158 332.226 105.793 331.982 105.474C331.738 105.154 331.434 104.886 331.086 104.684C330.739 104.482 330.355 104.35 329.956 104.296C329.558 104.243 329.153 104.268 328.764 104.371C328.375 104.474 328.011 104.653 327.691 104.896C327.371 105.14 327.103 105.445 326.901 105.792L321.298 115.538C320.362 117.156 319.054 118.527 317.481 119.538C315.909 120.548 314.117 121.169 312.257 121.347L298.249 122.671C297.451 122.707 296.7 123.059 296.162 123.649C295.624 124.239 295.342 125.018 295.378 125.816C295.415 126.614 295.767 127.365 296.356 127.903C296.946 128.441 297.726 128.723 298.524 128.687V128.721Z",
    fill: "#F2B1B5"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M323.481 121.468C324.142 121.47 324.792 121.297 325.365 120.969C325.938 120.64 326.415 120.166 326.747 119.594L332.78 109.281C333.283 108.418 333.423 107.389 333.169 106.422C332.914 105.455 332.286 104.629 331.422 104.125C330.558 103.621 329.529 103.481 328.562 103.736C327.595 103.991 326.769 104.619 326.265 105.483L320.232 115.796C319.982 116.223 319.819 116.696 319.752 117.187C319.684 117.677 319.715 118.177 319.841 118.656C319.967 119.135 320.186 119.584 320.487 119.978C320.787 120.372 321.162 120.703 321.59 120.952C322.162 121.293 322.815 121.472 323.481 121.468Z",
    fill: "#EBEDF7"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M337.901 192.368L342.215 199.69C342.391 200.072 342.464 200.493 342.428 200.912C342.392 201.331 342.247 201.733 342.009 202.08L337.695 208.233L335.134 210.416C333.965 212.134 331.885 212.134 329.84 211.997L327.158 211.825C326.904 211.808 326.659 211.725 326.448 211.583C326.237 211.441 326.067 211.246 325.955 211.017L324.975 208.903C324.821 208.439 325.68 209.573 326.007 209.109L331.163 204.194L331.283 200.756L329.823 196.356L337.901 192.368Z",
    fill: "#5A3CFF"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M339.244 193.228L341.496 198.057C341.672 198.436 341.746 198.855 341.709 199.271C341.673 199.687 341.528 200.087 341.29 200.429L336.563 207.202L335.05 208.766C333.864 210.484 331.183 210.484 329.121 210.364L326.525 210.141C326.235 210.106 325.958 209.998 325.72 209.827C325.483 209.656 325.294 209.427 325.17 209.162C325.046 208.897 324.991 208.604 325.012 208.312C325.033 208.02 325.128 207.739 325.288 207.494L328.364 205.534L330.427 202.561L329.688 198.178H330.066L339.244 193.228Z",
    fill: "#F9F7F9"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M337.06 192.248C339.483 192.471 340.308 194.293 338.916 196.304C338.103 197.345 337.058 198.181 335.864 198.745C334.67 199.309 333.361 199.586 332.041 199.553C329.652 199.346 328.809 197.524 330.185 195.496C330.986 194.443 332.029 193.598 333.226 193.033C334.422 192.467 335.737 192.198 337.06 192.248Z",
    fill: "#5A3CFF"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M336.014 193.76C337.44 193.898 337.921 194.964 337.096 196.132C336.623 196.742 336.011 197.231 335.312 197.56C334.613 197.889 333.846 198.047 333.074 198.023C331.682 197.903 331.201 196.837 331.992 195.668C332.459 195.05 333.068 194.554 333.769 194.221C334.469 193.889 335.239 193.731 336.014 193.76Z",
    fill: "white"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M346.358 205.156L347.166 213.613C347.164 214.032 347.052 214.443 346.84 214.805C346.629 215.167 346.326 215.467 345.963 215.675L336.922 220.831C336.047 221.339 335.054 221.606 334.043 221.606C333.032 221.606 332.039 221.339 331.164 220.831L328.792 219.542C328.57 219.416 328.384 219.234 328.255 219.014C328.125 218.793 328.055 218.543 328.053 218.288V215.967C328.053 215.469 328.414 216.878 328.895 216.586L335.237 212.942L336.784 209.866L337.334 205.259L346.358 205.156Z",
    fill: "#5A3CFF"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M347.168 206.462V211.791C347.167 212.212 347.056 212.626 346.845 212.991C346.634 213.356 346.33 213.659 345.965 213.87L336.924 219.027C336.049 219.534 335.056 219.801 334.045 219.801C333.034 219.801 332.041 219.534 331.166 219.027L328.897 217.72C328.649 217.566 328.443 217.351 328.301 217.095C328.159 216.84 328.084 216.552 328.084 216.259C328.084 215.967 328.159 215.679 328.301 215.423C328.443 215.168 328.649 214.953 328.897 214.798L335.24 211.137L336.409 206.84L336.787 206.961L347.168 206.462Z",
    fill: "#F9F7F9"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M345.603 204.658C346.066 204.818 346.468 205.118 346.752 205.517C347.037 205.916 347.19 206.394 347.19 206.884C347.19 207.373 347.037 207.851 346.752 208.25C346.468 208.649 346.066 208.95 345.603 209.109C344.422 209.702 343.118 210.011 341.796 210.011C340.474 210.011 339.171 209.702 337.989 209.109C335.909 207.906 335.926 205.895 337.989 204.641C339.168 204.037 340.474 203.724 341.798 203.727C343.122 203.73 344.427 204.049 345.603 204.658Z",
    fill: "#5A3CFF"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M344.023 205.586C344.29 205.684 344.521 205.862 344.683 206.096C344.846 206.329 344.934 206.607 344.934 206.892C344.934 207.177 344.846 207.455 344.683 207.688C344.521 207.922 344.29 208.1 344.023 208.198C343.335 208.546 342.576 208.727 341.806 208.727C341.035 208.727 340.276 208.546 339.588 208.198C339.319 208.104 339.086 207.929 338.921 207.696C338.757 207.464 338.668 207.186 338.668 206.901C338.668 206.616 338.757 206.338 338.921 206.105C339.086 205.873 339.319 205.697 339.588 205.603C340.272 205.243 341.031 205.054 341.803 205.051C342.576 205.048 343.337 205.231 344.023 205.586Z",
    fill: "white"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M341.805 208.044C341.043 208.044 340.313 207.741 339.775 207.203C339.237 206.664 338.934 205.934 338.934 205.173V199.175C338.904 198.78 338.955 198.383 339.085 198.01C339.215 197.636 339.421 197.293 339.689 197.003C339.958 196.713 340.284 196.481 340.647 196.322C341.009 196.164 341.401 196.082 341.796 196.082C342.192 196.082 342.583 196.164 342.946 196.322C343.308 196.481 343.634 196.713 343.903 197.003C344.172 197.293 344.377 197.636 344.507 198.01C344.637 198.383 344.689 198.78 344.658 199.175V205.173C344.66 205.549 344.588 205.922 344.446 206.27C344.303 206.618 344.094 206.935 343.828 207.202C343.563 207.469 343.248 207.68 342.901 207.825C342.553 207.969 342.181 208.044 341.805 208.044Z",
    fill: "#EF9EA3"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M333.863 197.387C333.345 197.39 332.837 197.253 332.392 196.989C331.947 196.726 331.582 196.347 331.336 195.892L328.5 190.598C328.173 189.931 328.117 189.163 328.345 188.456C328.572 187.749 329.064 187.158 329.719 186.806C330.373 186.455 331.138 186.37 331.853 186.571C332.568 186.772 333.177 187.241 333.553 187.882L336.389 193.176C336.744 193.847 336.821 194.631 336.602 195.358C336.383 196.085 335.887 196.697 335.22 197.061C334.801 197.278 334.335 197.39 333.863 197.387Z",
    fill: "#EF9EA3"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M325.871 129.46V146.82L341.529 155.861C342.198 156.247 342.956 156.452 343.728 156.455C344.5 156.459 345.259 156.26 345.931 155.88C346.603 155.5 347.164 154.951 347.559 154.287C347.953 153.624 348.168 152.869 348.181 152.097L348.387 142.351L325.871 129.46Z",
    fill: "#5A3CFF"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M341.805 204.366C340.587 204.366 339.42 203.882 338.559 203.021C337.699 202.161 337.215 200.993 337.215 199.776L333.279 142.196C333.279 139.67 339.261 138.673 341.873 138.673C343.086 138.673 344.249 139.155 345.106 140.012C345.964 140.87 346.445 142.032 346.445 143.245V199.776C346.445 200.383 346.325 200.984 346.091 201.545C345.857 202.105 345.515 202.613 345.083 203.04C344.651 203.467 344.139 203.804 343.577 204.031C343.014 204.259 342.412 204.372 341.805 204.366Z",
    fill: "#5A3CFF"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M332.042 195.72C331.248 195.719 330.469 195.513 329.779 195.122C329.089 194.73 328.513 194.166 328.106 193.485L316.865 174.579C316.232 173.511 315.839 172.319 315.712 171.084C315.584 169.85 315.725 168.603 316.126 167.428L325.441 140.323C325.637 139.753 325.942 139.228 326.341 138.777C326.74 138.326 327.224 137.958 327.766 137.694C328.307 137.431 328.895 137.277 329.496 137.241C330.097 137.206 330.699 137.289 331.268 137.487C333.657 138.312 337.679 142.764 336.854 145.153L325.871 167.892C325.58 168.588 325.456 169.343 325.51 170.095C325.563 170.847 325.793 171.577 326.18 172.224L336.029 188.793C336.337 189.31 336.54 189.882 336.626 190.477C336.712 191.072 336.68 191.679 336.532 192.261C336.383 192.844 336.121 193.392 335.761 193.873C335.4 194.355 334.948 194.76 334.431 195.067C333.713 195.508 332.884 195.734 332.042 195.72Z",
    fill: "#5A3CFF"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M331.973 85.7509C331.563 84.952 331.098 84.1825 330.581 83.4477C329.831 82.1638 328.886 81.0041 327.78 80.0101C324.858 77.6038 320.062 80.1648 320.114 83.929C320.114 85.5274 321.523 87.2463 322.056 88.7416C322.761 90.8042 323.053 93.0042 323.551 95.1184C323.662 95.8792 323.983 96.5938 324.479 97.1809C324.737 97.4387 325.047 97.6278 325.304 97.9028C325.613 98.253 325.847 98.6624 325.992 99.106C326.49 100.292 326.972 101.461 327.47 102.63C327.952 104.181 328.864 105.563 330.1 106.617C330.415 106.863 330.776 107.043 331.162 107.149C331.547 107.254 331.95 107.282 332.346 107.231C332.742 107.18 333.125 107.05 333.471 106.851C333.817 106.651 334.12 106.385 334.363 106.067C334.566 105.628 334.694 105.157 334.741 104.675C335.222 101.231 335.017 97.7265 334.139 94.3621C333.434 91.6808 333.211 88.2775 331.973 85.7509Z",
    fill: "url(#paint436_linear_1606_3980)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M333.831 101.512L343.302 106.772C345.519 108.009 346.121 110.467 346.894 112.891C350.057 122.757 349.008 147.043 349.008 147.043C343.182 150.481 327.644 147.937 324 142.214C324 142.214 327.042 129.408 324.395 121.502C323.769 120.793 323.328 119.94 323.112 119.019C322.896 118.099 322.912 117.139 323.158 116.225L324.395 111.499V107.064C324.392 105.957 324.68 104.869 325.228 103.907C325.777 102.945 326.567 102.144 327.521 101.582C328.475 101.021 329.56 100.719 330.667 100.707C331.774 100.695 332.865 100.972 333.831 101.512Z",
    fill: "white"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M346.892 112.891C346.119 110.467 345.517 108.009 343.3 106.772L333.829 101.512C332.749 100.9 331.51 100.625 330.271 100.722C331.149 100.805 331.999 101.075 332.764 101.512L342.234 106.772C344.452 108.009 345.053 110.467 345.844 112.891C349.006 122.757 347.941 148.556 347.941 148.556C346.438 149.35 344.759 149.752 343.059 149.725C345.112 149.894 347.171 149.489 349.006 148.556C349.006 148.556 350.055 122.757 346.892 112.891Z",
    fill: "#D6DCEF"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M338.093 98.745H332.077C325.425 98.745 323.07 93.3652 323.07 86.7134C323.07 86.095 323.192 85.4825 323.429 84.9112C323.665 84.3398 324.012 83.8206 324.45 83.3833C324.887 82.946 325.406 82.5991 325.978 82.3624C326.549 82.1257 327.161 82.0039 327.78 82.0039H338.093V98.745Z",
    fill: "#F2B1B5"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M335.034 106.565C334.223 106.565 333.444 106.243 332.871 105.669C332.297 105.096 331.975 104.317 331.975 103.506V95.2902H338.094V103.506C338.094 104.317 337.771 105.096 337.197 105.669C336.624 106.243 335.845 106.565 335.034 106.565Z",
    fill: "#F2B1B5"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M342.047 148.16C344.247 148.332 346.258 149.673 347.84 149.106L349.094 132.244V132.038L341.222 108.869C340.689 107.322 339.228 107.03 337.785 107.648C336.341 108.267 336.495 109.367 336.994 110.845L342.15 128.961C343.012 131.509 343.351 134.204 343.147 136.885L342.047 148.16Z",
    fill: "#99A7D8"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M345.828 154.709H345.605C344.846 154.652 344.14 154.296 343.644 153.719C343.148 153.142 342.901 152.392 342.958 151.633L344.058 136.885C344.264 134.202 343.919 131.506 343.044 128.962L336.89 110.845C336.636 110.139 336.659 109.363 336.956 108.673C337.253 107.984 337.801 107.433 338.489 107.133C338.849 106.985 339.235 106.913 339.624 106.921C340.013 106.928 340.396 107.015 340.75 107.176C341.105 107.337 341.422 107.568 341.683 107.857C341.945 108.145 342.144 108.483 342.27 108.852L349.145 128.876C349.865 130.979 350.145 133.208 349.97 135.424L348.75 152.045C348.697 152.779 348.365 153.465 347.821 153.961C347.277 154.456 346.564 154.724 345.828 154.709Z",
    fill: "#F2B1B5"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M342.268 108.869C342.048 108.214 341.597 107.661 340.999 107.313C340.402 106.965 339.698 106.846 339.02 106.978C339.518 107.072 339.983 107.297 340.366 107.629C340.75 107.961 341.038 108.389 341.202 108.869L348.078 129.151C348.745 131.088 349.008 133.141 348.851 135.184L347.596 152.062C347.547 152.684 347.297 153.272 346.885 153.74C346.473 154.208 345.92 154.53 345.31 154.658H345.585H345.809C346.53 154.655 347.224 154.382 347.753 153.892C348.281 153.401 348.606 152.73 348.662 152.011L349.934 135.012C350.083 133.069 349.837 131.116 349.212 129.271L342.268 108.869Z",
    fill: "#EF9EA3"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M344.092 126.572C343.377 126.572 342.679 126.348 342.097 125.932C341.514 125.516 341.076 124.929 340.844 124.252L336.306 110.949C336.131 110.515 336.047 110.051 336.058 109.584C336.068 109.117 336.174 108.657 336.369 108.232C336.563 107.807 336.842 107.426 337.189 107.113C337.535 106.8 337.942 106.56 338.384 106.409C338.826 106.258 339.294 106.199 339.76 106.235C340.226 106.272 340.68 106.402 341.093 106.62C341.507 106.837 341.872 107.136 342.166 107.499C342.46 107.862 342.677 108.282 342.803 108.731L347.341 122.086C347.637 122.948 347.578 123.892 347.179 124.71C346.779 125.529 346.071 126.155 345.21 126.452C344.846 126.55 344.469 126.591 344.092 126.572Z",
    fill: "white"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M344.778 96.0466C343.916 93.9562 343.338 91.7594 343.059 89.5152C342.784 85.8026 344.417 82.1243 341.341 79.2024C339.089 77.0539 335.669 76.8648 332.558 76.8648C330.478 76.8648 325.253 75.9194 324.17 78.5836C324.045 78.9418 324.003 79.3241 324.05 79.7008C324.119 81.6644 324.859 83.5449 326.147 85.0291C327.023 85.9572 328.278 86.5245 329.12 87.5042C329.962 88.4839 329.79 90.3574 330.65 91.6293C331.652 93.2592 332.898 94.7257 334.345 95.9779C337.577 98.5732 337.112 100.447 337.112 104.572C337.112 108.164 337.353 112.255 340.138 114.507C340.496 114.755 340.83 115.037 341.134 115.349C341.498 115.885 341.798 116.462 342.028 117.068C342.444 117.887 343.071 118.58 343.845 119.076C344.618 119.571 345.51 119.851 346.428 119.886C346.849 119.922 347.272 119.873 347.673 119.743C348.074 119.613 348.446 119.405 348.766 119.13C349.251 118.602 349.589 117.956 349.746 117.257C351.063 112.669 350.584 107.753 348.405 103.506C347.872 102.492 347.253 101.53 346.686 100.515C346.119 99.5014 345.397 97.6107 344.778 96.0466Z",
    fill: "url(#paint437_linear_1606_3980)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      mixBlendMode: "overlay"
    }
  }, _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M324.154 78.4804C324.859 76.7616 327.368 76.5897 329.603 76.6585C327.884 76.6585 326.165 77.1397 325.65 78.4804C325.538 78.8416 325.503 79.2221 325.547 79.5976C325.611 81.5591 326.345 83.4394 327.626 84.9259C328.52 85.854 329.775 86.4212 330.6 87.401C331.425 88.3807 331.287 90.2542 332.147 91.5261C333.149 93.156 334.395 94.6225 335.842 95.8746C339.074 98.47 338.609 100.344 338.609 104.469C338.609 108.061 338.85 112.152 341.635 114.403C341.993 114.652 342.327 114.934 342.631 115.246C342.995 115.782 343.295 116.358 343.525 116.964C343.891 117.684 344.42 118.308 345.071 118.785C345.722 119.263 346.476 119.581 347.272 119.714C346.987 119.748 346.698 119.748 346.413 119.714C345.495 119.679 344.603 119.399 343.829 118.904C343.056 118.408 342.428 117.715 342.013 116.896C341.783 116.29 341.483 115.713 341.119 115.177C340.814 114.865 340.48 114.583 340.122 114.335C337.338 112.083 337.114 107.992 337.097 104.4C337.097 100.361 337.561 98.4872 334.33 95.8059C332.883 94.5538 331.637 93.0872 330.634 91.4573C329.775 90.1854 330.084 88.4838 329.104 87.3322C328.125 86.1806 327.008 85.7853 326.131 84.8571C324.843 83.373 324.103 81.4924 324.034 79.5288C323.998 79.1748 324.039 78.8172 324.154 78.4804Z",
    fill: "white"
  }))), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M349.554 153.042C349.554 153.682 349.365 154.307 349.009 154.839C348.653 155.371 348.147 155.785 347.556 156.029C346.964 156.273 346.314 156.336 345.686 156.21C345.059 156.084 344.483 155.774 344.032 155.321C343.581 154.867 343.275 154.29 343.152 153.662C343.029 153.034 343.096 152.384 343.343 151.793C343.59 151.203 344.007 150.7 344.54 150.347C345.074 149.994 345.701 149.807 346.34 149.811C346.764 149.811 347.183 149.894 347.574 150.057C347.965 150.219 348.32 150.458 348.619 150.758C348.918 151.058 349.154 151.415 349.315 151.807C349.475 152.199 349.557 152.618 349.554 153.042Z",
    fill: "#F2B1B5"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M344.469 152.2L343.592 153.592C343.483 153.756 343.316 153.872 343.124 153.917C342.933 153.961 342.731 153.931 342.561 153.833C342.397 153.724 342.282 153.555 342.24 153.363C342.198 153.17 342.233 152.969 342.338 152.801L343.231 151.409C343.282 151.327 343.349 151.255 343.428 151.199C343.507 151.143 343.596 151.103 343.691 151.082C343.786 151.061 343.884 151.06 343.979 151.078C344.074 151.095 344.165 151.132 344.246 151.186C344.328 151.237 344.4 151.303 344.456 151.382C344.512 151.461 344.552 151.551 344.572 151.645C344.593 151.74 344.595 151.838 344.577 151.933C344.559 152.028 344.523 152.119 344.469 152.2Z",
    fill: "#F2B1B5"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M293.153 125.074L299.713 124.2C300.117 124.146 300.402 123.774 300.348 123.37L300.316 123.131C300.262 122.726 299.89 122.442 299.486 122.496L292.926 123.37C292.522 123.424 292.237 123.796 292.291 124.2L292.323 124.439C292.377 124.843 292.749 125.128 293.153 125.074Z",
    fill: "#F2B1B5"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M297.507 122.058L303.622 124.587C303.999 124.743 304.431 124.564 304.587 124.187L304.679 123.964C304.835 123.587 304.656 123.155 304.279 122.999L298.164 120.47C297.786 120.314 297.354 120.493 297.198 120.87L297.106 121.093C296.95 121.47 297.13 121.902 297.507 122.058Z",
    fill: "#F2B1B5"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M623.222 535.664L625.061 535.132C626.538 534.705 628.094 534.619 629.609 534.881C631.125 535.143 632.561 535.746 633.809 536.644L635.735 535.217L637.694 539.738L647.13 538.93L645.068 547.318C645.005 547.582 644.873 547.824 644.686 548.021C644.499 548.217 644.263 548.36 644.002 548.435L640.117 549.569C638.53 550.035 636.848 550.076 635.24 549.687C633.632 549.297 632.155 548.492 630.956 547.352L622.362 539.154C622.096 538.903 621.901 538.586 621.797 538.235C621.694 537.885 621.685 537.513 621.773 537.158C621.86 536.803 622.04 536.477 622.295 536.215C622.55 535.953 622.869 535.763 623.222 535.664Z",
    fill: "#363650"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M623.221 535.664L625.06 535.132C626.537 534.705 628.093 534.619 629.608 534.881C631.124 535.143 632.56 535.746 633.808 536.644L635.733 535.217L637.693 539.738L647.129 538.93L646.064 543.279C645.826 544.226 645.347 545.095 644.671 545.8C643.996 546.505 643.149 547.022 642.213 547.301L640.495 547.782C638.907 548.248 637.225 548.288 635.617 547.899C634.009 547.51 632.532 546.705 631.333 545.565L622.739 537.366C622.511 537.309 622.315 537.164 622.195 536.962C622.074 536.761 622.038 536.52 622.095 536.292C622.152 536.064 622.297 535.868 622.498 535.747C622.7 535.626 622.941 535.59 623.169 535.647L623.221 535.664Z",
    fill: "#5A3CFF"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M636.49 538.827C634.514 536.936 635.046 534.788 637.659 534.014C639.115 533.681 640.628 533.693 642.078 534.048C643.528 534.403 644.875 535.092 646.012 536.06C647.972 537.95 647.456 540.116 644.844 540.872C643.388 541.206 641.875 541.195 640.424 540.84C638.974 540.485 637.627 539.796 636.49 538.827Z",
    fill: "#F9F7F9"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M641.666 539.119C642.491 539.119 643.282 538.791 643.866 538.208C644.449 537.624 644.777 536.833 644.777 536.008V523.976C644.777 523.151 644.449 522.36 643.866 521.777C643.282 521.193 642.491 520.865 641.666 520.865C640.841 520.865 640.049 521.193 639.466 521.777C638.882 522.36 638.555 523.151 638.555 523.976V536.008C638.555 536.833 638.882 537.624 639.466 538.208C640.049 538.791 640.841 539.119 641.666 539.119Z",
    fill: "#EF9EA3"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M641.666 537.211H641.889C642.535 537.18 643.168 537.022 643.753 536.747C644.337 536.471 644.862 536.082 645.296 535.603C645.731 535.124 646.066 534.564 646.284 533.955C646.501 533.346 646.596 532.701 646.564 532.055L645.241 502.681L646.564 455.654C646.582 455.011 646.474 454.37 646.244 453.769C646.015 453.167 645.669 452.617 645.227 452.15C644.785 451.682 644.255 451.306 643.667 451.043C643.08 450.78 642.446 450.636 641.803 450.618C639.122 450.515 633.793 452.663 633.725 455.379L635.443 502.749V502.938L636.784 532.502C636.833 533.765 637.368 534.96 638.278 535.838C639.188 536.716 640.401 537.208 641.666 537.211Z",
    fill: "#5A3CFF"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M610.14 547.644L611.859 546.682C613.195 545.917 614.688 545.465 616.224 545.361C617.76 545.257 619.3 545.503 620.728 546.08L622.257 544.241L625.214 548.143L634.203 545.118V553.712C634.199 553.985 634.127 554.253 633.991 554.49C633.856 554.728 633.663 554.927 633.43 555.07L629.992 557.098C628.559 557.921 626.935 558.354 625.282 558.354C623.63 558.354 622.006 557.921 620.573 557.098L610.26 551.185C609.947 551.013 609.685 550.762 609.498 550.458C609.311 550.153 609.207 549.806 609.195 549.449C609.182 549.092 609.263 548.738 609.429 548.422C609.595 548.105 609.84 547.838 610.14 547.644Z",
    fill: "#363650"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M610.141 547.644L611.86 546.682C613.196 545.917 614.689 545.465 616.225 545.361C617.761 545.257 619.301 545.503 620.729 546.08L622.259 544.241L625.215 548.143L634.204 545.118V549.604C634.201 550.579 633.942 551.537 633.453 552.381C632.965 553.225 632.264 553.927 631.42 554.416L629.924 555.293C628.493 556.121 626.869 556.558 625.215 556.558C623.561 556.558 621.937 556.121 620.505 555.293L610.193 549.38C609.84 549.178 609.557 548.872 609.385 548.504C609.551 548.152 609.814 547.854 610.141 547.644Z",
    fill: "#5A3CFF"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M623.791 547.524C621.419 546.166 621.419 543.932 623.791 542.574C625.124 541.904 626.596 541.555 628.088 541.555C629.58 541.555 631.051 541.904 632.385 542.574C634.739 543.932 634.739 546.166 632.385 547.524C631.051 548.194 629.58 548.542 628.088 548.542C626.596 548.542 625.124 548.194 623.791 547.524Z",
    fill: "#F9F7F9"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M628.102 547.06C628.928 547.055 629.72 546.724 630.303 546.138C630.886 545.551 631.213 544.758 631.213 543.932V531.9C631.245 531.471 631.188 531.04 631.045 530.634C630.903 530.228 630.678 529.855 630.386 529.54C630.093 529.225 629.738 528.973 629.344 528.801C628.949 528.629 628.523 528.54 628.093 528.54C627.663 528.54 627.237 528.629 626.843 528.801C626.448 528.973 626.093 529.225 625.801 529.54C625.508 529.855 625.283 530.228 625.141 530.634C624.999 531.04 624.942 531.471 624.973 531.9V543.932C624.973 544.761 625.303 545.557 625.89 546.144C626.476 546.73 627.272 547.06 628.102 547.06Z",
    fill: "#EF9EA3"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M641.665 463.681C642.286 463.688 642.897 463.533 643.44 463.231C643.982 462.93 644.437 462.493 644.759 461.962L651.187 450.807C654.429 445.192 655.518 438.59 654.254 432.231C652.989 425.872 649.455 420.189 644.312 416.242L642.593 414.901C641.841 414.363 640.909 414.138 639.994 414.275C639.079 414.412 638.253 414.9 637.692 415.635C637.131 416.371 636.878 417.296 636.988 418.215C637.097 419.134 637.561 419.973 638.279 420.556L639.998 421.897C643.785 424.78 646.395 428.94 647.344 433.603C648.292 438.267 647.514 443.116 645.154 447.249L638.709 458.387C638.475 458.792 638.323 459.239 638.262 459.703C638.201 460.167 638.232 460.638 638.353 461.09C638.474 461.542 638.684 461.965 638.969 462.336C639.254 462.707 639.609 463.018 640.015 463.251C640.52 463.531 641.088 463.679 641.665 463.681Z",
    fill: "black"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M646.22 467.84L646.564 455.637L626.987 448.108L627.141 458.902C626.098 459.109 625.15 459.65 624.443 460.445C623.736 461.239 623.307 462.242 623.222 463.303L620.541 506.084L623.222 539.067C623.318 540.292 623.871 541.436 624.773 542.271C625.675 543.106 626.858 543.57 628.087 543.571C628.619 543.573 629.147 543.486 629.651 543.313C630.692 542.936 631.581 542.227 632.181 541.295C632.78 540.363 633.057 539.261 632.968 538.156L630.338 506.118L634.841 477.053L643.659 472.051C644.403 471.619 645.028 471.007 645.475 470.272C645.922 469.536 646.178 468.7 646.22 467.84Z",
    fill: "#5A3CFF"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M623.223 463.303C623.308 462.015 623.896 460.813 624.862 459.957C625.827 459.101 627.091 458.66 628.38 458.731H628.724C627.604 458.883 626.571 459.418 625.8 460.245C625.029 461.072 624.568 462.14 624.495 463.268L621.797 506.049L624.495 538.964C624.588 540.075 625.058 541.121 625.827 541.928C626.596 542.734 627.619 543.254 628.724 543.399H628.483H628.071C626.842 543.398 625.658 542.934 624.757 542.1C623.855 541.265 623.301 540.121 623.206 538.896L620.508 505.981L623.223 463.303Z",
    fill: "#1D0891"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M644.758 461.91C644.436 462.441 643.982 462.878 643.439 463.18C642.897 463.481 642.285 463.636 641.665 463.629C641.059 463.623 640.466 463.457 639.946 463.148C639.54 462.915 639.185 462.604 638.9 462.233C638.614 461.862 638.405 461.439 638.284 460.987C638.163 460.535 638.131 460.064 638.193 459.6C638.254 459.136 638.405 458.689 638.64 458.284L645.085 447.146C646.11 445.334 646.846 443.374 647.268 441.336C647.23 444.583 647.425 447.829 647.852 451.048L648.351 455.723L644.758 461.91Z",
    fill: "#231F20"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M647.509 397.524L632.143 406.393C628.792 408.326 626.01 411.106 624.076 414.456C622.142 417.805 621.124 421.604 621.125 425.472V469.233C627.364 473.598 644.157 467.514 647.509 460.639L646.512 451.065C645.98 447.262 645.79 443.42 645.944 439.583L647.509 397.524Z",
    fill: "black"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M641.543 407.15H635.046C631.964 407.15 629.009 405.925 626.83 403.746C624.651 401.567 623.427 398.612 623.427 395.53V386.232H641.543V407.15Z",
    fill: "#F2B1B5"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M636.835 410.639H634.12C633.477 410.639 632.86 410.383 632.406 409.929C631.951 409.474 631.696 408.858 631.696 408.215V395.496H639.259V408.146C639.268 408.47 639.212 408.793 639.094 409.095C638.977 409.397 638.8 409.672 638.574 409.905C638.348 410.137 638.077 410.322 637.779 410.448C637.48 410.574 637.159 410.639 636.835 410.639Z",
    fill: "#F2B1B5"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M621.123 435.046C621.663 434.837 622.136 434.485 622.49 434.028C622.844 433.57 623.067 433.025 623.134 432.45L624.561 421.347C624.685 420.412 625.174 419.563 625.921 418.987C626.668 418.411 627.613 418.153 628.549 418.27C630.491 418.528 630.594 420.573 630.267 422.516L630.13 433.361C629.882 435.342 629.065 437.208 627.778 438.734C626.49 440.259 624.788 441.378 622.877 441.955C622.282 442.133 621.672 442.254 621.055 442.316L621.123 435.046Z",
    fill: "#231F20"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M612.134 436.936L601.821 425.214C601.196 424.505 600.879 423.577 600.939 422.634C600.998 421.692 601.43 420.811 602.139 420.187C602.848 419.562 603.776 419.245 604.719 419.304C605.661 419.364 606.542 419.796 607.166 420.505L617.479 432.227C617.892 432.694 618.429 433.032 619.028 433.202C619.628 433.372 620.263 433.366 620.859 433.185C621.455 433.004 621.986 432.655 622.39 432.18C622.793 431.706 623.051 431.125 623.134 430.508L624.561 419.387C624.682 418.451 625.17 417.6 625.917 417.023C626.288 416.738 626.711 416.528 627.162 416.405C627.613 416.283 628.085 416.251 628.548 416.311C629.012 416.371 629.46 416.521 629.865 416.754C630.271 416.987 630.627 417.297 630.913 417.667C631.198 418.038 631.408 418.461 631.53 418.912C631.653 419.363 631.685 419.835 631.625 420.298L630.198 431.419C629.951 433.4 629.134 435.266 627.846 436.792C626.559 438.317 624.856 439.436 622.945 440.013C621.942 440.318 620.9 440.474 619.851 440.477C618.387 440.468 616.942 440.148 615.611 439.538C614.281 438.927 613.095 438.04 612.134 436.936Z",
    fill: "black"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M608.885 422.447L607.166 420.504C606.542 419.796 605.661 419.364 604.719 419.304C603.776 419.245 602.848 419.562 602.139 420.186C601.43 420.811 600.998 421.692 600.939 422.634C600.879 423.577 601.196 424.505 601.821 425.214L603.884 427.552L608.885 422.447Z",
    fill: "#F2B1B5"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M598.488 421.794C598.488 422.647 598.741 423.481 599.215 424.191C599.689 424.9 600.363 425.453 601.152 425.779C601.94 426.106 602.807 426.191 603.644 426.025C604.481 425.859 605.25 425.448 605.853 424.844C606.456 424.241 606.867 423.472 607.034 422.635C607.2 421.798 607.115 420.931 606.788 420.143C606.462 419.354 605.909 418.681 605.199 418.207C604.49 417.733 603.656 417.479 602.802 417.479C601.658 417.479 600.561 417.934 599.752 418.743C598.943 419.552 598.488 420.65 598.488 421.794Z",
    fill: "#F2B1B5"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M604.73 420.277L598.804 414.052C598.75 413.995 598.707 413.928 598.679 413.854C598.65 413.78 598.636 413.702 598.638 413.623C598.64 413.544 598.658 413.466 598.69 413.394C598.722 413.321 598.768 413.256 598.825 413.202L599.323 412.728C599.442 412.614 599.601 412.553 599.765 412.557C599.929 412.561 600.085 412.63 600.198 412.749L606.123 418.974C606.178 419.031 606.22 419.098 606.249 419.172C606.277 419.246 606.291 419.324 606.289 419.403C606.287 419.482 606.27 419.56 606.238 419.632C606.206 419.704 606.16 419.77 606.102 419.824L605.604 420.298C605.546 420.354 605.476 420.398 605.4 420.427C605.325 420.457 605.244 420.471 605.163 420.469C605.081 420.467 605.001 420.449 604.927 420.416C604.853 420.383 604.786 420.336 604.73 420.277Z",
    fill: "#F2B1B5"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M622.14 382.519C625.268 378.824 632.573 379.924 636.629 381.23C641.631 382.829 647.887 384.668 648.781 390.718C648.901 392.262 648.901 393.814 648.781 395.359C648.774 398.936 649.598 402.466 651.187 405.671C653.456 410.226 654.539 413.131 652.133 417.875C650.723 420.659 649.812 425.025 646.976 426.744C644.14 428.463 637.643 429.614 634.773 427.449C630.785 424.424 628.774 417.136 629.135 412.392C629.53 407.321 632.074 402.199 630.545 397.335C629.565 394.293 625.491 390.89 623.171 388.741C621.108 386.919 620.06 385.046 622.14 382.519Z",
    fill: "#5A3CFF"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M622.141 382.519C623.962 380.353 627.297 379.855 630.46 380.061C629.337 380.041 628.223 380.248 627.183 380.67C626.143 381.093 625.199 381.722 624.409 382.519C622.347 384.977 623.378 386.85 625.423 388.758C627.744 390.89 631.835 394.293 632.797 397.352C634.327 402.217 631.8 407.339 631.405 412.409C631.044 417.119 633.124 424.441 637.043 427.466C638.111 428.171 639.355 428.564 640.635 428.6C638.603 428.93 636.52 428.528 634.757 427.466C630.769 424.441 628.758 417.153 629.136 412.409C629.514 407.339 632.058 402.217 630.511 397.352C629.549 394.31 625.475 390.907 623.155 388.758C621.109 386.919 620.061 385.046 622.141 382.519Z",
    fill: "#5A3CFF"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237.144 436.231C237.252 436.227 237.358 436.198 237.454 436.146L343.589 375.85C343.663 375.809 343.729 375.753 343.781 375.687C343.833 375.62 343.872 375.544 343.894 375.462C343.917 375.381 343.922 375.295 343.911 375.211C343.9 375.127 343.873 375.047 343.83 374.973C343.789 374.899 343.734 374.834 343.667 374.782C343.6 374.73 343.524 374.691 343.442 374.669C343.361 374.646 343.275 374.641 343.191 374.651C343.108 374.662 343.027 374.69 342.953 374.733L236.818 435.028C236.744 435.069 236.678 435.125 236.626 435.191C236.574 435.258 236.535 435.334 236.513 435.416C236.49 435.498 236.485 435.583 236.496 435.667C236.507 435.751 236.534 435.832 236.577 435.905C236.636 436.003 236.719 436.085 236.818 436.142C236.917 436.199 237.03 436.23 237.144 436.231Z",
    fill: "#231F20"
  }))), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M242.3 420.762C242.409 420.758 242.515 420.728 242.61 420.676L336.181 367.479C336.329 367.395 336.438 367.255 336.483 367.091C336.528 366.927 336.506 366.751 336.422 366.603C336.338 366.455 336.198 366.346 336.033 366.301C335.869 366.256 335.693 366.278 335.545 366.362L241.974 419.559C241.9 419.6 241.835 419.656 241.782 419.722C241.73 419.789 241.692 419.865 241.669 419.947C241.647 420.028 241.641 420.114 241.652 420.198C241.663 420.282 241.69 420.363 241.733 420.436C241.792 420.534 241.875 420.616 241.974 420.673C242.073 420.73 242.186 420.761 242.3 420.762Z",
    fill: "#5A3CFF"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M184.119 448.108C187.889 446.202 192.055 445.209 196.28 445.209C200.504 445.209 204.67 446.202 208.44 448.108L288.158 494.138C294.844 498.005 294.913 504.451 288.296 508.421L251.29 530.766C247.571 532.734 243.435 533.782 239.227 533.824C235.02 533.866 230.864 532.9 227.106 531.006L145.876 484.22C139.19 480.353 139.19 474.045 145.876 470.195L184.119 448.108Z",
    fill: "#5A3CFF"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter8_f_1606_3980)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.089 451.924C193.186 450.364 196.606 449.552 200.075 449.552C203.543 449.552 206.963 450.364 210.061 451.924L275.547 489.738C281.047 492.918 281.099 498.194 275.668 501.46L245.262 519.817C242.206 521.435 238.808 522.296 235.35 522.329C231.893 522.362 228.478 521.565 225.393 520.006L158.669 481.591C153.186 478.428 153.169 473.237 158.669 470.057L190.089 451.924Z",
    fill: "url(#paint438_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.305 519.215L158.582 480.783C153.099 477.62 153.081 472.43 158.582 469.267L190.087 451.134C193.183 449.566 196.604 448.749 200.073 448.749C203.543 448.749 206.964 449.566 210.06 451.134L275.546 488.947C281.046 492.11 281.098 497.387 275.666 500.669L245.261 519.009C242.196 520.644 238.782 521.516 235.308 521.552C231.835 521.588 228.404 520.786 225.305 519.215Z",
    fill: "url(#paint439_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.305 518.407L158.582 479.975C153.099 476.812 153.081 471.639 158.582 468.459L190.087 450.326C193.183 448.758 196.604 447.941 200.073 447.941C203.543 447.941 206.964 448.758 210.06 450.326L275.546 488.139C281.046 491.302 281.098 496.579 275.666 499.861L245.261 518.201C242.196 519.836 238.782 520.708 235.308 520.744C231.835 520.78 228.404 519.978 225.305 518.407Z",
    fill: "url(#paint440_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.305 517.6L158.582 479.184C153.099 476.022 153.081 470.831 158.582 467.651L190.087 449.552C193.185 447.993 196.605 447.18 200.073 447.18C203.542 447.18 206.962 447.993 210.06 449.552L275.546 487.366C281.046 490.546 281.098 495.822 275.666 499.088L245.261 517.445C242.192 519.072 238.776 519.935 235.302 519.962C231.828 519.989 228.399 519.179 225.305 517.6Z",
    fill: "url(#paint441_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.305 516.809L158.582 478.377C153.099 475.214 153.081 470.023 158.582 466.861L190.087 448.727C193.183 447.16 196.604 446.343 200.073 446.343C203.543 446.343 206.964 447.16 210.06 448.727L275.546 486.541C281.046 489.721 281.098 494.997 275.666 498.28L245.175 516.585C242.122 518.209 238.724 519.076 235.267 519.115C231.81 519.154 228.394 518.363 225.305 516.809Z",
    fill: "url(#paint442_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.305 516.001L158.582 477.569C153.099 474.406 153.081 469.232 158.582 466.053L190.087 447.919C193.183 446.352 196.604 445.535 200.073 445.535C203.543 445.535 206.964 446.352 210.06 447.919L275.546 485.733C281.046 488.895 281.098 494.172 275.666 497.455L245.261 515.795C242.196 517.43 238.782 518.302 235.308 518.338C231.835 518.374 228.404 517.572 225.305 516.001Z",
    fill: "url(#paint443_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.305 515.193L158.582 476.778C153.099 473.616 153.081 468.425 158.582 465.245L190.087 447.112C193.185 445.552 196.605 444.74 200.073 444.74C203.542 444.74 206.962 445.552 210.06 447.112L275.546 484.925C281.046 488.105 281.098 493.382 275.666 496.647L245.261 515.004C242.194 516.636 238.78 517.506 235.306 517.539C231.833 517.572 228.402 516.767 225.305 515.193Z",
    fill: "url(#paint444_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.305 514.403L158.582 475.97C153.099 472.808 153.081 467.617 158.582 464.454L190.087 446.321C193.183 444.753 196.604 443.936 200.073 443.936C203.543 443.936 206.964 444.753 210.06 446.321L275.546 484.134C281.046 487.314 281.098 492.591 275.666 495.874L245.261 514.213C242.194 515.846 238.78 516.715 235.306 516.748C231.833 516.781 228.402 515.976 225.305 514.403Z",
    fill: "url(#paint445_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.305 513.595L158.582 475.162C153.099 472 153.081 466.826 158.582 463.646L190.087 445.513C193.183 443.945 196.604 443.129 200.073 443.129C203.543 443.129 206.964 443.945 210.06 445.513L275.546 483.327C281.046 486.489 281.098 491.766 275.666 495.049L245.261 513.389C242.196 515.023 238.782 515.896 235.308 515.931C231.835 515.967 228.404 515.166 225.305 513.595Z",
    fill: "url(#paint446_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.305 512.787L158.582 474.372C153.099 471.209 153.081 466.018 158.582 462.839L190.087 444.705C193.185 443.146 196.605 442.333 200.073 442.333C203.542 442.333 206.962 443.146 210.06 444.705L275.546 482.519C281.046 485.699 281.098 490.975 275.666 494.241L245.261 512.598C242.194 514.23 238.78 515.099 235.306 515.132C231.833 515.165 228.402 514.361 225.305 512.787Z",
    fill: "url(#paint447_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.305 511.996L158.582 473.615C153.099 470.453 153.081 465.262 158.582 462.099L190.087 443.914C193.183 442.347 196.604 441.53 200.073 441.53C203.543 441.53 206.964 442.347 210.06 443.914L275.546 481.728C281.046 484.908 281.098 490.185 275.666 493.467L245.261 511.807C242.194 513.439 238.78 514.309 235.306 514.341C231.833 514.374 228.402 513.57 225.305 511.996Z",
    fill: "url(#paint448_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.305 511.188L158.582 472.756C153.099 469.593 153.081 464.42 158.582 461.24L190.087 443.107C193.183 441.539 196.604 440.722 200.073 440.722C203.543 440.722 206.964 441.539 210.06 443.107L275.546 480.92C281.046 484.083 281.098 489.36 275.666 492.643L245.261 510.982C242.196 512.617 238.782 513.489 235.308 513.525C231.835 513.561 228.404 512.759 225.305 511.188Z",
    fill: "url(#paint449_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.305 510.381L158.582 471.897C153.099 468.734 153.081 463.543 158.582 460.364L190.087 442.299C193.185 440.739 196.605 439.927 200.073 439.927C203.542 439.927 206.962 440.739 210.06 442.299L275.546 480.113C281.046 483.292 281.098 488.569 275.666 491.835L245.261 510.192C242.194 511.824 238.78 512.693 235.306 512.726C231.833 512.759 228.402 511.954 225.305 510.381Z",
    fill: "url(#paint450_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.305 509.59L158.582 471.157C153.099 467.995 153.081 462.804 158.582 459.641L190.087 441.508C193.183 439.941 196.604 439.124 200.073 439.124C203.543 439.124 206.964 439.941 210.06 441.508L275.546 479.322C281.046 482.502 281.098 487.778 275.666 491.061L245.261 509.401C242.194 511.033 238.78 511.902 235.306 511.935C231.833 511.968 228.402 511.164 225.305 509.59Z",
    fill: "url(#paint451_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.305 508.782L158.582 470.35C153.099 467.187 153.081 462.013 158.582 458.834L190.087 440.7C193.183 439.133 196.604 438.316 200.073 438.316C203.543 438.316 206.964 439.133 210.06 440.7L275.546 478.514C281.046 481.677 281.098 486.953 275.666 490.236L245.261 508.576C242.196 510.211 238.782 511.083 235.308 511.119C231.835 511.155 228.404 510.353 225.305 508.782Z",
    fill: "url(#paint452_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.305 507.991L158.582 469.576C153.099 466.414 153.081 461.223 158.582 458.043L190.087 439.893C193.185 438.333 196.605 437.52 200.073 437.52C203.542 437.52 206.962 438.333 210.06 439.893L275.546 477.706C281.046 480.886 281.098 486.163 275.666 489.428L245.261 507.785C242.196 509.42 238.782 510.292 235.308 510.328C231.835 510.364 228.404 509.563 225.305 507.991Z",
    fill: "url(#paint453_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.305 507.184L158.582 468.751C153.099 465.589 153.081 460.398 158.582 457.235L190.087 439.085C193.185 437.525 196.605 436.713 200.073 436.713C203.542 436.713 206.962 437.525 210.06 439.085L275.546 476.898C281.046 480.078 281.098 485.355 275.666 488.638L245.261 506.977C242.196 508.612 238.782 509.484 235.308 509.52C231.835 509.556 228.404 508.755 225.305 507.184Z",
    fill: "url(#paint454_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.305 506.376L158.582 467.943C153.099 464.781 153.081 459.59 158.582 456.427L190.087 438.294C193.183 436.726 196.604 435.91 200.073 435.91C203.543 435.91 206.964 436.726 210.06 438.294L275.546 476.108C281.046 479.27 281.098 484.547 275.666 487.83L245.261 506.169C242.196 507.804 238.782 508.677 235.308 508.712C231.835 508.748 228.404 507.947 225.305 506.376Z",
    fill: "url(#paint455_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.305 505.568L158.582 467.153C153.099 463.99 153.081 458.799 158.582 455.62L190.087 437.521C193.185 435.961 196.605 435.149 200.073 435.149C203.542 435.149 206.962 435.961 210.06 437.521L275.546 475.334C281.046 478.514 281.098 483.791 275.666 487.056L245.261 505.413C242.192 507.04 238.776 507.903 235.302 507.93C231.828 507.957 228.399 507.147 225.305 505.568Z",
    fill: "url(#paint456_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.305 504.777L158.582 466.345C153.099 463.182 153.081 457.992 158.582 454.829L190.087 436.678C193.185 435.119 196.605 434.306 200.073 434.306C203.542 434.306 206.962 435.119 210.06 436.678L275.546 474.492C281.046 477.672 281.098 482.948 275.666 486.231L245.175 504.554C242.122 506.177 238.724 507.044 235.267 507.083C231.81 507.122 228.394 506.331 225.305 504.777Z",
    fill: "url(#paint457_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.305 503.969L158.582 465.537C153.099 462.374 153.081 457.184 158.582 454.021L190.087 435.888C193.183 434.32 196.604 433.503 200.073 433.503C203.543 433.503 206.964 434.32 210.06 435.888L275.546 473.701C281.046 476.864 281.098 482.141 275.666 485.423L245.261 503.763C242.196 505.398 238.782 506.27 235.308 506.306C231.835 506.342 228.404 505.54 225.305 503.969Z",
    fill: "url(#paint458_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.305 503.162L158.582 464.747C153.099 461.584 153.081 456.393 158.582 453.213L190.087 435.08C193.185 433.52 196.605 432.708 200.073 432.708C203.542 432.708 206.962 433.52 210.06 435.08L275.546 472.894C281.046 476.073 281.098 481.35 275.666 484.616L245.261 502.973C242.194 504.605 238.78 505.474 235.306 505.507C231.833 505.54 228.402 504.735 225.305 503.162Z",
    fill: "url(#paint459_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.305 502.371L158.582 463.939C153.099 460.776 153.081 455.585 158.582 452.423L190.087 434.272C193.185 432.712 196.605 431.9 200.073 431.9C203.542 431.9 206.962 432.712 210.06 434.272L275.546 472.086C281.046 475.265 281.098 480.542 275.666 483.825L245.261 502.165C242.196 503.799 238.782 504.672 235.308 504.708C231.835 504.744 228.404 503.942 225.305 502.371Z",
    fill: "url(#paint460_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.305 501.563L158.582 463.131C153.099 459.968 153.081 454.777 158.582 451.615L190.087 433.481C193.183 431.914 196.604 431.097 200.073 431.097C203.543 431.097 206.964 431.914 210.06 433.481L275.546 471.295C281.046 474.458 281.098 479.734 275.666 483.017L245.261 501.357C242.196 502.992 238.782 503.864 235.308 503.9C231.835 503.936 228.404 503.134 225.305 501.563Z",
    fill: "url(#paint461_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.305 500.755L158.582 462.34C153.099 459.16 153.081 453.987 158.582 450.807L190.087 432.674C193.185 431.114 196.605 430.302 200.073 430.302C203.542 430.302 206.962 431.114 210.06 432.674L275.546 470.487C281.046 473.667 281.098 478.944 275.666 482.209L245.261 500.566C242.194 502.198 238.78 503.068 235.306 503.101C231.833 503.134 228.402 502.329 225.305 500.755Z",
    fill: "url(#paint462_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.305 499.965L158.582 461.584C153.099 458.421 153.081 453.23 158.582 450.068L190.087 431.866C193.185 430.306 196.605 429.494 200.073 429.494C203.542 429.494 206.962 430.306 210.06 431.866L275.546 469.679C281.046 472.859 281.098 478.136 275.666 481.419L245.261 499.758C242.196 501.393 238.782 502.265 235.308 502.301C231.835 502.337 228.404 501.536 225.305 499.965Z",
    fill: "url(#paint463_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.305 499.157L158.582 460.724C153.099 457.562 153.081 452.371 158.582 449.208L190.087 431.075C193.183 429.508 196.604 428.691 200.073 428.691C203.543 428.691 206.964 429.508 210.06 431.075L275.546 468.889C281.046 472.051 281.098 477.328 275.666 480.611L245.261 498.951C242.196 500.585 238.782 501.458 235.308 501.494C231.835 501.529 228.404 500.728 225.305 499.157Z",
    fill: "url(#paint464_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.305 498.349L158.582 459.865C153.099 456.685 153.081 451.512 158.582 448.332L190.087 430.267C193.185 428.708 196.605 427.895 200.073 427.895C203.542 427.895 206.962 428.708 210.06 430.267L275.546 468.081C281.046 471.261 281.098 476.537 275.666 479.803L245.261 498.16C242.194 499.792 238.78 500.661 235.306 500.694C231.833 500.727 228.402 499.923 225.305 498.349Z",
    fill: "url(#paint465_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.305 497.558L158.582 459.126C153.099 455.963 153.081 450.773 158.582 447.61L190.087 429.46C193.185 427.9 196.605 427.087 200.073 427.087C203.542 427.087 206.962 427.9 210.06 429.46L275.546 467.273C281.046 470.453 281.098 475.73 275.666 479.013L245.261 497.352C242.196 498.987 238.782 499.859 235.308 499.895C231.835 499.931 228.404 499.13 225.305 497.558Z",
    fill: "url(#paint466_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.305 496.75L158.582 458.318C153.099 455.155 153.081 449.965 158.582 446.802L190.087 428.669C193.183 427.101 196.604 426.284 200.073 426.284C203.543 426.284 206.964 427.101 210.06 428.669L275.546 466.482C281.046 469.645 281.098 474.922 275.666 478.205L245.261 496.544C242.196 498.179 238.782 499.051 235.308 499.087C231.835 499.123 228.404 498.322 225.305 496.75Z",
    fill: "url(#paint467_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.305 495.96L158.582 457.545C153.099 454.365 153.081 449.191 158.582 446.011L190.087 427.861C193.185 426.301 196.605 425.489 200.073 425.489C203.542 425.489 206.962 426.301 210.06 427.861L275.546 465.675C281.046 468.854 281.098 474.131 275.666 477.397L245.261 495.736C242.197 497.374 238.784 498.249 235.31 498.288C231.837 498.327 228.405 497.528 225.305 495.96Z",
    fill: "url(#paint468_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.305 495.152L158.582 456.72C153.099 453.557 153.081 448.366 158.582 445.204L190.087 427.053C193.185 425.494 196.605 424.681 200.073 424.681C203.542 424.681 206.962 425.494 210.06 427.053L275.546 464.867C281.046 468.047 281.098 473.323 275.666 476.606L245.261 494.946C242.196 496.581 238.782 497.453 235.308 497.489C231.835 497.525 228.404 496.723 225.305 495.152Z",
    fill: "url(#paint469_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.305 494.344L158.582 455.912C153.099 452.749 153.081 447.558 158.582 444.396L190.087 426.262C193.183 424.695 196.604 423.878 200.073 423.878C203.543 423.878 206.964 424.695 210.06 426.262L275.546 464.076C281.046 467.239 281.098 472.515 275.666 475.798L245.261 494.138C242.196 495.773 238.782 496.645 235.308 496.681C231.835 496.717 228.404 495.915 225.305 494.344Z",
    fill: "url(#paint470_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.305 493.536L158.582 455.121C153.099 451.941 153.081 446.768 158.582 443.588L190.087 425.489C193.185 423.929 196.605 423.117 200.073 423.117C203.542 423.117 206.962 423.929 210.06 425.489L275.546 463.303C281.046 466.482 281.098 471.759 275.666 475.025L245.261 493.364C242.193 494.994 238.778 495.86 235.304 495.89C231.83 495.92 228.401 495.113 225.305 493.536Z",
    fill: "url(#paint471_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.305 492.746L158.582 454.313C153.099 451.151 153.081 445.96 158.582 442.797L190.087 424.647C193.185 423.087 196.605 422.275 200.073 422.275C203.542 422.275 206.962 423.087 210.06 424.647L275.546 462.46C281.046 465.64 281.098 470.917 275.666 474.2L245.175 492.522C242.121 494.141 238.724 495.006 235.267 495.045C231.811 495.084 228.395 494.296 225.305 492.746Z",
    fill: "url(#paint472_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.305 491.938L158.582 453.505C153.099 450.343 153.081 445.152 158.582 441.989L190.087 423.856C193.183 422.288 196.604 421.472 200.073 421.472C203.543 421.472 206.964 422.288 210.06 423.856L275.546 461.67C281.046 464.832 281.098 470.109 275.666 473.392L245.261 491.731C242.196 493.366 238.782 494.239 235.308 494.274C231.835 494.31 228.404 493.509 225.305 491.938Z",
    fill: "url(#paint473_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.305 491.13L158.582 452.715C153.099 449.535 153.081 444.362 158.582 441.182L190.087 423.048C193.185 421.489 196.605 420.676 200.073 420.676C203.542 420.676 206.962 421.489 210.06 423.048L275.546 460.862C281.046 464.042 281.098 469.319 275.666 472.584L245.261 490.924C242.196 492.559 238.782 493.431 235.308 493.467C231.835 493.503 228.404 492.701 225.305 491.13Z",
    fill: "url(#paint474_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.305 490.339L158.582 451.907C153.099 448.744 153.081 443.554 158.582 440.391L190.087 422.24C193.185 420.681 196.605 419.868 200.073 419.868C203.542 419.868 206.962 420.681 210.06 422.24L275.546 460.054C281.046 463.234 281.098 468.511 275.666 471.793L245.261 490.133C242.194 491.764 238.781 492.634 235.308 492.669C231.835 492.705 228.405 491.906 225.305 490.339Z",
    fill: "url(#paint475_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.305 489.532L158.582 451.099C153.099 447.937 153.081 442.746 158.582 439.583L190.087 421.45C193.183 419.882 196.604 419.065 200.073 419.065C203.543 419.065 206.964 419.882 210.06 421.45L275.546 459.263C281.046 462.426 281.098 467.703 275.666 470.986L245.261 489.325C242.196 490.96 238.782 491.832 235.308 491.868C231.835 491.904 228.404 491.103 225.305 489.532Z",
    fill: "url(#paint476_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.305 488.724L158.582 450.309C153.099 447.129 153.081 441.955 158.582 438.775L190.087 420.642C193.183 419.074 196.604 418.258 200.073 418.258C203.543 418.258 206.964 419.074 210.06 420.642L275.546 458.456C281.046 461.618 281.098 466.912 275.666 470.178L245.261 488.518C242.196 490.152 238.782 491.025 235.308 491.061C231.835 491.096 228.404 490.295 225.305 488.724Z",
    fill: "url(#paint477_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.305 487.933L158.582 449.552C153.099 446.39 153.081 441.199 158.582 438.019L190.087 419.834C193.185 418.274 196.605 417.462 200.073 417.462C203.542 417.462 206.962 418.274 210.06 419.834L275.546 457.648C281.046 460.827 281.098 466.104 275.666 469.387L245.261 487.727C242.194 489.357 238.781 490.227 235.308 490.263C231.835 490.299 228.405 489.5 225.305 487.933Z",
    fill: "url(#paint478_linear_1606_3980)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.087 419.043C193.183 417.476 196.604 416.659 200.073 416.659C203.543 416.659 206.964 417.476 210.06 419.043L275.546 456.857C281.046 460.02 281.098 465.296 275.666 468.579L245.261 486.919C242.207 488.539 238.808 489.404 235.351 489.44C231.894 489.476 228.478 488.682 225.391 487.125L158.582 448.693C153.099 445.53 153.081 440.339 158.582 437.177L190.087 419.043Z",
    fill: "url(#paint479_linear_1606_3980)",
    fillOpacity: 0.15
  }))), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M184.12 401.77C187.893 399.871 192.058 398.883 196.281 398.883C200.504 398.883 204.669 399.871 208.441 401.77L293.213 450.085V456.96C293.215 457.585 293.059 458.2 292.758 458.747C292.457 459.294 292.022 459.756 291.494 460.089L251.36 484.375C247.642 486.347 243.506 487.399 239.297 487.441C235.089 487.482 230.933 486.514 227.176 484.616L144.055 436.833C143.092 436.279 142.292 435.48 141.736 434.517C141.181 433.554 140.89 432.462 140.893 431.35V426.194L184.12 401.77Z",
    fill: "url(#paint480_linear_1606_3980)"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M184.119 397.558C187.892 395.66 192.056 394.671 196.28 394.671C200.503 394.671 204.668 395.66 208.44 397.558L288.158 443.588C294.844 447.455 294.913 453.901 288.296 457.871L251.29 480.216C247.572 482.188 243.436 483.239 239.227 483.281C235.019 483.323 230.863 482.354 227.106 480.456L145.876 433.67C139.19 429.82 139.19 423.495 145.876 419.645L184.119 397.558Z",
    fill: "#5A3CFF"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M186.252 414.196C187.915 413.358 189.752 412.921 191.615 412.921C193.477 412.921 195.314 413.358 196.977 414.196L255.193 447.524C258.15 449.243 258.167 452.062 255.193 453.815L238.899 463.646C237.263 464.521 235.44 464.988 233.585 465.009C231.731 465.03 229.898 464.604 228.242 463.767L169.459 430.113C166.503 428.394 166.503 425.627 169.459 423.925L186.252 414.196Z",
    fill: "#EBE9EC"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M225.75 443.554C225.985 443.769 226.291 443.888 226.61 443.888C226.928 443.888 227.235 443.769 227.469 443.554L229.996 441.13C230.214 440.897 230.336 440.59 230.336 440.271C230.336 439.951 230.214 439.644 229.996 439.411C229.761 439.196 229.455 439.077 229.136 439.077C228.818 439.077 228.511 439.196 228.277 439.411L225.75 441.835C225.535 442.069 225.416 442.376 225.416 442.694C225.416 443.012 225.535 443.319 225.75 443.554Z",
    fill: "#F2B1B5"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M190.463 564.402L194.812 561.859V559.899L199.315 559.246L209.507 553.333C210.088 553.011 210.564 552.527 210.875 551.94C211.187 551.353 211.322 550.688 211.264 550.027C211.205 549.365 210.957 548.734 210.547 548.21C210.138 547.687 209.586 547.293 208.957 547.077C207.993 546.726 206.968 546.572 205.944 546.625C204.919 546.679 203.916 546.937 202.993 547.386L195.138 551.202L184.275 555.207L184.499 559.16C184.578 560.575 185.195 561.907 186.224 562.881C187.253 563.856 188.616 564.4 190.033 564.402H190.463Z",
    fill: "#363650"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M188.761 563.131H189.191L193.522 560.587V558.627L198.026 557.974L208.235 552.079C208.628 551.853 208.972 551.551 209.247 551.192C209.523 550.833 209.725 550.422 209.842 549.985C209.958 549.547 209.987 549.091 209.927 548.642C209.867 548.193 209.718 547.76 209.49 547.369C210.015 547.67 210.451 548.104 210.755 548.628C211.058 549.152 211.218 549.746 211.218 550.351C211.218 550.956 211.058 551.551 210.755 552.074C210.451 552.598 210.015 553.032 209.49 553.333L199.298 559.246L194.794 559.899V561.859L190.446 564.402H190.085C189.198 564.4 188.325 564.184 187.538 563.774C186.752 563.365 186.075 562.773 185.564 562.048C186.491 562.733 187.609 563.111 188.761 563.131Z",
    fill: "#5A3CFF"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M173.824 553.024L178.173 550.48V548.521L182.676 547.868L192.869 541.955C193.45 541.633 193.925 541.149 194.237 540.562C194.548 539.975 194.683 539.31 194.625 538.648C194.567 537.986 194.318 537.355 193.909 536.832C193.499 536.308 192.947 535.915 192.319 535.699C191.354 535.352 190.329 535.201 189.306 535.254C188.282 535.308 187.278 535.564 186.354 536.008L178.5 539.824L167.637 543.829L167.86 547.782C167.939 549.197 168.556 550.528 169.585 551.503C170.614 552.478 171.977 553.022 173.395 553.024H173.824Z",
    fill: "#363650"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M172.122 551.752H172.551L176.9 549.208V547.249L181.403 546.596L191.613 540.7C192.005 540.474 192.349 540.173 192.625 539.814C192.9 539.454 193.102 539.044 193.219 538.606C193.336 538.169 193.365 537.712 193.304 537.263C193.244 536.815 193.096 536.382 192.868 535.991C193.392 536.292 193.829 536.726 194.132 537.25C194.435 537.773 194.595 538.368 194.595 538.973C194.595 539.578 194.435 540.172 194.132 540.696C193.829 541.22 193.392 541.654 192.868 541.955L182.675 547.868L178.172 548.521V550.48L173.823 553.024H173.393C172.507 553.021 171.634 552.806 170.847 552.396C170.061 551.986 169.384 551.394 168.873 550.669C169.813 551.367 170.951 551.746 172.122 551.752Z",
    fill: "#5A3CFF"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M173.343 547.833C176.506 547.833 179.067 546.544 179.067 543.382L182.229 458.799C182.229 455.637 176.506 453.076 173.343 453.076C171.828 453.08 170.377 453.685 169.307 454.758C168.237 455.831 167.637 457.284 167.637 458.799V543.382C167.637 546.544 170.198 547.833 173.343 547.833Z",
    fill: "#D3DAED"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M189.603 557.562C192.542 557.562 195.052 557.201 195.292 554.21L198.489 504.726V504.296L195.327 457.888C195.277 457.14 195.079 456.409 194.746 455.737C194.413 455.064 193.951 454.464 193.386 453.971C192.821 453.478 192.164 453.101 191.453 452.862C190.742 452.623 189.991 452.526 189.242 452.577C186.097 452.784 175.784 455.602 176.007 458.748L185.581 504.674L183.862 553.247C183.622 556.393 185.959 557.235 189.019 557.493L189.603 557.562Z",
    fill: "#D3DAED"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M202.323 426.95C202.306 427.115 202.323 427.282 202.372 427.441C202.422 427.6 202.503 427.747 202.61 427.873C202.718 428 202.849 428.104 202.998 428.178C203.146 428.253 203.308 428.297 203.474 428.308L208.734 428.755C208.9 428.771 209.068 428.754 209.227 428.705C209.387 428.656 209.535 428.575 209.663 428.468C209.791 428.361 209.897 428.229 209.973 428.081C210.05 427.932 210.096 427.77 210.109 427.603C210.133 427.271 210.025 426.943 209.81 426.689C209.595 426.435 209.289 426.276 208.957 426.245L203.68 425.781C203.346 425.758 203.015 425.867 202.761 426.086C202.506 426.305 202.349 426.615 202.323 426.95Z",
    fill: "#F2B1B5"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M199.058 431.075C199.797 430.732 200.519 430.371 201.224 429.975L209.027 425.644C209.464 425.401 209.849 425.075 210.16 424.684C210.47 424.292 210.701 423.844 210.838 423.363C210.975 422.883 211.017 422.38 210.96 421.884C210.902 421.387 210.748 420.907 210.506 420.47C210.263 420.033 209.937 419.649 209.545 419.338C209.154 419.027 208.705 418.797 208.225 418.66C207.745 418.522 207.242 418.481 206.745 418.538C206.249 418.595 205.769 418.749 205.332 418.992L197.546 423.306C188.058 428.583 184.053 432.382 176.044 425.025C175.678 424.667 175.244 424.387 174.768 424.2C174.292 424.013 173.783 423.924 173.272 423.937C172.761 423.951 172.257 424.067 171.792 424.28C171.326 424.492 170.908 424.795 170.563 425.172C170.217 425.549 169.95 425.992 169.779 426.474C169.608 426.956 169.535 427.467 169.565 427.978C169.596 428.488 169.728 428.988 169.955 429.446C170.182 429.904 170.499 430.312 170.887 430.646C180.736 439.652 187.13 436.593 199.058 431.075Z",
    fill: "#F2B1B5"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M170.473 431.144C169.666 430.333 169.201 429.242 169.177 428.098C169.152 426.954 169.569 425.845 170.341 425C171.113 424.155 172.18 423.64 173.322 423.562C174.463 423.483 175.591 423.847 176.471 424.578C184.275 431.728 187.987 427.878 197.235 422.756C197.745 422.474 198.305 422.295 198.885 422.23C199.464 422.164 200.05 422.213 200.611 422.375C201.171 422.536 201.694 422.806 202.15 423.169C202.606 423.532 202.985 423.982 203.268 424.492C203.55 425.002 203.729 425.563 203.794 426.142C203.86 426.721 203.81 427.308 203.649 427.868C203.488 428.428 203.218 428.951 202.855 429.407C202.491 429.863 202.042 430.243 201.532 430.525C200.81 430.92 200.071 431.299 199.332 431.642C187.162 437.28 180.493 440.305 170.473 431.144Z",
    fill: "black"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M176.471 424.578C183.673 431.178 187.403 428.394 195.189 423.908C196.287 426.671 197.049 429.556 197.458 432.502C186.458 437.555 179.961 439.807 170.473 431.144C169.666 430.333 169.201 429.242 169.177 428.098C169.152 426.954 169.569 425.845 170.341 425C171.113 424.155 172.18 423.64 173.322 423.562C174.463 423.483 175.591 423.847 176.471 424.578Z",
    fill: "#231F20"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M167.121 413.079C167.912 407.665 172.965 404.124 177.778 406.72L179.308 407.648C193.058 416.465 196.255 427.912 196.255 440.305L195.997 450.772L197.888 477.603C195.524 479.032 192.77 479.682 190.016 479.459C189.724 479.459 188.177 470.556 187.902 470.522C187.214 470.522 186.509 479.253 185.805 479.116C177.743 477.723 170.181 474.354 167.121 468.304L168.067 436.747C168.067 436.747 165.832 422.051 167.121 413.079Z",
    fill: "black"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M178.757 414.282C179.5 414.282 180.213 413.987 180.738 413.462C181.264 412.936 181.559 412.224 181.559 411.481V398.573H175.973V411.481C175.973 412.221 176.265 412.931 176.787 413.456C177.309 413.981 178.017 414.278 178.757 414.282Z",
    fill: "#F2B1B5"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M178.981 407.098H172.106V383.035H188.984V397.077C188.971 399.728 187.913 402.266 186.041 404.142C184.168 406.018 181.631 407.08 178.981 407.098Z",
    fill: "#F2B1B5"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M187.456 397.146V382.983H189.037V397.146C189.04 398.452 188.784 399.746 188.286 400.953C187.788 402.16 187.056 403.258 186.134 404.182C185.211 405.106 184.115 405.84 182.909 406.34C181.702 406.84 180.409 407.098 179.103 407.098H177.521C178.828 407.098 180.121 406.84 181.327 406.34C182.534 405.84 183.63 405.106 184.552 404.182C185.475 403.258 186.207 402.16 186.705 400.953C187.203 399.746 187.458 398.452 187.456 397.146Z",
    fill: "#F7D0D3"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M166.657 395.393C166.657 394.757 166.657 394.138 166.657 393.502C166.5 391.062 166.54 388.614 166.778 386.18C166.911 384.645 167.418 383.167 168.254 381.873C169.09 380.579 170.229 379.508 171.573 378.755C173.309 378.122 175.162 377.87 177.004 378.016H188.245C189.932 377.861 191.626 378.215 193.11 379.03C195.757 380.749 194.45 384.186 192.869 386.283C192.02 387.424 190.921 388.353 189.655 388.999C188.434 389.583 186.372 389.102 185.581 390.34C184.498 392.058 186.561 397.473 184.189 398.126C182.35 398.641 182.59 396.734 182.298 395.685C182.235 395.344 182.069 395.03 181.824 394.784C181.578 394.539 181.264 394.374 180.923 394.31C180.064 394.31 179.497 395.221 179.325 396.029C179.184 397.758 179.318 399.498 179.72 401.185C179.905 402.024 179.888 402.895 179.669 403.726C179.451 404.557 179.039 405.324 178.465 405.964C177.989 406.358 177.44 406.656 176.85 406.84C175.131 407.459 172.054 408.215 170.49 406.978C169.4 406.266 168.484 405.32 167.809 404.207C167.133 403.094 166.716 401.845 166.588 400.549C166.502 398.831 166.525 397.109 166.657 395.393Z",
    fill: "#5A3CFF"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M216.108 450.154C216.915 450.154 217.723 450.154 218.531 450.068L232.281 449.38C233.259 449.287 234.163 448.821 234.806 448.078C235.448 447.335 235.78 446.373 235.731 445.393C235.682 444.412 235.257 443.487 234.544 442.812C233.831 442.136 232.885 441.762 231.903 441.766L218.05 442.471C212.754 442.872 207.467 441.593 202.94 438.815C198.413 436.038 194.877 431.904 192.835 427.002L190.24 420.797C190.044 420.335 189.76 419.917 189.403 419.565C189.046 419.213 188.623 418.935 188.159 418.747C187.694 418.558 187.197 418.463 186.696 418.467C186.195 418.471 185.699 418.573 185.238 418.769C184.776 418.964 184.358 419.248 184.006 419.605C183.654 419.962 183.376 420.385 183.188 420.849C183 421.314 182.905 421.811 182.908 422.312C182.912 422.813 183.014 423.309 183.21 423.77L185.822 429.975C188.314 435.953 192.519 441.06 197.909 444.651C203.299 448.242 209.631 450.157 216.108 450.154Z",
    fill: "#F2B1B5"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M183.689 425.489C183.513 424.933 183.448 424.347 183.499 423.766C183.55 423.185 183.715 422.619 183.985 422.102C184.255 421.584 184.624 421.125 185.072 420.751C185.519 420.377 186.036 420.094 186.593 419.92C188.948 419.181 190.598 420.711 191.337 423.048L194.19 429.253C194.645 430.619 195.22 431.942 195.909 433.206C196.201 435.573 196.344 437.955 196.339 440.339L196.15 447.472C191.302 443.375 187.724 437.978 185.837 431.917L183.689 425.489Z",
    fill: "#231F20"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M185.252 430.25L182.64 424.028C182.257 422.956 182.3 421.777 182.76 420.735C183.22 419.694 184.061 418.868 185.111 418.427C186.161 417.987 187.34 417.966 188.406 418.368C189.471 418.771 190.341 419.566 190.838 420.59L193.434 426.813C195.424 431.569 198.861 435.579 203.256 438.275C207.652 440.971 212.784 442.217 217.926 441.835L223.169 441.457C224.343 441.372 225.502 441.758 226.392 442.528C227.281 443.299 227.828 444.391 227.913 445.565C227.997 446.738 227.612 447.898 226.841 448.787C226.071 449.677 224.979 450.224 223.805 450.309L218.648 450.687C217.823 450.755 216.998 450.79 216.173 450.79C209.567 450.803 203.105 448.859 197.602 445.203C192.099 441.548 187.802 436.345 185.252 430.25Z",
    fill: "black"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M293.211 432.708C293.211 436.593 290.479 438.139 287.127 436.146L216.278 394.207C214.508 393.018 213.035 391.439 211.971 389.592C210.907 387.744 210.282 385.678 210.142 383.55L209.506 325.111C209.506 321.227 212.153 319.663 215.504 321.674L287.093 363.715C288.864 364.896 290.337 366.471 291.395 368.317C292.454 370.163 293.07 372.23 293.194 374.355L293.211 432.708Z",
    fill: "#D3DAED"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M291.064 434.083V375.764C290.942 373.641 290.329 371.575 289.273 369.729C288.217 367.883 286.748 366.307 284.98 365.125L213.392 323.1C212.445 322.47 211.31 322.184 210.178 322.292C211.175 320.573 213.186 320.316 215.506 321.674L287.094 363.715C288.865 364.896 290.338 366.471 291.397 368.317C292.456 370.163 293.072 372.23 293.196 374.355V432.708C293.196 435.2 292.061 436.73 290.36 436.988C290.863 436.105 291.107 435.098 291.064 434.083Z",
    fill: "#D3DAED"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M209.73 346.183C209.73 346.802 212.566 349.312 213.065 349.948C214.131 351.306 215.265 352.663 216.279 354.038C218.221 356.634 218.806 360.295 220.559 363.148C222.204 366.022 224.755 368.271 227.812 369.542C229.972 370.191 232.209 370.55 234.464 370.608C236.724 370.671 238.945 371.216 240.978 372.206C245.035 374.475 245.447 380.456 246.65 384.478C247.089 386.419 247.919 388.25 249.091 389.858C250.425 391.276 252.049 392.39 253.852 393.124C255.489 393.983 257.219 394.652 259.009 395.118C262.446 395.908 266.142 395.358 269.699 395.771C272.351 396.085 274.913 396.931 277.231 398.257C279.549 399.583 281.576 401.362 283.192 403.488C284.344 405.109 285.4 406.797 286.355 408.542C287.962 411.214 289.748 413.775 291.7 416.207C293.419 418.287 293.281 419.25 293.213 421.794C293.109 425.42 293.213 429.064 293.213 432.708C293.213 436.352 290.48 438.139 287.128 436.146L216.279 394.207C214.51 393.018 213.036 391.439 211.972 389.592C210.909 387.744 210.283 385.677 210.143 383.55L209.73 346.183Z",
    fill: "white"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M293.075 433.911V434.169C293.014 434.496 292.91 434.814 292.766 435.114V435.269C292.648 435.494 292.51 435.706 292.353 435.905L292.198 436.094C292.019 436.279 291.817 436.441 291.597 436.575L291.356 436.696C291.175 436.785 290.985 436.854 290.789 436.902H290.531C291.022 436.034 291.26 435.045 291.219 434.049V408.267C291.442 408.542 291.631 408.817 291.838 409.092C292.714 410.035 293.247 411.246 293.35 412.529V421.639C293.247 425.266 293.35 428.909 293.35 432.553C293.306 433.014 293.214 433.469 293.075 433.911Z",
    fill: "#D3DAED"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1606_3980",
    x: 301.717,
    y: 469.561,
    width: 124.848,
    height: 84.8195,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "effect1_foregroundBlur_1606_3980"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1606_3980",
    x: 259.992,
    y: 191.876,
    width: 395.535,
    height: 239.937,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "effect1_foregroundBlur_1606_3980"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1606_3980",
    x: 378.439,
    y: 423.513,
    width: 126.516,
    height: 85.6931,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "effect1_foregroundBlur_1606_3980"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_1606_3980",
    x: 0,
    y: 295.164,
    width: 126.492,
    height: 85.6301,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "effect1_foregroundBlur_1606_3980"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_1606_3980",
    x: 77.5977,
    y: 338.484,
    width: 126.832,
    height: 85.8994,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "effect1_foregroundBlur_1606_3980"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_1606_3980",
    x: 704.57,
    y: 234.983,
    width: 126.477,
    height: 85.6416,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "effect1_foregroundBlur_1606_3980"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_1606_3980",
    x: 633.252,
    y: 279.319,
    width: 121.902,
    height: 83.0599,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "effect1_foregroundBlur_1606_3980"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_1606_3980",
    x: 522.869,
    y: 408.276,
    width: 162.158,
    height: 156.24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "effect1_foregroundBlur_1606_3980"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_1606_3980",
    x: 139.463,
    y: 401.659,
    width: 155.244,
    height: 135.671,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "effect1_foregroundBlur_1606_3980"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1606_3980",
    x1: 509.396,
    y1: 530.159,
    x2: 433.302,
    y2: 425.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1606_3980",
    x1: 509.396,
    y1: 530.159,
    x2: 433.302,
    y2: 425.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1606_3980",
    x1: 509.396,
    y1: 530.159,
    x2: 433.302,
    y2: 425.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1606_3980",
    x1: 509.396,
    y1: 530.159,
    x2: 433.302,
    y2: 425.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1606_3980",
    x1: 509.396,
    y1: 530.159,
    x2: 433.302,
    y2: 425.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1606_3980",
    x1: 509.396,
    y1: 530.159,
    x2: 433.302,
    y2: 425.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1606_3980",
    x1: 509.396,
    y1: 530.159,
    x2: 433.302,
    y2: 425.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1606_3980",
    x1: 509.396,
    y1: 530.159,
    x2: 433.302,
    y2: 425.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1606_3980",
    x1: 509.396,
    y1: 530.159,
    x2: 433.302,
    y2: 425.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1606_3980",
    x1: 509.396,
    y1: 530.159,
    x2: 433.302,
    y2: 425.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1606_3980",
    x1: 509.396,
    y1: 530.159,
    x2: 433.302,
    y2: 425.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1606_3980",
    x1: 509.396,
    y1: 530.159,
    x2: 433.302,
    y2: 425.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1606_3980",
    x1: 509.396,
    y1: 530.159,
    x2: 433.302,
    y2: 425.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1606_3980",
    x1: 509.396,
    y1: 530.159,
    x2: 433.302,
    y2: 425.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1606_3980",
    x1: 509.396,
    y1: 530.159,
    x2: 433.302,
    y2: 425.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1606_3980",
    x1: 509.396,
    y1: 530.159,
    x2: 433.302,
    y2: 425.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1606_3980",
    x1: 509.396,
    y1: 530.159,
    x2: 433.302,
    y2: 425.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1606_3980",
    x1: 509.396,
    y1: 530.159,
    x2: 433.302,
    y2: 425.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1606_3980",
    x1: 509.396,
    y1: 530.159,
    x2: 433.302,
    y2: 425.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1606_3980",
    x1: 509.396,
    y1: 530.159,
    x2: 433.302,
    y2: 425.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1606_3980",
    x1: 509.396,
    y1: 530.159,
    x2: 433.302,
    y2: 425.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1606_3980",
    x1: 509.396,
    y1: 530.159,
    x2: 433.302,
    y2: 425.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1606_3980",
    x1: 509.396,
    y1: 530.159,
    x2: 433.302,
    y2: 425.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1606_3980",
    x1: 509.396,
    y1: 530.159,
    x2: 433.302,
    y2: 425.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1606_3980",
    x1: 509.396,
    y1: 530.159,
    x2: 433.302,
    y2: 425.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1606_3980",
    x1: 509.396,
    y1: 530.159,
    x2: 433.302,
    y2: 425.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1606_3980",
    x1: 509.396,
    y1: 530.159,
    x2: 433.302,
    y2: 425.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1606_3980",
    x1: 509.396,
    y1: 530.159,
    x2: 433.302,
    y2: 425.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1606_3980",
    x1: 509.396,
    y1: 530.159,
    x2: 433.302,
    y2: 425.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1606_3980",
    x1: 509.396,
    y1: 530.159,
    x2: 433.302,
    y2: 425.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1606_3980",
    x1: 509.396,
    y1: 530.159,
    x2: 433.302,
    y2: 425.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1606_3980",
    x1: 509.396,
    y1: 530.159,
    x2: 433.302,
    y2: 425.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1606_3980",
    x1: 509.396,
    y1: 530.159,
    x2: 433.302,
    y2: 425.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1606_3980",
    x1: 509.396,
    y1: 530.159,
    x2: 433.302,
    y2: 425.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1606_3980",
    x1: 509.396,
    y1: 530.159,
    x2: 433.302,
    y2: 425.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1606_3980",
    x1: 509.396,
    y1: 530.159,
    x2: 433.302,
    y2: 425.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1606_3980",
    x1: 509.396,
    y1: 530.159,
    x2: 433.302,
    y2: 425.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1606_3980",
    x1: 509.396,
    y1: 530.159,
    x2: 433.302,
    y2: 425.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_1606_3980",
    x1: 509.396,
    y1: 530.159,
    x2: 433.302,
    y2: 425.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1606_3980",
    x1: 509.396,
    y1: 530.159,
    x2: 433.302,
    y2: 425.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_1606_3980",
    x1: 509.396,
    y1: 530.159,
    x2: 433.302,
    y2: 425.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_1606_3980",
    x1: 509.396,
    y1: 530.159,
    x2: 433.302,
    y2: 425.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_1606_3980",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(364.269 509.211) scale(21.5538 11.208)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#9A9EC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#A2A6C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#CACCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#E7E8F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#F9F9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_1606_3980",
    x1: 641.235,
    y1: 136.542,
    x2: 706.223,
    y2: 136.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3DAED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99A7D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_1606_3980",
    x1: 637.629,
    y1: 134.806,
    x2: 706.226,
    y2: 134.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C629E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48486A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_1606_3980",
    x1: 634.137,
    y1: 129.512,
    x2: 680.922,
    y2: 129.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3DAED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99A7D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_1606_3980",
    x1: 633.658,
    y1: 129.598,
    x2: 680.616,
    y2: 129.598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C629E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48486A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_1606_3980",
    x1: 304.216,
    y1: 183.843,
    x2: 252.806,
    y2: 183.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F4FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#D6DCEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3DAED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_1606_3980",
    x1: 276.438,
    y1: 189.876,
    x2: 276.18,
    y2: 156.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F4FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#D6DCEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3DAED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_1606_3980",
    x1: 258.634,
    y1: 150.962,
    x2: 302.618,
    y2: 125.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FF9800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC107"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_1606_3980",
    x1: 254.352,
    y1: 143.657,
    x2: 298.319,
    y2: 117.876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FF9800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC107"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_1606_3980",
    x1: 247.597,
    y1: 132.142,
    x2: 291.564,
    y2: 106.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FF9800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC107"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_1606_3980",
    x1: 1017.56,
    y1: 381.499,
    x2: 726.716,
    y2: -19.1517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_1606_3980",
    x1: 1017.56,
    y1: 381.499,
    x2: 726.716,
    y2: -19.1517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_1606_3980",
    x1: 1017.56,
    y1: 381.499,
    x2: 726.716,
    y2: -19.1517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_1606_3980",
    x1: 1017.56,
    y1: 381.499,
    x2: 726.716,
    y2: -19.1517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_1606_3980",
    x1: 1017.56,
    y1: 381.499,
    x2: 726.716,
    y2: -19.1517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_1606_3980",
    x1: 1017.56,
    y1: 381.499,
    x2: 726.716,
    y2: -19.1517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_1606_3980",
    x1: 1017.56,
    y1: 381.499,
    x2: 726.716,
    y2: -19.1517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_1606_3980",
    x1: 1017.56,
    y1: 381.499,
    x2: 726.716,
    y2: -19.1517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_1606_3980",
    x1: 1017.56,
    y1: 381.499,
    x2: 726.716,
    y2: -19.1517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_1606_3980",
    x1: 1017.56,
    y1: 381.499,
    x2: 726.716,
    y2: -19.1517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_1606_3980",
    x1: 1017.56,
    y1: 381.499,
    x2: 726.716,
    y2: -19.1517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_1606_3980",
    x1: 1017.56,
    y1: 381.499,
    x2: 726.716,
    y2: -19.1517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_1606_3980",
    x1: 1017.56,
    y1: 381.499,
    x2: 726.716,
    y2: -19.1517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_1606_3980",
    x1: 1017.56,
    y1: 381.499,
    x2: 726.716,
    y2: -19.1517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_1606_3980",
    x1: 1017.56,
    y1: 381.499,
    x2: 726.716,
    y2: -19.1517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_1606_3980",
    x1: 1017.56,
    y1: 381.499,
    x2: 726.716,
    y2: -19.1517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_1606_3980",
    x1: 1017.56,
    y1: 381.499,
    x2: 726.716,
    y2: -19.1517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_1606_3980",
    x1: 1017.56,
    y1: 381.499,
    x2: 726.716,
    y2: -19.1517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_1606_3980",
    x1: 1017.56,
    y1: 381.499,
    x2: 726.716,
    y2: -19.1517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_1606_3980",
    x1: 1017.56,
    y1: 381.499,
    x2: 726.716,
    y2: -19.1517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_1606_3980",
    x1: 1017.56,
    y1: 381.499,
    x2: 726.716,
    y2: -19.1517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_1606_3980",
    x1: 1017.56,
    y1: 381.499,
    x2: 726.716,
    y2: -19.1517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_1606_3980",
    x1: 1017.56,
    y1: 381.499,
    x2: 726.716,
    y2: -19.1517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_1606_3980",
    x1: 1017.56,
    y1: 381.499,
    x2: 726.716,
    y2: -19.1517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_1606_3980",
    x1: 1017.56,
    y1: 381.499,
    x2: 726.716,
    y2: -19.1517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_1606_3980",
    x1: 1017.56,
    y1: 381.499,
    x2: 726.716,
    y2: -19.1517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_1606_3980",
    x1: 1017.56,
    y1: 381.499,
    x2: 726.716,
    y2: -19.1517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_1606_3980",
    x1: 1017.56,
    y1: 381.499,
    x2: 726.716,
    y2: -19.1517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_1606_3980",
    x1: 1017.56,
    y1: 381.499,
    x2: 726.716,
    y2: -19.1517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_1606_3980",
    x1: 1017.56,
    y1: 381.499,
    x2: 726.716,
    y2: -19.1517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_1606_3980",
    x1: 1017.56,
    y1: 381.499,
    x2: 726.716,
    y2: -19.1517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_1606_3980",
    x1: 1017.56,
    y1: 381.499,
    x2: 726.716,
    y2: -19.1517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_1606_3980",
    x1: 1017.56,
    y1: 381.499,
    x2: 726.716,
    y2: -19.1517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_1606_3980",
    x1: 1017.56,
    y1: 381.499,
    x2: 726.716,
    y2: -19.1517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_1606_3980",
    x1: 1017.56,
    y1: 381.499,
    x2: 726.716,
    y2: -19.1517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_1606_3980",
    x1: 1017.56,
    y1: 381.499,
    x2: 726.716,
    y2: -19.1517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_1606_3980",
    x1: 1017.56,
    y1: 381.499,
    x2: 726.716,
    y2: -19.1517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_1606_3980",
    x1: 1017.56,
    y1: 381.499,
    x2: 726.716,
    y2: -19.1517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_1606_3980",
    x1: 1017.56,
    y1: 381.499,
    x2: 726.716,
    y2: -19.1517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_1606_3980",
    x1: 1017.56,
    y1: 381.499,
    x2: 726.716,
    y2: -19.1517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_1606_3980",
    x1: 1017.56,
    y1: 381.499,
    x2: 726.716,
    y2: -19.1517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_1606_3980",
    x1: 1017.56,
    y1: 381.499,
    x2: 726.716,
    y2: -19.1517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_1606_3980",
    x1: 589.507,
    y1: 484.838,
    x2: 512.239,
    y2: 378.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_1606_3980",
    x1: 589.507,
    y1: 484.838,
    x2: 512.239,
    y2: 378.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_1606_3980",
    x1: 589.507,
    y1: 484.838,
    x2: 512.239,
    y2: 378.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_1606_3980",
    x1: 589.507,
    y1: 484.838,
    x2: 512.239,
    y2: 378.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_1606_3980",
    x1: 589.507,
    y1: 484.838,
    x2: 512.239,
    y2: 378.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_1606_3980",
    x1: 589.507,
    y1: 484.838,
    x2: 512.239,
    y2: 378.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_1606_3980",
    x1: 589.507,
    y1: 484.838,
    x2: 512.239,
    y2: 378.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_1606_3980",
    x1: 589.507,
    y1: 484.838,
    x2: 512.239,
    y2: 378.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_1606_3980",
    x1: 589.507,
    y1: 484.838,
    x2: 512.239,
    y2: 378.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_1606_3980",
    x1: 589.507,
    y1: 484.838,
    x2: 512.239,
    y2: 378.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_1606_3980",
    x1: 589.507,
    y1: 484.838,
    x2: 512.239,
    y2: 378.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_1606_3980",
    x1: 589.507,
    y1: 484.838,
    x2: 512.239,
    y2: 378.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_1606_3980",
    x1: 589.507,
    y1: 484.838,
    x2: 512.239,
    y2: 378.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_1606_3980",
    x1: 589.507,
    y1: 484.838,
    x2: 512.239,
    y2: 378.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_1606_3980",
    x1: 589.507,
    y1: 484.838,
    x2: 512.239,
    y2: 378.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_1606_3980",
    x1: 589.507,
    y1: 484.838,
    x2: 512.239,
    y2: 378.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_1606_3980",
    x1: 589.507,
    y1: 484.838,
    x2: 512.239,
    y2: 378.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_1606_3980",
    x1: 589.507,
    y1: 484.838,
    x2: 512.239,
    y2: 378.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_1606_3980",
    x1: 589.507,
    y1: 484.838,
    x2: 512.239,
    y2: 378.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_1606_3980",
    x1: 589.507,
    y1: 484.838,
    x2: 512.239,
    y2: 378.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_1606_3980",
    x1: 589.507,
    y1: 484.838,
    x2: 512.239,
    y2: 378.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_1606_3980",
    x1: 589.507,
    y1: 484.838,
    x2: 512.239,
    y2: 378.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_1606_3980",
    x1: 589.507,
    y1: 484.838,
    x2: 512.239,
    y2: 378.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_1606_3980",
    x1: 589.507,
    y1: 484.838,
    x2: 512.239,
    y2: 378.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_1606_3980",
    x1: 589.507,
    y1: 484.838,
    x2: 512.239,
    y2: 378.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_1606_3980",
    x1: 589.507,
    y1: 484.838,
    x2: 512.239,
    y2: 378.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_1606_3980",
    x1: 589.507,
    y1: 484.838,
    x2: 512.239,
    y2: 378.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_1606_3980",
    x1: 589.507,
    y1: 484.838,
    x2: 512.239,
    y2: 378.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_1606_3980",
    x1: 589.507,
    y1: 484.838,
    x2: 512.239,
    y2: 378.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_1606_3980",
    x1: 589.507,
    y1: 484.838,
    x2: 512.239,
    y2: 378.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_1606_3980",
    x1: 589.507,
    y1: 484.838,
    x2: 512.239,
    y2: 378.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_1606_3980",
    x1: 589.507,
    y1: 484.838,
    x2: 512.239,
    y2: 378.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_1606_3980",
    x1: 589.507,
    y1: 484.838,
    x2: 512.239,
    y2: 378.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_1606_3980",
    x1: 589.507,
    y1: 484.838,
    x2: 512.239,
    y2: 378.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_1606_3980",
    x1: 589.507,
    y1: 484.838,
    x2: 512.239,
    y2: 378.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_1606_3980",
    x1: 589.507,
    y1: 484.838,
    x2: 512.239,
    y2: 378.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_1606_3980",
    x1: 589.507,
    y1: 484.838,
    x2: 512.239,
    y2: 378.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_1606_3980",
    x1: 589.507,
    y1: 484.838,
    x2: 512.239,
    y2: 378.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_1606_3980",
    x1: 589.507,
    y1: 484.838,
    x2: 512.239,
    y2: 378.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_1606_3980",
    x1: 589.507,
    y1: 484.838,
    x2: 512.239,
    y2: 378.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_1606_3980",
    x1: 589.507,
    y1: 484.838,
    x2: 512.239,
    y2: 378.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_1606_3980",
    x1: 589.507,
    y1: 484.838,
    x2: 512.239,
    y2: 378.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint136_radial_1606_3980",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(440.909 465.389) scale(24.9054 12.9508)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#48486A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#505070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8D8DA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#BEBECA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#E2E2E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F7F7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_1606_3980",
    x1: 211.02,
    y1: 356.437,
    x2: 133.86,
    y2: 250.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_1606_3980",
    x1: 211.02,
    y1: 356.437,
    x2: 133.86,
    y2: 250.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_1606_3980",
    x1: 211.02,
    y1: 356.437,
    x2: 133.86,
    y2: 250.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_1606_3980",
    x1: 211.02,
    y1: 356.437,
    x2: 133.86,
    y2: 250.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_1606_3980",
    x1: 211.02,
    y1: 356.437,
    x2: 133.86,
    y2: 250.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_1606_3980",
    x1: 211.02,
    y1: 356.437,
    x2: 133.86,
    y2: 250.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_1606_3980",
    x1: 211.02,
    y1: 356.437,
    x2: 133.86,
    y2: 250.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_1606_3980",
    x1: 211.02,
    y1: 356.437,
    x2: 133.86,
    y2: 250.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_1606_3980",
    x1: 211.02,
    y1: 356.437,
    x2: 133.86,
    y2: 250.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_1606_3980",
    x1: 211.02,
    y1: 356.437,
    x2: 133.86,
    y2: 250.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_1606_3980",
    x1: 211.02,
    y1: 356.437,
    x2: 133.86,
    y2: 250.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_1606_3980",
    x1: 211.02,
    y1: 356.437,
    x2: 133.86,
    y2: 250.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_1606_3980",
    x1: 211.02,
    y1: 356.437,
    x2: 133.86,
    y2: 250.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_1606_3980",
    x1: 211.02,
    y1: 356.437,
    x2: 133.86,
    y2: 250.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_1606_3980",
    x1: 211.02,
    y1: 356.437,
    x2: 133.86,
    y2: 250.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_1606_3980",
    x1: 211.02,
    y1: 356.437,
    x2: 133.86,
    y2: 250.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_1606_3980",
    x1: 211.02,
    y1: 356.437,
    x2: 133.86,
    y2: 250.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_1606_3980",
    x1: 211.02,
    y1: 356.437,
    x2: 133.86,
    y2: 250.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_1606_3980",
    x1: 211.02,
    y1: 356.437,
    x2: 133.86,
    y2: 250.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_1606_3980",
    x1: 211.02,
    y1: 356.437,
    x2: 133.86,
    y2: 250.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_1606_3980",
    x1: 211.02,
    y1: 356.437,
    x2: 133.86,
    y2: 250.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_1606_3980",
    x1: 211.02,
    y1: 356.437,
    x2: 133.86,
    y2: 250.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_1606_3980",
    x1: 211.02,
    y1: 356.437,
    x2: 133.86,
    y2: 250.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_1606_3980",
    x1: 211.02,
    y1: 356.437,
    x2: 133.86,
    y2: 250.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_1606_3980",
    x1: 211.02,
    y1: 356.437,
    x2: 133.86,
    y2: 250.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_1606_3980",
    x1: 211.02,
    y1: 356.437,
    x2: 133.86,
    y2: 250.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_1606_3980",
    x1: 211.02,
    y1: 356.437,
    x2: 133.86,
    y2: 250.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_1606_3980",
    x1: 211.02,
    y1: 356.437,
    x2: 133.86,
    y2: 250.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_1606_3980",
    x1: 211.02,
    y1: 356.437,
    x2: 133.86,
    y2: 250.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_1606_3980",
    x1: 211.02,
    y1: 356.437,
    x2: 133.86,
    y2: 250.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_1606_3980",
    x1: 211.02,
    y1: 356.437,
    x2: 133.86,
    y2: 250.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_1606_3980",
    x1: 211.02,
    y1: 356.437,
    x2: 133.86,
    y2: 250.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_1606_3980",
    x1: 211.02,
    y1: 356.437,
    x2: 133.86,
    y2: 250.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_1606_3980",
    x1: 211.02,
    y1: 356.437,
    x2: 133.86,
    y2: 250.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_1606_3980",
    x1: 211.02,
    y1: 356.437,
    x2: 133.86,
    y2: 250.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_1606_3980",
    x1: 211.02,
    y1: 356.437,
    x2: 133.86,
    y2: 250.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_1606_3980",
    x1: 211.02,
    y1: 356.437,
    x2: 133.86,
    y2: 250.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_1606_3980",
    x1: 211.02,
    y1: 356.437,
    x2: 133.86,
    y2: 250.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_1606_3980",
    x1: 211.02,
    y1: 356.437,
    x2: 133.86,
    y2: 250.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_1606_3980",
    x1: 211.02,
    y1: 356.437,
    x2: 133.86,
    y2: 250.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_1606_3980",
    x1: 211.02,
    y1: 356.437,
    x2: 133.86,
    y2: 250.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_1606_3980",
    x1: 211.02,
    y1: 356.437,
    x2: 133.86,
    y2: 250.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint179_radial_1606_3980",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.2013 334.621) scale(24.9054 12.9508)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#48486A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#505070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8D8DA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#BEBECA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#E2E2E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F7F7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear_1606_3980",
    x1: 47.4243,
    y1: 280.972,
    x2: 80.0644,
    y2: 280.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48486A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#4D4F78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#585D94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C629E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear_1606_3980",
    x1: 57.2543,
    y1: 272.774,
    x2: 70.2312,
    y2: 272.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC107"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FF9800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint182_linear_1606_3980",
    x1: 41.0801,
    y1: 226.727,
    x2: 57.7868,
    y2: 226.727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FF9800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC107"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear_1606_3980",
    x1: 39.1904,
    y1: 235.441,
    x2: 50.0876,
    y2: 235.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FF9800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC107"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear_1606_3980",
    x1: 43.144,
    y1: 246.545,
    x2: 85.289,
    y2: 246.545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FFC107"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear_1606_3980",
    x1: 67.707,
    y1: 257.201,
    x2: 62.8943,
    y2: 224.854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FF9800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC107"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear_1606_3980",
    x1: 289.307,
    y1: 399.981,
    x2: 211.743,
    y2: 293.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear_1606_3980",
    x1: 289.307,
    y1: 399.981,
    x2: 211.743,
    y2: 293.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint188_linear_1606_3980",
    x1: 289.307,
    y1: 399.981,
    x2: 211.743,
    y2: 293.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint189_linear_1606_3980",
    x1: 289.307,
    y1: 399.981,
    x2: 211.743,
    y2: 293.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear_1606_3980",
    x1: 289.307,
    y1: 399.981,
    x2: 211.743,
    y2: 293.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint191_linear_1606_3980",
    x1: 289.307,
    y1: 399.981,
    x2: 211.743,
    y2: 293.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear_1606_3980",
    x1: 289.307,
    y1: 399.981,
    x2: 211.743,
    y2: 293.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint193_linear_1606_3980",
    x1: 289.307,
    y1: 399.981,
    x2: 211.743,
    y2: 293.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint194_linear_1606_3980",
    x1: 289.307,
    y1: 399.981,
    x2: 211.743,
    y2: 293.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint195_linear_1606_3980",
    x1: 289.307,
    y1: 399.981,
    x2: 211.743,
    y2: 293.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint196_linear_1606_3980",
    x1: 289.307,
    y1: 399.981,
    x2: 211.743,
    y2: 293.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint197_linear_1606_3980",
    x1: 289.307,
    y1: 399.981,
    x2: 211.743,
    y2: 293.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint198_linear_1606_3980",
    x1: 289.307,
    y1: 399.981,
    x2: 211.743,
    y2: 293.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint199_linear_1606_3980",
    x1: 289.307,
    y1: 399.981,
    x2: 211.743,
    y2: 293.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint200_linear_1606_3980",
    x1: 289.307,
    y1: 399.981,
    x2: 211.743,
    y2: 293.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint201_linear_1606_3980",
    x1: 289.307,
    y1: 399.981,
    x2: 211.743,
    y2: 293.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint202_linear_1606_3980",
    x1: 289.307,
    y1: 399.981,
    x2: 211.743,
    y2: 293.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint203_linear_1606_3980",
    x1: 289.307,
    y1: 399.981,
    x2: 211.743,
    y2: 293.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint204_linear_1606_3980",
    x1: 289.307,
    y1: 399.981,
    x2: 211.743,
    y2: 293.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint205_linear_1606_3980",
    x1: 289.307,
    y1: 399.981,
    x2: 211.743,
    y2: 293.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint206_linear_1606_3980",
    x1: 289.307,
    y1: 399.981,
    x2: 211.743,
    y2: 293.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint207_linear_1606_3980",
    x1: 289.307,
    y1: 399.981,
    x2: 211.743,
    y2: 293.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint208_linear_1606_3980",
    x1: 289.307,
    y1: 399.981,
    x2: 211.743,
    y2: 293.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint209_linear_1606_3980",
    x1: 289.307,
    y1: 399.981,
    x2: 211.743,
    y2: 293.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint210_linear_1606_3980",
    x1: 289.307,
    y1: 399.981,
    x2: 211.743,
    y2: 293.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint211_linear_1606_3980",
    x1: 289.307,
    y1: 399.981,
    x2: 211.743,
    y2: 293.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint212_linear_1606_3980",
    x1: 289.307,
    y1: 399.981,
    x2: 211.743,
    y2: 293.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint213_linear_1606_3980",
    x1: 289.307,
    y1: 399.981,
    x2: 211.743,
    y2: 293.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint214_linear_1606_3980",
    x1: 289.307,
    y1: 399.981,
    x2: 211.743,
    y2: 293.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint215_linear_1606_3980",
    x1: 289.307,
    y1: 399.981,
    x2: 211.743,
    y2: 293.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint216_linear_1606_3980",
    x1: 289.307,
    y1: 399.981,
    x2: 211.743,
    y2: 293.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint217_linear_1606_3980",
    x1: 289.307,
    y1: 399.981,
    x2: 211.743,
    y2: 293.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint218_linear_1606_3980",
    x1: 289.307,
    y1: 399.981,
    x2: 211.743,
    y2: 293.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint219_linear_1606_3980",
    x1: 289.307,
    y1: 399.981,
    x2: 211.743,
    y2: 293.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint220_linear_1606_3980",
    x1: 289.307,
    y1: 399.981,
    x2: 211.743,
    y2: 293.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint221_linear_1606_3980",
    x1: 289.307,
    y1: 399.981,
    x2: 211.743,
    y2: 293.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint222_linear_1606_3980",
    x1: 289.307,
    y1: 399.981,
    x2: 211.743,
    y2: 293.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint223_linear_1606_3980",
    x1: 289.307,
    y1: 399.981,
    x2: 211.743,
    y2: 293.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint224_linear_1606_3980",
    x1: 289.307,
    y1: 399.981,
    x2: 211.743,
    y2: 293.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint225_linear_1606_3980",
    x1: 289.307,
    y1: 399.981,
    x2: 211.743,
    y2: 293.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint226_linear_1606_3980",
    x1: 289.307,
    y1: 399.981,
    x2: 211.743,
    y2: 293.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint227_linear_1606_3980",
    x1: 289.307,
    y1: 399.981,
    x2: 211.743,
    y2: 293.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint228_radial_1606_3980",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(140.652 320.387) scale(18.0302 10.4575)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#48486A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#505070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8D8DA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#BEBECA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#E2E2E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F7F7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint229_linear_1606_3980",
    x1: 113.012,
    y1: 265.537,
    x2: 171.074,
    y2: 270.851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint230_linear_1606_3980",
    x1: 915.556,
    y1: 296.265,
    x2: 838.371,
    y2: 190.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint231_linear_1606_3980",
    x1: 915.556,
    y1: 296.265,
    x2: 838.371,
    y2: 190.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint232_linear_1606_3980",
    x1: 915.556,
    y1: 296.265,
    x2: 838.371,
    y2: 190.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint233_linear_1606_3980",
    x1: 915.556,
    y1: 296.265,
    x2: 838.371,
    y2: 190.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint234_linear_1606_3980",
    x1: 915.556,
    y1: 296.265,
    x2: 838.371,
    y2: 190.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint235_linear_1606_3980",
    x1: 915.556,
    y1: 296.265,
    x2: 838.371,
    y2: 190.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint236_linear_1606_3980",
    x1: 915.556,
    y1: 296.265,
    x2: 838.371,
    y2: 190.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint237_linear_1606_3980",
    x1: 915.556,
    y1: 296.265,
    x2: 838.371,
    y2: 190.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint238_linear_1606_3980",
    x1: 915.556,
    y1: 296.265,
    x2: 838.371,
    y2: 190.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint239_linear_1606_3980",
    x1: 915.556,
    y1: 296.265,
    x2: 838.371,
    y2: 190.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint240_linear_1606_3980",
    x1: 915.556,
    y1: 296.265,
    x2: 838.371,
    y2: 190.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint241_linear_1606_3980",
    x1: 915.556,
    y1: 296.265,
    x2: 838.371,
    y2: 190.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint242_linear_1606_3980",
    x1: 915.556,
    y1: 296.265,
    x2: 838.371,
    y2: 190.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint243_linear_1606_3980",
    x1: 915.556,
    y1: 296.265,
    x2: 838.371,
    y2: 190.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint244_linear_1606_3980",
    x1: 915.556,
    y1: 296.265,
    x2: 838.371,
    y2: 190.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint245_linear_1606_3980",
    x1: 915.556,
    y1: 296.265,
    x2: 838.371,
    y2: 190.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint246_linear_1606_3980",
    x1: 915.556,
    y1: 296.265,
    x2: 838.371,
    y2: 190.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint247_linear_1606_3980",
    x1: 915.556,
    y1: 296.265,
    x2: 838.371,
    y2: 190.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint248_linear_1606_3980",
    x1: 915.556,
    y1: 296.265,
    x2: 838.371,
    y2: 190.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint249_linear_1606_3980",
    x1: 915.556,
    y1: 296.265,
    x2: 838.371,
    y2: 190.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint250_linear_1606_3980",
    x1: 915.556,
    y1: 296.265,
    x2: 838.371,
    y2: 190.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint251_linear_1606_3980",
    x1: 915.556,
    y1: 296.265,
    x2: 838.371,
    y2: 190.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint252_linear_1606_3980",
    x1: 915.556,
    y1: 296.265,
    x2: 838.371,
    y2: 190.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint253_linear_1606_3980",
    x1: 915.556,
    y1: 296.265,
    x2: 838.371,
    y2: 190.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint254_linear_1606_3980",
    x1: 915.556,
    y1: 296.265,
    x2: 838.371,
    y2: 190.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint255_linear_1606_3980",
    x1: 915.556,
    y1: 296.265,
    x2: 838.371,
    y2: 190.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint256_linear_1606_3980",
    x1: 915.556,
    y1: 296.265,
    x2: 838.371,
    y2: 190.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint257_linear_1606_3980",
    x1: 915.556,
    y1: 296.265,
    x2: 838.371,
    y2: 190.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint258_linear_1606_3980",
    x1: 915.556,
    y1: 296.265,
    x2: 838.371,
    y2: 190.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint259_linear_1606_3980",
    x1: 915.556,
    y1: 296.265,
    x2: 838.371,
    y2: 190.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint260_linear_1606_3980",
    x1: 915.556,
    y1: 296.265,
    x2: 838.371,
    y2: 190.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint261_linear_1606_3980",
    x1: 915.556,
    y1: 296.265,
    x2: 838.371,
    y2: 190.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint262_linear_1606_3980",
    x1: 915.556,
    y1: 296.265,
    x2: 838.371,
    y2: 190.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint263_linear_1606_3980",
    x1: 915.556,
    y1: 296.265,
    x2: 838.371,
    y2: 190.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint264_linear_1606_3980",
    x1: 915.556,
    y1: 296.265,
    x2: 838.371,
    y2: 190.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint265_linear_1606_3980",
    x1: 915.556,
    y1: 296.265,
    x2: 838.371,
    y2: 190.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint266_linear_1606_3980",
    x1: 915.556,
    y1: 296.265,
    x2: 838.371,
    y2: 190.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint267_linear_1606_3980",
    x1: 915.556,
    y1: 296.265,
    x2: 838.371,
    y2: 190.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint268_linear_1606_3980",
    x1: 915.556,
    y1: 296.265,
    x2: 838.371,
    y2: 190.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint269_linear_1606_3980",
    x1: 915.556,
    y1: 296.265,
    x2: 838.371,
    y2: 190.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint270_linear_1606_3980",
    x1: 915.556,
    y1: 296.265,
    x2: 838.371,
    y2: 190.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint271_linear_1606_3980",
    x1: 915.556,
    y1: 296.265,
    x2: 838.371,
    y2: 190.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint272_radial_1606_3980",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(766.846 275.846) scale(24.9054 12.9508)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#48486A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#505070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8D8DA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#BEBECA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#E2E2E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F7F7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint273_linear_1606_3980",
    x1: 762.139,
    y1: 171.949,
    x2: 766.281,
    y2: 171.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC107"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#FF9800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint274_linear_1606_3980",
    x1: 766.811,
    y1: 171.21,
    x2: 773.187,
    y2: 171.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC107"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#FF9800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint275_linear_1606_3980",
    x1: 834.948,
    y1: 338.453,
    x2: 761.321,
    y2: 237.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint276_linear_1606_3980",
    x1: 834.948,
    y1: 338.453,
    x2: 761.321,
    y2: 237.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint277_linear_1606_3980",
    x1: 834.948,
    y1: 338.453,
    x2: 761.321,
    y2: 237.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint278_linear_1606_3980",
    x1: 834.948,
    y1: 338.453,
    x2: 761.321,
    y2: 237.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint279_linear_1606_3980",
    x1: 834.948,
    y1: 338.453,
    x2: 761.321,
    y2: 237.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint280_linear_1606_3980",
    x1: 834.948,
    y1: 338.453,
    x2: 761.321,
    y2: 237.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint281_linear_1606_3980",
    x1: 834.948,
    y1: 338.453,
    x2: 761.321,
    y2: 237.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint282_linear_1606_3980",
    x1: 834.948,
    y1: 338.453,
    x2: 761.321,
    y2: 237.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint283_linear_1606_3980",
    x1: 834.948,
    y1: 338.453,
    x2: 761.321,
    y2: 237.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint284_linear_1606_3980",
    x1: 834.948,
    y1: 338.453,
    x2: 761.321,
    y2: 237.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint285_linear_1606_3980",
    x1: 834.948,
    y1: 338.453,
    x2: 761.321,
    y2: 237.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint286_linear_1606_3980",
    x1: 834.948,
    y1: 338.453,
    x2: 761.321,
    y2: 237.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint287_linear_1606_3980",
    x1: 834.948,
    y1: 338.453,
    x2: 761.321,
    y2: 237.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint288_linear_1606_3980",
    x1: 834.948,
    y1: 338.453,
    x2: 761.321,
    y2: 237.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint289_linear_1606_3980",
    x1: 834.948,
    y1: 338.453,
    x2: 761.321,
    y2: 237.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint290_linear_1606_3980",
    x1: 834.948,
    y1: 338.453,
    x2: 761.321,
    y2: 237.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint291_linear_1606_3980",
    x1: 834.948,
    y1: 338.453,
    x2: 761.321,
    y2: 237.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint292_linear_1606_3980",
    x1: 834.948,
    y1: 338.453,
    x2: 761.321,
    y2: 237.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint293_linear_1606_3980",
    x1: 834.948,
    y1: 338.453,
    x2: 761.321,
    y2: 237.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint294_linear_1606_3980",
    x1: 834.948,
    y1: 338.453,
    x2: 761.321,
    y2: 237.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint295_linear_1606_3980",
    x1: 834.948,
    y1: 338.453,
    x2: 761.321,
    y2: 237.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint296_linear_1606_3980",
    x1: 834.948,
    y1: 338.453,
    x2: 761.321,
    y2: 237.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint297_linear_1606_3980",
    x1: 834.948,
    y1: 338.453,
    x2: 761.321,
    y2: 237.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint298_linear_1606_3980",
    x1: 834.948,
    y1: 338.453,
    x2: 761.321,
    y2: 237.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint299_linear_1606_3980",
    x1: 834.948,
    y1: 338.453,
    x2: 761.321,
    y2: 237.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint300_linear_1606_3980",
    x1: 834.948,
    y1: 338.453,
    x2: 761.321,
    y2: 237.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint301_linear_1606_3980",
    x1: 834.948,
    y1: 338.453,
    x2: 761.321,
    y2: 237.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint302_linear_1606_3980",
    x1: 834.948,
    y1: 338.453,
    x2: 761.321,
    y2: 237.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint303_linear_1606_3980",
    x1: 834.948,
    y1: 338.453,
    x2: 761.321,
    y2: 237.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint304_linear_1606_3980",
    x1: 834.948,
    y1: 338.453,
    x2: 761.321,
    y2: 237.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint305_linear_1606_3980",
    x1: 834.948,
    y1: 338.453,
    x2: 761.321,
    y2: 237.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint306_linear_1606_3980",
    x1: 834.948,
    y1: 338.453,
    x2: 761.321,
    y2: 237.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint307_linear_1606_3980",
    x1: 834.948,
    y1: 338.453,
    x2: 761.321,
    y2: 237.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint308_linear_1606_3980",
    x1: 834.948,
    y1: 338.453,
    x2: 761.321,
    y2: 237.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint309_linear_1606_3980",
    x1: 834.948,
    y1: 338.453,
    x2: 761.321,
    y2: 237.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint310_linear_1606_3980",
    x1: 834.948,
    y1: 338.453,
    x2: 761.321,
    y2: 237.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint311_linear_1606_3980",
    x1: 834.948,
    y1: 338.453,
    x2: 761.321,
    y2: 237.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint312_linear_1606_3980",
    x1: 834.948,
    y1: 338.453,
    x2: 761.321,
    y2: 237.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint313_linear_1606_3980",
    x1: 834.948,
    y1: 338.453,
    x2: 761.321,
    y2: 237.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint314_linear_1606_3980",
    x1: 834.948,
    y1: 338.453,
    x2: 761.321,
    y2: 237.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint315_linear_1606_3980",
    x1: 834.948,
    y1: 338.453,
    x2: 761.321,
    y2: 237.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint316_linear_1606_3980",
    x1: 834.948,
    y1: 338.453,
    x2: 761.321,
    y2: 237.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint317_linear_1606_3980",
    x1: 676.197,
    y1: 270.638,
    x2: 713.538,
    y2: 273.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint318_linear_1606_3980",
    x1: 677.018,
    y1: 242.354,
    x2: 712.175,
    y2: 243.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint319_linear_1606_3980",
    x1: 677.018,
    y1: 242.354,
    x2: 712.175,
    y2: 243.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint320_linear_1606_3980",
    x1: 677.018,
    y1: 242.354,
    x2: 712.175,
    y2: 243.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint321_linear_1606_3980",
    x1: 677.018,
    y1: 242.354,
    x2: 712.175,
    y2: 243.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint322_linear_1606_3980",
    x1: 677.018,
    y1: 242.354,
    x2: 712.175,
    y2: 243.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint323_linear_1606_3980",
    x1: 677.018,
    y1: 242.354,
    x2: 712.175,
    y2: 243.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint324_linear_1606_3980",
    x1: 677.018,
    y1: 242.354,
    x2: 712.175,
    y2: 243.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint325_linear_1606_3980",
    x1: 677.018,
    y1: 242.354,
    x2: 712.175,
    y2: 243.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint326_linear_1606_3980",
    x1: 677.018,
    y1: 242.354,
    x2: 712.175,
    y2: 243.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint327_linear_1606_3980",
    x1: 677.018,
    y1: 242.354,
    x2: 712.175,
    y2: 243.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint328_linear_1606_3980",
    x1: 677.018,
    y1: 242.354,
    x2: 712.175,
    y2: 243.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint329_linear_1606_3980",
    x1: 677.018,
    y1: 242.354,
    x2: 712.175,
    y2: 243.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint330_linear_1606_3980",
    x1: 677.018,
    y1: 242.354,
    x2: 712.175,
    y2: 243.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint331_linear_1606_3980",
    x1: 677.018,
    y1: 242.354,
    x2: 712.175,
    y2: 243.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint332_linear_1606_3980",
    x1: 677.018,
    y1: 242.354,
    x2: 712.175,
    y2: 243.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint333_linear_1606_3980",
    x1: 677.018,
    y1: 242.354,
    x2: 712.175,
    y2: 243.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint334_linear_1606_3980",
    x1: 677.018,
    y1: 242.354,
    x2: 712.175,
    y2: 243.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint335_linear_1606_3980",
    x1: 677.018,
    y1: 242.354,
    x2: 712.175,
    y2: 243.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint336_linear_1606_3980",
    x1: 677.018,
    y1: 242.354,
    x2: 712.175,
    y2: 243.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint337_linear_1606_3980",
    x1: 677.018,
    y1: 242.354,
    x2: 712.175,
    y2: 243.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint338_linear_1606_3980",
    x1: 677.018,
    y1: 242.354,
    x2: 712.175,
    y2: 243.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint339_linear_1606_3980",
    x1: 677.018,
    y1: 242.354,
    x2: 712.175,
    y2: 243.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint340_linear_1606_3980",
    x1: 677.018,
    y1: 242.354,
    x2: 712.175,
    y2: 243.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint341_linear_1606_3980",
    x1: 677.018,
    y1: 242.354,
    x2: 712.175,
    y2: 243.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint342_linear_1606_3980",
    x1: 677.018,
    y1: 242.354,
    x2: 712.175,
    y2: 243.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint343_linear_1606_3980",
    x1: 677.018,
    y1: 242.354,
    x2: 712.175,
    y2: 243.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint344_linear_1606_3980",
    x1: 677.018,
    y1: 242.354,
    x2: 712.175,
    y2: 243.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint345_linear_1606_3980",
    x1: 677.018,
    y1: 242.354,
    x2: 712.175,
    y2: 243.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint346_linear_1606_3980",
    x1: 677.018,
    y1: 242.354,
    x2: 712.175,
    y2: 243.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint347_linear_1606_3980",
    x1: 677.018,
    y1: 242.354,
    x2: 712.175,
    y2: 243.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint348_linear_1606_3980",
    x1: 677.018,
    y1: 242.354,
    x2: 712.175,
    y2: 243.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint349_linear_1606_3980",
    x1: 677.018,
    y1: 242.354,
    x2: 712.175,
    y2: 243.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint350_linear_1606_3980",
    x1: 677.018,
    y1: 242.354,
    x2: 712.175,
    y2: 243.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint351_linear_1606_3980",
    x1: 677.018,
    y1: 242.354,
    x2: 712.175,
    y2: 243.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint352_linear_1606_3980",
    x1: 677.018,
    y1: 242.354,
    x2: 712.175,
    y2: 243.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint353_linear_1606_3980",
    x1: 677.018,
    y1: 242.354,
    x2: 712.175,
    y2: 243.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint354_linear_1606_3980",
    x1: 677.018,
    y1: 242.354,
    x2: 712.175,
    y2: 243.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint355_linear_1606_3980",
    x1: 677.018,
    y1: 242.354,
    x2: 712.175,
    y2: 243.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint356_linear_1606_3980",
    x1: 677.018,
    y1: 242.354,
    x2: 712.175,
    y2: 243.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint357_linear_1606_3980",
    x1: 677.018,
    y1: 242.354,
    x2: 712.175,
    y2: 243.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint358_linear_1606_3980",
    x1: 677.018,
    y1: 242.354,
    x2: 712.175,
    y2: 243.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint359_linear_1606_3980",
    x1: 677.018,
    y1: 242.354,
    x2: 712.175,
    y2: 243.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint360_linear_1606_3980",
    x1: 360.18,
    y1: 75.9709,
    x2: 561.792,
    y2: 93.9041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint361_linear_1606_3980",
    x1: 357.223,
    y1: 117.686,
    x2: 367.703,
    y2: 118.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint362_linear_1606_3980",
    x1: 395.311,
    y1: 147.336,
    x2: 403.189,
    y2: 147.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint363_linear_1606_3980",
    x1: 478.449,
    y1: 156.273,
    x2: 483.547,
    y2: 156.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint364_linear_1606_3980",
    x1: 378.52,
    y1: 49.8108,
    x2: 541.863,
    y2: 64.3217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint365_linear_1606_3980",
    x1: 404.715,
    y1: 106.084,
    x2: 413.199,
    y2: 106.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint366_linear_1606_3980",
    x1: 480.287,
    y1: 113.028,
    x2: 486.668,
    y2: 113.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint367_linear_1606_3980",
    x1: 525.682,
    y1: 96.7513,
    x2: 529.817,
    y2: 96.9107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint368_linear_1606_3980",
    x1: 372.33,
    y1: 125.129,
    x2: 542.296,
    y2: 130.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint369_linear_1606_3980",
    x1: 372.33,
    y1: 125.129,
    x2: 542.296,
    y2: 130.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint370_linear_1606_3980",
    x1: 372.33,
    y1: 125.129,
    x2: 542.296,
    y2: 130.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint371_linear_1606_3980",
    x1: 372.33,
    y1: 125.129,
    x2: 542.296,
    y2: 130.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint372_linear_1606_3980",
    x1: 372.33,
    y1: 125.129,
    x2: 542.296,
    y2: 130.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint373_linear_1606_3980",
    x1: 372.33,
    y1: 125.129,
    x2: 542.296,
    y2: 130.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint374_linear_1606_3980",
    x1: 372.33,
    y1: 125.129,
    x2: 542.296,
    y2: 130.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint375_linear_1606_3980",
    x1: 372.33,
    y1: 125.129,
    x2: 542.296,
    y2: 130.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint376_linear_1606_3980",
    x1: 372.33,
    y1: 125.129,
    x2: 542.296,
    y2: 130.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint377_linear_1606_3980",
    x1: 372.33,
    y1: 125.129,
    x2: 542.296,
    y2: 130.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint378_linear_1606_3980",
    x1: 372.33,
    y1: 125.129,
    x2: 542.296,
    y2: 130.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint379_linear_1606_3980",
    x1: 372.33,
    y1: 125.129,
    x2: 542.296,
    y2: 130.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint380_linear_1606_3980",
    x1: 372.33,
    y1: 125.129,
    x2: 542.296,
    y2: 130.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint381_linear_1606_3980",
    x1: 372.33,
    y1: 125.129,
    x2: 542.296,
    y2: 130.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint382_linear_1606_3980",
    x1: 372.33,
    y1: 125.129,
    x2: 542.296,
    y2: 130.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint383_linear_1606_3980",
    x1: 372.33,
    y1: 125.129,
    x2: 542.296,
    y2: 130.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint384_linear_1606_3980",
    x1: 372.33,
    y1: 125.129,
    x2: 542.296,
    y2: 130.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint385_linear_1606_3980",
    x1: 372.33,
    y1: 125.129,
    x2: 542.296,
    y2: 130.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint386_linear_1606_3980",
    x1: 372.33,
    y1: 125.129,
    x2: 542.296,
    y2: 130.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint387_linear_1606_3980",
    x1: 372.33,
    y1: 125.129,
    x2: 542.296,
    y2: 130.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint388_linear_1606_3980",
    x1: 372.33,
    y1: 125.129,
    x2: 542.296,
    y2: 130.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint389_linear_1606_3980",
    x1: 372.33,
    y1: 125.129,
    x2: 542.296,
    y2: 130.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint390_linear_1606_3980",
    x1: 372.33,
    y1: 125.129,
    x2: 542.296,
    y2: 130.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint391_linear_1606_3980",
    x1: 372.33,
    y1: 125.129,
    x2: 542.296,
    y2: 130.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint392_linear_1606_3980",
    x1: 372.33,
    y1: 125.129,
    x2: 542.296,
    y2: 130.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint393_linear_1606_3980",
    x1: 372.33,
    y1: 125.129,
    x2: 542.296,
    y2: 130.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint394_linear_1606_3980",
    x1: 806.343,
    y1: 528.281,
    x2: 625.622,
    y2: 378.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint395_linear_1606_3980",
    x1: 806.343,
    y1: 528.281,
    x2: 625.622,
    y2: 378.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint396_linear_1606_3980",
    x1: 806.343,
    y1: 528.281,
    x2: 625.622,
    y2: 378.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint397_linear_1606_3980",
    x1: 806.343,
    y1: 528.281,
    x2: 625.622,
    y2: 378.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint398_linear_1606_3980",
    x1: 806.343,
    y1: 528.281,
    x2: 625.622,
    y2: 378.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint399_linear_1606_3980",
    x1: 806.343,
    y1: 528.281,
    x2: 625.622,
    y2: 378.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint400_linear_1606_3980",
    x1: 806.343,
    y1: 528.281,
    x2: 625.622,
    y2: 378.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint401_linear_1606_3980",
    x1: 806.343,
    y1: 528.281,
    x2: 625.622,
    y2: 378.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint402_linear_1606_3980",
    x1: 806.343,
    y1: 528.281,
    x2: 625.622,
    y2: 378.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint403_linear_1606_3980",
    x1: 806.343,
    y1: 528.281,
    x2: 625.622,
    y2: 378.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint404_linear_1606_3980",
    x1: 806.343,
    y1: 528.281,
    x2: 625.622,
    y2: 378.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint405_linear_1606_3980",
    x1: 806.343,
    y1: 528.281,
    x2: 625.622,
    y2: 378.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint406_linear_1606_3980",
    x1: 806.343,
    y1: 528.281,
    x2: 625.622,
    y2: 378.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint407_linear_1606_3980",
    x1: 806.343,
    y1: 528.281,
    x2: 625.622,
    y2: 378.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint408_linear_1606_3980",
    x1: 806.343,
    y1: 528.281,
    x2: 625.622,
    y2: 378.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint409_linear_1606_3980",
    x1: 806.343,
    y1: 528.281,
    x2: 625.622,
    y2: 378.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint410_linear_1606_3980",
    x1: 806.343,
    y1: 528.281,
    x2: 625.622,
    y2: 378.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint411_linear_1606_3980",
    x1: 806.343,
    y1: 528.281,
    x2: 625.622,
    y2: 378.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint412_linear_1606_3980",
    x1: 806.343,
    y1: 528.281,
    x2: 625.622,
    y2: 378.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint413_linear_1606_3980",
    x1: 806.343,
    y1: 528.281,
    x2: 625.622,
    y2: 378.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint414_linear_1606_3980",
    x1: 806.343,
    y1: 528.281,
    x2: 625.622,
    y2: 378.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint415_linear_1606_3980",
    x1: 806.343,
    y1: 528.281,
    x2: 625.622,
    y2: 378.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint416_linear_1606_3980",
    x1: 806.343,
    y1: 528.281,
    x2: 625.622,
    y2: 378.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint417_linear_1606_3980",
    x1: 806.343,
    y1: 528.281,
    x2: 625.622,
    y2: 378.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint418_linear_1606_3980",
    x1: 806.343,
    y1: 528.281,
    x2: 625.622,
    y2: 378.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint419_linear_1606_3980",
    x1: 806.343,
    y1: 528.281,
    x2: 625.622,
    y2: 378.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint420_linear_1606_3980",
    x1: 806.343,
    y1: 528.281,
    x2: 625.622,
    y2: 378.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint421_linear_1606_3980",
    x1: 806.343,
    y1: 528.281,
    x2: 625.622,
    y2: 378.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint422_linear_1606_3980",
    x1: 806.343,
    y1: 528.281,
    x2: 625.622,
    y2: 378.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint423_linear_1606_3980",
    x1: 806.343,
    y1: 528.281,
    x2: 625.622,
    y2: 378.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint424_linear_1606_3980",
    x1: 806.343,
    y1: 528.281,
    x2: 625.622,
    y2: 378.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint425_linear_1606_3980",
    x1: 806.343,
    y1: 528.281,
    x2: 625.622,
    y2: 378.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint426_linear_1606_3980",
    x1: 806.343,
    y1: 528.281,
    x2: 625.622,
    y2: 378.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint427_linear_1606_3980",
    x1: 806.343,
    y1: 528.281,
    x2: 625.622,
    y2: 378.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint428_linear_1606_3980",
    x1: 806.343,
    y1: 528.281,
    x2: 625.622,
    y2: 378.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint429_linear_1606_3980",
    x1: 806.343,
    y1: 528.281,
    x2: 625.622,
    y2: 378.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint430_linear_1606_3980",
    x1: 806.343,
    y1: 528.281,
    x2: 625.622,
    y2: 378.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint431_linear_1606_3980",
    x1: 806.343,
    y1: 528.281,
    x2: 625.622,
    y2: 378.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint432_linear_1606_3980",
    x1: 806.343,
    y1: 528.281,
    x2: 625.622,
    y2: 378.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint433_linear_1606_3980",
    x1: 806.343,
    y1: 528.281,
    x2: 625.622,
    y2: 378.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint434_linear_1606_3980",
    x1: 806.343,
    y1: 528.281,
    x2: 625.622,
    y2: 378.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint435_linear_1606_3980",
    x1: 806.343,
    y1: 528.281,
    x2: 625.622,
    y2: 378.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint436_linear_1606_3980",
    x1: 320.113,
    y1: 79.0732,
    x2: 335.561,
    y2: 79.3875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint437_linear_1606_3980",
    x1: 324.031,
    y1: 76.7019,
    x2: 351.479,
    y2: 77.3493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint438_linear_1606_3980",
    x1: 408.891,
    y1: 504.555,
    x2: 255.239,
    y2: 360.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint439_linear_1606_3980",
    x1: 408.891,
    y1: 504.555,
    x2: 255.239,
    y2: 360.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint440_linear_1606_3980",
    x1: 408.891,
    y1: 504.555,
    x2: 255.239,
    y2: 360.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint441_linear_1606_3980",
    x1: 408.891,
    y1: 504.555,
    x2: 255.239,
    y2: 360.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint442_linear_1606_3980",
    x1: 408.891,
    y1: 504.555,
    x2: 255.239,
    y2: 360.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint443_linear_1606_3980",
    x1: 408.891,
    y1: 504.555,
    x2: 255.239,
    y2: 360.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint444_linear_1606_3980",
    x1: 408.891,
    y1: 504.555,
    x2: 255.239,
    y2: 360.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint445_linear_1606_3980",
    x1: 408.891,
    y1: 504.555,
    x2: 255.239,
    y2: 360.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint446_linear_1606_3980",
    x1: 408.891,
    y1: 504.555,
    x2: 255.239,
    y2: 360.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint447_linear_1606_3980",
    x1: 408.891,
    y1: 504.555,
    x2: 255.239,
    y2: 360.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint448_linear_1606_3980",
    x1: 408.891,
    y1: 504.555,
    x2: 255.239,
    y2: 360.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint449_linear_1606_3980",
    x1: 408.891,
    y1: 504.555,
    x2: 255.239,
    y2: 360.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint450_linear_1606_3980",
    x1: 408.891,
    y1: 504.555,
    x2: 255.239,
    y2: 360.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint451_linear_1606_3980",
    x1: 408.891,
    y1: 504.555,
    x2: 255.239,
    y2: 360.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint452_linear_1606_3980",
    x1: 408.891,
    y1: 504.555,
    x2: 255.239,
    y2: 360.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint453_linear_1606_3980",
    x1: 408.891,
    y1: 504.555,
    x2: 255.239,
    y2: 360.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint454_linear_1606_3980",
    x1: 408.891,
    y1: 504.555,
    x2: 255.239,
    y2: 360.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint455_linear_1606_3980",
    x1: 408.891,
    y1: 504.555,
    x2: 255.239,
    y2: 360.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint456_linear_1606_3980",
    x1: 408.891,
    y1: 504.555,
    x2: 255.239,
    y2: 360.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint457_linear_1606_3980",
    x1: 408.891,
    y1: 504.555,
    x2: 255.239,
    y2: 360.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint458_linear_1606_3980",
    x1: 408.891,
    y1: 504.555,
    x2: 255.239,
    y2: 360.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint459_linear_1606_3980",
    x1: 408.891,
    y1: 504.555,
    x2: 255.239,
    y2: 360.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint460_linear_1606_3980",
    x1: 408.891,
    y1: 504.555,
    x2: 255.239,
    y2: 360.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint461_linear_1606_3980",
    x1: 408.891,
    y1: 504.555,
    x2: 255.239,
    y2: 360.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint462_linear_1606_3980",
    x1: 408.891,
    y1: 504.555,
    x2: 255.239,
    y2: 360.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint463_linear_1606_3980",
    x1: 408.891,
    y1: 504.555,
    x2: 255.239,
    y2: 360.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint464_linear_1606_3980",
    x1: 408.891,
    y1: 504.555,
    x2: 255.239,
    y2: 360.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint465_linear_1606_3980",
    x1: 408.891,
    y1: 504.555,
    x2: 255.239,
    y2: 360.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint466_linear_1606_3980",
    x1: 408.891,
    y1: 504.555,
    x2: 255.239,
    y2: 360.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint467_linear_1606_3980",
    x1: 408.891,
    y1: 504.555,
    x2: 255.239,
    y2: 360.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint468_linear_1606_3980",
    x1: 408.891,
    y1: 504.555,
    x2: 255.239,
    y2: 360.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint469_linear_1606_3980",
    x1: 408.891,
    y1: 504.555,
    x2: 255.239,
    y2: 360.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint470_linear_1606_3980",
    x1: 408.891,
    y1: 504.555,
    x2: 255.239,
    y2: 360.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint471_linear_1606_3980",
    x1: 408.891,
    y1: 504.555,
    x2: 255.239,
    y2: 360.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint472_linear_1606_3980",
    x1: 408.891,
    y1: 504.555,
    x2: 255.239,
    y2: 360.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint473_linear_1606_3980",
    x1: 408.891,
    y1: 504.555,
    x2: 255.239,
    y2: 360.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint474_linear_1606_3980",
    x1: 408.891,
    y1: 504.555,
    x2: 255.239,
    y2: 360.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint475_linear_1606_3980",
    x1: 408.891,
    y1: 504.555,
    x2: 255.239,
    y2: 360.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint476_linear_1606_3980",
    x1: 408.891,
    y1: 504.555,
    x2: 255.239,
    y2: 360.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint477_linear_1606_3980",
    x1: 408.891,
    y1: 504.555,
    x2: 255.239,
    y2: 360.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint478_linear_1606_3980",
    x1: 408.891,
    y1: 504.555,
    x2: 255.239,
    y2: 360.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint479_linear_1606_3980",
    x1: 408.891,
    y1: 504.555,
    x2: 255.239,
    y2: 360.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint480_linear_1606_3980",
    x1: 293.178,
    y1: 443.176,
    x2: 140.893,
    y2: 443.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBE9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99A7D8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudImage);
export default __webpack_public_path__ + "static/media/cloud_image.b7cee3767d66e4acb7e0ad4d35cdff25.svg";
export { ForwardRef as ReactComponent };